export const QUESTIONS_CN = [
  {
    "index": 1,
    "id": "ABMW0425RU19",
    "section": "控制车辆",
    "question": "突然刹车的可能后果是什么？",
    "options": [
      "车辆的刹车灯会亮起，不会造成任何后果",
      "其他车辆可以超车",
      "车辆的制动系统可能会过热",
      "车辆可能会被后方追尾"
    ],
    "correct_answer": 3,
    "explanation": "除了看前方道路，你还应该注意后方来车。这将有助于你在需要突然刹车的情况下做出正确反应。"
  },
  {
    "index": 2,
    "id": "ABMW0655RU19",
    "section": "控制车辆",
    "question": "当车辆刹车踏板感觉松软或弹性过大时，这意味着什么？",
    "options": [
      "制动液系统故障",
      "手刹电缆故障",
      "手刹已拉紧",
      "刹车片磨损"
    ],
    "correct_answer": 0,
    "explanation": "如果踩刹车踏板时感觉软或有弹性，可能表示刹车油液位较低且系统存在故障。每次驾驶员开始旅程时，都应测试刹车。如果发现故障，请由有能力的人员检查。驾驶员应定期检查刹车油液位。",
    "image_name": ""
  },
  {
    "index": 3,
    "id": "ABMW0656RU19",
    "section": "控制车辆",
    "question": "当驾驶时，驾驶员为什么会怀疑车辆的制动液液位较低？",
    "options": [
      "制动器释放时间比平时更长",
      "制动器异常锐利",
      "制动器感觉很难踩",
      "制动器感觉柔软且松软"
    ],
    "correct_answer": 3,
    "explanation": "如果踩下刹车踏板时感觉软或海绵状，可能表明制动液位过低且系统存在故障。每次驾驶员出发旅行时，都应该测试刹车。如果检测到故障，应请熟练的人员检查。驾驶员应定期检查刹车液位。",
    "image_name": ""
  },
  {
    "index": 4,
    "id": "ABMW0658RU19",
    "section": "控制车辆",
    "question": "如果司机踩下制动踏板听到刮擦声，最有可能的原因是什么？",
    "options": [
      "刹车片潮湿",
      "一个后轮胎瘪了",
      "一个前轮胎瘪了",
      "刹车衬板磨损"
    ],
    "correct_answer": 3,
    "explanation": "司机应定期检查刹车，特别是在启程前。然而，如果在行驶时按下刹车时听到刮擦声，最有可能的原因是刹车片已磨损。在这种情况下，刹车性能会受影响，司机应立即请能胜任的人员更换刹车。",
    "image_name": ""
  },
  {
    "index": 5,
    "id": "ABMW0659RU19",
    "section": "控制车辆",
    "question": "车辆制动系统可能存在问题的迹象是什么？",
    "options": [
      "车辆的制动能力会受到影响",
      "车辆的悬挂会受到影响",
      "车辆的驻车制动更有效",
      "车辆的燃油消耗减少"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员在启程前应该测试他们的刹车。如果在驾驶过程中注意到车辆需要比平常更长的时间才能停下来，应立即请有经验的人检查刹车。",
    "image_name": ""
  },
  {
    "index": 6,
    "id": "RSA225190",
    "section": "控制车辆",
    "question": "突然刹车的危险在哪里？",
    "options": [
      "车辆可能会打滑",
      "驾驶员气囊可能会弹出",
      "手刹可能会拉起"
    ],
    "correct_answer": 0,
    "explanation": "司机们应始终阅读前方道路并保持足够距离以确保安全停车。当司机需要突然刹车时，他们应意识到可能失控导致车辆打滑。",
    "image_name": ""
  },
  {
    "index": 7,
    "id": "ABMW31U19",
    "section": "控制车辆",
    "question": "什么可能导致车辆打滑？",
    "options": [
      "在四档停车",
      "惯性滑行停车",
      "控制加速",
      "过度重型刹车"
    ],
    "correct_answer": 3,
    "explanation": "紧急制动可能导致车辆打滑，特别是在路面潮湿或不平整，或者轮胎磨损或充气不正确的情况下。提前观察并避免紧急制动，特别是在潮湿或滑的路况下。",
    "image_name": ""
  },
  {
    "index": 8,
    "id": "RSA225168",
    "section": "控制车辆",
    "question": "停车时迟迟使用离合器会导致什么结果？",
    "options": [
      "轮胎磨损更快",
      "车辆可能熄火",
      "有助于节省燃料"
    ],
    "correct_answer": 1,
    "explanation": "駕駛員在換擋時，應始終適當使用車輛的離合器，這將使換擋始終順暢。當車輛即將停止時，應及時使用離合器，以避免車輛熄火。",
    "image_name": ""
  },
  {
    "index": 9,
    "id": "ABMW0140RU19",
    "section": "控制车辆",
    "question": "这个手势代表什么？",
    "options": [
      "自行车骑手打算向左移动或转弯",
      "自行车骑手打算向右移动或转弯",
      "自行车骑手打算停下来",
      "自行车骑手打算减速"
    ],
    "correct_answer": 1,
    "explanation": "这个手势告诉其他道路使用者，自行车骑手打算要么向外移动，要么右转。司机应该意识到自行车骑手可能会在未看清情况下突然冲入其车道。",
    "image_name": "ABMW0140RU19.png"
  },
  {
    "index": 10,
    "id": "RSA225228",
    "section": "控制车辆",
    "question": "当制动减速和停车时，司机应注意什么？",
    "options": [
      "车辆越短，刹车距离越长",
      "载重车辆刹车距离较长",
      "空载车辆刹车距离较长"
    ],
    "correct_answer": 1,
    "explanation": "制动时，您需要考虑到一辆满载的车辆因为额外的重量，需要比空载车辆更长的距离才能完全停下来。",
    "image_name": ""
  },
  {
    "index": 11,
    "id": "BW0023RU19",
    "section": "控制车辆",
    "question": "为什么拖拉机在不平整的路面上应该行驶得更慢？",
    "options": [
      "为了避免燃油从油箱溢出",
      "为了保持轮胎压力",
      "为了避免严重颠簸",
      "为了减少路面噪音"
    ],
    "correct_answer": 2,
    "explanation": "在不平整的路面上行驶时，驾驶员应该减慢车速，因为以高速驾驶拖拉机可能导致车辆或拖车变得不稳定且难以控制。在严重颠簸时，拖拉机的车轮可能会失去与路面的接触，对转向和制动产生负面影响。",
    "image_name": ""
  },
  {
    "index": 12,
    "id": "BWO0110",
    "section": "控制车辆",
    "question": "快速转弯可能会产生什么类型的噪音？",
    "options": [
      "轮胎尖叫声",
      "排气管回火声",
      "刹车尖叫声",
      "发动机回火声"
    ],
    "correct_answer": 0,
    "explanation": "如果你开车在转弯时速度太快，车辆的轮胎会开始失去与路面的接触，造成尖叫声。如果你继续这样驾驶，你可能会失去对车辆的控制。",
    "image_name": ""
  },
  {
    "index": 13,
    "id": "RSA225229",
    "section": "控制车辆",
    "question": "当车辆开始打滑时，驾驶员应该怎么做？",
    "options": [
      "放松油门以减速",
      "保持速度以避免打滑",
      "牢牢踩刹车以减速"
    ],
    "correct_answer": 0,
    "explanation": "水滑车是指在雨天行驶时，路面和轮胎之间形成一层水膜，影响车辆的操控。当车辆水滑时，方向盘会感觉非常“松散”。司机应保持冷静，松开油门减速，尽量避免刹车。在低速行驶时，水会分散，轮胎会重新获得抓地力。",
    "image_name": ""
  },
  {
    "index": 14,
    "id": "RSA225230",
    "section": "控制车辆",
    "question": "电子稳定控制的目的是什么？",
    "options": [
      "在高速公路行驶时保持速度。",
      "以减少燃油消耗。",
      "保持车辆平稳，防止打滑。"
    ],
    "correct_answer": 2,
    "explanation": "电子稳定控制（ESC）是一种主动安全系统，可安装在汽车、公共汽车、长途客车和卡车上。它是防抱死制动技术的延伸，具有针对每个车轮的速度传感器和独立制动。它的目的是在所有行驶条件和情况下稳定车辆，并避免打滑，但要在物理限制内实现。它通过识别关键的驾驶情况来实现这一目标，并采取措施...",
    "image_name": ""
  },
  {
    "index": 15,
    "id": "RSA225231",
    "section": "控制车辆",
    "question": "最常见的打滑原因是什么？",
    "options": [
      "刹车片磨损严重",
      "在特定情况或条件下超速驾驶",
      "制动片因在下坡过程中过度使用而变热"
    ],
    "correct_answer": 1,
    "explanation": "路况行驶超速是一个因素，可能会减少轮胎与路面的附着力，导致或加剧打滑。驾驶员应根据道路和交通状况调整车速，并意识到潮湿或有油脂的道路、磨损或气压不当的轮胎、泥浆、树叶、冰雪等都可能导致车辆打滑。",
    "image_name": ""
  },
  {
    "index": 16,
    "id": "BW0024RU19",
    "section": "控制车辆",
    "question": "手刹应该在什么时候用来使车辆停止？",
    "options": [
      "只有在下坡时",
      "通常从不",
      "随时都可以",
      "只有在上坡时"
    ],
    "correct_answer": 1,
    "explanation": "通常情况下，手刹不应该用来停车。这种做法存在潜在的危险，因为后轮可能会锁死，导致车辆失控打滑。此外，使用手刹不会点亮后部刹车灯来警示后方车辆。",
    "image_name": ""
  },
  {
    "index": 17,
    "id": "BW0025RU19",
    "section": "控制车辆",
    "question": "当车辆在移动时使用手刹（停车制动器）可能存在的危险是什么？",
    "options": [
      "ABS可能会断开并导致车辆打滑",
      "在高速行驶时，一旦拉起手刹，发动机将熄火",
      "车轮可能会锁死并导致车辆打滑",
      "没有危险 由于手刹可以被快速释放，车辆不会打滑"
    ],
    "correct_answer": 2,
    "explanation": "除非紧急情况，否则车辆行驶时永远不应使用手刹（停车制动器）。这种做法潜在危险，因为车轮可能会锁死，车辆可能会失控打滑。此外，刹车灯不会向后续交通发出警告。",
    "image_name": ""
  },
  {
    "index": 18,
    "id": "BW0079RU19",
    "section": "控制车辆",
    "question": "停车制动器（手刹）通常控制哪些车轮？",
    "options": [
      "所有轮子",
      "后右轮",
      "后轮",
      "前轮"
    ],
    "correct_answer": 2,
    "explanation": "在大多数车辆中，驻车制动器仅作用于后轮。 驻车制动器（手刹）的功能是在停放时或停在斜坡上停车时阻止车辆移动。 驾驶员通常在车辆已经静止时使用驻车制动器，并通常不应该用它来停止车辆。 当停放在斜坡上或需要...时更重要时，应该使用驻车制动器。",
    "image_name": ""
  },
  {
    "index": 19,
    "id": "BW0081RU19",
    "section": "控制车辆",
    "question": "自动变速器汽车的推荐驾驶方法是什么？",
    "options": [
      "使用右脚踩油门和刹车",
      "使用右脚踩油门，左脚踩刹车",
      "使用左脚踩油门和刹车",
      "使用手刹将车辆停下来"
    ],
    "correct_answer": 0,
    "explanation": "在驾驶自动挡汽车时，驾驶员应该使用右脚来操作油门和刹车，就像在手动挡汽车中一样。一般来说，避免同时踩油门和刹车是很重要的。",
    "image_name": ""
  },
  {
    "index": 20,
    "id": "BWOO96R",
    "section": "控制车辆",
    "question": "司机座椅调整不当的影响是什么？",
    "options": [
      "它提高了驾驶员操纵离合器的能力",
      "它让司机在后视镜中看得更清楚",
      "它可能延迟了驾驶员操作控制器的时间",
      "它让驾驶员在长途旅行中放松"
    ],
    "correct_answer": 2,
    "explanation": "在开始旅程之前，您应该通过调整驾驶座椅的位置，使所有车辆控制装置可以高效操作，采取适当舒适的驾驶姿势。",
    "image_name": ""
  },
  {
    "index": 21,
    "id": "RSA225167",
    "section": "控制车辆",
    "question": "司机应该什么时候双手握住方向盘？",
    "options": [
      "在任何时候都要关掉",
      "只有在进行机动时",
      "在任何时候都要关闭，除非在使用其他车辆控制时"
    ],
    "correct_answer": 2,
    "explanation": "为了保持对车辆的正确控制，驾驶员在除了使用其它车辆控制装置，如换挡、使用转向灯、雨刷或拉手刹之外，应始终双手握住方向盘。",
    "image_name": ""
  },
  {
    "index": 22,
    "id": "RSA225289",
    "section": "控制车辆",
    "question": "当使用油门时，司机如何可以帮助减少车辆的燃油消耗？",
    "options": [
      "驾驶员应平稳加速以达到并保持适当的速度。",
      "驾驶员应快速加速以达到适当的速度，然后减速以保持速度。",
      "驾驶员只有在车辆满载时才应平稳加速。"
    ],
    "correct_answer": 0,
    "explanation": "尽量平稳逐渐地使用油门。平稳驾驶不仅可以减少燃料消耗，还可减少车辆的磨损。记住 驾驶员对燃料消耗和安全性都有最大的影响。",
    "image_name": ""
  },
  {
    "index": 23,
    "id": "BW0038RU23",
    "section": "控制车辆",
    "question": "学习许可证持有者何时必须在其汽车上展示 L 牌照？",
    "options": [
      "当第一次持有学习驾驶执照时",
      "当未有持有完整驾驶执照的人陪同驾驶时",
      "在驾驶时始终如一"
    ],
    "correct_answer": 2,
    "explanation": "持有学习许可证的人在驾驶汽车上公共道路时必须始终在车辆的前后显示“L”标志牌。",
    "image_name": ""
  },
  {
    "index": 24,
    "id": "ABMW0141RU19",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么意思？",
    "options": [
      "骑自行车的人打算靠外侧行驶",
      "骑自行车的人正在示意后方车辆超车",
      "骑自行车的人打算减速或停车",
      "骑自行车的人打算向左转"
    ],
    "correct_answer": 2,
    "explanation": "这种手势告知其他道路使用者，自行车骑手打算放慢速度或停车。这可能表示骑手已经意识到前方有危险，所以请特别小心驾驶。",
    "image_name": "ABMW0141RU19.png"
  },
  {
    "index": 25,
    "id": "ABMW0142R",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么？",
    "options": [
      "骑自行车的人打算停下来",
      "骑自行车的人打算左转",
      "骑自行车的人打算直行",
      "骑自行车的人正在礼让其他交通"
    ],
    "correct_answer": 2,
    "explanation": "这个手势告诉其他道路使用者，自行车骑手打算在交叉路口直行，驾驶员应该保持警惕。",
    "image_name": "ABMW0142R.png"
  },
  {
    "index": 26,
    "id": "ABMW0143RU23",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么？",
    "options": [
      "骑自行车的人打算左转",
      "骑自行车的人打算停车",
      "骑自行车的人打算右转"
    ],
    "correct_answer": 0,
    "explanation": "该手势信号告知其他道路使用者骑车人打算左转。",
    "image_name": "ABMW0143R.png"
  },
  {
    "index": 27,
    "id": "ABMW0144RU23",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么？",
    "options": [
      "骑自行车的人打算停下来",
      "骑自行车的人打算左转",
      "骑自行车的人打算右转"
    ],
    "correct_answer": 2,
    "explanation": "这个手势告诉其他道路使用者，骑车人打算要么向外移动，要么向右转弯。驾驶员应该意识到骑车者可能会穿过他们车辆的路径。",
    "image_name": "ABMW0144RU19.png"
  },
  {
    "index": 28,
    "id": "ABMW0145RU23",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么？",
    "options": [
      "骑车者打算穿过马路",
      "骑车者打算停下来",
      "骑车者打算左转"
    ],
    "correct_answer": 2,
    "explanation": "这个手势告诉其他道路使用者，骑自行车的人打算离开或右转。司机应该意识到骑自行车的人可能会横穿车辆的道路。",
    "image_name": "ABMW0145R.png"
  },
  {
    "index": 29,
    "id": "ABMW0146R",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么意思？",
    "options": [
      "驾驶员打算减速或停车",
      "驾驶员打算左转",
      "驾驶员打算直行",
      "驾驶员打算右转"
    ],
    "correct_answer": 1,
    "explanation": "该手势信号告知其他道路使用者，驾驶员打算左转，车辆将改变方向。",
    "image_name": "ABMW0146R.png"
  },
  {
    "index": 30,
    "id": "ABMW0147R",
    "section": "法律事务/交通规则",
    "question": "这个手势是什么意思？",
    "options": [
      "司机打算掉头。",
      "司机打算左转。",
      "司机打算停车",
      "司机打算靠右行驶或右转"
    ],
    "correct_answer": 3,
    "explanation": "这个手势告知其他道路使用者，驾驶员打算驶出或右转，车辆将改变方向。",
    "image_name": "ABMW0147R.png"
  },
  {
    "index": 31,
    "id": "ABMW0148R",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么意思？",
    "options": [
      "司机打算向左转",
      "司机打算向右转",
      "司机打算减速或停车",
      "司机打算开始掉头"
    ],
    "correct_answer": 2,
    "explanation": "这种手势告知其他道路使用者，驾驶员打算减速或停车，后方交通应该准备减速。",
    "image_name": "ABMW0148R.png"
  },
  {
    "index": 32,
    "id": "ABMW0149R",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么？",
    "options": [
      "驾驶员打算停车",
      "驾驶员打算减速",
      "驾驶员打算右转",
      "驾驶员打算左转"
    ],
    "correct_answer": 3,
    "explanation": "這個手勢告知其他道路使用者或交通警察（面對這輛車輛），駕駛員打算左轉彎。",
    "image_name": "ABMW0149R.png"
  },
  {
    "index": 33,
    "id": "ABMW0150R",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么？",
    "options": [
      "司机打算减速",
      "司机将开始倒车",
      "司机打算左转",
      "司机打算右转"
    ],
    "correct_answer": 3,
    "explanation": "这个手势告知其他道路使用者或指挥交通的交警（面对此车辆）司机打算向右转。",
    "image_name": "ABMW0150R.png"
  },
  {
    "index": 34,
    "id": "ABMW0151RU19",
    "section": "法律事务/交通规则",
    "question": "这个手势代表什么意思？",
    "options": [
      "驾驶员打算减速或停车",
      "驾驶员打算倒车",
      "驾驶员打算向左转",
      "驾驶员打算直行前进"
    ],
    "correct_answer": 3,
    "explanation": "这个手势告知其他道路使用者或指挥交通的交警，驾驶员打算直行前进。",
    "image_name": "ABMW0151RU19.png"
  },
  {
    "index": 35,
    "id": "ABMW0152RU23",
    "section": "法律事务/交通规则",
    "question": "这个交警手势代表什么意思？",
    "options": [
      "如果从前方接近请停车",
      "如果从前方接近请继续行驶",
      "如果从后方接近请停车"
    ],
    "correct_answer": 0,
    "explanation": "逼近展示此手势的警察时，您必须停车。",
    "image_name": "ABMW0152R.png"
  },
  {
    "index": 36,
    "id": "ABMW0153R",
    "section": "法律事务/交通规则",
    "question": "这个交警手势代表什么意思？",
    "options": [
      "右转",
      "左转",
      "如果后方接近，请停车",
      "如果前方接近，请停车"
    ],
    "correct_answer": 2,
    "explanation": "接近一名准备发出这个信号的警察时，您必须停车。",
    "image_name": "ABMW0153R.png"
  },
  {
    "index": 37,
    "id": "ABMW0154R",
    "section": "法律事务/交通规则",
    "question": "這位警察的手勢是什麼意思？",
    "options": [
      "向右转",
      "向左转",
      "如果是从前面接近，请继续前进",
      "如果是从前面或后面接近，请停下"
    ],
    "correct_answer": 3,
    "explanation": "接近一位持有此信号的交警时，您必须停车。",
    "image_name": "ABMW0154R.png"
  },
  {
    "index": 38,
    "id": "ABMW0155R",
    "section": "法律事务/交通规则",
    "question": "这个警察的信号代表什么？",
    "options": [
      "警察正在招手引导两侧来车",
      "警察正在招手引导前方来车",
      "驾驶员不得向左行驶",
      "驾驶员不得向右行驶"
    ],
    "correct_answer": 0,
    "explanation": "当你接近一个给出这个信号的警察时，你可以继续前行。",
    "image_name": "ABMW0155R.png"
  },
  {
    "index": 39,
    "id": "ABMW0156R",
    "section": "法律事务/交通规则",
    "question": "这个交警的手势代表什么意思？",
    "options": [
      "前方来车可以通行",
      "后方来车必须停车",
      "前方来车必须停车",
      "右侧来车可以通行"
    ],
    "correct_answer": 0,
    "explanation": "當接近一名展示這個手勢的交警時，您可以繼續前行。",
    "image_name": "ABMW0156R.png"
  },
  {
    "index": 40,
    "id": "ABMW0211RU19",
    "section": "法律事务/交通规则",
    "question": "在公共道路上，何时可以拖曳挂车而不需有后方号码牌？",
    "options": [
      "在被农业拖拉机牵引时",
      "在拆除尾板时",
      "在载有超出拖车的货物时",
      "永远不能，必须始终显示车牌"
    ],
    "correct_answer": 3,
    "explanation": "法律要求所有机动车辆都必须展示清洁、可辨认的后牌照。",
    "image_name": ""
  },
  {
    "index": 41,
    "id": "ABMW0567RU19",
    "section": "法律事务/交通规则",
    "question": "在自动变速器车辆上通过考试的驾驶员获得的全照，有何样限制？",
    "options": [
      "他们不得驾驶手动变速器的车辆",
      "他们不得在高速公路上驾驶",
      "他们不得以超过80km/h的速度行驶",
      "他们必须继续展示L牌"
    ],
    "correct_answer": 0,
    "explanation": "如果您在配备自动变速器的车辆上通过了驾驶考试，驾照上的限制/信息栏中将会注明代码78。",
    "image_name": ""
  },
  {
    "index": 42,
    "id": "ABMW0568RU19",
    "section": "法律事务/交通规则",
    "question": "学习驾照持有者允许驾驶哪些道路？",
    "options": [
      "除了高速公路和双车道公路外的所有道路",
      "除了高速公路外的所有道路",
      "除了国道外的所有道路",
      "除了双车道公路外的所有道路"
    ],
    "correct_answer": 1,
    "explanation": "学习许可证持有者不得在高速公路上驾驶。这是一种严重违法行为。",
    "image_name": ""
  },
  {
    "index": 43,
    "id": "ABMW0570RU19",
    "section": "法律事务/交通规则",
    "question": "新手许可证持有者不得驾驶哪些道路？",
    "options": [
      "他们不得在国道上驾驶",
      "他们不得在乡村道路上驾驶",
      "他们不得在双车道上驾驶",
      "他们不得在高速公路上驾驶"
    ],
    "correct_answer": 3,
    "explanation": "持有学习驾照的人不得在高速公路上驾驶，这样做是一种严重的违法行为。",
    "image_name": ""
  },
  {
    "index": 44,
    "id": "ABMW0601RU19",
    "section": "法律事务/交通规则",
    "question": "如果司机使用自动变速器的车辆通过考试，他们被授权驾驶哪些车辆？",
    "options": [
      "许可证类别中的所有车辆，但仅限高速公路上的自动驾驶车辆。",
      "仅限牌照类别中的自动驾驶车辆。",
      "许可证类别中的所有车辆。",
      "仅限许可证类别中的手动车辆。"
    ],
    "correct_answer": 1,
    "explanation": "如果您在自动或改装车辆上通过驾驶考试，您的完整驾照仅适用于该类型的车辆。 限制为自动车辆的驾照将在驾照的限制/信息栏中标有代码78。",
    "image_name": ""
  },
  {
    "index": 45,
    "id": "ABMW0569R",
    "section": "法律事务/交通规则",
    "question": "L牌应该如何组成？",
    "options": [
      "一個紅色背景上的白色L",
      "一個白色背景上的綠色L",
      "一個白色背景上的紅色L",
      "一個透明背景上的紅色L"
    ],
    "correct_answer": 2,
    "explanation": "L牌应在前后展示。盘子应为白底红色 L，高度不小于 15 厘米，边框至少 2 厘米。摩托车学习者必须穿着黄色战袍，前后都有 L 牌照。白底 L 板高度不得低于 15 厘米。",
    "image_name": ""
  },
  {
    "index": 46,
    "id": "ABMW0586RU19",
    "section": "法律事务/交通规则",
    "question": "在公共场所使用车辆时是否需要展示有效的税票？",
    "options": [
      "是的，但不得超过前一个牌照过期后的10天",
      "否，只有老式车辆可以不显示税牌",
      "是的，但不得超过前一个牌照过期后的一个月",
      "否，所有机动车辆必须显示有效的税牌"
    ],
    "correct_answer": 3,
    "explanation": "机动车必须办理税务，并且必须在上路前展示最新的税务牌。",
    "image_name": ""
  },
  {
    "index": 47,
    "id": "ABMW0588RU19",
    "section": "法律事务/交通规则",
    "question": "如果一名驾驶员希望驾驶一辆车，但车辆税费已过期，他们应该怎么做？",
    "options": [
      "他们应该只在紧急情况下驾驶",
      "他们应该联系警方获得批准",
      "他们应该在到期后的10天内更新",
      "他们应该立即办理税费"
    ],
    "correct_answer": 3,
    "explanation": "机动车必须交税，并且必须在上路前展示最新的税务牌。",
    "image_name": ""
  },
  {
    "index": 48,
    "id": "ABMW0589RU19",
    "section": "法律事务/交通规则",
    "question": "如果一名驾驶员希望驾驶另一辆目前未缴税的车辆，他们可以将自己车辆上的当前税证转移到另一辆车上吗？",
    "options": [
      "绝不应该将车辆税票转移到另一辆车上",
      "只有在其他车辆暂时适用较低税率的情况下",
      "在适当填写并发送给当地机动车税务局表格的情况下",
      "是的，前提是他们自己的车辆同时没有在使用"
    ],
    "correct_answer": 0,
    "explanation": "机动车必须缴纳税款，并且必须在上路之前展示自己的当前税单。税单包括有关车辆的信息，包括其品牌和型号、颜色和注册号码。",
    "image_name": ""
  },
  {
    "index": 49,
    "id": "ABMW0590RU19",
    "section": "法律事务/交通规则",
    "question": "当车辆由非车主驾驶时，谁负责确保车辆缴纳税款并展示有效的车辆税收标识？",
    "options": [
      "司机是唯一负有责任的",
      "司机和/或车辆所有者负有责任",
      "车主是唯一负有责任的",
      "警察在这方面负有完全责任"
    ],
    "correct_answer": 1,
    "explanation": "如果您是车辆的所有者或驾驶员，您必须确保车辆已缴纳税款并在上路前展示最新的税务标牌。",
    "image_name": ""
  },
  {
    "index": 50,
    "id": "ABMW0591RU19",
    "section": "法律事务/交通规则",
    "question": "新车辆在公共道路上必须展示当前的税务证明牌是在什么时候？",
    "options": [
      "只有在高速公路上行驶时",
      "注册后不迟于10天内",
      "注册后不迟于1个月内",
      "车辆在公共道路上时始终如一"
    ],
    "correct_answer": 3,
    "explanation": "机动车必须在上路之前缴纳税款，并且必须始终展示最新的税标。",
    "image_name": ""
  },
  {
    "index": 51,
    "id": "ABMW0592RU23",
    "section": "法律事务/交通规则",
    "question": "谁有权查看驾驶员的车辆注册文件？",
    "options": [
      "任何涉及驾驶员碰撞事故的消防员或救护人员",
      "任何与司机发生碰撞的人",
      "警察可能会要求您在指定的警察局出示车辆登记文件",
      "汽车回收公司的成员或任何协助回收的人"
    ],
    "correct_answer": 2,
    "explanation": "警察随时可能要求查看您的驾驶执照，驾驶时您应随身携带。警察还可能检查您的保险证、税务证和NCT证（如果适用）。警察可能要求您在指定的警察局内提供其他文件（包括车辆登记文件），期限为10天。",
    "image_name": ""
  },
  {
    "index": 52,
    "id": "ABMW0593RU19",
    "section": "法律事务/交通规则",
    "question": "如果一辆汽车由非所有者驾驶，但得到所有者的同意，谁应该确保驾驶员有适当的保险？",
    "options": [
      "车辆所有者",
      "驾驶员和车辆所有者",
      "驾驶员",
      "保险公司"
    ],
    "correct_answer": 1,
    "explanation": "所有驾驶员必须有保险才能在公共道路上驾驶车辆。驾驶未投保的车辆是一种严重违法行为。允许未投保的驾驶员驾驶您名下的车辆也是违法行为。",
    "image_name": ""
  },
  {
    "index": 53,
    "id": "ABMW0594RU19",
    "section": "法律事务/交通规则",
    "question": "保险单到期后，驾驶员还可以继续驾驶他们的车辆吗？",
    "options": [
      "驾驶员保险到期后仍有10天保险",
      "驾驶员保险到期后仍有7天保险",
      "驾驶员保险到期后仍有14天保险",
      "驾驶员保险在到期后不再有效"
    ],
    "correct_answer": 3,
    "explanation": "所有驾驶员在公共道路上驾驶车辆时必须具备适用的保险。车辆必须展示最新的保险牌。",
    "image_name": ""
  },
  {
    "index": 54,
    "id": "ABMW0595RU19",
    "section": "法律事务/交通规则",
    "question": "如果一位驾驶员希望驾驶另一辆私人所有的车辆，但他们不确定是否有保险来驾驶该车辆，他们应该怎么办？",
    "options": [
      "将保险从自己的车辆转移到他们希望驾驶的车辆",
      "如果车辆有保险牌照，您就可以驾驶",
      "驾车者应联系保险公司，确认其保单是否涵盖其他车辆的驾驶",
      "如果您在 10 天内通知您的保险公司并同意支付任何额外费用，您就可以开车"
    ],
    "correct_answer": 2,
    "explanation": "如果您对保险范围有任何疑问，应该与您的保险公司讨论此事。未经保险驾驶属于严重违法行为。",
    "image_name": ""
  },
  {
    "index": 55,
    "id": "ABMW0596RU19",
    "section": "法律事务/交通规则",
    "question": "当驾驶员希望驾驶车辆但不确定是否有保险时，他们应该怎么做？",
    "options": [
      "他们应当在保险公司确认他们已经投保之前不应该驾驶",
      "他们应该与当地警察局核实是否已投保",
      "他们应该与当地NDLS办公室核实是否已投保",
      "他们应该与当地汽车税务局核实是否已投保"
    ],
    "correct_answer": 0,
    "explanation": "如果你对你的保险有任何疑问，你应该与你的保险公司讨论这个问题。驾驶没有保险是一项严重的违法行为。",
    "image_name": ""
  },
  {
    "index": 56,
    "id": "ABMW0597U19",
    "section": "法律事务/交通规则",
    "question": "在公共道路上驾驶，驾驶员需要的最低保险覆盖要求是什么？",
    "options": [
      "第三方责任险",
      "第三者责任险、车辆损失险和盗窃险",
      "人身意外伤害保险",
      "全险"
    ],
    "correct_answer": 0,
    "explanation": "作为驾驶员，您必须至少拥有第三方保险。",
    "image_name": ""
  },
  {
    "index": 57,
    "id": "ABMW0781RU19",
    "section": "法律事务/交通规则",
    "question": "驾驶员在哪里可以找到车辆的最大授权质量（MAM）？",
    "options": [
      "在NCT圆盘上",
      "在保险圆盘上",
      "在车辆上的金属板上",
      "在税收圆盘上"
    ],
    "correct_answer": 2,
    "explanation": "通常，显示车辆最大授权质量（MAM）的牌照通常位于引擎盖下方或乘客车厢内。如果您不确定它位于车辆的哪个位置，请查阅所提供的驾驶员手册。",
    "image_name": ""
  },
  {
    "index": 58,
    "id": "ABMW0189RU19",
    "section": "法律事务/交通规则",
    "question": "司机可以停车的地方在哪里？",
    "options": [
      "司机未阻碍其他道路使用者看到交通信号或前方道路的情况",
      "在道路工程现场",
      "在道路中央有一条连续的白色线的地方",
      "在人行道上"
    ],
    "correct_answer": 0,
    "explanation": "在道路两侧有单条或双条连续白线的地方停车是一种违法行为。在这样的道路上停车可能会造成阻碍，并对其他道路使用者造成不便或危险。",
    "image_name": ""
  },
  {
    "index": 59,
    "id": "ABMW0190RU19",
    "section": "法律事务/交通规则",
    "question": "泽布拉过街处前禁止停车的距离是多少？",
    "options": [
      "15 米",
      "5 米",
      "20 米",
      "10 米"
    ],
    "correct_answer": 0,
    "explanation": "停车15米前或者5米后人行横道是违法行为。以这种方式停车可能会限制接近人行横道的驾驶员的视野区域，并危及行人的安全。",
    "image_name": ""
  },
  {
    "index": 60,
    "id": "ABMW0191RU19",
    "section": "法律事务/交通规则",
    "question": "停车禁止的距离在路口内多远？",
    "options": [
      "20米，除非停车位明确标记",
      "10米，除非停车位明确标记",
      "5米，除非停车位明确标记",
      "15米，除非停车位明确标记"
    ],
    "correct_answer": 2,
    "explanation": "在距离路口5米以内停车是违法行为，除非停车位有明确标记。在该区域停车可能会限制驶向路口的驾驶员的视野范围，并可能会对希望转弯的大型车辆造成阻碍。",
    "image_name": ""
  },
  {
    "index": 61,
    "id": "ABMW0193RU19",
    "section": "法律事务/交通规则",
    "question": "司机可以停车在进入物业的入口处吗？",
    "options": [
      "是的，在23:30至07:00间的1小时",
      "是的，需得到物业所有者的同意",
      "是的，在07:00至23:30间的1小时",
      "是的，在营业时间外"
    ],
    "correct_answer": 1,
    "explanation": "只有在业主同意的情况下，您才可以停在产业入口处。在入口处停车可能给进出产业的人员带来不便和危险。",
    "image_name": ""
  },
  {
    "index": 62,
    "id": "ABMW0194RU19",
    "section": "法律事务/交通规则",
    "question": "在何时可以在人行道上停车？",
    "options": [
      "当至少一半的人行道仍保留给行人时",
      "当汽车停在道路两侧时",
      "当不超过一半的车辆停在人行道上时",
      "切勿将车停在人行道上"
    ],
    "correct_answer": 3,
    "explanation": "在人行道上停车是违法行为。如果一辆车停在人行道上，行人可能不得不走上马路绕过车辆，从而置自己于危险之中。",
    "image_name": ""
  },
  {
    "index": 63,
    "id": "ABMW0195RU19",
    "section": "法律事务/交通规则",
    "question": "双车道停车什么时候允许？",
    "options": [
      "当出现双白线时",
      "当出现双黄线时",
      "当遇到路肩时",
      "从来不允许"
    ],
    "correct_answer": 3,
    "explanation": "绝对不允许在双车道停车。严禁在可能干扰正常交通、阻塞或危及其他道路使用者的地方停车。",
    "image_name": ""
  },
  {
    "index": 64,
    "id": "ABMW0196RU19",
    "section": "法律事务/交通规则",
    "question": "出租车站点准许停车的时间是什么时候？",
    "options": [
      "等待接送乘客时",
      "停放不超过15分钟时",
      "出租车站点无人驻留时",
      "除非驾驶出租车，否则禁止在出租车站点停放"
    ],
    "correct_answer": 3,
    "explanation": "禁止在标有出租车停靠标记的区域停车或泊车，因为这可能会阻碍出租车进出停车区。",
    "image_name": ""
  },
  {
    "index": 65,
    "id": "ABMW0197RU19",
    "section": "法律事务/交通规则",
    "question": "停车场是在急转弯处允许停车的吗？",
    "options": [
      "在急弯处禁止停车",
      "只有在距路缘或道路边缘不超过45厘米时才能停车",
      "只有当后方来车能看到停放的车辆时才能停车",
      "只有当停放车辆的危险警示灯打开时才能停车"
    ],
    "correct_answer": 0,
    "explanation": "永远不得停车，如果可能干扰交通的正常流动，或者阻碍或危及其他道路使用者，例如迫使其他驾驶员进入迎面而来的交通流。",
    "image_name": ""
  },
  {
    "index": 66,
    "id": "ABMW0198RU19",
    "section": "法律事务/交通规则",
    "question": "在山顶处可以停车吗？",
    "options": [
      "当驾驶员将车轮转向路缘时。",
      "仅当道路上没有车辆时。",
      "当车辆具有有效的手刹时，才允许停车。",
      "山坡上绝对不允许停车。"
    ],
    "correct_answer": 3,
    "explanation": "在山丘的顶部或驼峰桥上停车是被禁止的。在这样的地方停车可能会限制接近山丘的司机的视野范围，并迫使他们进入对面车流的道路。",
    "image_name": ""
  },
  {
    "index": 67,
    "id": "ABMW0251",
    "section": "法律事务/交通规则",
    "question": "哪辆车停错了？",
    "options": [
      "红车",
      "都不是车",
      "两辆车",
      "绿车"
    ],
    "correct_answer": 2,
    "explanation": "在行人穿越道前15米或后5米停车是违法行为。这样停车可能会限制驶向穿越道的驾驶员的视野范围，危及行人安全。",
    "image_name": "ABMW0251.png"
  },
  {
    "index": 68,
    "id": "ABMW0001U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "司机必须停下来让学校横穿的学生通过",
      "司机必须给右侧来车让行",
      "司机必须停车"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌出現在次要道路與主要道路相交的路口。您必須在停車標誌處完全停下您的車輛。",
    "image_name": "ABMW0001.png"
  },
  {
    "index": 69,
    "id": "ABMW0002R23",
    "section": "法律事务/交通规则",
    "question": "当路上有这个标志并伴随着一条白色停车线时，驾驶员必须做什么？",
    "options": [
      "停在线外",
      "只有当看到交通接近时，停在线上",
      "仅当您看到有车辆驶近时才在排队处停车。"
    ],
    "correct_answer": 1,
    "explanation": "当带有停车标志时，白色停车线指示您必须停车的地点。",
    "image_name": "ABMW0001.png"
  },
  {
    "index": 70,
    "id": "ABMW0003R",
    "section": "法律事务/交通规则",
    "question": "当道路上的这个标志没有白色停车线时，司机必须做什么？",
    "options": [
      "过了标志就停下来。",
      "停在路标后面不超过一辆车的距离。",
      "停在标志处。",
      "仅当主要道路上有交通时才停车。"
    ],
    "correct_answer": 2,
    "explanation": "在没有白色停止线的情况下，您必须在标志处停止。",
    "image_name": "ABMW0001.png"
  },
  {
    "index": 71,
    "id": "ABMW0004R",
    "section": "法律事务/交通规则",
    "question": "在交叉口，这个标志是什么意思？",
    "options": [
      "让来自右侧的交通通过",
      "允许所有重型货车通过",
      "减速并给行人让路",
      "允许主要道路上的车辆通过"
    ],
    "correct_answer": 3,
    "explanation": "在十字路口，让行标志告诉你必须给予前方主干道的车辆让路。这意味着你必须放慢速度并做好随时停车的准备。",
    "image_name": "ABMW0004R.png"
  },
  {
    "index": 72,
    "id": "ABMW0005RU19",
    "section": "法律事务/交通规则",
    "question": "在环形交叉路口，这个标志是什么意思？",
    "options": [
      "给行驶过来的交通让路，或者已经在环形交叉处行驶的车辆",
      "给公交车和卡车让路",
      "给左侧行驶的车辆让路",
      "只给自行车手和摩托车手让路"
    ],
    "correct_answer": 0,
    "explanation": "在环形交叉路口，让行标志告诉您必须减速并做好停车准备。您必须给予环形交叉路口内或右侧即将驶入的车辆让行。",
    "image_name": "ABMW0004R.png"
  },
  {
    "index": 73,
    "id": "ABMW0006R23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "直行",
      "限高",
      "高速公路"
    ],
    "correct_answer": 0,
    "explanation": "这个标志告诉您必须直行。这个标志通常显示在单行道的入口处。",
    "image_name": "ABMW0006R.png"
  },
  {
    "index": 74,
    "id": "ABMW0007",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "右侧有交通优先通行",
      "左侧行驶的高速公路",
      "只能左转",
      "前方左转绕行"
    ],
    "correct_answer": 2,
    "explanation": "这个标志告诉你必须左转。通常显示在所有车辆必须左转的交叉路口 例如，在包含交叉路口的单向系统中。",
    "image_name": "ABMW0007.png"
  },
  {
    "index": 75,
    "id": "ABMW0008U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "转弯提醒，向右转",
      "主干道从左侧汇入",
      "仅允许右转",
      "只可在右侧超车"
    ],
    "correct_answer": 2,
    "explanation": "这个标志告诉您必须右转。通常出现在所有车辆必须右转的路口处 例如，在一个包含路口的单行道系统中。",
    "image_name": "ABMW0008U19.png"
  },
  {
    "index": 76,
    "id": "ABMW0009R",
    "section": "法律事务/交通规则",
    "question": "这个标志代表什么？",
    "options": [
      "左侧行驶",
      "向左转",
      "前方有急转弯",
      "前方有左转弯绕行"
    ],
    "correct_answer": 1,
    "explanation": "这个标志告诉您必须在前方左转。通常显示在进入单行道系统前。",
    "image_name": "ABMW0009R.png"
  },
  {
    "index": 77,
    "id": "ABMW0010U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "右侧单行道",
      "您必须向右转",
      "右侧有绕行路线",
      "前方有急转弯"
    ],
    "correct_answer": 1,
    "explanation": "这个标志告诉你必须右转。通常显示为接近单向系统。",
    "image_name": "ABMW0010U19.png"
  },
  {
    "index": 78,
    "id": "ABMW0011RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "请向左超车",
      "左侧有陡坡",
      "靠左行驶"
    ],
    "correct_answer": 2,
    "explanation": "这个标志告诉您必须靠左行驶。通常显示在道路中心的交通岛上，有时也用于控制道路施工交通。",
    "image_name": "ABMW0011RU19.png"
  },
  {
    "index": 79,
    "id": "ABMW0012RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "交通从左侧穿过。",
      "靠右。",
      "从左开始急剧下降。"
    ],
    "correct_answer": 1,
    "explanation": "这个标志告诉你必须靠右行驶。通常出现在单行道系统中，要求交通靠右行驶，并有时在道路施工地点控制交通时使用。",
    "image_name": "ABMW0012RU19.png"
  },
  {
    "index": 80,
    "id": "ABMW0013U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "可以通过任一侧",
      "前方有双向交通",
      "前方有双车道",
      "单行道"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌告訴您交通可以在交通島的兩側通行。",
    "image_name": "ABMW0013U19.png"
  },
  {
    "index": 81,
    "id": "ABMW0014RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方是死胡同",
      "前方没有高度限制",
      "前方禁止通行"
    ],
    "correct_answer": 2,
    "explanation": "这个标志告诉您不能朝箭头方向前行。这是为了防止交通朝错误的方向行驶，比如逆向驶入单行道。",
    "image_name": "ABMW0014RU19.png"
  },
  {
    "index": 82,
    "id": "ABMW0015RU23",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "禁止右转",
      "只能右转",
      "右侧为死胡同"
    ],
    "correct_answer": 0,
    "explanation": "在你不能右转的路口处展示这个标志。",
    "image_name": "ABMW0015R.png"
  },
  {
    "index": 83,
    "id": "ABMW0016RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "右转",
      "前方有危险的右弯路",
      "禁止右转"
    ],
    "correct_answer": 2,
    "explanation": "在一个十字路口，您不能右转时，这个标志会显示。",
    "image_name": "ABMW0015R.png"
  },
  {
    "index": 84,
    "id": "ABMW0017RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "只能右转",
      "禁止左转",
      "禁止右转"
    ],
    "correct_answer": 1,
    "explanation": "在一个十字路口处展示着这个标志，您不得向左转。",
    "image_name": "ABMW0017RU19.png"
  },
  {
    "index": 85,
    "id": "ABMW0018RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "禁止双向交通",
      "禁止进入隧道",
      "禁止掉头",
      "禁止倒车"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌告訴您禁止掉頭。這通常在雙向快車道交匯處標示。司机還應該注意，任何有連續的中央白線或單向街道的地方也是禁止掉頭的。",
    "image_name": "ABMW0018RU19.png"
  },
  {
    "index": 86,
    "id": "ABMW0019U23",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "最高速度为30km/h",
      "最低速度为30km/h",
      "速度限制持续30公里"
    ],
    "correct_answer": 0,
    "explanation": "这个标志告诉你，这段道路的最高法定时速限制是30km/h。这些标志通常在居民区的慢行区域中找到。",
    "image_name": "ABMW0019U19.png"
  },
  {
    "index": 87,
    "id": "ABMW0020U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "速限保持50公里",
      "最高速度为50km/h",
      "最低速度为50km/h"
    ],
    "correct_answer": 1,
    "explanation": "這個標誌告訴您，此路段允許的最高法定速限為50公里/小時。",
    "image_name": "ABMW0020U19.png"
  },
  {
    "index": 88,
    "id": "ABMW0021U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "最低车速为60km/h",
      "最高车速为60km/h",
      "速度限制持续60米"
    ],
    "correct_answer": 1,
    "explanation": "此标识告诉您，该路段允许的最高法定车速限制为60km/h。",
    "image_name": "ABMW0021U19.png"
  },
  {
    "index": 89,
    "id": "ABMW0022RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "速度限制持续80米",
      "最高速度为80km/h",
      "最低速度为80km/h"
    ],
    "correct_answer": 1,
    "explanation": "这个路标告诉您，这段道路的最高法定时速限速为80km/h。",
    "image_name": "ABMW0022RU19.png"
  },
  {
    "index": 90,
    "id": "ABMW0023U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "最高时速为100km/h",
      "最低时速为100km/h",
      "限速持续100米"
    ],
    "correct_answer": 0,
    "explanation": "这个标志告诉您，这段道路的最高法定速度限制是100km/h。",
    "image_name": "ABMW0023U19.png"
  },
  {
    "index": 91,
    "id": "ABMW0024U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "120米处的交通合流",
      "最高时速为120km/h",
      "最低时速为120km/h"
    ],
    "correct_answer": 1,
    "explanation": "这个标志告诉您，这段道路的最高法定限速为120km/h。",
    "image_name": "ABMW0024U19.png"
  },
  {
    "index": 92,
    "id": "ABMW0025U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "允许停车时间显示",
      "禁止停车时间显示",
      "在所示时间内最长停车一小时"
    ],
    "correct_answer": 0,
    "explanation": "这些标志告诉您，停车可以双向进行，但仅在信息牌上显示的时间。",
    "image_name": "ABMW0025U19.png"
  },
  {
    "index": 93,
    "id": "ABMW0026U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "仅限公共服务车辆停车",
      "仅限私人车辆停车",
      "禁止停车"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌告訴您，雙向停車是禁止的。",
    "image_name": "ABMW0026.png"
  },
  {
    "index": 94,
    "id": "ABMW0027U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "清场 在所示时间内禁止停车",
      "封闭道路 在所示时间关闭",
      "行人专用街道 车辆禁止通行"
    ],
    "correct_answer": 0,
    "explanation": "“清解道路”标示意味着在信息牌上显示的时间内，禁止在此区域停车或泊车。",
    "image_name": "ABMW0027U19.png"
  },
  {
    "index": 95,
    "id": "ABMW0028U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "无需停放牌照的情况下允许停车的时间段",
      "停车牌照在指定时间段内有效",
      "除非在指定时间段内，否则需要使用停车牌照",
      "在指定时间段内禁止停车"
    ],
    "correct_answer": 1,
    "explanation": "这个标志告诉您，车辆必须在信息牌显示的小时停放时展示停车盘。",
    "image_name": "ABMW0028U19.png"
  },
  {
    "index": 96,
    "id": "ABMW0029RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "私人车辆可以接送乘客",
      "当出租车车位空时，允许私人停车",
      "出租车指定停放位置",
      "只有出租车可以向右或向左转弯"
    ],
    "correct_answer": 2,
    "explanation": "出租车停靠标志表示这是专供出租车停靠的区域，其他道路使用者不得停车或停留。",
    "image_name": "ABMW0029RU19.png"
  },
  {
    "index": 97,
    "id": "ABMW0030U19",
    "section": "法律事务/交通规则",
    "question": "这个标志代表什么？",
    "options": [
      "給摩托車騎手專用的跑道",
      "自行車手必須提前下車",
      "自行車比賽跑道",
      "自行車道的開始"
    ],
    "correct_answer": 3,
    "explanation": "這個標誌表示自行車道的開始。如果該道路由間隔的白色虛線界定，其他道路使用者應盡量避免使用它。如果該道路由連續的白色實線界定，汽車和其他車輛的駕駛員不能行駛在上面。",
    "image_name": "ABMW0030U19.png"
  },
  {
    "index": 98,
    "id": "ABMW0033RU19",
    "section": "法律事务/交通规则",
    "question": "这些标志一起是什么意思？",
    "options": [
      "只准巴士和出租车通行，限定时段内",
      "限定时段内禁止停车",
      "前方为清行区，限定时段内禁止停车",
      "前方为步行街，除指定时段外禁止车辆通行"
    ],
    "correct_answer": 3,
    "explanation": "这两个标志放在一起告诉您前方是步行街，交通不允许进入，除非在信息牌上注明的时间。",
    "image_name": "ABMW0033RU19.png"
  },
  {
    "index": 99,
    "id": "ABMW0034U19",
    "section": "法律事务/交通规则",
    "question": "這個標誌的意思是什麼？",
    "options": [
      "三轴车辆不允许",
      "最低允许重量为3吨",
      "最高允许重量为3吨",
      "只有三轴车辆允许"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌告訴您，如果您的車輛超過3噸或3,000公斤，則不能進入此區域。",
    "image_name": "ABMW0034U19.png"
  },
  {
    "index": 100,
    "id": "ABMW0039U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "雙重停車不允許",
      "右側禁止停車",
      "雙向通道結束",
      "禁止超車"
    ],
    "correct_answer": 3,
    "explanation": "這個標誌告訴您禁止超車。這些標誌通常出現在超車可能危險的地方，例如能見度降低的地區。",
    "image_name": "ABMW0039U19.png"
  },
  {
    "index": 101,
    "id": "ABMW0040RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "只有在指定时间内才允许公交车和自行车停放",
      "只有自行车和公交车可在指定时间使用该车道",
      "只有公交车、自行车和出租车可在指定时间使用前方车道",
      "只有在指定时间外，公交车、自行车和出租车可使用该车道"
    ],
    "correct_answer": 2,
    "explanation": "此标志告诉您，前方将有一条与交通方向相同的顺向靠路公交专用车道，即公交车与其右侧交通同向行驶。信息牌告诉您公交专用车道的运营时间。在这些时间内，只有公交车、出租车和骑自行车的人可以使用该公交专用车道。",
    "image_name": "ABMW0040RU19.png"
  },
  {
    "index": 102,
    "id": "ABMW0041RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "只有双层巴士和骑自行车的人可以使用车道",
      "只有巴士和骑自行车的人可以停车",
      "左前方有与车流方向一致的专用公交车和自行车车道",
      "骑自行车的人和乘坐公交车的人必须左转"
    ],
    "correct_answer": 2,
    "explanation": "这个标志告诉您，在左侧前方有一条沿向近侧巴士专用道。只有在规定营运时间内，巴士、出租车和骑自行车的人可以使用巴士专用道。",
    "image_name": "ABMW0041RU19.png"
  },
  {
    "index": 103,
    "id": "ABMW0042RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "左侧停放巴士和自行车",
      "左侧带流动的巴士和自行车道",
      "只有巴士可以穿过左侧的自行车道"
    ],
    "correct_answer": 1,
    "explanation": "這個標誌指示左側有一條帶流動巴士專用車道。在指定的運營時間內，只有巴士、出租車和騎自行車的人可以使用巴士專用車道。",
    "image_name": "ABMW0042RU19.png"
  },
  {
    "index": 104,
    "id": "ABMW0043RU19",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "公共汽车必须让前方其他交通通行",
      "自行车必须让前方的公共汽车通行",
      "公共汽车必须让前方的自行车通行",
      "右侧有公共汽车和自行车专用车道"
    ],
    "correct_answer": 3,
    "explanation": "此标志告诉您前方右侧有一个隔离型公交专用车道。只有公交车、出租车和骑自行车的人在规定的运营时间内可以使用该公交专用车道。",
    "image_name": "ABMW0043RU19.png"
  },
  {
    "index": 105,
    "id": "ABMWO0044RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有逆向行驶的专用公交车道",
      "公交车可能会挡住驾驶员看到骑自行车的视线",
      "左侧有顺向行驶的公交车道",
      "右侧有顺向行驶的公交车道"
    ],
    "correct_answer": 3,
    "explanation": "此标志表示在右侧有一个与流向一致的线外公交车道。只有在规定的运营时间内，公交车、出租车和骑自行车的人才可以使用公交车道。",
    "image_name": "ABMW0044RAU19.png"
  },
  {
    "index": 106,
    "id": "ABMW0045RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "自行车道可能会被公共汽车横穿",
      "右侧与车流方向一致的公共汽车专用车道",
      "右侧的逆向行驶公共汽车专用车道",
      "从右侧驶出的公共汽车"
    ],
    "correct_answer": 2,
    "explanation": "这个标志告诉您必须靠左行驶，白天或夜晚不得使用逆向专用公交车道。逆向专用公交车道是指公交车朝相反方向行驶的车道。",
    "image_name": "ABMW0045RU19.png"
  },
  {
    "index": 107,
    "id": "ABMW0046U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "雙向交通系統",
      "逆向專用巴士車道",
      "僅限雙層巴士",
      "順向專用巴士車道"
    ],
    "correct_answer": 1,
    "explanation": "这个标志告诉您必须靠左行驶，白天或晚上不得使用逆向专用公交车道。逆向专用公交车道是指车辆行驶方向与公交车相反的车道。",
    "image_name": "ABMW0045RU19.png"
  },
  {
    "index": 108,
    "id": "ABMWOO50RAU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "右侧电车道",
      "只能停放在白线内",
      "左侧电车道",
      "前方有顺向公交车道"
    ],
    "correct_answer": 0,
    "explanation": "这个标志告诉您右侧有离车道。驾驶员还应注意该区域可能有行人。",
    "image_name": "ABMW0050RAU19.png"
  },
  {
    "index": 109,
    "id": "ABMW0109RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "驶入高速公路",
      "高速公路尽头",
      "前方有桥梁"
    ],
    "correct_answer": 0,
    "explanation": "这个路标告知道路使用者即将驶入高速公路，并必须遵守高速公路规则。在驶入高速公路之前，道路使用者必须熟悉高速公路规则。",
    "image_name": "ABMW0109RU19.png"
  },
  {
    "index": 110,
    "id": "ABMW0110U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "距离低桥还有500米",
      "距离桥梁维修处还有500米",
      "禁止500米内超车",
      "距离高速公路尽头还有500米"
    ],
    "correct_answer": 3,
    "explanation": "這是一個高速公路信息牌，告訴您高速公路將在500米後結束。高速公路的規則將不再適用，例如可能會有較低的速限。",
    "image_name": "ABMW0110U19.png"
  },
  {
    "index": 111,
    "id": "ABMW0111RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "高速公路尽头",
      "前方无桥",
      "天桥区域结束",
      "禁止超车"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌表示高速公路的終點。您正在離開高速公路，其規則將不再適用。",
    "image_name": "ABMW0111RU19.png"
  },
  {
    "index": 112,
    "id": "ABMW0112RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "三百公尺到达下一个出口",
      "前方有交叉车流",
      "前方三条车道"
    ],
    "correct_answer": 0,
    "explanation": "这是一块高速公路信息标示牌，告诉您高速公路的下一个出口在300米之后。",
    "image_name": "ABMW0112R.png"
  },
  {
    "index": 113,
    "id": "ABMW0113R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有雙向行駛的快速道路交叉口",
      "200米內禁止超車",
      "200米後有急坡",
      "距下一出口200米"
    ],
    "correct_answer": 3,
    "explanation": "這是一個高速公路信息牌，告訴您高速公路的下一個出口在200米以後。",
    "image_name": "ABMW0113R.png"
  },
  {
    "index": 114,
    "id": "ABMW0114RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方低桥",
      "接下来有100米急坡",
      "距下一个出口100米"
    ],
    "correct_answer": 2,
    "explanation": "這是一個高速公路信息標誌，告訴您高速公路下一個出口就在100米前方。",
    "image_name": "ABMW0114R.png"
  },
  {
    "index": 115,
    "id": "ABMW0132RU23",
    "section": "法律事务/交通规则",
    "question": "在路面工程中，这个标志表示什么？",
    "options": [
      "谨慎前行",
      "只有在示意下才前行",
      "只使用手势前行"
    ],
    "correct_answer": 0,
    "explanation": "这个交通控制标志告诉您在道路工程中可以小心前行。",
    "image_name": "ABMW0132RU19.png"
  },
  {
    "index": 116,
    "id": "ABMW0133RU23",
    "section": "法律事务/交通规则",
    "question": "在施工路段，这个标志是什么意思？",
    "options": [
      "在校园警卫处停车",
      "仅在面对对向车辆时停车",
      "在标志前或标志处停车"
    ],
    "correct_answer": 2,
    "explanation": "這個在道路工程中的交通控制標誌意味著你必須停車。",
    "image_name": "ABMW0133RU19.png"
  },
  {
    "index": 117,
    "id": "ABMW3U19",
    "section": "法律事务/交通规则",
    "question": "這個標誌在接近收費站時顯示代表什麼？",
    "options": [
      "收费员操作车道",
      "向左是警察检查站",
      "前方有服务站",
      "此车道关闭 请靠左行驶"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌用於在收費站引導交通進入一條車道，車費可以直接支付給收費員。這條車道通常由那些既沒有準確的零錢，也沒有車輛上的電子標籤的駕駛員使用。",
    "image_name": "ABMW3U19.png"
  },
  {
    "index": 118,
    "id": "ABMW4U19",
    "section": "法律事务/交通规则",
    "question": "这个标志在驶向收费站时显示代表什么？",
    "options": [
      "在本车道中硬币篮",
      "在本车道中发票分发机",
      "在本车道中收费员",
      "电子收费系统"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌用於引導車輛進入收費站，可以通過將準確的零錢放入自動硬幣機來支付通行費。這條車道通常會安裝高度障礙，以防止大型車輛使用。",
    "image_name": "ABMW4U19.png"
  },
  {
    "index": 119,
    "id": "ABMW5U19",
    "section": "法律事务/交通规则",
    "question": "当出现在通往收费站的路口时，这个标志是什么意思？",
    "options": [
      "任何车道均接受电子通行费",
      "此车道不接受电子通行费",
      "此车道仅接受欧元支付",
      "此车道的电子通行费系统故障"
    ],
    "correct_answer": 0,
    "explanation": "这个标志用于在收费站引导交通进入一个车道，通过该车道可以实现电子收费。当车辆通过收费站时，通过安装在前挡风玻璃上的电子标签来识别车辆。支付将通过用户的账户进行。只有安装了标签的车辆才能使用这些车道。",
    "image_name": "ABMW5U19.png"
  },
  {
    "index": 120,
    "id": "ABMW0183U23",
    "section": "法律事务/交通规则",
    "question": "汽车和摩托车在高速公路上允许的最高速度是多少？",
    "options": [
      "120 km/h",
      "80 km/h",
      "60 km/h",
      "100 km/h"
    ],
    "correct_answer": 0,
    "explanation": "在高速公路上驾驶时超速120km/h是违法的。",
    "image_name": ""
  },
  {
    "index": 121,
    "id": "ABMW0184RU23",
    "section": "法律事务/交通规则",
    "question": "除非另有指示，汽车或摩托车在国道上的最高允许速度是多少？",
    "options": [
      "120 km/h",
      "60 km/h",
      "80 km/h",
      "100 km/h"
    ],
    "correct_answer": 3,
    "explanation": "在单行道国道驾驶时超过100km/h是违法的。",
    "image_name": ""
  },
  {
    "index": 122,
    "id": "ABMW0185RU23",
    "section": "法律事务/交通规则",
    "question": "除非另有指示，牵引旅行拖车在国道上的最高允许车速是多少？",
    "options": [
      "100 km/h",
      "60 km/h",
      "120 km/h",
      "80 km/h"
    ],
    "correct_answer": 3,
    "explanation": "在国道上拖曳房车时，超过80公里每小时是违法的 过高的速度会使这种车辆不稳定。",
    "image_name": ""
  },
  {
    "index": 123,
    "id": "ABMW0186U23",
    "section": "法律事务/交通规则",
    "question": "除非另有指示，拖曳房车在高速公路上的最高限速是多少？",
    "options": [
      "100 km/h",
      "90 km/h",
      "80 km/h",
      "120 km/h"
    ],
    "correct_answer": 2,
    "explanation": "在高速公路上拖曳房车超过80km/h是非法的 过快的速度会使这样的车辆不稳定。",
    "image_name": ""
  },
  {
    "index": 124,
    "id": "ABMW0187U23",
    "section": "法律事务/交通规则",
    "question": "除非另有指示，汽车在国道上拖曳挂车的最高允许速度是多少？",
    "options": [
      "100 km/h",
      "60 km/h",
      "120 km/h",
      "80 km/h"
    ],
    "correct_answer": 3,
    "explanation": "在国道上拖曳拖车时，超过80km/h是违法的 超过这个速度会使车辆不稳定。",
    "image_name": ""
  },
  {
    "index": 125,
    "id": "ABMW0188U23",
    "section": "法律事务/交通规则",
    "question": "除非另有标示，拖曳拖车的汽车在高速公路上的最高允许速度是多少？",
    "options": [
      "100 km/h",
      "60 km/h",
      "120 km/h",
      "80 km/h"
    ],
    "correct_answer": 3,
    "explanation": "在高速公路上拖曳拖车时，超过80km/h是非法的 过高的速度会使这种车辆不稳定。",
    "image_name": ""
  },
  {
    "index": 126,
    "id": "ABMW0221RU19",
    "section": "法律事务/交通规则",
    "question": "暫時性速限在哪些道路工程時適用？",
    "options": [
      "只在营业时间内",
      "只有在道路工人在现场时",
      "只有在有对向车流时",
      "只在施工期间"
    ],
    "correct_answer": 3,
    "explanation": "在道路工程期间，临时速度限制适用。当道路工程完成时，恢复正常速度限制。",
    "image_name": ""
  },
  {
    "index": 127,
    "id": "ABMW0739R",
    "section": "法律事务/交通规则",
    "question": "在紧急情况下使用时,哪种车辆可以豁免速度限制？",
    "options": [
      "山区救援",
      "故障拖车服务",
      "医生上门",
      "消防队"
    ],
    "correct_answer": 3,
    "explanation": "在履行职责时，警察、消防队和救护人员豁免于一些交通法规，包括限速，只要不会危及其他道路使用者安全。如果听到或看到警察或急救车辆处于紧急情况下接近，应格外小心并让路，如果情况允许的话。",
    "image_name": ""
  },
  {
    "index": 128,
    "id": "ABMW33",
    "section": "法律事务/交通规则",
    "question": "在紧急情况下使用时，哪种车辆可以豁免限速？",
    "options": [
      "山区救援",
      "救护车",
      "故障拖车",
      "值班医生"
    ],
    "correct_answer": 1,
    "explanation": "在执行职务时，警察、消防队和救护人员在某些交通法规，包括速限方面享有豁免权，只要不将其他道路使用者置于危险之中。如果听到或看到警察或应急车辆在紧急情况下接近，请特别小心让路，如果情况允许的话。",
    "image_name": ""
  },
  {
    "index": 129,
    "id": "ABMW34",
    "section": "法律事务/交通规则",
    "question": "在紧急情况下使用时哪种车辆可以豁免速度限制？",
    "options": [
      "警察",
      "山岳救援",
      "故障拖车服务",
      "值班医生"
    ],
    "correct_answer": 0,
    "explanation": "在执行职责时，警察、消防队和救护人员可以豁免一些交通法规，包括速度限制，前提是不会危及其他道路使用者的安全。如果你听到或看到警察或紧急车辆以紧急状态接近，请特别小心并让路，如果情况允许的话。",
    "image_name": ""
  },
  {
    "index": 130,
    "id": "ABMW0038U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "不允许超越所示重量的其他车辆",
      "不允许停放低于所示重量的车辆",
      "禁止停车在装载区",
      "不允许停放超过所示重量的车辆"
    ],
    "correct_answer": 3,
    "explanation": "這個標誌告訴您，如果您的車輛超過所示的重量限制，則不能在這個區域停車。",
    "image_name": "ABMW0038U19.png"
  },
  {
    "index": 131,
    "id": "ABMW0157RU23",
    "section": "法律事务/交通规则",
    "question": "这个道路标线表示什么？",
    "options": [
      "行人岛",
      "交通缓行措施",
      "斑马线"
    ],
    "correct_answer": 2,
    "explanation": "斑马线是指定供行人穿越道路的区域。作为司机，您必须始终让步给在斑马线上的行人。",
    "image_name": "ABMW0157R.png"
  },
  {
    "index": 132,
    "id": "ABMW0158R",
    "section": "法律事务/交通规则",
    "question": "这个道路标线表示什么？",
    "options": [
      "斑马线",
      "禁止通行",
      "减速带",
      "信号灯控制人行横道"
    ],
    "correct_answer": 0,
    "explanation": "斑马线是供行人横穿马路的指定区域。作为驾驶员，您必须始终让斑马线上的行人先行。",
    "image_name": "ABMW0157R.png"
  },
  {
    "index": 133,
    "id": "ABMW0159R",
    "section": "法律事务/交通规则",
    "question": "这个路标代表什么意思？",
    "options": [
      "只能停靠区",
      "在这个区域可以超车",
      "路面不平坦",
      "禁止在此停车"
    ],
    "correct_answer": 3,
    "explanation": "白色斜线表示您正接近一个人行横道。您不能在此区域停车或超车。",
    "image_name": "ABMW0159R.png"
  },
  {
    "index": 134,
    "id": "ABMW0160U19",
    "section": "法律事务/交通规则",
    "question": "这个路标代表什么意思？",
    "options": [
      "当车辆从左右进入方形路口时，除非直行，否则它拥有通行权",
      "进入街区交叉路口的交通可能优先于来自右侧和左侧的交通",
      "出租车下客区",
      "仅当您能够在不停车的情况下通过街区交叉路口或右转时，车辆才能进入"
    ],
    "correct_answer": 3,
    "explanation": "除非您可以不停车通过黄色方块区域，或者您正要右转但被对向交通阻挡，否则不得进入黄色方块区域。",
    "image_name": "ABMW0160U19.png"
  },
  {
    "index": 135,
    "id": "ABMW0161U19",
    "section": "法律事务/交通规则",
    "question": "这个道路标线代表什么意思？",
    "options": [
      "司机可以超车",
      "所有交通必须保持在白线的左侧",
      "前方道路变窄",
      "司机正要接近一个停车标志"
    ],
    "correct_answer": 1,
    "explanation": "在路中央有一条连续的白线时，您不得：1.跨越或越过白线；2.超车；3.执行掉头；或4.在路上停车。",
    "image_name": "ABMW0161U19.png"
  },
  {
    "index": 136,
    "id": "ABMW0163RU19",
    "section": "法律事务/交通规则",
    "question": "这个路标和信息牌一起代表什么？",
    "options": [
      "仅限出租车在指定时间和日期停车",
      "仅限在未显示的时间和日期停车",
      "仅在指定时间和日期停车",
      "禁止在指定时间和日期停车"
    ],
    "correct_answer": 3,
    "explanation": "路边沿着一条单黄线表示您在伴随的信息牌上显示的时间内不能停车。",
    "image_name": "ABMW0163RU19.png"
  },
  {
    "index": 137,
    "id": "ABMW0164R",
    "section": "法律事务/交通规则",
    "question": "这个路标和信息牌一起代表什么？",
    "options": [
      "指定时间停车区",
      "任何时间禁止停车",
      "指定时间出租车上客区",
      "指定时间禁止停车"
    ],
    "correct_answer": 3,
    "explanation": "路边有单黄线意味着您在附带信息牌上显示的时间内不能停车。",
    "image_name": "ABMW0164R.png"
  },
  {
    "index": 138,
    "id": "ABMW0165R",
    "section": "法律事务/交通规则",
    "question": "这个路标代表什么意思？",
    "options": [
      "司机必须不穿越破损的白线，除非情况安全",
      "司机可以超车，前提是不穿越破损的白线",
      "司机不得沿此路停车",
      "司机不得在此路上超车"
    ],
    "correct_answer": 0,
    "explanation": "路中间的一条断裂的白色线意味着你在超车或会车时只有在安全情况下才能越过该线。",
    "image_name": "ABMW0165R.png"
  },
  {
    "index": 139,
    "id": "ABMW0166RU19",
    "section": "法律事务/交通规则",
    "question": "这些道路标线代表什么意思？",
    "options": [
      "双向车道即将开始",
      "不允许停车",
      "前方有连续白色线",
      "不允许超车"
    ],
    "correct_answer": 2,
    "explanation": "道路中央的双虚线警示您前方是连续的白色线。除非安全，否则不要越线。",
    "image_name": "ABMW0166RU19.png"
  },
  {
    "index": 140,
    "id": "ABMW0167R",
    "section": "法律事务/交通规则",
    "question": "如果从A开车到B，这些道路标线代表什么意思？",
    "options": [
      "司机可以超车，如果情况允许",
      "司机不得超车",
      "双向行车道即将到来",
      "道路即将变窄"
    ],
    "correct_answer": 0,
    "explanation": "在道路中央有一段破碎的白线和一段连续的白线时，您必须遵守距离您最近的那条线。在这种情况下，只要安全就可以越过这些线。",
    "image_name": "ABMW0167R.png"
  },
  {
    "index": 141,
    "id": "ABMW0168R",
    "section": "法律事务/交通规则",
    "question": "如果从A驾驶到B，这些道路标线是什么意思？",
    "options": [
      "只有摩托车手可以越过实线超车",
      "司机不能越过实线超车",
      "对向车辆不能越过实线超车",
      "司机可以越过实线超车"
    ],
    "correct_answer": 1,
    "explanation": "在路中央有一条断裂的白色线和一条连续的白色线时，您必须遵守离您最近的线。在这种情况下，您不可以越过这些线。",
    "image_name": "ABMW0168R.png"
  },
  {
    "index": 142,
    "id": "ABMW0169RU19",
    "section": "法律事务/交通规则",
    "question": "这个道路标志是什么意思？",
    "options": [
      "人行横道",
      "禁止私家车辆",
      "禁止通行",
      "前方为死胡同"
    ],
    "correct_answer": 2,
    "explanation": "这道路标示表示单行道。你不可以进入这条街道。",
    "image_name": "ABMW0169RU19.png"
  },
  {
    "index": 143,
    "id": "ABMW0170",
    "section": "法律事务/交通规则",
    "question": "这个道路标线代表什么意思？",
    "options": [
      "请将车停在黄线外",
      "仅限出租车停车",
      "营业时间禁止停车",
      "全天禁止停车"
    ],
    "correct_answer": 3,
    "explanation": "路边沿有两条黄线意味着任何时候都不允许停车。",
    "image_name": "ABMW0170.png"
  },
  {
    "index": 144,
    "id": "ABMW0171R",
    "section": "法律事务/交通规则",
    "question": "这个路标代表什么意思？",
    "options": [
      "只有摩托车手可以跨过实线超车",
      "驾驶员必须保持在连续的白线左侧",
      "对向车辆可以跨越线条超车",
      "驾驶员可以跨过线条超车"
    ],
    "correct_answer": 1,
    "explanation": "道路中央一条连续的白色实线表示所有交通都必须保持在线的左侧。在这段道路上，您不得超车或掉头。",
    "image_name": "ABMW0171R.png"
  },
  {
    "index": 145,
    "id": "ABMW0172R",
    "section": "法律事务/交通规则",
    "question": "破折号黄线道路标线的含义是什么？",
    "options": [
      "禁止停车，除非紧急情况",
      "全天禁止停车",
      "车道边缘或硬路肩",
      "慢车道仅供重型车辆使用"
    ],
    "correct_answer": 2,
    "explanation": "路边一条单破折黄线标识着道路的边缘/硬路肩。这通常供行人和骑车者使用。然而作为司机，您可以简短地使用它让速度更快的车辆超车，但只能在安全的情况下这样做。",
    "image_name": "ABMW0172R.png"
  },
  {
    "index": 146,
    "id": "ABMW0173R",
    "section": "法律事务/交通规则",
    "question": "这个交通灯是什么意思？",
    "options": [
      "通行，如果路清楚的话",
      "准备启动",
      "交通灯故障",
      "停车，除非这样做不安全"
    ],
    "correct_answer": 3,
    "explanation": "当交通灯显示黄色时，除非你离交通灯太近而停车会很危险，否则你不应该越过停车线。",
    "image_name": "ABMW0173R.png"
  },
  {
    "index": 147,
    "id": "ABMW0174RU23",
    "section": "法律事务/交通规则",
    "question": "这个交通灯是什么意思？",
    "options": [
      "驾驶员必须向右转",
      "如果道路畅通，驾驶员可以沿着绿色箭头的方向前行",
      "驾驶员必须停下等待直到出现完整的绿灯"
    ],
    "correct_answer": 1,
    "explanation": "绿色箭头（过滤灯）表示交通可以沿箭头方向前行，如果安全的话。",
    "image_name": "ABMW0174R.png"
  },
  {
    "index": 148,
    "id": "ABMW0175U19",
    "section": "法律事务/交通规则",
    "question": "这个交通灯是什么意思？",
    "options": [
      "交通左转应准备完全绿灯起步",
      "所有车辆必须只能左转",
      "交通左转可以在道路通畅时继续前行",
      "不允许交通左转"
    ],
    "correct_answer": 2,
    "explanation": "绿色箭头（过滤信号灯）表示如果安全的话，交通可以沿着箭头方向前行。",
    "image_name": "ABMW0175U19.png"
  },
  {
    "index": 149,
    "id": "ABMW0176RU23",
    "section": "法律事务/交通规则",
    "question": "这个交通灯代表什么？",
    "options": [
      "交通有可能停止，如果安全的话",
      "交通必须在红绿灯处停车",
      "如果安全的话，交通必须继续前行"
    ],
    "correct_answer": 1,
    "explanation": "红灯意味着停车。您不能越过停车线或（如果没有停车线）越过红灯。",
    "image_name": "ABMW0176R.png"
  },
  {
    "index": 150,
    "id": "ABMW0177R",
    "section": "法律事务/交通规则",
    "question": "这个交通灯是什么意思？",
    "options": [
      "车辆可前行但不能右转",
      "请让右转的对向车辆先行",
      "如果道路畅通，车辆可继续前行",
      "车辆必须在交通灯处停车"
    ],
    "correct_answer": 2,
    "explanation": "您可以在绿灯亮起时前进，但只有在安全的情况下才可以这样做。",
    "image_name": "ABMW0177R.png"
  },
  {
    "index": 151,
    "id": "ABMW0178",
    "section": "法律事务/交通规则",
    "question": "绿灯后会亮起什么颜色的交通灯？",
    "options": [
      "绿箭头",
      "仅红色",
      "仅黄色",
      "闪烁的黄色"
    ],
    "correct_answer": 2,
    "explanation": "交通灯的正常顺序是红-绿-黄。",
    "image_name": ""
  },
  {
    "index": 152,
    "id": "ABMW0179RU19",
    "section": "法律事务/交通规则",
    "question": "当交通灯为绿色时，驾驶员什么情况下不应继续前行？",
    "options": [
      "什么时候不安全的时候进行操作？ 当对向车辆等待左转时",
      "当交通因等待从左侧道路转弯而停止时",
      "当交通因等待从右侧道路转弯而停止时"
    ],
    "correct_answer": 0,
    "explanation": "綠燈雖然表示可以謹慎通過，但如果道路不清晰，或者通過會對其他道路使用者造成阻礙，則不應進入路口。",
    "image_name": ""
  },
  {
    "index": 153,
    "id": "ABMW0180RU19",
    "section": "法律事务/交通规则",
    "question": "在交通灯上闪烁的向左的琥珀色箭头代表什么？",
    "options": [
      "司机可在另一條路上的交通前行",
      "司机不得朝该方向行驶",
      "司机必须等待红绿灯",
      "司机可以左转，但必须礼让另一条道路上的交通"
    ],
    "correct_answer": 3,
    "explanation": "在路口处闪动的左边琥珀色箭头意味着你可以左转，但必须让步给已经通过另一条路口的行人和车辆。",
    "image_name": "ABMW0180RU19.png"
  },
  {
    "index": 154,
    "id": "ABMW0181R",
    "section": "法律事务/交通规则",
    "question": "在一個非閃爍的琥珀色燈後，會亮起哪種顏色的交通燈？",
    "options": [
      "红色信号灯",
      "绿色信号灯",
      "闪烁红色灯",
      "闪烁琥珀灯"
    ],
    "correct_answer": 0,
    "explanation": "交通信号灯的正常顺序是红灯-绿灯-黄灯。",
    "image_name": ""
  },
  {
    "index": 155,
    "id": "ABMW0182",
    "section": "法律事务/交通规则",
    "question": "行人穿越道上的闪烁琥珀色灯光是什么意思？",
    "options": [
      "车辆有通行权",
      "驾驶员正在进入特殊时速限制区域",
      "前方危险，驾驶员必须停车等待，直到灯光停止闪烁",
      "停车礼让行人 如路清可通行"
    ],
    "correct_answer": 3,
    "explanation": "斑马线处的闪烁琥珀色灯光意味着您必须让行人先行。但是，如果过街区域畅通无阻，您可以继续前行。",
    "image_name": ""
  },
  {
    "index": 156,
    "id": "ABMW0205RU23",
    "section": "法律事务/交通规则",
    "question": "道路使用者必须遵守交通信号灯（包括行人信号灯）吗？",
    "options": [
      "只有驾驶员和行人",
      "所有道路使用者",
      "只有驾驶员和骑车者"
    ],
    "correct_answer": 1,
    "explanation": "所有道路使用者，包括行人，都必须遵守交通控制。 驾驶员应意识到交通信号灯和人行灯在路口可能会合并，应对行人表现出谨慎和考虑。",
    "image_name": ""
  },
  {
    "index": 157,
    "id": "ABMW0210RU19",
    "section": "法律事务/交通规则",
    "question": "交通镇静措施的目的是什么？",
    "options": [
      "优先考虑重型货物交通",
      "减缓周围交通",
      "通知驾驶员前方有提高的速度限制",
      "提醒驾驶员前方道路可能有洪水"
    ],
    "correct_answer": 1,
    "explanation": "交通减速措施的目的是减缓快速行驶的车辆速度，使其适应所进入的区域。这些措施通常在农村地区的进入城镇或村庄的入口处找到。",
    "image_name": ""
  },
  {
    "index": 158,
    "id": "ABMW0213R",
    "section": "法律事务/交通规则",
    "question": "谁可以使用在左侧伴有连续白线的已签字的自行车道？",
    "options": [
      "自行车手和摩托车手",
      "驾驶员在自行车手未使用时",
      "驾驶员超车右转的车辆时",
      "自行车手和电动轮椅使用者"
    ],
    "correct_answer": 3,
    "explanation": "自行车道仅供骑自行车和电动轮椅的使用，其他车辆不得进入或越过强制自行车道，除非必须离开或进入侧路或与自行车道相邻的财产。",
    "image_name": ""
  },
  {
    "index": 159,
    "id": "ABMW0214RU19",
    "section": "法律事务/交通规则",
    "question": "什么交通可以使用伴有连续白线的自行车道？",
    "options": [
      "自行车和电动轮椅",
      "自行车手和摩托车手",
      "公共汽车和自行车手",
      "自行车手和出租车"
    ],
    "correct_answer": 0,
    "explanation": "自行车道供自行车和机动轮椅使用。除非必须离开侧路或临近自行车道的财产，否则任何其他车辆均不得越过或进入强制性自行车道。",
    "image_name": ""
  },
  {
    "index": 160,
    "id": "ABMW0215RU19",
    "section": "法律事务/交通规则",
    "question": "除了自行车手和电动轮椅使用者之外，还有哪些道路使用者可以使用带有一条断裂白线的未被占用的自行车道？",
    "options": [
      "所有驾驶员都可以暂时使用",
      "只有踏板车骑手和摩托车手",
      "只有出租车和计程车",
      "只有公共汽车和出租车"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员可以临时使用右侧有破碎白线的自行车道，前提是该道路为空。",
    "image_name": ""
  },
  {
    "index": 161,
    "id": "ABMW0216RU19",
    "section": "法律事务/交通规则",
    "question": "驾驶员在自动铁路道口遇到栏杆和红色闪烁灯时必须停车吗？",
    "options": [
      "在没有灯光可见时",
      "当出现琥珀色灯光时，请安全停车，或者当红灯开始闪烁时",
      "红色和琥珀色灯光停止闪烁时",
      "当道闸完全升起时"
    ],
    "correct_answer": 1,
    "explanation": "當琥珀色燈亮起時，您必須安全停車。閃爍的紅燈與固定的紅燈具有相同的含義-當它們亮起時，您必須安全停車。",
    "image_name": ""
  },
  {
    "index": 162,
    "id": "ABMW0217RU19",
    "section": "法律事务/交通规则",
    "question": "在没有看守的铁路道口，汽车司机应该怎么做？",
    "options": [
      "在继续横穿之前，先打开两扇门",
      "在打开门之前，给最近的火车站打电话",
      "打开两扇门，在通过第一扇门后停下并关闭它",
      "在驶过一半后，关闭第一道门再打开第二道门"
    ],
    "correct_answer": 0,
    "explanation": "在无人看守的铁路道口处，驾驶员必须停车，寻找火车并倾听喇叭声或接近火车的声音。如果安全，打开两扇车闸，完成通过后再关闭两扇车闸。",
    "image_name": ""
  },
  {
    "index": 163,
    "id": "ABMW0218R",
    "section": "法律事务/交通规则",
    "question": "什么灯光表示斑马线？",
    "options": [
      "连续点亮的琥珀色信标",
      "连续点亮的红色信标",
      "闪烁的琥珀色信标",
      "闪烁的红色信标"
    ],
    "correct_answer": 2,
    "explanation": "斑马线由路灯杆上的琥珀色闪烁信标和道路上的黑白条纹标示。您必须停下让行人通过，以及等待要过马路的人。",
    "image_name": ""
  },
  {
    "index": 164,
    "id": "ABMW0219RU19",
    "section": "法律事务/交通规则",
    "question": "在十字路口上，闪烁的琥珀色箭头表示什么？",
    "options": [
      "请通过路口迅速通过以避免延误",
      "指示的方向是一个死胡同",
      "在安全的情况下，驾驶员应该朝着指示的方向前进",
      "禁止朝指示的方向前进"
    ],
    "correct_answer": 2,
    "explanation": "遇到在十字路口上闪动的琥珀色箭头时，如果有安全条件，应该朝指示的方向前行。",
    "image_name": ""
  },
  {
    "index": 165,
    "id": "ABMW0220R",
    "section": "法律事务/交通规则",
    "question": "道路工程中临时交通灯代表什么意思？",
    "options": [
      "司机只有在对向有车辆时才需要遵守",
      "司机必须始终遵守交通灯",
      "如果有一个朝同一方向行驶的车队，司机就不需要遵守",
      "司机只有当工人在现场时才需要遵守交通灯"
    ],
    "correct_answer": 1,
    "explanation": "在或接近道路工程中，您必须遵守任何临时交通灯以控制车辆行驶。不遵守这些交通灯是一种违法行为。",
    "image_name": ""
  },
  {
    "index": 166,
    "id": "ABMW0256RU19",
    "section": "法律事务/交通规则",
    "question": "沿着道路中心的连续白线代表什么？",
    "options": [
      "交通可以超车",
      "禁止掉头",
      "营业时间可停车",
      "日间可掉头"
    ],
    "correct_answer": 1,
    "explanation": "在任何有中间连续白线的道路上，都不可进行掉头。在这样的地方，视线受阻会导致掉头非常危险。",
    "image_name": "ABMW0256RU19.png"
  },
  {
    "index": 167,
    "id": "ABMW0259RU23",
    "section": "法律事务/交通规则",
    "question": "在路中央的连续白线代表什么？",
    "options": [
      "车辆可能会短时间越过实线",
      "车辆可以执行掉头",
      "车辆只能在白天停车",
      "车辆不能越过或驶过实线"
    ],
    "correct_answer": 3,
    "explanation": "除非您想要进入土地或建筑物并且安全可行，否则您不得跨越或跨越道路中央的连续白线。",
    "image_name": "ABMW0259RU19.png"
  },
  {
    "index": 168,
    "id": "ABMW0268R",
    "section": "法律事务/交通规则",
    "question": "当驾驶员接近绿灯变为黄灯时应该怎么做？",
    "options": [
      "在通过交叉路口时按喇叭",
      "除非不安全，否则停下来",
      "加速通过路口",
      "立即停车"
    ],
    "correct_answer": 1,
    "explanation": "當你接近一組顯示為綠燈的交通燈時，應該小心並做好準備，如果黃燈亮起時要停車。",
    "image_name": "ABMW0268R.png"
  },
  {
    "index": 169,
    "id": "ABMW0280R",
    "section": "法律事务/交通规则",
    "question": "在黄灯亮起时，司机应该做什么？",
    "options": [
      "只有确定十字路口没有行人才可以通行",
      "确保在交通灯变红之前通过路口",
      "只有在路口没有交通时才能继续前行",
      "除非安全，否则请在停车线停车"
    ],
    "correct_answer": 3,
    "explanation": "根据法律规定，如果安全的话，你必须在黄色交通灯处停车。",
    "image_name": "ABMW0280R.png"
  },
  {
    "index": 170,
    "id": "ABMW0331RU19",
    "section": "法律事务/交通规则",
    "question": "当想要在拥挤地区暂时停车时，司机应该停在哪里？",
    "options": [
      "停在人行道上，以不妨礙道路上車輛的自由流動",
      "在人行道上稍微停車並打開危險警示燈",
      "在便利的地點雙重停車並打開危險警示燈",
      "在一個安全、合法和方便的地方停車"
    ],
    "correct_answer": 3,
    "explanation": "您应该只在安全、合法和方便停车的地方停车。您停放的车辆不得对其他道路使用者构成危险或阻碍。使用危险警示灯并不能成为不安全或违法停车的借口。",
    "image_name": ""
  },
  {
    "index": 171,
    "id": "ABMW0501RU19",
    "section": "法律事务/交通规则",
    "question": "清障区是什么？",
    "options": [
      "禁止在特定时间停车的区域",
      "专供行人和电动轮椅使用的区域",
      "仅限公共汽车和出租车停放的区域",
      "严格为重型货车装卸货物而保留的区域"
    ],
    "correct_answer": 0,
    "explanation": "清障区是指在一天的特定时间（通常是繁忙时段）必须保持清洁以便车辆通行的道路区域。停车或泊车禁止的时间会显示在标志下的信息牌上。",
    "image_name": ""
  },
  {
    "index": 172,
    "id": "ABMW0051R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "道路交汇，道路等级较高",
      "前方交汇处有铁路穿越",
      "前方交汇处，道路等级相同",
      "前方交汇处，道路等级较低"
    ],
    "correct_answer": 3,
    "explanation": "这个标志提前警示前方有两侧有次要道路交汇处。请注意，车辆可能会从次要道路驶出。",
    "image_name": "ABMW0051R.png"
  },
  {
    "index": 173,
    "id": "ABMW0052RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "车辆必须向左转的 Y 字形交叉口",
      "主要道路向左转的 Y 字形交叉口",
      "主要道路向右转的 Y 字形交叉口",
      "重型车辆必须向左转的 Y 字形交叉口"
    ],
    "correct_answer": 1,
    "explanation": "這個標誌提前警告前方有一個 Y 字形交叉口，其中一條小路連接。 Y 字形交叉口中較寬的一側表示主要道路的行進方向。",
    "image_name": "ABMW0052RU19.png"
  },
  {
    "index": 174,
    "id": "ABMW0053RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "左右两侧都有道路关闭",
      "叉形交叉路口，道路同等重要",
      "左右两侧都是死胡同"
    ],
    "correct_answer": 1,
    "explanation": "此标志提前警示前方有左右分叉口，注意可能有车辆从这些道路驶出。",
    "image_name": "ABMW0053R.png"
  },
  {
    "index": 175,
    "id": "ABMW0054RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "主要道路前方",
      "具有同等重要性的十字路口前方",
      "具有较低重要性的十字路口前方"
    ],
    "correct_answer": 1,
    "explanation": "此标志提前警示前方即将到达一个交叉路口，在此类路口，您应礼让从右侧接近的交通和已经转弯的交通。",
    "image_name": "ABMW0054RU19.png"
  },
  {
    "index": 176,
    "id": "ABMW0055R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "交汇路口，有来车并道",
      "T型路口前是双车道",
      "T型路口前是等同重要的道路",
      "T型路口前是次要道路"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示前方有一个重要性相同的T型交叉路口。您必须让行驶在您要加入的道路上的交通先行。",
    "image_name": "ABMW0055R.png"
  },
  {
    "index": 177,
    "id": "ABMW0056RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有次要道路",
      "前方有等重要性的Y形交叉路口",
      "前方有双车道的交叉路口",
      "前方有次要重要性的Y形交叉路口"
    ],
    "correct_answer": 1,
    "explanation": "此标志提前警示前方有一个两条同等重要性道路相交的Y型交叉口。接近这样的交叉口时要小心，随时准备应对交通状况的变化。",
    "image_name": "ABMW0056RU19.png"
  },
  {
    "index": 178,
    "id": "ABMW0057RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "Y形路口，两条道路同等重要",
      "次要道路前方",
      "双车道的起点"
    ],
    "correct_answer": 0,
    "explanation": "该标志提前警示前方有一个重要性相等的Y形交叉路口危险。请做好准备让行给其他道路使用者。",
    "image_name": "ABMW0056RU19.png"
  },
  {
    "index": 179,
    "id": "ABMW0058RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有主要道路的十字路口",
      "前方有桥下通行",
      "前方有重要道路的T型交叉口",
      "前方有双车道的十字路口"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警示前方有一条主干道的十字路口。准备停车。",
    "image_name": "ABMW0058RU19.png"
  },
  {
    "index": 180,
    "id": "ABMW0059RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "向左的死胡同",
      "向右的死胡同",
      "前方有一条主要道路的T型路口",
      "前方有一条次要道路的T型路口"
    ],
    "correct_answer": 2,
    "explanation": "此标志提前警示前方有一条与主干道相交的T形路口。请做好让行或停车的准备。",
    "image_name": "ABMW0059RU19.png"
  },
  {
    "index": 181,
    "id": "ABMW0060RU19",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "有闸门保护的平交道",
      "前方有T型路口和十字路口",
      "前方有无保护的平交道",
      "前方有双车道的十字路口"
    ],
    "correct_answer": 3,
    "explanation": "这个标志提前警示双车道前方即将有十字路口。驾驶员需要保持警觉，特别注意来自每个方向的交通。根据需要让行或停车。",
    "image_name": "ABMW0060RU19.png"
  },
  {
    "index": 182,
    "id": "ABMW0061RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有低桥",
      "前方有T形交叉路口，即将进入双车道",
      "前方有带栏杆的平交道口",
      "前方有无人看守的平交道口"
    ],
    "correct_answer": 1,
    "explanation": "该标志提前警示前方双向车道T型交叉路口。驾驶员需要保持警惕，特别注意来自各个方向的交通。根据情况让行或停车。",
    "image_name": "ABMW0061RU19.png"
  },
  {
    "index": 183,
    "id": "ABMW0062RU19",
    "section": "法律事务/交通规则",
    "question": "这个标识是什么意思？",
    "options": [
      "右侧行车道交通并入",
      "双车道行驶将结束",
      "左侧行车道交通并入",
      "左侧交通优先通行"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示左侧车辆并线。您应该预期左侧有车辆要并入。您可能需要减速，让他们安全地并线。",
    "image_name": "ABMW0062RU19.png"
  },
  {
    "index": 184,
    "id": "ABMW0063RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有分流",
      "交通合流/分流前方",
      "让出前方合流/分流的交通",
      "道路前方会短暂变窄"
    ],
    "correct_answer": 1,
    "explanation": "该标志提前警示道路即将合流（进入主干道）和分流（离开主干道）的情况。驾驶员应做好准备，因为车辆在前方左侧的交叉口进出时，交通可能会改变速度和方向。",
    "image_name": "ABMW0063RU19.png"
  },
  {
    "index": 185,
    "id": "ABMW0064RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "环形道路前方",
      "环岛前方",
      "环路前方"
    ],
    "correct_answer": 1,
    "explanation": "這個標誌提前警告前方有環形交叉路口。您必須準備讓先進入環狀交叉路口的其他道路使用者或者右方來車優先通行。",
    "image_name": "ABMW0064RU19.png"
  },
  {
    "index": 186,
    "id": "ABMW0065RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "迷你环形交叉路口前",
      "道路工程进行中，采取绕行路线",
      "环形道路前方"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警示前方有一个迷你环形交叉路口。你必须准备好让行给已经在环形交叉路口内或从右侧驶来的其他道路使用者。",
    "image_name": "ABMW0065RU19.png"
  },
  {
    "index": 187,
    "id": "ABMW0066U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有危险弯道",
      "前方单行道",
      "左侧有路口",
      "前方有危险转角"
    ],
    "correct_answer": 3,
    "explanation": "这个标志提前警示左转处的危险转弯。您可能需要减速并对前方交通情况的任何变化做出反应。",
    "image_name": "ABMW0066U19.png"
  },
  {
    "index": 188,
    "id": "ABMW0067U23",
    "section": "法律事务/交通规则",
    "question": "這個標誌代表什麼？",
    "options": [
      "前面有危险的拐角",
      "前方危险转弯",
      "左转"
    ],
    "correct_answer": 1,
    "explanation": "该标志提前警示左转危险弯道。您可能需要减速并对前方交通形势的任何变化做出反应。",
    "image_name": "ABMW0067U19.png"
  },
  {
    "index": 189,
    "id": "ABMW0068U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "高架电缆",
      "前方有一系列危险的拐弯",
      "前方有一系列危险的弯道"
    ],
    "correct_answer": 1,
    "explanation": "此标志提前警示前方有一系列危险拐弯。您应该减速并对交通情况的任何变化作出反应。",
    "image_name": "ABMW0068U19.png"
  },
  {
    "index": 190,
    "id": "ABMW0069RU23",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "一连串危险的弯道前方",
      "前方有一连串危险的弯道",
      "前方道路湿滑"
    ],
    "correct_answer": 1,
    "explanation": "这个标志提前警示前方有一系列危险的弯道。您应该减速并对交通状况的任何变化做出反应。",
    "image_name": "ABMW0069RU19.png"
  },
  {
    "index": 191,
    "id": "ABMW0070RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "急转向右",
      "急转向左",
      "一系列速度减震带前方",
      "道路关闭 驾驶员必须掉头"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌預先警告向右急轉彎。您應該在接近危險時減速。",
    "image_name": "ABMW0070RU19.png"
  },
  {
    "index": 192,
    "id": "ABMW0071RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "左侧车辆并入",
      "左侧道路变窄",
      "驾驶员只能从右侧超车",
      "双车道结束"
    ],
    "correct_answer": 1,
    "explanation": "這個標誌提前警告道路將在左側變窄。您應該小心並準備調整您的行車位置。",
    "image_name": "ABMW0071RU19.png"
  },
  {
    "index": 193,
    "id": "ABMW0072U23",
    "section": "法律事务/交通规则",
    "question": "这个标记代表什么？",
    "options": [
      "双车道即将到来",
      "道路两侧变窄",
      "双车道结束"
    ],
    "correct_answer": 1,
    "explanation": "这个标志提前警示道路将在前方两侧变窄。您应该注意并准备减速。",
    "image_name": "ABMW0072U19.png"
  },
  {
    "index": 194,
    "id": "ABMW0073RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方道路分隔",
      "只能在前方左侧超车",
      "有电车轨道",
      "有铁路隧道"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警示道路将在前方分岔。您应该准备向左移动。",
    "image_name": "ABMW0073RU19.png"
  },
  {
    "index": 195,
    "id": "ABMW0074U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "隧道前方",
      "雙向行駛道結束",
      "道路變窄"
    ],
    "correct_answer": 1,
    "explanation": "该标志提前警示双车道的尽头。您即将进入双向行驶的道路。",
    "image_name": "ABMW0074.png"
  },
  {
    "index": 196,
    "id": "ABMW0075U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方双车道",
      "前方单行道",
      "前方双向交通"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示前方有双向交通，对向车道有迎面来车。",
    "image_name": "ABMW0075U19.png"
  },
  {
    "index": 197,
    "id": "ABMW0076U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有河流或没有护栏的码头",
      "前方路面不平",
      "前方有陡坡上坡",
      "前方有陡坡下坡"
    ],
    "correct_answer": 3,
    "explanation": "这个标志预告前方有陡坡。您应该根据情况调整速度并选用合适的齿轮。",
    "image_name": "ABMW0076U19.png"
  },
  {
    "index": 198,
    "id": "ABMW0077U23",
    "section": "法律事务/交通规则",
    "question": "这个标志代表什么？",
    "options": [
      "前方陡坡",
      "前方驼背桥",
      "前方陡坡上升"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌提前警告前方有一段陡峭的上坡。你應該透過選擇適當的檔位來做出反應。",
    "image_name": "ABMW0077U19.png"
  },
  {
    "index": 199,
    "id": "ABMW0078U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方限宽",
      "前方路变窄-最大车辆长度已指示",
      "前方低桥",
      "路段限重已指示"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌提前警告您正接近一座低矮的橋樑，此橋樑的通行高度有限，如標誌所示。",
    "image_name": "ABMW0078U19.png"
  },
  {
    "index": 200,
    "id": "ABMW0079",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有急转弯",
      "上方有电缆架设",
      "前方有无线电发射塔",
      "前方有侧风"
    ],
    "correct_answer": 1,
    "explanation": "这个标志提前警示上方有电缆。有高载重的司机应特别小心。",
    "image_name": "ABMW0079.png"
  },
  {
    "index": 201,
    "id": "ABMW0080R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方施工结束",
      "前方无闸门或栏杆的无人值守道口",
      "前方有重大道路施工",
      "前方有闸门或栏杆的有人值守道口"
    ],
    "correct_answer": 1,
    "explanation": "此标志提前警示前方有一个无护栏的平交道。这是一个没有闸门或屏障的交叉路口，应极度谨慎通过。",
    "image_name": "ABMW0080R.png"
  },
  {
    "index": 202,
    "id": "ABMW0081",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有受门或栅栏保护的平交道口",
      "前方有农用机械道口",
      "前方有道路围栏",
      "私人地盘 禁止进入"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警示前方有受栅闸或升降杆保护的铁路道口。您应该做好准备停车并遵守必要的程序。",
    "image_name": "ABMW0081.png"
  },
  {
    "index": 203,
    "id": "ABMW0082U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "铁路桥前方",
      "前方有受灯光和栏杆保护的平交道口",
      "前方有铁路站",
      "前方有无灯光和栏杆保护的平交道口"
    ],
    "correct_answer": 1,
    "explanation": "这个标志提前警示前方有铁路道口，有灯光和障碍物保护。这个道口也可能配有听得见的警报器。您应该做好准备停车。",
    "image_name": "ABMW0082U19.png"
  },
  {
    "index": 204,
    "id": "ABMW0083U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "司机在红灯亮起时必须停车",
      "在继续前停下等待绿灯",
      "在继续前停下等待黄灯"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌提前警告您，在紅燈亮時必須停車。這個標誌可能會在鐵路道口出現。",
    "image_name": "ABMW0083.png"
  },
  {
    "index": 205,
    "id": "ABMW0084RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有受控道路平交",
      "前方有無人值守的道路平交",
      "前方有自動道路平交"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示前方有一个自动道口。驾驶员应谨慎接近，必要时准备减速或停车。",
    "image_name": "ABMW0084RU19.png"
  },
  {
    "index": 206,
    "id": "ABMW0085R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "道路中心到左右两侧倾斜",
      "前方有交通岛",
      "前方有一系列颠簸或凹坑",
      "前方道路急剧上升，例如骆驼背桥"
    ],
    "correct_answer": 3,
    "explanation": "這個標誌提前警示路面有凸起。您應該相應調整您的速度。",
    "image_name": "ABMW0085R.png"
  },
  {
    "index": 207,
    "id": "ABMW0086RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "道路前方受损",
      "道路将分岔 可由左侧或右侧通行",
      "前方有明显的凹陷",
      "道路前方积水"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示前方道路上可能有隐藏的下坡或凹陷，可能会遮挡你对迎面行驶交通的视线。您应相应减速，并注意这些区域超车是危险的。",
    "image_name": "ABMW0086RU19.png"
  },
  {
    "index": 208,
    "id": "ABMW0087RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "陡峭的山坡前方",
      "连续凸起带前方",
      "连续凹凸或坑洼前方",
      "前方施工中"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌提前警告前方有一系列的凹凸不平。請隨時準備根據需要減速。",
    "image_name": "ABMW0087RU19.png"
  },
  {
    "index": 209,
    "id": "ABMW0088U19",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "前方有一系列弯道",
      "前方道路湿滑",
      "前方有陡坡",
      "道路右侧变窄"
    ],
    "correct_answer": 1,
    "explanation": "此标志提前警示可能出现的道路湿滑危险。",
    "image_name": "ABMW0088U19.png"
  },
  {
    "index": 210,
    "id": "ABMW0089RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方是陡坡",
      "道路容易发生洪涝",
      "前方有无护栏的码头、运河或河流"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示前方存在没有保护的水域。由于极度危险，您应该保持谨慎。",
    "image_name": "ABMW0089RU19.png"
  },
  {
    "index": 211,
    "id": "ABMW0090RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志代表什么意思？",
    "options": [
      "前方有交通信号",
      "前方有学生过马路",
      "在斑马线处停车",
      "前方有铁路道口"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警示前方有一个交通灯控制的十字路口。这个标志通常出现在灯光对驾驶员来说可能无法及时看到的区域 例如，在道路拐弯后。",
    "image_name": "ABMW0090RU19.png"
  },
  {
    "index": 212,
    "id": "ABMW0091RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "儿童游乐区在前方",
      "人行横道在前方",
      "野餐区在前方",
      "学校在前方"
    ],
    "correct_answer": 3,
    "explanation": "这个标志提前警示前方有学校。您应该调整车速，并据此做出反应，因为该区域可能有儿童。",
    "image_name": "ABMW0091RU19.png"
  },
  {
    "index": 213,
    "id": "ABMW0092U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "学校前有孩子横穿",
      "前方有游乐场",
      "前方有人行横道的平交道"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警示可能会有学生在前方横穿马路，请根据需要减速并做好准备停车。",
    "image_name": "ABMW0092U19.png"
  },
  {
    "index": 214,
    "id": "ABMW0093U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "学校操场前方",
      "学校小孩过马路前方",
      "儿童游乐区前方"
    ],
    "correct_answer": 1,
    "explanation": "這個標誌提前警告可能會有學生橫穿前方的道路，如有需要應減速並準備停車。",
    "image_name": "ABMW0092U19.png"
  },
  {
    "index": 215,
    "id": "ABMW0094U23",
    "section": "法律事务/交通规则",
    "question": "这些标志一起意味着什么？",
    "options": [
      "路面湿滑 孩子可能跌倒",
      "注意孩子过马路",
      "前方路面有松散的砾石"
    ],
    "correct_answer": 1,
    "explanation": "这些标志通常出现在住宅区，它们提前警示可能会有儿童横穿道路。您应该谨慎前行，并准备随时停车。",
    "image_name": "ABMW0094U19.png"
  },
  {
    "index": 216,
    "id": "ABMW0095R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "马术学校入口",
      "自行车道，禁止车辆通行",
      "前方陪伴的马匹和小马",
      "前面有一个赛马场"
    ],
    "correct_answer": 2,
    "explanation": "这个标志提前警示可能会有马匹出现在前方道路上。您应该对马匹和骑手表示应有的尊重。",
    "image_name": "ABMW0095R.png"
  },
  {
    "index": 217,
    "id": "ABMW0096U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有牲畜市场",
      "前方有牛栏",
      "前方可能有牛或农场动物"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌提前警告可能有牛或其他農場動物出現在前方道路上。必要時減速並準備停車。\n\nTranslated to Simplified Chinese:\n此标志提前警告可能有牛或其他农场动物出现在前方道路上。必要时减速并准备停车。",
    "image_name": "ABMW0096U19.png"
  },
  {
    "index": 218,
    "id": "ABMW0097U23",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "宰杀场前方",
      "羊市前方",
      "可能有羊群前方"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌提前警告可能會有羊群出現在前方道路上。必要時減速並準備停車。",
    "image_name": "ABMW0097U19.png"
  },
  {
    "index": 219,
    "id": "ABMW0098U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "注意：前方有鹿或野生动物",
      "前方有马鹿狩猎",
      "前方有牛和农场动物"
    ],
    "correct_answer": 0,
    "explanation": "此标志预先警示可能会有鹿或其他野生动物进入道路。如有必要，请做好减速或突然停车的准备。",
    "image_name": "ABMW0098U19.png"
  },
  {
    "index": 220,
    "id": "ABMW0099RU19",
    "section": "法律事务/交通规则",
    "question": "這個標誌代表什麼？",
    "options": [
      "前方有侧风",
      "前方有掉落的岩石",
      "前方有机场",
      "前方有高尔夫球场"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌提前警告可能會有橫風。橫風可能會影響你車輛在道路上的穩定性。如果需要的話，請準備減速。",
    "image_name": "ABMW0099RU19.png"
  },
  {
    "index": 221,
    "id": "ABMW0100R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有人行横道",
      "专用于行人的车道",
      "前方有学校",
      "夜间注意行人"
    ],
    "correct_answer": 0,
    "explanation": "此标志提前警示前方有行人穿越道。您应该显示谨慎并做好准备停车。",
    "image_name": "ABMW0100R.png"
  },
  {
    "index": 222,
    "id": "ABMW0101RU23",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "隧道前方",
      "历史遗迹前方",
      "低桥前方"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌提前警告前方有隧道。進入隧道時，應該注意應該遵循的程序，包括保持與前方車輛的安全距離或者取下太陽眼鏡。",
    "image_name": "ABMW0101RU19.png"
  },
  {
    "index": 223,
    "id": "ABMW0102RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "注意：前方有落石危险",
      "前方有陡坡",
      "前方有崎岖海岸"
    ],
    "correct_answer": 0,
    "explanation": "这个标志提前警告道路上有岩石和其他杂物可能掉落的危险。请谨慎驾驶。",
    "image_name": "ABMW0102RU19.png"
  },
  {
    "index": 224,
    "id": "ABMW0103RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "主要风向",
      "机场前方",
      "可能有低空飞行的飞机"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌提前警告可能有低空飛行的飛機在該區域。低空飛行的飛機可能因為突然的巨響而分散注意力。",
    "image_name": "ABMW0103RU19.png"
  },
  {
    "index": 225,
    "id": "ABMW0104RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志代表什么意思？",
    "options": [
      "司机必须在左侧行驶",
      "司机必须从左侧合并",
      "司机必须在左侧超车"
    ],
    "correct_answer": 0,
    "explanation": "這個標誌通常出現在遊客旅行的地方，提醒駕駛人員保持左側行駛。這些標誌通常在機場和渡輪碼頭附近常見。",
    "image_name": "ABMW0104RU19.png"
  },
  {
    "index": 226,
    "id": "ABMW0105RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方有平交道",
      "火车站",
      "前方有有轨道交叉",
      "前方有公共汽车和有轨电车交叉"
    ],
    "correct_answer": 2,
    "explanation": "此标志提前警示有电车路口。如有需要，您应准备停车并让电车先行。",
    "image_name": "ABMW0105RU23.png"
  },
  {
    "index": 227,
    "id": "ABMW0115U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "交警在前",
      "道路施工中",
      "建筑工地在前"
    ],
    "correct_answer": 1,
    "explanation": "这个警告标志告诉您前方有道路施工。您应该谨慎靠近，警惕道路表面的变化，并留意机械设备和道路工人的存在。",
    "image_name": "ABMW0115U19.png"
  },
  {
    "index": 228,
    "id": "ABMW0117RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "湿滑的路面",
      "右侧道路变窄",
      "前方有一系列弯道"
    ],
    "correct_answer": 0,
    "explanation": "这个道路施工警示牌告诉你，前方路面因泥泞或残渣而变得很滑，存在更高的打滑风险。",
    "image_name": "ABMW0117RU19.png"
  },
  {
    "index": 229,
    "id": "ABMW0118RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "左侧车道路面不平",
      "道路从左侧变窄",
      "前方慢车道将结束"
    ],
    "correct_answer": 1,
    "explanation": "這個警告標誌告訴您，前方有道路工程施工，道路從左側變窄，可能造成危險。",
    "image_name": "ABMW0118RU19.png"
  },
  {
    "index": 230,
    "id": "ABMW0119RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "道路右侧变窄",
      "超车道即将结束",
      "右侧车道路面不平",
      "驾驶员只能在右侧超车"
    ],
    "correct_answer": 0,
    "explanation": "在将要进行道路施工的地方，这个警示标志告诉您道路从右侧变窄，可能会产生潜在危险。",
    "image_name": "ABMW0119RU19.png"
  },
  {
    "index": 231,
    "id": "ABMW0120RU19",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "车道之间障碍结束",
      "双侧道路变窄",
      "交通双向合流",
      "双行道即将结束"
    ],
    "correct_answer": 1,
    "explanation": "这个道路施工警告标志告诉您道路两侧变窄，可能存在潜在危险。请做好减速并谨慎驾驶的准备。",
    "image_name": "ABMW0120RU19.png"
  },
  {
    "index": 232,
    "id": "ABMW0121RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "足球场前方",
      "右侧有行人横穿道",
      "允许搭便车",
      "前方有引导交通的人"
    ],
    "correct_answer": 3,
    "explanation": "这个道路施工警告标志告诉您前方的交通流量由旗手手动控制。请注意并遵循旗手的指示。",
    "image_name": "ABMW0121RU19.png"
  },
  {
    "index": 233,
    "id": "ABMW0122RU23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "临时交通信号",
      "学生过街",
      "铁路道口"
    ],
    "correct_answer": 0,
    "explanation": "这个道路工程警告标志告诉您前方正在使用临时交通信号。您应准备减速，谨慎靠近，并遵守显示的信号。",
    "image_name": "ABMW0122RU19.png"
  },
  {
    "index": 234,
    "id": "ABMW0123U19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "车辆不得停车",
      "单行道",
      "双向交通",
      "前方双车道"
    ],
    "correct_answer": 2,
    "explanation": "这个警告标志告诉您，在道路施工期间，前方将有双向交通。请继续小心驾驶。",
    "image_name": "ABMW0123U19.png"
  },
  {
    "index": 235,
    "id": "ABMW0124RU19",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "两条封闭车道",
      "前方T型路口在左车道",
      "靠近路边车道必须向左转",
      "两条封闭车道"
    ],
    "correct_answer": 3,
    "explanation": "这个路政警告标志告诉您近侧（左侧）车道即将关闭。如果您在这条车道上，需要在确保安全的情况下换到远侧（右侧）车道。",
    "image_name": "ABMW0124RU19.png"
  },
  {
    "index": 236,
    "id": "ABMW0125RU23",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "超车允许，但不得在左车道超车",
      "不要沿着硬路肩行驶",
      "三条车道中的最靠近路边的车道关闭"
    ],
    "correct_answer": 2,
    "explanation": "这个道路施工警告标志告诉您，三条车道中的靠近路边（左侧）车道即将关闭。如果您在这条车道上，需要在安全的情况下换到中间车道。",
    "image_name": "ABMW0125RU19.png"
  },
  {
    "index": 237,
    "id": "ABMW0127RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "前方禁止变道",
      "除了靠右车道外，禁止停车",
      "前方靠右车道有弯道",
      "双向车道结束"
    ],
    "correct_answer": 0,
    "explanation": "這個施工警告標誌告訴您，向前方關閉了三條車道中的右側（右手）車道。靠近邊和中間車道的司机應意識到右側的車輛可能會合併進入。",
    "image_name": "ABMW0127RU19.png"
  },
  {
    "index": 238,
    "id": "ABMW0134U23",
    "section": "法律事务/交通规则",
    "question": "这些标志一起是什么意思？",
    "options": [
      "道路尽头",
      "绕行路线结束",
      "道路施工结束"
    ],
    "correct_answer": 1,
    "explanation": "这两个标志一起表示绕行路线已结束。",
    "image_name": "ABMW0134U19.png"
  },
  {
    "index": 239,
    "id": "ABMW0135RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "车辆应提前回到左车道",
      "前方有停车湾",
      "前方慢车道供重型交通使用",
      "前方有向左转弯的道路弯曲"
    ],
    "correct_answer": 0,
    "explanation": "这个道路施工警告标志告诉您道路将在前方左转。这通常会出现在将交通引导到右车道的路段之后。",
    "image_name": "ABMW0135RU19.png"
  },
  {
    "index": 240,
    "id": "ABMW0136RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "交通应该向右边车道驶出",
      "禁止超车标志结束",
      "前方路道右转",
      "前方有交通减速措施"
    ],
    "correct_answer": 0,
    "explanation": "這個道路施工警告標誌告訴您道路將在前方向右偏移。",
    "image_name": "ABMW0136RU19.png"
  },
  {
    "index": 241,
    "id": "ABMW0137R",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "中央隔离带或障碍物开始处",
      "前方双车道",
      "前方迷你环形交叉路口",
      "优先通行重型车辆"
    ],
    "correct_answer": 0,
    "explanation": "這個道路工程警告標誌告訴您，雙向交通將分開以避免障礙物。",
    "image_name": "ABMW0137R.png"
  },
  {
    "index": 242,
    "id": "ABMW0138RU19",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "注意载宽货物的车辆",
      "双向通行道即将结束",
      "中央隔离带或障碍物的结束",
      "隧道即将结束"
    ],
    "correct_answer": 2,
    "explanation": "这个道路施工警告标志告诉您，之前由中央隔离带或障碍物分隔的交通将恢复为双向交通。",
    "image_name": "ABMW0138RU19.png"
  },
  {
    "index": 243,
    "id": "ABMW2",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "不得停车在白线内",
      "左侧为公共汽车和有轨电车专用车道",
      "左侧为有轨电车专用车道",
      "有轨电车从左侧驶出"
    ],
    "correct_answer": 2,
    "explanation": "這個標誌告訴您左側有電車專用車道。請注意該區域可能有行人穿越道路。",
    "image_name": "ABMW2.png"
  },
  {
    "index": 244,
    "id": "ABMW6U23",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "左侧路面不平",
      "道路上有散落的碎石",
      "前方道路湿滑"
    ],
    "correct_answer": 1,
    "explanation": "这个道路施工警示牌告诉您前方的道路已经重新铺路，可能会有碎石。在通过这个区域时，您应该减速驾驶，因为碎石可能影响您车辆的抓地力和刹车效果。",
    "image_name": "ABMW6.png"
  },
  {
    "index": 245,
    "id": "ABMW7",
    "section": "法律事务/交通规则",
    "question": "这个标志是什么意思？",
    "options": [
      "三辆车可能会排队等候",
      "左侧停放工程车辆",
      "前方可能出现交通拥堵",
      "前方有陡坡"
    ],
    "correct_answer": 2,
    "explanation": "這個道路工程警告演示告訴您前方可能會有交通隊列，可能是因為工程施工區設置了臨時交通燈。請謹慎前行。",
    "image_name": "ABMW7.png"
  },
  {
    "index": 246,
    "id": "ABMW8U19",
    "section": "法律事务/交通规则",
    "question": "這個標誌是什麼意思？",
    "options": [
      "不平整的路面",
      "左侧软边缘",
      "湿滑的路面",
      "只能左侧停车"
    ],
    "correct_answer": 0,
    "explanation": "這個道路工程警告牌告訴您道路表面可能不平整，可能是由於部分車道進行重新鋪設。請小心行駛。",
    "image_name": "ABMW8U19.png"
  },
  {
    "index": 247,
    "id": "ABMW0405R",
    "section": "法律事务/交通规则",
    "question": "高速行驶会如何影响车辆的路感？",
    "options": [
      "悬挂系统补偿道路表面的不平整",
      "车轮定位保持轮胎与道路全面接触",
      "车辆的路面抓地力增加",
      "车辆的路面抓地力降低"
    ],
    "correct_answer": 3,
    "explanation": "在高速行驶是影响路面附着力的因素。在较高速度下，车辆下方的气流会减少轮胎对路面的抓地力，当你接近一条弯道或转角时，车辆的动量会使改变方向变得更加困难。",
    "image_name": ""
  },
  {
    "index": 248,
    "id": "BW0044RU19",
    "section": "法律事务/交通规则",
    "question": "持有B类驾驶执照的驾驶员所驾驶的车辆最多可载客多少人？",
    "options": [
      "7名乘客",
      "10名乘客",
      "9名乘客",
      "8名乘客"
    ],
    "correct_answer": 3,
    "explanation": "持有B类驾驶执照的持有人不得驾驶座位超过8个（不包括驾驶员）的车辆。",
    "image_name": ""
  },
  {
    "index": 249,
    "id": "BW0045RU19",
    "section": "法律事务/交通规则",
    "question": "持有W类学习许可证的持有人何时可以搭载乘客？\n",
    "options": [
      "只有当乘客也持有W类驾驶执照，并且车辆设计用于搭载乘客时",
      "只有当乘客持有AM类驾驶执照，并且车辆设计用于搭载乘客时",
      "只有当乘客持有AM类驾驶执照时",
      "只有当乘客也持有W类驾驶执照时"
    ],
    "correct_answer": 0,
    "explanation": "持有W类学习许可证的持有人只有在以下情况下才能在车辆中搭载乘客：车辆设计可搭载乘客，并且乘客持有W类的全面驾驶执照已有两年或更长时间。",
    "image_name": ""
  },
  {
    "index": 250,
    "id": "BW0052RU23",
    "section": "法律事务/交通规则",
    "question": "一名不满十六岁的儿童什么时候可以在公共道路上驾驶拖拉机？",
    "options": [
      "16岁以下的孩子持有学习许可证时允许在公共道路上驾驶拖拉机",
      "16岁以下的孩子在有完全驾驶执照的陪同下允许在公共道路上驾驶拖拉机",
      "16岁以下的儿童不允许在公共道路上驾驶拖拉机"
    ],
    "correct_answer": 2,
    "explanation": "未满16岁的人不得在公共场所驾驶拖拉机。",
    "image_name": ""
  },
  {
    "index": 251,
    "id": "BW0037R",
    "section": "法律事务/交通规则",
    "question": "汽车应该在哪里展示 L 牌？",
    "options": [
      "仅在后部",
      "仅在驾驶员一侧",
      "仅在前部",
      "前后都有"
    ],
    "correct_answer": 3,
    "explanation": "在公共道路上驾驶时，学习许可证持有人必须始终在汽车前部和后部展示 L 牌。",
    "image_name": ""
  },
  {
    "index": 252,
    "id": "BW0039RU19",
    "section": "法律事务/交通规则",
    "question": "司机如何计算其车辆的最大允许总重量？",
    "options": [
      "透过检查车辆的空载重量",
      "通过将车辆的空载重量与允许携带的载荷相加",
      "通过检查可携带的载荷重量",
      "通过计算车辆的空载重量加上燃料重量"
    ],
    "correct_answer": 1,
    "explanation": "车辆的最大允许重量是车辆本身的空载重量与可载重的最大重量之和。超载是一种违法行为，因为会降低您有效控制车辆的能力。",
    "image_name": ""
  },
  {
    "index": 253,
    "id": "BW0040RU19",
    "section": "法律事务/交通规则",
    "question": "拥有 B 级驾驶执照的人可以驾驶的汽车的最大授权质量 (MAM) 是多少？",
    "options": [
      "3,500 千克",
      "4,000 千克",
      "3,750 千克",
      "3,000 千克"
    ],
    "correct_answer": 0,
    "explanation": "持有B级驾驶执照的人不得驾驶总重量超过3500公斤的车辆。此限制将注明在驾驶执照上。",
    "image_name": ""
  },
  {
    "index": 254,
    "id": "BW0582R",
    "section": "法律事务/交通规则",
    "question": "持有B类驾驶执照驾驶的车辆的最大总重量是多少？",
    "options": [
      "3,450 公斤",
      "3,000 公斤",
      "3,250 公斤",
      "3,500 公斤"
    ],
    "correct_answer": 3,
    "explanation": "持有B類駕駛執照的人不得駕駛總設計車重超過3,500公斤的車輛。此限制事項已註明在執照上。",
    "image_name": ""
  },
  {
    "index": 255,
    "id": "BW0085RU19",
    "section": "法律事务/交通规则",
    "question": "在公共道路上，驾驶员被允许在汽车中使用绿色柴油吗？",
    "options": [
      "绿色柴油不能用于汽车",
      "只有出租车可以使用绿色柴油",
      "只有在夏季月份才能使用绿色柴油",
      "只有在冬季月份才能使用绿色柴油"
    ],
    "correct_answer": 0,
    "explanation": "在正常使用中，如果车辆在公共道路上行驶，必须使用未染色（白色）柴油，因为适当的货物税已包含在购买价格中。驾驶员可能会因在公共道路上使用绿色柴油而受到起诉。",
    "image_name": ""
  },
  {
    "index": 256,
    "id": "RSA225298",
    "section": "法律事务/交通规则",
    "question": "停车时，驾驶员应该检查什么？",
    "options": [
      "确保道路照明充足",
      "确保车辆与路缘至少相隔15厘米",
      "确保遵守强制性道路标线和标志"
    ],
    "correct_answer": 2,
    "explanation": "驾驶员停放车辆时，应确保遵守道路上所有相关的路标和路标志，例如，驾驶员不应停放在连续的白色线对面。",
    "image_name": ""
  },
  {
    "index": 257,
    "id": "BW0087RU19",
    "section": "法律事务/交通规则",
    "question": "拖拉机或工程车辆何时必须安装后视镜？",
    "options": [
      "只有在拖曳拖车时才必须安装后视镜",
      "必须始终安装后视镜",
      "只有在拖曳超过8米长的拖车时才必须安装后视镜",
      "拖拉机或工程车辆不需要安装后视镜"
    ],
    "correct_answer": 1,
    "explanation": "所有在公共道路上使用的车辆必须配备后视镜。后视镜应用于让驾驶员能够看到车辆后方和两侧的交通和道路情况。",
    "image_name": ""
  },
  {
    "index": 258,
    "id": "RSA225233",
    "section": "法律事务/交通规则",
    "question": "司机在人行横道后可以停车多远以便进行交付？",
    "options": [
      "10 米",
      "15 米",
      "5 米"
    ],
    "correct_answer": 2,
    "explanation": "确保不影响正常交通流畅，并且您的车辆不会干扰、阻塞或危及其他道路使用者。驾驶员不得停车在人行横道或交通灯前15米处或后5米处。",
    "image_name": ""
  },
  {
    "index": 259,
    "id": "RSA225291",
    "section": "法律事务/交通规则",
    "question": "停车或在晚上短时间停放车辆于路边时，建议使用哪种灯光？",
    "options": [
      "使用前后侧灯来提醒其他道路使用者注意车辆的存在",
      "使用前照灯来提示其他道路使用者车辆的位置",
      "使用后雾灯来提醒其他道路使用者注意车辆的大小"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员可能会因为停放车辆的前灯或雾灯而很快感到眼花缭乱和失去方向感。如果在这种情况下需要开灯，应该只使用侧面或停车灯。停车时不应该保持前灯开启。",
    "image_name": ""
  },
  {
    "index": 260,
    "id": "BW0046RU19",
    "section": "法律事务/交通规则",
    "question": "司机在无人看守的平交道中间熄火了，无法重新启动发动机。警铃正在响。司机应该怎么做？",
    "options": [
      "留在车辆旁边并警告正在接近的火车",
      "将车辆推离路口",
      "远离路口并联系信号操作员以停止火车",
      "尝试在一档重新启动引擎"
    ],
    "correct_answer": 2,
    "explanation": "在这种情况下，司机和所有乘客应该下车，并立即使用路口的紧急电话联系信号操作员，以便列车停下来。必要时，警告其他司机。直到接到信号操作员或急救服务的指示前，请不要返回车辆。",
    "image_name": ""
  },
  {
    "index": 261,
    "id": "ABMW0430RU19",
    "section": "风险管理",
    "question": "携带货物会对车辆的制动能力产生什么影响？",
    "options": [
      "只要刹车良好，这没有影响",
      "它提高了刹车效率",
      "它增加了停止所需距离",
      "它减少了停止所需距离"
    ],
    "correct_answer": 2,
    "explanation": "驾驶载重车辆时，驾驶员应意识到作用于车辆上的力会增加停车所需距离。驾驶员应增加与前方车辆的距离以应对这一情况。",
    "image_name": ""
  },
  {
    "index": 262,
    "id": "ABMW0434RU19",
    "section": "风险管理",
    "question": "拖曳载满货物的拖车会对制动能力产生什么影响？",
    "options": [
      "它减少了制动距离",
      "它增加了制动距离",
      "它增加了制动器的效率",
      "它对制动距离没有影响"
    ],
    "correct_answer": 1,
    "explanation": "如果您正在拖曳一辆装载货物的拖车，您需要意识到您的制动距离可能会明显增加，这取决于拖车的重量和大小。驾驶员应通过增加与前方车辆的距离来考虑这一点。",
    "image_name": ""
  },
  {
    "index": 263,
    "id": "ABMW0611RU19",
    "section": "风险管理",
    "question": "当驾驶员参与事故，无人受伤，但车辆造成道路危险或阻塞时，驾驶员应该怎么做？",
    "options": [
      "搬移所有乘客，并在道路上放上红色警示三角牌",
      "在移动受损车辆时要小心，并尽一切努力警示其他车辆",
      "暂停所有交通直到确定责任方",
      "等待警察到场后再移动车辆"
    ],
    "correct_answer": 1,
    "explanation": "在发生交通事故时，如果没有人受伤，车辆只受到轻微损坏，应将车辆移至路边，以确保它们不会造成阻碍或危及其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 264,
    "id": "ABMW0615RU19",
    "section": "风险管理",
    "question": "司机如果卷入仅涉及财产损害的事故应该做什么？",
    "options": [
      "在48小时内向车主和警察报告此事件",
      "只需在10天内向警察报告此事",
      "如果车辆没有受损，无需报告此事件",
      "如果已向车主报告，就不必向警察报告"
    ],
    "correct_answer": 3,
    "explanation": "如果事故只造成财产损害且有警察在场，必须向警察报告。如果没有警察在场，则必须通知财产的所有者或负责人。如果二者都不在场，则必须尽快提供相关信息至警察局。",
    "image_name": ""
  },
  {
    "index": 265,
    "id": "ABMW0616RU19",
    "section": "风险管理",
    "question": "在碰撞事故中受伤的情况下，司机应该做什么？",
    "options": [
      "将车辆移开以避免造成阻碍",
      "只有在火灾或进一步受伤的风险下才移动受伤者",
      "将受伤者移到路边",
      "始终移动受伤者和车辆"
    ],
    "correct_answer": 1,
    "explanation": "在发生碰撞事故现场，除非存在火灾或进一步受伤的风险，否则请勿移动受伤人员。移动受伤人员可能会加重他们的伤势。受过专业训练的人员最懂如何照顾受伤者。请拨打紧急服务电话（999或112），或确保其他人已经拨打了电话。",
    "image_name": ""
  },
  {
    "index": 266,
    "id": "ABMW0617RU19",
    "section": "风险管理",
    "question": "在碰撞中受伤的人应该饮用什么类型的饮料？",
    "options": [
      "一杯热饮",
      "一杯冷饮",
      "一种无酒精饮料",
      "不应提供饮料"
    ],
    "correct_answer": 3,
    "explanation": "在碰撞中受伤的人不应该被喂饮料，因为这样可能导致他们窒息。最好在处理受伤人员之前咨询受过培训的人员。致电紧急服务部门（拨打999或112）或确保有其他人已经打过电话给他们。",
    "image_name": ""
  },
  {
    "index": 267,
    "id": "ABMW0618RU19",
    "section": "风险管理",
    "question": "在事故後，司机應該怎樣幫助一個失去意識的人？",
    "options": [
      "立即将人送往最近的医院",
      "尝试让人喝些温暖的东西",
      "用毯子或外套保暖",
      "抬高人的头部并维持该位置"
    ],
    "correct_answer": 2,
    "explanation": "如果一个人在碰撞后失去意识，驾驶员应该试图用毯子或外套让他们保持温暖，直到急救人员到达。拨打紧急服务电话（999或112），或确保其他人已经拨打了电话。",
    "image_name": ""
  },
  {
    "index": 268,
    "id": "ABMW0621RU23",
    "section": "风险管理",
    "question": "在碰撞事故中受伤的人应首先联系谁？",
    "options": [
      "紧急服务",
      "受伤人员的家属",
      "受伤人员的保险公司"
    ],
    "correct_answer": 0,
    "explanation": "在发生碰撞导致有人受伤时，立即拨打999或112联系紧急服务至关重要。受过训练的紧急服务人员最懂得如何处理受伤者。",
    "image_name": ""
  },
  {
    "index": 269,
    "id": "ABMW0623RU19",
    "section": "风险管理",
    "question": "如果司机与无保险的驾驶员发生严重碰撞，没有人受伤，应向谁报告？",
    "options": [
      "当地的机动车税务办公室",
      "爱尔兰保险联合会",
      "驾驶员的保险公司和警察",
      "国家驾驶证服务（NDLS）"
    ],
    "correct_answer": 2,
    "explanation": "如果你参与了严重碰撞，你应该始终向爱尔兰警方和保险公司报告。",
    "image_name": ""
  },
  {
    "index": 270,
    "id": "ABMW0624RU19",
    "section": "风险管理",
    "question": "如果司机与另一辆车发生碰撞但无人受伤，司机应该怎么做？",
    "options": [
      "与对方驾驶员交换所有相关细节",
      "向爱尔兰保险局提交书面报告",
      "不交换任何细节，但向警察报告事故",
      "只向对方提供姓名和地址"
    ],
    "correct_answer": 0,
    "explanation": "如果您与另一辆车发生碰撞，没有人受伤，您应该与对方司机交换所有相关细节 包括姓名、地址、车辆注册信息、品牌和型号以及所有保险详细信息。",
    "image_name": ""
  },
  {
    "index": 271,
    "id": "ABMW0625RU19",
    "section": "风险管理",
    "question": "如果司机到达涉及运载危险物质的车辆事故现场，司机应该怎么做？",
    "options": [
      "联系拥有该车辆的运输公司",
      "尽量将车辆移动到安全地点",
      "远离现场并拨打紧急救援电话",
      "在报警之前尽量防止危险材料进一步泄漏"
    ],
    "correct_answer": 2,
    "explanation": "如果一名司机到达现场看到一起涉及运输危险材料的车辆的碰撞，他们应该远离现场。立即拨打999或112紧急救援电话并提供尽可能多关于车辆上标记标签的信息。您还应警告其他道路使用者注意危险。让紧急救援人员进行任何救援。",
    "image_name": ""
  },
  {
    "index": 272,
    "id": "CPC1297U19",
    "section": "风险管理",
    "question": "如果车辆抛锚了，驾驶员应该停在哪里？",
    "options": [
      "在发生问题的车道内",
      "最近的出口匝道",
      "尽可能靠左",
      "尽可能靠右"
    ],
    "correct_answer": 2,
    "explanation": "当车辆抛锚时，为了方便其他道路使用者和车辆乘员的安全起见，重要的是尽量靠左边停放。",
    "image_name": ""
  },
  {
    "index": 273,
    "id": "CPC1307U19",
    "section": "风险管理",
    "question": "怎样能最快地通知其他车辆发生事故？",
    "options": [
      "在马路中间放置一个大物体",
      "站在马路上挥动手臂",
      "打电话给当地广播电台",
      "使用危险警示灯"
    ],
    "correct_answer": 3,
    "explanation": "如果你抵达事故现场，请找一个安全的地方停车，以免危害自己或其他人，并使用危险警示灯警告其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 274,
    "id": "CPC1316U19",
    "section": "风险管理",
    "question": "為了通知應急服務機構有車禍發生，應撥打哪個電話號碼？",
    "options": [
      "555",
      "112",
      "199",
      "911"
    ],
    "correct_answer": 1,
    "explanation": "如果一名司机到达现场或参与事故，可能需要紧急寻求紧急救援服务的帮助。欧洲常用的紧急电话号码是112，但在爱尔兰，您也可以拨打999。",
    "image_name": ""
  },
  {
    "index": 275,
    "id": "CPC1317U19",
    "section": "风险管理",
    "question": "在高速公路上紧急电话求助时，电话会打到谁那里？",
    "options": [
      "国家安全委员会",
      "国家公路管理局",
      "道路安全局",
      "警察"
    ],
    "correct_answer": 3,
    "explanation": "高速公路旁边的紧急电话直接连接到警察局，以便他们能够尽快做出适当的响应。警察通过这些电话精确知道每个呼叫的位置。",
    "image_name": ""
  },
  {
    "index": 276,
    "id": "CPC1322U19",
    "section": "风险管理",
    "question": "当发现有受伤的人躺在马路上时，他们应该何时移动？",
    "options": [
      "如果这个人感到寒冷",
      "如果这个人有骨折",
      "如果这个人需要进行心肺复苏术",
      "如果这个人在流血"
    ],
    "correct_answer": 2,
    "explanation": "如果发现躺在路上的人没有呼吸，为了安全进行急救心肺复苏，可能需要移动他们。在其他情况下可能也需要移动他们，但首先应紧急评估情况。",
    "image_name": ""
  },
  {
    "index": 277,
    "id": "CPC1324U19",
    "section": "风险管理",
    "question": "处理事故受害者时，请记住 A B C。A 代表什么？",
    "options": [
      "协助",
      "事故",
      "胳膊",
      "呼吸道"
    ],
    "correct_answer": 3,
    "explanation": "在评估事故受害者的生命体征时，应使用以下基本程序：首先检查受害者的呼吸道是否通畅，然后检查他们是否在呼吸，最后检查他们的循环（ABC）。",
    "image_name": ""
  },
  {
    "index": 278,
    "id": "CPC1329U19",
    "section": "风险管理",
    "question": "一個被燒傷的人應該接受哪些基本急救？",
    "options": [
      "揭掉覆盖烧伤的衣物",
      "给烧伤处涂抹温水",
      "在烧伤处涂抹软膏",
      "用冷水冲洗烧伤处"
    ],
    "correct_answer": 3,
    "explanation": "當一個人被燒傷時，首先應檢查其是否有休克，然後嘗試冷卻燒傷部位。試圖找到乾淨、冷卻且無毒的水或其他液體倒在燒傷處。冷卻的液體可能使受影響的區域降溫並減少損傷。應建議該人盡快尋求醫療建議。",
    "image_name": ""
  },
  {
    "index": 279,
    "id": "ABMW0633RU19",
    "section": "风险管理",
    "question": "为什么重要确保车辆前灯对准正确？",
    "options": [
      "为了让驾驶员能够正确看清路况",
      "为了延长头灯的使用寿命",
      "为了让驾驶员在黑暗中能够更快行驶",
      "为了减少电池消耗"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员应确保他们的车头灯对齐正确，以免照射到迎面而来的驾驶员，并确保自己能够正确地看清道路。",
    "image_name": ""
  },
  {
    "index": 280,
    "id": "ABMW0635R",
    "section": "风险管理",
    "question": "Incorrectly aligned headlights could have what effect?\n迷糊的前大灯会产生什么影响？",
    "options": [
      "它们可能会使对向驾驶员看不清",
      "它们可能会提前烧坏灯泡",
      "它们可能会引发火灾",
      "它们可能会缩短电池寿命"
    ],
    "correct_answer": 0,
    "explanation": "司机应确保他们的车头灯正确对齐，以免使对向来车眩目，也便于自己正确看清路况。",
    "image_name": ""
  },
  {
    "index": 281,
    "id": "ABMW0636RU19",
    "section": "风险管理",
    "question": "通常情况下，车辆的灯光应该进行多久一次检查？",
    "options": [
      "在小保养间隔时",
      "每天开车前",
      "在大保养间隔时",
      "冬季临近时"
    ],
    "correct_answer": 1,
    "explanation": "司机负责确保车辆适合上路，并且应在开车前进行每日检查。其中，他们应该检查的项目包括确保所有灯光清洁且功能正常。",
    "image_name": ""
  },
  {
    "index": 282,
    "id": "ABMW0637RU19",
    "section": "风险管理",
    "question": "一个破损的透镜对前灯有什么影响？",
    "options": [
      "它可能导致灯泡过热",
      "它可能增加对向另一边头灯的亮度",
      "它可能减少并扭曲光束",
      "如果不立即修复，它可能导致其他灯泡爆炸"
    ],
    "correct_answer": 2,
    "explanation": "司机有义务确保车辆适合上路，并应定期检查。其中，他们应进行的检查之一是确认所有灯具均正常工作。如果发现灯具有缺陷，比如破裂的镜片，应尽快进行维修或更换。",
    "image_name": ""
  },
  {
    "index": 283,
    "id": "ABMW0642RU23",
    "section": "风险管理",
    "question": "在公共道路上行驶时，车辆的制动灯不亮可以吗？",
    "options": [
      "不允许驾驶",
      "是的，在照明时间外",
      "是的，在照明时间内",
      "不允许，除非在城市建成区驾驶"
    ],
    "correct_answer": 0,
    "explanation": "司机在驾驶车辆上公共道路前，必须确保车辆的制动灯清洁并正常工作。切勿在制动灯未正常工作时驾驶车辆。",
    "image_name": ""
  },
  {
    "index": 284,
    "id": "ABMW0643RU19",
    "section": "风险管理",
    "question": "这个灯的意思是什么？",
    "options": [
      "机油液位过低",
      "电池未充电",
      "变速箱过热",
      "引擎过热"
    ],
    "correct_answer": 1,
    "explanation": "当行驶时，如果电池警告灯亮起，则意味着车辆的电气充电系统存在某种问题，电池未能得到正确充电。驾驶员应尽快请专业人员检查此问题。了解车辆警告灯的含义非常重要，相关信息可以在车辆手册中找到。",
    "image_name": "ABMW0643RU19.png"
  },
  {
    "index": 285,
    "id": "ABMW0644RU19",
    "section": "风险管理",
    "question": "这个灯的意思是什么？",
    "options": [
      "前照灯光应该调低",
      "倒车灯已打开",
      "开启远光灯",
      "车牌灯损坏"
    ],
    "correct_answer": 2,
    "explanation": "所有车辆都配备了警示灯，以警示驾驶员注意不同的事情。当开启远光灯时，这个灯会亮起。了解车辆警示灯的含义非常重要，相关信息可在车辆手册中找到。",
    "image_name": "ABMW0644RU19.png"
  },
  {
    "index": 286,
    "id": "ABMW0645U19",
    "section": "风险管理",
    "question": "这个灯代表什么意思？",
    "options": [
      "电池液位过低",
      "发动机油液位过低",
      "制动液液位过低",
      "发动机冷却液液位过低"
    ],
    "correct_answer": 1,
    "explanation": "如果发动机机油警告灯亮起，意味着发动机机油液位/压力已经下降。在问题得到解决之前，您不应该驾驶这辆车辆。如果在行驶中看到灯亮起，请尽快靠边停车到一个安全的地方。理解车辆警告灯的含义非常重要，相关信息可以在车辆手册中找到。",
    "image_name": "ABMW0645U19.png"
  },
  {
    "index": 287,
    "id": "ABMW0646RU19",
    "section": "风险管理",
    "question": "这个灯代表什么意思？",
    "options": [
      "转向指示器打开",
      "刹车灯泡烧坏",
      "前灯泡烧坏",
      "右侧雾灯打开"
    ],
    "correct_answer": 0,
    "explanation": "所有车辆都配备了警示灯，用于警示您注意不同情况。本灯告诉您转向灯已打开。如果在您完成机动后该指示灯仍旧亮着，请取消它以避免误导其他道路使用者。了解您车辆警示灯的含义非常重要，相关信息可在车辆手册中找到。",
    "image_name": "ABMW0646RU19.png"
  },
  {
    "index": 288,
    "id": "ABMW0628RU19",
    "section": "风险管理",
    "question": "司机如何知道车辆的总载重量？",
    "options": [
      "通过检查发动机的马力",
      "通过参考车辆制造商的规格",
      "通过计算座位数",
      "通过测量后备箱的大小"
    ],
    "correct_answer": 1,
    "explanation": "设计总重量是制造商用于指代车辆重量与其设计可携带的最大载荷之和的术语。驾驶员必须了解其车辆的承载能力。超载会使车辆更难控制，并且是一种违法行为。",
    "image_name": ""
  },
  {
    "index": 289,
    "id": "ABMW0629U19",
    "section": "风险管理",
    "question": "车辆的最大允许牵引重量是由什么确定的？",
    "options": [
      "车辆及拖车的总重量",
      "拖车销力的强度",
      "制造商规格",
      "车辆轮胎尺寸"
    ],
    "correct_answer": 2,
    "explanation": "您的车辆可以安全牵引的最大重量由制造商规定，通常在车辆的驾驶手册中列出，在某些情况下也会在车辆上附有的牌子上注明。这是车辆的安全牵引限制，您不应该超过它。",
    "image_name": ""
  },
  {
    "index": 290,
    "id": "ABMW0630U19",
    "section": "风险管理",
    "question": "过载车辆会对其抓地力有什么影响？",
    "options": [
      "若货物均匀分布，可提高车辆稳定性",
      "货物可能使车辆更难控制，但仅在下坡时",
      "货物可能使车辆更难控制，但仅在倒车时",
      "货物可能使车辆更难控制"
    ],
    "correct_answer": 3,
    "explanation": "超载您的车辆会使其更难控制。请记住：超载车辆是违法行为。",
    "image_name": ""
  },
  {
    "index": 291,
    "id": "ABMW0631RU19",
    "section": "风险管理",
    "question": "超载载客或货物会造成什么影响？",
    "options": [
      "这将提高车辆的抓地力",
      "超载不会降低操控车辆的能力",
      "只要减速，这将不会有任何影响",
      "这会降低驾驶员操控车辆的能力"
    ],
    "correct_answer": 3,
    "explanation": "超载车辆会增加操控难度，增加碰撞风险。",
    "image_name": ""
  },
  {
    "index": 292,
    "id": "ABMW0632RU19",
    "section": "风险管理",
    "question": "不均匀分布的载荷会对车辆产生什么影响？",
    "options": [
      "这可能导致离合器在加速时打滑",
      "这可能使车辆在转弯时不稳定",
      "这可能导致车辆过热",
      "这可能导致变速箱过热"
    ],
    "correct_answer": 1,
    "explanation": "在装载车辆时，您应确保货物均匀分布。不均匀分布的货物可能会改变车辆的重心，这可能会影响制动和转向。",
    "image_name": ""
  },
  {
    "index": 293,
    "id": "RSA225187",
    "section": "风险管理",
    "question": "在夜晚，什么会让行人对驾驶员更加显眼？",
    "options": [
      "穿着防水夹克",
      "戴着耳机",
      "穿着高能见度夹克"
    ],
    "correct_answer": 2,
    "explanation": "即使配备最好的车辆前灯，驾驶员在夜间看到的视野仍然比白天少，作为易受伤的道路使用者，行人在黑暗中极其难以被看到。穿反光衣可以使行人更加显眼。行人在白天行走时应始终穿着明亮和高能见度的衣物，在夜间在非市区行走时应穿反光衣。",
    "image_name": ""
  },
  {
    "index": 294,
    "id": "RSA225313",
    "section": "风险管理",
    "question": "车辆白天行驶灯的目的是什么？",
    "options": [
      "在白天惡劣天氣下照亮道路",
      "在夜間行駛時給予車輛附加光線",
      "在白天增加車輛能見度"
    ],
    "correct_answer": 2,
    "explanation": "白天行车灯是指车辆前方的白色照明系统，在白天自动开启。 白天行车灯的目的是增加车辆对其他道路使用者的可见性和存在感。",
    "image_name": ""
  },
  {
    "index": 295,
    "id": "ABMW0487RU19",
    "section": "风险管理",
    "question": "在轮胎压力和在高速公路行驶之间哪个陈述是正确的？",
    "options": [
      "驾驶员应该增加前轮胎的气压以应对长时间高速行驶",
      "驾驶员应该增加后轮胎的气压以应对长时间高速行驶",
      "驾驶员应该确保轮胎气压正确，符合制造商的建议",
      "驾驶员应该降低轮胎气压，因为高速行驶会导致轮胎加热"
    ],
    "correct_answer": 2,
    "explanation": "司机应始终确保车辆的轮胎气压正确。 在长途旅行、在高速公路上以及高速行驶时，正确的轮胎气压尤为重要。",
    "image_name": ""
  },
  {
    "index": 296,
    "id": "ABMW0640RU19",
    "section": "风险管理",
    "question": "司机如何知道刹车灯泡损坏了？",
    "options": [
      "站在车辆后方，当另一个人踩下制动踏板时进行检查，他们会注意到制动踏板在加压时变得更加坚硬",
      "他们会注意到制动踏板在加压时变得更加软",
      "站在车辆后方，让另一个人打开侧灯"
    ],
    "correct_answer": 0,
    "explanation": "为了确认驾驶员知道后制动灯是否正常工作，他们应站在车辆后面，在另一人踩刹车时检查制动灯是否亮起。",
    "image_name": ""
  },
  {
    "index": 297,
    "id": "ABMW0650RU19",
    "section": "风险管理",
    "question": "驾驶员在行驶时如果车辆仪表盘上的系统警示灯亮起，应该怎么办？",
    "options": [
      "继续行驶并稍后检查问题",
      "停下来并检查问题",
      "继续驾驶并倾听是否有异常声音",
      "继续行驶一段距离，看灯是否熄灭"
    ],
    "correct_answer": 1,
    "explanation": "如果您在驾驶过程中看到系统警告灯亮起，您应该尽快停在安全的地方，然后调查问题，然后决定采取何种行动。了解您的车辆警告灯的含义非常重要，相关信息可以在车辆手册中找到。",
    "image_name": ""
  },
  {
    "index": 298,
    "id": "ABMW0651RU19",
    "section": "风险管理",
    "question": "如果司机的车辆仪表板上出现红色系统警告灯，司机应该怎么做？",
    "options": [
      "继续行驶并倾听任何异常声音",
      "停下来调查原因",
      "驾驶到最近的车库并进行检查",
      "继续行驶并观察故障是否消失"
    ],
    "correct_answer": 1,
    "explanation": "如果您在驾驶过程中看到红色系统警示灯亮起，您应尽快停在安全的地方，并在决定采取什么措施之前调查问题。了解车辆警示灯的含义很重要，可以在车辆手册中找到相关信息。",
    "image_name": ""
  },
  {
    "index": 299,
    "id": "ABMW0652RU19",
    "section": "风险管理",
    "question": "车辆后部的红色反光器的目的是什么？",
    "options": [
      "他们警告后车驾驶员切换到远光灯",
      "它们在制动灯故障时起替代作用",
      "它们在夜间反射光线，使其他道路使用者注意到车辆",
      "它们警告行人车辆的位置"
    ],
    "correct_answer": 2,
    "explanation": "机动车配备红色反光器，以便其他道路使用者更容易看到。 驾驶员应保持反光器清洁完好，并通过照射光线来检查它们，以确保它们的效果良好。 驾驶时，驾驶员应谨慎，因为红色反光器可能表明前方有停放的或移动的车辆。",
    "image_name": ""
  },
  {
    "index": 300,
    "id": "ABMW0664RU19",
    "section": "风险管理",
    "question": "如果驾驶人注意到引擎动力低于正常水平，应该怎么办？",
    "options": [
      "更换不同燃料",
      "请有能力的人检查车辆",
      "调整燃料混合比控制机构",
      "更换发动机机油滤清器"
    ],
    "correct_answer": 1,
    "explanation": "如果驾驶员注意到车辆在行驶时似乎动力不足，这可能会导致一些问题，例如在超车时缺乏动力。 驾驶员应尽快请有经验的人检查，因为可能有多种原因，其中一些可能会进一步恶化。",
    "image_name": ""
  },
  {
    "index": 301,
    "id": "ABMW0672RU23",
    "section": "风险管理",
    "question": "当驾驶时，司机注意到有浓烈的燃油味道。他们应该怎么做？",
    "options": [
      "以降低速度行驶",
      "在安全的地方停车并调查",
      "打开风扇清理空气"
    ],
    "correct_answer": 1,
    "explanation": "汽油味道浓烈通常意味着出现问题，驾驶员应尽快停车并进行调查。泄漏或溢出汽油可能很危险，因为它易燃，而漏出柴油可能会导致路面非常滑。",
    "image_name": ""
  },
  {
    "index": 302,
    "id": "ABMW0677RU19",
    "section": "风险管理",
    "question": "当驾驶时，驾驶员注意到车辆温度计显示红色。他们应该怎么做？",
    "options": [
      "将散热器盖取下并检查是否有漏水",
      "在添加防蜡剂到冷却液之前，请不要驾驶",
      "停在安全的地方并让问题得到调查",
      "驾驶到最近的服务中心并在散热器中加水"
    ],
    "correct_answer": 2,
    "explanation": "许多车辆配备了各种警示灯和仪表。警示灯或温度表上的红色区域意味着发动机开始过热，车辆在问题得到纠正之前不应该继续行驶。请查阅车辆手册获取更多信息和指导，或寻求熟悉的人员建议。",
    "image_name": ""
  },
  {
    "index": 303,
    "id": "ABMW0678RU19",
    "section": "风险管理",
    "question": "如果司机注意到发动机舱内有蒸汽上升，司机应该怎么做？",
    "options": [
      "增加车速以增加空气流入发动机舱",
      "从冷却液瓶中取下加注口塞",
      "在安全的地方停下来并调查原因",
      "立即添加防冻液"
    ],
    "correct_answer": 2,
    "explanation": "如果驾驶员注意到汽车引擎舱内升起蒸汽，应在安全的地方停车，等待冷却后再调查原因。当发动机热时，不要打开散热器或水箱盖。汽车引擎升起蒸汽表明发动机过热，不应继续驾驶。请查阅车辆手册以获取更多信息和指导。",
    "image_name": ""
  },
  {
    "index": 304,
    "id": "ABMW0680RU19",
    "section": "风险管理",
    "question": "如果司机注意到车辆的车身结构部分受到锈蚀的影响，他们应该怎么办？",
    "options": [
      "用相同颜色喷漆覆盖",
      "请找有资质的修理店修复",
      "用油脂处理并涂上油漆",
      "用砂纸打磨并保持受影响的区域干燥"
    ],
    "correct_answer": 1,
    "explanation": "隨著時間的推移，車輛可能會受到不同程度的鏽蝕影響。駕駛者應定期檢查他們的車輛，如果發現有鏽蝕跡象，應及時進行評估和必要的修復，以防止進一步惡化。車輛結構變弱可能在碰撞事件中帶來嚴重后果。",
    "image_name": ""
  },
  {
    "index": 305,
    "id": "ABMW0694RU19",
    "section": "风险管理",
    "question": "更换车轮后，接下来应当尽快检查以下哪项？",
    "options": [
      "气门",
      "轮胎螺母",
      "刹车片间隙",
      "轮胎花纹深度"
    ],
    "correct_answer": 1,
    "explanation": "更换车辆轮胎后，建议在短时间驾驶后检查轮毂螺母，确保它们仍然正确固定。",
    "image_name": ""
  },
  {
    "index": 306,
    "id": "ABMW0696RU19",
    "section": "风险管理",
    "question": "一般情况下，司机应该多久检查一次车辆的轮胎气压？",
    "options": [
      "定期",
      "每年",
      "每月",
      "每六个月"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员有法律责任确保他们的车辆适合上路行驶。为此，他们应进行定期、每周和定期检查，包括每周一次的轮胎气压检查。轮胎充气不当可能导致车辆不稳定、轮胎磨损不均匀和制动距离延长。",
    "image_name": ""
  },
  {
    "index": 307,
    "id": "ABMW0697RU19",
    "section": "风险管理",
    "question": "保持正确的轮胎气压的主要原因是什么？",
    "options": [
      "为减少发动机磨损",
      "为提供最佳的路面附着力",
      "为保持正确的离地高度",
      "为防止车辆向左倾斜"
    ],
    "correct_answer": 1,
    "explanation": "车辆制造商规定了车辆轮胎应充气的压力。这种压力能够在路面抓地力、有效制动和燃油消耗方面提供最佳性能。一些制造商规定前后轮胎的气压不同。",
    "image_name": ""
  },
  {
    "index": 308,
    "id": "ABMW0698RU19",
    "section": "风险管理",
    "question": "哪个组件的故障可能导致轮胎磨损不均匀或过度？",
    "options": [
      "油门",
      "离合器",
      "变速箱",
      "悬挂"
    ],
    "correct_answer": 3,
    "explanation": "如果车辆的悬架磨损严重，可能会导致轮胎磨损不均匀或过度。如果驾驶员注意到轮胎磨损不均匀，他们应该调查原因，并由有经验的人修理。",
    "image_name": ""
  },
  {
    "index": 309,
    "id": "ABMW0699RU19",
    "section": "风险管理",
    "question": "在操控汽车时，哪些方面会受到影响？",
    "options": [
      "冷却系统",
      "油压",
      "燃油消耗",
      "排气系统"
    ],
    "correct_answer": 2,
    "explanation": "错误的轮胎气压会影响车辆的许多系统，包括制动系统、悬挂和转向系统。特别是轮胎气压过低会增加车辆的燃油消耗。定期检查轮胎气压，确保按照制造商的推荐值充气。",
    "image_name": ""
  },
  {
    "index": 310,
    "id": "ABMW0700RU19",
    "section": "风险管理",
    "question": "轮胎压力应该何时检查？",
    "options": [
      "当轮胎温度高时",
      "当轮胎磨损程度中等时",
      "当轮胎温度低时",
      "仅在保养间隔时"
    ],
    "correct_answer": 2,
    "explanation": "驾驶员应每周至少检查一次车辆的轮胎气压，并在开始长途旅行前进行检查。为了准确起见，在轮胎处于冷却状态时使用可靠的压力表进行检查。轮胎应始终根据车辆制造商的建议进行充气，相关信息可以在车辆手册中找到。",
    "image_name": ""
  },
  {
    "index": 311,
    "id": "ABMW0702RU19",
    "section": "风险管理",
    "question": "在每周检查中，驾驶员注意到前轮轮胎严重磨损。驾驶员应该怎么做？",
    "options": [
      "在潮湿路面行驶时减速",
      "检查轮胎气压以确保恒定",
      "更换磨损的轮胎",
      "将磨损的轮胎安装在后轮之一"
    ],
    "correct_answer": 2,
    "explanation": "车轮是车辆与道路唯一接触的部分，接触面积较小，如果磨损，将无法有效地提供牵引力和安全性。车辆的轮胎质量是影响车辆路面附着力和制动能力的重要因素。驾驶员应定期检查车轮，一旦发现轮胎严重磨损，应立即更换。大多数车辆轮胎的最小法定胎纹深度应该是多少？",
    "image_name": ""
  },
  {
    "index": 312,
    "id": "ABMW0703RU19",
    "section": "风险管理",
    "question": "撞击或爬上路缘会对车辆的轮胎产生什么影响？",
    "options": [
      "可能会损坏侧壁",
      "可能会加强侧壁",
      "可能会增加气压",
      "可能会磨损胎面"
    ],
    "correct_answer": 0,
    "explanation": "司机应避免撞击或爬上路缘石，因为这会损坏轮胎的侧壁。造成的损害可能会导致轮胎后来爆炸。如果这种情况发生在高速行驶中，司机可能会失控，带来危险后果。",
    "image_name": ""
  },
  {
    "index": 313,
    "id": "ABMW0704RU19",
    "section": "风险管理",
    "question": "簡化中文：輪胎內側邊緣磨損的跡象代表什麼？",
    "options": [
      "车辆在拐弯时驶过快",
      "车胎气压过低",
      "车胎气压过高",
      "转向对不准"
    ],
    "correct_answer": 3,
    "explanation": "如果驾驶员注意到轮胎内侧磨损，这可能表明转向对齐存在问题。这是一个潜在的危险问题，应尽快由有能力的人修复。如果不这样做，可能会导致爆胎并失去对车辆的控制。",
    "image_name": ""
  },
  {
    "index": 314,
    "id": "ABMW0706RU19",
    "section": "风险管理",
    "question": "在开长途旅行之前，司机应该做什么与轮胎有关？",
    "options": [
      "增加轮胎的气压",
      "检查轮胎是否充气到正常气压",
      "减少轮胎的气压",
      "减少前轮胎的气压并增加后轮胎的气压"
    ],
    "correct_answer": 1,
    "explanation": "在开始长途旅行前检查轮胎气压非常重要，因为不正确的气压会对许多车辆系统产生不利影响，包括制动系统、转向系统、悬挂系统和燃油消耗。轮胎应根据车辆制造商的指导进行充气，关于此信息可以在车辆手册中找到。",
    "image_name": ""
  },
  {
    "index": 315,
    "id": "ABMW0707RU23",
    "section": "风险管理",
    "question": "在什麼情況下，駕駛員會增加輪胎的氣壓？",
    "options": [
      "在携带额外乘客进行旅行时",
      "当轮胎胎纹深度低于2毫米时",
      "当预期在高速公路行驶时速度较高时",
      "当旅程超过200公里时"
    ],
    "correct_answer": 0,
    "explanation": "在搭载额外乘客或装载物品出行前，驾驶员应检查轮胎气压，当充气时，应根据车辆制造商建议的轮胎压力增加车辆的轮胎压力。这些信息可以在车辆制造商的手册中找到。",
    "image_name": ""
  },
  {
    "index": 316,
    "id": "ABMW0714RU19",
    "section": "风险管理",
    "question": "重心轻的最常见原因是什么？",
    "options": [
      "转向系统润滑不良",
      "轮胎过度充气",
      "轮胎欠气",
      "制动器磨损严重"
    ],
    "correct_answer": 2,
    "explanation": "重舡方向是指驾驶员需要比平时更多的力量来转动方向盘，这可能直接是由于轮胎气压不足造成的。请检查轮胎气压，但要注意重舡方向的其他可能原因，如助力转向油液位过低。请咨询专业人士并立即进行调查。",
    "image_name": ""
  },
  {
    "index": 317,
    "id": "ABMW0262RU23",
    "section": "风险管理",
    "question": "在照明不足的街道上驾驶可能会有什么危险？",
    "options": [
      "司机只能看到前方的交通",
      "在黑暗区域过马路的行人可能不容易被看到",
      "司机只能看到迎面而来的交通"
    ],
    "correct_answer": 1,
    "explanation": "當您駕駛行駛在照明不足的街道時，您應該格外小心 軟弱的道路使用者如行人可能不那麼容易被看到。您應該隨時準備應對交通情況的變化。",
    "image_name": "ABMW0262RU23.png"
  },
  {
    "index": 318,
    "id": "BW0051RU19",
    "section": "风险管理",
    "question": "如果驾驶员的车辆在自动铁路道口抛锚，应该怎么做？",
    "options": [
      "將乘客遠離路口並致電信號操作員停止列車",
      "在路口打開警示鈴",
      "盡快嘗試將車輛推離路口",
      "沿著軌道走去，向任何接近的列車發出警告"
    ],
    "correct_answer": 0,
    "explanation": "在这种情况下，您和所有乘客应该下车，立即使用路口的紧急电话联系信号操作员，以便停止火车。如有必要，警告其他司机。直到受到信号操作员或紧急服务人员的指示，不要返回车辆。",
    "image_name": ""
  },
  {
    "index": 319,
    "id": "BW0053U23",
    "section": "风险管理",
    "question": "两辆车以高速正面相撞会立即产生什么效果？",
    "options": [
      "每辆车内的所有人只会被猛烈向后抛",
      "只有前排座位的安全带会启动",
      "每辆车内的所有人都会被猛烈向前抛"
    ],
    "correct_answer": 2,
    "explanation": "在正面碰撞中，两辆车的乘客会向前冲，如果他们没有系安全带，他们可能会冲出挡风玻璃。司机有责任确保所有未满17岁的乘客系安全带。年龄较大的乘客自己负责系安全带。",
    "image_name": ""
  },
  {
    "index": 320,
    "id": "BW0073RU19",
    "section": "风险管理",
    "question": "司机什么时候应该使用危险警示灯？",
    "options": [
      "当车辆发生故障时",
      "在单黄色线上短时间停车时",
      "当刹车灯不工作时",
      "当要停车并停下时"
    ],
    "correct_answer": 0,
    "explanation": "使用危险警报灯警示其他道路使用者前方有危险。例如，如果驾驶员的车辆抛锚并停在硬路肩上，他们应该使用车辆的危险警报灯来警示其他道路使用者他们的存在。",
    "image_name": ""
  },
  {
    "index": 321,
    "id": "BW0075RU19",
    "section": "风险管理",
    "question": "司机何时应该使用车辆的危险警示灯？",
    "options": [
      "在造成不可避免的阻塞时",
      "在双重停车时",
      "当刹车灯不工作时",
      "当跟车太近时"
    ],
    "correct_answer": 0,
    "explanation": "使用危险警示灯来警告其他道路使用者前方有危险。例如，若司机的车辆造成无法避免的阻塞，如车辆抛锚，应当使用车辆的危险警示灯来提醒其他道路使用者他们的存在。",
    "image_name": ""
  },
  {
    "index": 322,
    "id": "BW0076RU19",
    "section": "风险管理",
    "question": "司机应该在什么时候使用车辆的危险警示灯？",
    "options": [
      "停放在拐弯或转角处时",
      "当故障并造成障碍时",
      "在倒车进入狭窄道路时",
      "在交通中缓慢移动时"
    ],
    "correct_answer": 1,
    "explanation": "使用危险警示灯警告其他道路使用者前方有危险。例如，如果驾驶员的车辆造成不可避免的阻碍，比如车辆抛锚，他们应该使用车辆的危险警示灯警告其他道路使用者自己的存在。",
    "image_name": ""
  },
  {
    "index": 323,
    "id": "BW0099RU19",
    "section": "风险管理",
    "question": "当雨刷无法清理挡风玻璃时，驾驶员应该怎么办？",
    "options": [
      "尽快更换雨刷片",
      "弯曲雨刷臂以增加对挡风玻璃的压力",
      "将雨刷控制开关从高速切换到低速，反复操作",
      "在两只雨刷片上轻涂一层油膜"
    ],
    "correct_answer": 0,
    "explanation": "使用雨刷器清除雨水、喷雾、雪或雾气，定期检查，确保其正常运转，及时更换磨损的雨刷，以免影响清洁效果。",
    "image_name": ""
  },
  {
    "index": 324,
    "id": "BW0112U19",
    "section": "风险管理",
    "question": "如果一辆车在高速公路上抛锚了，一个人应该怎么做？",
    "options": [
      "打开远光灯以提醒其他驾驶员",
      "让乘客站在路上警告其他交通",
      "使用路边电话联系Gardaí，永远不要自行尝试维修",
      "在高速公路上放置红色警告三角形来警示其他驾驶员"
    ],
    "correct_answer": 2,
    "explanation": "當車輛在高速公路上發生故障時，駕駛應該將車輛移至硬肩，使用路邊電話聯繫警察局，不要在高速公路上放置警告裝置。駕駛永遠不應該在硬肩上自行嘗試維修。",
    "image_name": ""
  },
  {
    "index": 325,
    "id": "BW1U19",
    "section": "风险管理",
    "question": "在高速公路上，司机应该何时使用危险警示灯？",
    "options": [
      "当另一辆车跟车距离太近时",
      "当拖曳另一辆车时",
      "当停在紧急停车带接打电话时",
      "当车辆抛锚时"
    ],
    "correct_answer": 3,
    "explanation": "使用危险警告灯来警告其他道路使用者前方有危险。例如，如果您的车辆抛锚停在硬路肩上，您可以使用危险警告灯来警示后方车辆注意您的存在。",
    "image_name": ""
  },
  {
    "index": 326,
    "id": "BW3U19",
    "section": "风险管理",
    "question": "如果车辆在高速公路上抛锚了，一个人应该怎么做？",
    "options": [
      "将车辆移至硬路肩",
      "要求乘客站在高速公路上警告其他车辆",
      "打开远光灯",
      "将红色警示三角形放置在车辆左侧"
    ],
    "correct_answer": 0,
    "explanation": "将车辆移至硬路肩。尽量靠近左侧停车。如果无法做到这一点，采取措施警示其他驾驶员，例如打开危险警示灯。",
    "image_name": ""
  },
  {
    "index": 327,
    "id": "BW4U19",
    "section": "风险管理",
    "question": "如果一辆车在高速公路上抛锚了，一个人应该怎么处理？\n",
    "options": [
      "打开远光大灯",
      "在车辆左侧放置红色警示三角牌",
      "穿上高能见度背心",
      "请乘客站在高速公路上警告其他车辆"
    ],
    "correct_answer": 2,
    "explanation": "将车辆移至硬路肩。尽量靠左停车。如果无法靠左停车，采取措施警示其他司机，例如打开危险警示灯。穿戴高能见度背心。车内始终携带至少两件。",
    "image_name": ""
  },
  {
    "index": 328,
    "id": "ABMW0638RU19",
    "section": "风险管理",
    "question": "司机想要在晚上行驶，但是右侧的近光灯熄灭了。司机应该怎么办？",
    "options": [
      "将其暂时替换为刹车灯泡",
      "开启危险警示灯行驶",
      "不要开车，直到更换灯泡",
      "将其暂时替换为近侧（左侧）灯泡"
    ],
    "correct_answer": 2,
    "explanation": "司机负责车辆的适合行驶于道路，他们应定期检查。司机在车辆前照灯工作正常、调整适当且清洁时才可上路行驶。",
    "image_name": ""
  },
  {
    "index": 329,
    "id": "BW0028RU19",
    "section": "风险管理",
    "question": "夜间驾驶时，如果右侧大灯灯泡熄灭，司机应该怎么做？",
    "options": [
      "在开启危险警示灯的情况下驾驶",
      "暂时用左侧前灯泡替换它",
      "立即更换灯泡",
      "暂时用制动灯泡替换它"
    ],
    "correct_answer": 2,
    "explanation": "法律规定除摩托车外的车辆必须配备左右车灯。故障的车灯应立即修理。只有一个车灯的车辆可能会对其他道路使用者造成危险，或被误认为是摩托车。",
    "image_name": ""
  },
  {
    "index": 330,
    "id": "BW0032U19",
    "section": "风险管理",
    "question": "一般情况下，汽车、拖拉机或工程车在行驶时必须具备哪些灯光？",
    "options": [
      "前照灯、前后侧灯、后牌照灯、红色后反光器、刹车灯和转向灯",
      "只有前照灯、刹车灯和转向灯",
      "只有前照灯、牌照灯和后反光器",
      "只有前照灯和倒车灯"
    ],
    "correct_answer": 0,
    "explanation": "一般来说，所有的汽车、拖拉机和工程车辆都必须依法配备前灯、前后示廓灯、后牌照灯、后反光器、刹车灯和转向灯。当然也有一些例外情况，比如最高时速为38km/h的电动车辆。",
    "image_name": ""
  },
  {
    "index": 331,
    "id": "BW0072RU19",
    "section": "风险管理",
    "question": "紧急警告灯对刹车灯有什么影响？",
    "options": [
      "它们会导致刹车灯完全熄灭",
      "它们会导致刹车灯反复闪烁",
      "它们没有效果",
      "它们会导致左右刹车灯交替闪烁"
    ],
    "correct_answer": 2,
    "explanation": "紧急警示灯独立于车辆上的其他灯光（除了方向指示器）运作，并不影响制动灯。当您的车辆发生故障并造成阻塞或需要在高速公路上急剧减速时，请使用紧急警示灯来警示其他道路使用者前方存在危险。",
    "image_name": ""
  },
  {
    "index": 332,
    "id": "BW0077RU19",
    "section": "风险管理",
    "question": "双轴汽车挂车必须开启哪些灯光？",
    "options": [
      "只点亮转向灯和后牌照灯",
      "只点亮刹车灯和转向灯",
      "闪烁的后尾灯",
      "只点亮转向灯、刹车灯、后牌照灯、红色反光器和后尾灯"
    ],
    "correct_answer": 3,
    "explanation": "所有车辆，包括拖车，必须具有后部指示灯、制动灯、后牌照灯、红色反光器和后尾灯。",
    "image_name": ""
  },
  {
    "index": 333,
    "id": "BW0078U19",
    "section": "风险管理",
    "question": "拖拉机拖车在夜间必须点亮哪些灯光？",
    "options": [
      "只有刹车灯和转向灯",
      "一个卸载灯",
      "转向灯、刹车灯、后牌照灯、红色反光器和后尾灯",
      "只有转向灯、两个白色或黄色前灯和后牌照灯"
    ],
    "correct_answer": 2,
    "explanation": "拖拉机牵引的挂车在公共道路上行驶时必须配备后置指示灯、制动灯、后牌照灯、红色反光器和后尾灯。",
    "image_name": ""
  },
  {
    "index": 334,
    "id": "BW0034RU19",
    "section": "风险管理",
    "question": "驾驶拖拉机和拖车通过驼峰桥可能会存在哪些危险？",
    "options": [
      "挂车可能会造成卡脖子现象",
      "挂车可能会脱落",
      "拖车的悬架可能会减缓颠簸",
      "挂车的驻车制动器可能会自动启用"
    ],
    "correct_answer": 1,
    "explanation": "在拖曳拖车之前，驾驶员应确保牵引销具有足够的离地间隙。 如果这个牵引销触地，例如在通过驼背桥时，有可能导致拖车脱落。 驾驶员还应该在计划和进行旅程时意识到这种风险。",
    "image_name": ""
  },
  {
    "index": 335,
    "id": "BW0057R",
    "section": "风险管理",
    "question": "当要求驾驶员驾驶他们觉得超载的车辆时，驾驶员应该怎么做？",
    "options": [
      "拒绝驾驶车辆",
      "以比正常速度慢的速度驾驶",
      "只有在有人陪同的情况下才能驾驶车辆",
      "确保货物得到妥善固定"
    ],
    "correct_answer": 0,
    "explanation": "您不应该将您认为超载的车辆开上公共道路。超载是危险的，因为它会影响车辆的稳定性和制动能力。",
    "image_name": ""
  },
  {
    "index": 336,
    "id": "BWOO58R",
    "section": "风险管理",
    "question": "拖曳超重的拖车会对车辆造成什么影响？",
    "options": [
      "在下坡时能够提高制动能力",
      "它可能会影响车辆的转向和制动",
      "它可能会改善车辆的燃油消耗",
      "它可能会改善车辆在弯道上的路感"
    ],
    "correct_answer": 1,
    "explanation": "你不应该在公共道路上使用超载的拖车。超载的拖车会影响牵引车辆的稳定性，转向和制动。",
    "image_name": ""
  },
  {
    "index": 337,
    "id": "BW0091",
    "section": "风险管理",
    "question": "轮胎的载荷指数表示什么？",
    "options": [
      "轮胎可承受的最大载重量",
      "轮胎的最大气压",
      "每个轴的最大载重量",
      "车辆的最大载重量"
    ],
    "correct_answer": 0,
    "explanation": "**荷载指数**表示一个轮胎可以安全支撑的最大重量。更换车辆上的轮胎时，您应确保新轮胎的荷载指数适合车辆。",
    "image_name": ""
  },
  {
    "index": 338,
    "id": "BW0005RU19",
    "section": "风险管理",
    "question": "在拖曳房车前，驾驶员应该做什么？",
    "options": [
      "在房车内确保所有乘客坐稳",
      "在牵引车上安装延长镜",
      "只在车辆驾驶员一侧安装延长镜",
      "确保只有成年乘客坐在房车内"
    ],
    "correct_answer": 1,
    "explanation": "如果驾驶员打算拖曳房车，他们应该在拖车车辆的两侧安装延伸镜。这样可以让驾驶员更好地观察车辆后方和两侧的交通情况。",
    "image_name": ""
  },
  {
    "index": 339,
    "id": "BW0010RU19",
    "section": "风险管理",
    "question": "如果车窗起雾影响视线，司机应该怎么做？",
    "options": [
      "用布擦干窗户，然后使用除霜系统",
      "开着窗户行驶几公里",
      "确保所有除霜通风口和窗户都关闭",
      "用手背擦拭窗户"
    ],
    "correct_answer": 0,
    "explanation": "确保车窗随时清洁透明，以便驾驶员能清晰地看到四周的道路和交通状况。窗户上的凝结物会严重影响您正确观察的能力。驾驶员应熟悉如何正确设置车辆的通风系统，以确保窗户保持清晰。",
    "image_name": ""
  },
  {
    "index": 340,
    "id": "BW0011RU23",
    "section": "风险管理",
    "question": "阳光如何影响车窗脏的车内能见度？",
    "options": [
      "这会严重降低能见度",
      "这可能导致物体看起来比实际距离更远",
      "这会提高能见度",
      "这可能导致物体看起来比实际距离更近"
    ],
    "correct_answer": 0,
    "explanation": "所有车辆的玻璃窗必须始终保持清晰干净，以便驾驶员能够清晰看到周围的道路和交通状况。当太阳位置较低时，脏窗户尤其危险。在黄昏和黑暗时段，脏窗户也会降低能见度。",
    "image_name": ""
  },
  {
    "index": 341,
    "id": "BWO055R",
    "section": "风险管理",
    "question": "在公共道路上更换轮胎时，为确保自身安全，一个人应该做什么？",
    "options": [
      "确保车辆在倒挡，并且前轮对着道路",
      "请路人站在马路中间示意交通",
      "确保车辆在一档，轮子对着道路",
      "穿反光衣并打开车辆危险警示灯"
    ],
    "correct_answer": 3,
    "explanation": "在路边更换车轮时，请打开车辆危险警示灯，并穿反光或浅色衣服。这样会帮助其他车辆的驾驶者在经过时能够及时反应并减速。",
    "image_name": ""
  },
  {
    "index": 342,
    "id": "BW0086RU19",
    "section": "风险管理",
    "question": "在发生后撞事件时，驾驶员应该做什么来减少颈部受伤的风险？",
    "options": [
      "使用正确调整的头枕",
      "确保车辆有后扰流板",
      "确保车辆配备防抱死制动系统",
      "使用正确调整的安全带"
    ],
    "correct_answer": 0,
    "explanation": "司机和乘客必须正确调整头枕是非常重要的。头枕的设计是为了在碰撞中保护颈部和脊椎，从而预防或减少剪鞭效应。如果头枕没有正确调整，车辆乘员面临着增加的风险。",
    "image_name": ""
  },
  {
    "index": 343,
    "id": "BW0118RU23",
    "section": "风险管理",
    "question": "汽车配备了安全带时，成年乘客在什么时候必须系上安全带？",
    "options": [
      "随时",
      "在长途旅行时",
      "只有在司机指示时"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员和车内所有乘客都必须系安全带，对于儿童，则需使用合适的约束系统。",
    "image_name": ""
  },
  {
    "index": 344,
    "id": "BW0121RU19",
    "section": "风险管理",
    "question": "谁负责确保乘坐汽车的17岁以上乘客系安全带？",
    "options": [
      "驾驶员和乘客",
      "只有乘客",
      "乘客坐在前排座位时的驾驶员",
      "只有驾驶员"
    ],
    "correct_answer": 1,
    "explanation": "乘客年满17岁且乘坐汽车时，遵守安全带规定是他们的法律责任。未满该年龄的乘客，则由驾驶员承担责任。",
    "image_name": ""
  },
  {
    "index": 345,
    "id": "BW0122RU19",
    "section": "风险管理",
    "question": "谁负责确保17岁以下乘客在汽车旅行时系安全带？",
    "options": [
      "仅限乘客",
      "仅限驾驶员，但前座有乘客时除外",
      "乘客的父母",
      "仅限驾驶员"
    ],
    "correct_answer": 3,
    "explanation": "在乘客年满 17 岁且乘坐汽车时，遵守安全带规定是他们的法定责任。在此年龄以下，则归司机责任。",
    "image_name": ""
  },
  {
    "index": 346,
    "id": "BW0123AU19",
    "section": "风险管理",
    "question": "谁负责确保儿童在车辆中使用儿童安全座椅？",
    "options": [
      "只有司机",
      "任何成年乘客",
      "只有孩子的父母",
      "如果年龄超过12岁，则孩子"
    ],
    "correct_answer": 0,
    "explanation": "当乘客年满17岁且乘坐汽车时，遵守儿童约束规定便成为他们的法律责任。在此年龄以下，则由驾驶员来负责。",
    "image_name": ""
  },
  {
    "index": 347,
    "id": "BW0124U19",
    "section": "风险管理",
    "question": "一般来说，3岁以下的儿童在车辆中应该如何安全固定？",
    "options": [
      "他们应该始终坐在前排乘客座位上，系好安全带",
      "他们应该始终安全固定在正确的儿童座椅上",
      "他们应该始终坐在后排乘客座位上",
      "他们应该始终由成年人抱在膝上"
    ],
    "correct_answer": 1,
    "explanation": "安全带主要设计给成人和年龄较大的孩子使用。3岁以下的儿童必须使用适当的儿童安全座椅约束。警告：决不要在有主动前排气囊保护的座位上使用向后面朝向的婴儿汽车座椅。",
    "image_name": ""
  },
  {
    "index": 348,
    "id": "BW0125RU19",
    "section": "风险管理",
    "question": "三岁以下的儿童可以在车辆的前排客座椅上不受约束地搭乘吗？",
    "options": [
      "不可以，除非儿童使用儿童增高座椅",
      "可以，但只有当车辆安装了主动安全气囊时",
      "不可以，婴儿必须始终被正确的儿童座椅约束",
      "可以，前提是婴儿由成年人牢固地抱着"
    ],
    "correct_answer": 2,
    "explanation": "通常情况下，孩子在车辆中绝不能没有任何约束地旅行。三岁以下的儿童必须使用合适的儿童安全座椅进行约束。警告：绝对不要在装有主动前排安全气囊的座位上使用向后朝向的儿童汽车座椅。",
    "image_name": ""
  },
  {
    "index": 349,
    "id": "RSA225307",
    "section": "风险管理",
    "question": "在开始旅程前，为什么司机应该调整头枕？",
    "options": [
      "为了防止后方车辆的前灯眩光",
      "为了改善后排乘客对前方道路的视野",
      "为了在碰撞事件中给颈部提供支撑"
    ],
    "correct_answer": 2,
    "explanation": "车辆座椅配备了头枕，以帮助在车辆发生碰撞时减少剪裂伤等伤害。驾驶员和乘客应确保调整头枕以提供最大保护。头枕顶部应与头顶齐平。头枕中心应大致与耳朵顶部齐平。",
    "image_name": ""
  },
  {
    "index": 350,
    "id": "ABMW0710RU19",
    "section": "风险管理",
    "question": "司机在更换前近侧（左侧）车轮时应该做什么来确保车辆安全？",
    "options": [
      "确保换档杆处于空档位置",
      "将前轮对准路缘",
      "确保车辆升起后不能滚动",
      "将前轮远离路缘"
    ],
    "correct_answer": 2,
    "explanation": "如果司机必须更换前部近侧（左侧）车轮，请确保在平整地面上的安全地点进行操作。注意安全，穿戴高能见度马甲/夹克，根据需要使用警示三角牌和危险警示灯。通过拉紧驻车制动器（手刹），熄灭发动机，挂入低速挡，必要时使用车轮垫固定车辆。如果对操作不熟悉，应寻求帮助。",
    "image_name": ""
  },
  {
    "index": 351,
    "id": "ABMW25U19",
    "section": "风险管理",
    "question": "以下哪一项是司机必须保持良好状态的？",
    "options": [
      "座椅",
      "油漆工作",
      "收音机",
      "安全带"
    ],
    "correct_answer": 3,
    "explanation": "司机有责任确保车辆的路况良好，并应定期检查。其中，他们应该检查的项目包括所有的安全带（驾驶员和乘客）是否清洁、没有缠结并且正常运作。",
    "image_name": ""
  },
  {
    "index": 352,
    "id": "BW0054",
    "section": "风险管理",
    "question": "拖拉机的动力输出轴可能会带来什么危险？",
    "options": [
      "如果未解除锁定，方向盘将会锁定",
      "如果未解除锁定，电池会耗尽电量",
      "如果未盖住，拖拉机会迅速加速",
      "如果未盖住，服装可能被卷入其中"
    ],
    "correct_answer": 3,
    "explanation": "在拖拉机后部工作时，应注意如果动力输出轴没有遮盖，松弛的衣服可能会被卷入其中，导致受伤甚至死亡。",
    "image_name": ""
  },
  {
    "index": 353,
    "id": "BW0060RU19",
    "section": "风险管理",
    "question": "连接挂车时，驾驶员必须检查什么？",
    "options": [
      "确保货物均匀分布",
      "确保货物位于拖车的前部",
      "确保拖车备有备用轮胎",
      "确保货物位于拖车的后部"
    ],
    "correct_answer": 0,
    "explanation": "正确的重量分配有助于确保牵引车辆和拖车的稳定性。在拖车上，大部分负载应该集中在轴上。如果将重物放在拖车前部，这将导致挂车吊座上的鼻重量过大，使操纵困难。如果将重物放在拖车后部，这将导致后轴的重量减少。",
    "image_name": ""
  },
  {
    "index": 354,
    "id": "BW0061RU19",
    "section": "风险管理",
    "question": "连接拖车到他们的车辆时，驾驶员必须检查什么？",
    "options": [
      "确保拖车连接牢固",
      "确保拖车备用轮胎齐全",
      "确保拖车弹簧充分润滑",
      "确保货物位于拖车前部"
    ],
    "correct_answer": 0,
    "explanation": "在拖曳拖车或房车之前，请检查拖车钩牢固地连接到牵引车上，拖车联接器正确连接到拖车钩并锁定在位，并确保安全绳正确连接。",
    "image_name": ""
  },
  {
    "index": 355,
    "id": "BWO0062R",
    "section": "风险管理",
    "question": "驾驶员在拆卸拖车之前应该怎么样确保牵引车辆的安全？",
    "options": [
      "拉起手刹，降低载重轮，关闭发动机",
      "拉起手刹，熄灭点火，挂入低挡",
      "断开拖车灯的电源，放下支撑轮",
      "先放下支撑轮，然后熄灭点火"
    ],
    "correct_answer": 1,
    "explanation": "在拆卸拖车之前，应拉起手刹，关闭点火，并挂入低档，以防在拆卸拖车时牵引车移动。",
    "image_name": ""
  },
  {
    "index": 356,
    "id": "BWO088R",
    "section": "风险管理",
    "question": "汽车轮胎的最低法律胎纹深度是多少？",
    "options": [
      "2.6 毫米",
      "1 毫米",
      "0.6 毫米",
      "1.6 毫米"
    ],
    "correct_answer": 3,
    "explanation": "所有道路車輛，除了摩托車和古董車外，都必須保持主胎面最少1.6毫米的胎紋深度。然而，基於安全考量，您應該在輪胎磨損到這個程度之前就更換車輛的輪胎。",
    "image_name": ""
  },
  {
    "index": 357,
    "id": "BW0097RU19",
    "section": "风险管理",
    "question": "司机注意到雨刷片磨损了。他们应该怎么办？",
    "options": [
      "慢慢开车时，请将车窗摇下",
      "请尽快更换刮水器片",
      "使用报纸擦拭挡风玻璃",
      "下雨时请使用挡风玻璃洗涤器系统"
    ],
    "correct_answer": 1,
    "explanation": "使用雨刷器保持挡风玻璃清洁，防止雨水、喷雾、雪或雾气影响视线。定期检查雨刷器，确保它们能正常工作，当雨刷器磨损时要及时更换，以免影响使用效果。",
    "image_name": ""
  },
  {
    "index": 358,
    "id": "BW0126RU19",
    "section": "风险管理",
    "question": "如何在车辆中安装儿童安全座椅？",
    "options": [
      "应将其放置在前排乘客座位上",
      "应将其放置在地板上",
      "应保持不固定",
      "应根据制造商的说明安装"
    ],
    "correct_answer": 3,
    "explanation": "建议按照制造商的指示正确安装儿童座椅，将座椅安装在汽车后座上更安全，并且仅从能够确认座椅适合汽车和儿童的零售商那里购买儿童汽车座椅。",
    "image_name": ""
  },
  {
    "index": 359,
    "id": "BW0001RU23",
    "section": "风险管理",
    "question": "驾驶员在想使用手机时应该怎么做？",
    "options": [
      "减速，注意，对其他道路使用者保持警惕",
      "与前方车辆保持更大的间距，以正常速度继续行驶",
      "保持交流简短",
      "在安全的地方停车"
    ],
    "correct_answer": 3,
    "explanation": "在驾驶过程中使用或操作手机是违法的。驾驶需要您全神贯注，所以您绝对不应该在驾驶时使用或操作手机。如果您想使用手机，唯一安全的做法就是找到一个安全的停车地点。",
    "image_name": ""
  },
  {
    "index": 360,
    "id": "ABMW0263R",
    "section": "安全与负责驾驶",
    "question": "在照明不良的街道驾驶可能危险的原因是什么？",
    "options": [
      "交通信号灯将不起作用",
      "司机只能看到迎面而来的交通",
      "司机只能看到他们前面的交通",
      "在黑暗区域可能很难辨认光线暗淡的车辆"
    ],
    "correct_answer": 3,
    "explanation": "当您驾驶在照明不足的街道上时，您应该格外小心，并准备应对未点亮的停放车辆等危险。",
    "image_name": "ABMW0263R.png"
  },
  {
    "index": 361,
    "id": "ABMW0266RU23",
    "section": "安全与负责驾驶",
    "question": "如果被对向车辆的灯光晃眼，司机应该怎么做？",
    "options": [
      "向对向车辆闪灯并向左移动",
      "看向道路的左侧边缘（靠近路边），如有必要请减速",
      "加速以尽快远离灯光范围"
    ],
    "correct_answer": 1,
    "explanation": "如果您被对向车辆的灯光弄晕了，将视线转向路的左侧边缘（靠近路边）。如有必要，停下让眼睛恢复后再继续开车。",
    "image_name": "ABMW0266RU23.png"
  },
  {
    "index": 362,
    "id": "ABMW0341RU23",
    "section": "安全与负责驾驶",
    "question": "在什么时候应该向其他道路用户发出信号（例如，使用转向灯）？",
    "options": [
      "只有在有必要警告跟车时，才应提前清晰地告知其他道路使用者您的意图",
      "转弯时，除非道路标线显示您的行驶方向"
    ],
    "correct_answer": 1,
    "explanation": "发出信号是告诉其他道路使用者你打算做什么的一种方式。因此，在启动前、向右或向左转弯、变道、超车、减速或停车前，你应该适当地发出信号。清晰而及时地发出信号，并牢记发出信号并不给予你通行权。",
    "image_name": ""
  },
  {
    "index": 363,
    "id": "ABMW0489RU19",
    "section": "安全与负责驾驶",
    "question": "在高速公路上，司机可以让乘客上车或下车吗？",
    "options": [
      "只允许在出口匝道200米范围内停车",
      "只有在白天才允许停车",
      "司机在高速公路上永远不允许接送乘客",
      "只要司机在硬路肩上停车，就允许接送乘客"
    ],
    "correct_answer": 2,
    "explanation": "高速公路旨在让交通能更快速、更自由地行驶。在高速公路的任何部分停车都是非法且危险的，除非是在紧急情况下，或者被交警示意要停车。",
    "image_name": ""
  },
  {
    "index": 364,
    "id": "ABMW0223RU19",
    "section": "安全与负责驾驶",
    "question": "一名正在接近的駕駛員注意到兒童自行車上的男孩已經向他的朋友道別。駕駛員應該採取正確的行動是什麼？",
    "options": [
      "停车直到男孩离开",
      "当男孩在人行道上时继续前行",
      "减速并示意男孩穿过马路",
      "随时准备男孩随时启程"
    ],
    "correct_answer": 3,
    "explanation": "由於難以預測孩子們的行為，您應該隨時做好準備應對交通情況的變化或停車。",
    "image_name": "ABMW0223RU19.png"
  },
  {
    "index": 365,
    "id": "ABMW0226RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机必须做好哪些准备？",
    "options": [
      "一个小孩可能会往回跑去马路上捡球",
      "迎面而来的车辆可能会朝你的方向转弯",
      "你通过后球可能会爆炸",
      "球可能会损坏你的车辆"
    ],
    "correct_answer": 0,
    "explanation": "由于孩子们的行为很难预测，您应该随时做好准备应对交通状况的变化，并随时准备停车。",
    "image_name": "ABMW0223RU19.png"
  },
  {
    "index": 366,
    "id": "ABMW0227RU23",
    "section": "安全与负责驾驶",
    "question": "当接近人行横道时，司机应该怎么做？",
    "options": [
      "提前减速并做好停车准备",
      "保持速度，因为行人尚未踏上人行横道",
      "继续以较快速度驾驶，因为行人需要等待"
    ],
    "correct_answer": 0,
    "explanation": "在斑马线附近有行人时，你应该减速接近并随时准备停下来让行人安全过马路。",
    "image_name": "ABMW0226RU19.png"
  },
  {
    "index": 367,
    "id": "ABMW0232RU23",
    "section": "安全与负责驾驶",
    "question": "如果有孩子在路边玩耍，司机应该怎么做？",
    "options": [
      "加速并移到道路的右侧以避开儿童",
      "发出警告信号并以相同的速度驶过",
      "减速，小心驾驶并随时准备刹车"
    ],
    "correct_answer": 2,
    "explanation": "由於很難預測孩子的行為，您應該隨時準備應對交通狀況的變化，做好停車的準備。",
    "image_name": "ABMW0232RU23.png"
  },
  {
    "index": 368,
    "id": "ABMW0236R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该注意什么？",
    "options": [
      "巴士可能開始倒車",
      "左側街道將有車輛駛出",
      "巴士後方有行人穿越馬路",
      "巴士駕駛員將在啟動前始終發出信號"
    ],
    "correct_answer": 2,
    "explanation": "你应该始终看向前方的道路并准备好应对不断变化的交通情况。特别是，你应该注意到行人可能会从公共汽车后方出现。在这种情况下，你还应当留意那些正走向等候公共汽车的行人。",
    "image_name": "ABMW0236R.png"
  },
  {
    "index": 369,
    "id": "ABMW0237R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该做什么？",
    "options": [
      "司机应该靠近红色的汽车",
      "司机应该以相同的速度继续行驶",
      "如果没有碰到球，司机应该继续行驶",
      "大幅减速并随时准备停车"
    ],
    "correct_answer": 3,
    "explanation": "您在通过可能有儿童玩耍的区域时应该留意道路，驾驶时要格外小心。当球弹出到路上时，您应该预料到可能有儿童会跟着去捡球。",
    "image_name": "ABMW0237R.png"
  },
  {
    "index": 370,
    "id": "ABMW0238RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该注意什么？",
    "options": [
      "行人可以不注意就离开交通岛",
      "电车在轨道上，没有危险",
      "行人始终有权在交通车辆前横穿马路",
      "电车可能会未经警告就移开"
    ],
    "correct_answer": 0,
    "explanation": "當有電車停靠時，您應該注意前方的道路並預期會有更多行人活動。",
    "image_name": "ABMW0238RU19.png"
  },
  {
    "index": 371,
    "id": "ABMW0239R",
    "section": "安全与负责驾驶",
    "question": "驾驶员正跟随这两辆车并希望超车 在此超车前，驾驶员必须考虑什么？",
    "options": [
      "司机应该一起超越这两辆车",
      "银色车辆的司机可能决定右转",
      "这里的道路标记禁止超车",
      "司机的视野不足以安全超车"
    ],
    "correct_answer": 3,
    "explanation": "你应该始终确保前方道路畅通，以便有足够的距离让你超车并回到正确的道路一侧，而不会强迫其他道路使用者改变速度或路线。在这种情况下，山丘的山脊太近，不允许驾驶员安全地超车。",
    "image_name": "ABMW0239R.png"
  },
  {
    "index": 372,
    "id": "ABMW0240R",
    "section": "安全与负责驾驶",
    "question": "驾驶员在接近正在尝试停车的车辆时应注意什么？",
    "options": [
      "停放的车辆可能会在没有警告的情况下移动",
      "司机可能需要停车并协助停放车辆的司机",
      "车辆可能在指定的装载区域停放",
      "停车的地点可能是一个车辆通道",
      ""
    ],
    "correct_answer": 0,
    "explanation": "当你接近一辆正在路边停车的车辆时，应该意识到它的驾驶员可能会集中精力停车，可能不会注意到车辆移动以纠正位置而驶入道路。",
    "image_name": "ABMW0240R.png"
  },
  {
    "index": 373,
    "id": "ABMW0248RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，驾驶员应该最关注什么？",
    "options": [
      "行人可能会突然穿过车辆前面的道路",
      "路的左侧不应停放任何车辆",
      "行人始终有权穿过道路",
      "停放的车辆中可能有一辆车会倒车进入司机的道路"
    ],
    "correct_answer": 0,
    "explanation": "在道路上很难预测其他道路使用者的行为。当道路两侧有停放的车辆时，您应该谨慎驶近，并随时准备对交通状况的变化做出反应并停车。",
    "image_name": "ABMW0248RU19.png"
  },
  {
    "index": 374,
    "id": "ABMW0255R",
    "section": "安全与负责驾驶",
    "question": "当驾驶员跟在这辆车后面时应该怎么做？",
    "options": [
      "在左侧行驶时缓慢通过车辆",
      "必要时减速并准备停车",
      "超越前方车辆",
      "尽可能靠近车辆行驶"
    ],
    "correct_answer": 1,
    "explanation": "您应该始终阅读前方的道路，并在接近交叉口时准备好应对不断变化的交通状况。",
    "image_name": "ABMW0255R.png"
  },
  {
    "index": 375,
    "id": "ABMW0278RU23",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该注意什么？",
    "options": [
      "在公共汽车前面可能会有一辆车藏在视野之外",
      "公共汽车可能会停在终点站",
      "只有公共汽车可以使用这条路"
    ],
    "correct_answer": 0,
    "explanation": "接近视野受限制的区域时，应格外小心，并做好准备应对交通状况的变化。",
    "image_name": "ABMW0278RU23.png"
  },
  {
    "index": 376,
    "id": "ABMW0287RU23",
    "section": "安全与负责驾驶",
    "question": "当在这条双向停车道上行驶时，司机应该准备好什么？",
    "options": [
      "在司机超越卡车时，需要注意对向车辆",
      "该卡车可能是左驾驶车辆",
      "车门可能会在街道的任一侧打开"
    ],
    "correct_answer": 2,
    "explanation": "在单行道上驾驶时，你应该格外小心，并且应该准备好应对交通状况的变化。",
    "image_name": "ABMW0287R.png"
  },
  {
    "index": 377,
    "id": "ABMW0292RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该注意什么？",
    "options": [
      "前方的道路变成双车道",
      "前方正在进行道路标线划分",
      "跟车可能会抄近道",
      "减速并做好反应准备"
    ],
    "correct_answer": 3,
    "explanation": "當您接近視野受限的彎道或拐角時，如果有必要應該放慢速度並準備應對交通狀況的任何變化。",
    "image_name": "ABMW0292RU19.png"
  },
  {
    "index": 378,
    "id": "ABMW0294R",
    "section": "安全与负责驾驶",
    "question": "在夜晚沿着一条有许多不同光源的购物街驾驶时，驾驶员应注意什么？",
    "options": [
      "由于明亮的灯光，行人更容易看到",
      "停车位可能难以注意到",
      "交通灯可能难以与其他明亮的灯光区分开来",
      "其他车辆不需要使用前灯"
    ],
    "correct_answer": 2,
    "explanation": "夜间驾驶时，如果在灯光来源多样的地区行驶，需要格外小心，因为潜在的危险可能更难以看清。",
    "image_name": "ABMW0294R.png"
  },
  {
    "index": 379,
    "id": "ABMW0295RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，驾驶员应该最注意什么？",
    "options": [
      "在山丘的顶端可能会突然出现一辆车",
      "孩子们可能会从停放的车辆之间突然冲出来",
      "其中一辆停放的车辆可能会倒车进入驾驶员的行驶路径",
      "停在双黄线对面是违规的"
    ],
    "correct_answer": 1,
    "explanation": "在居民区驾驶时，您需要考虑您可能对玩耍的儿童造成的危险。您应始终注意与儿童有关的警示标志并相应地驾驶。",
    "image_name": "ABMW0295RU19.png"
  },
  {
    "index": 380,
    "id": "ABMW0296RU23",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该怎么办？",
    "options": [
      "降低速度并准备停车，因为其他孩子可能会跟随",
      "按喇叭作为警告并继续前行",
      "继续前行，同时打转向灯超越停放的汽车"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员应始终注意其他道路使用者，尤其是孩子，他们可能行为难以预测且缺乏道路意识。驾驶员应在孩子们出没的地区减速并格外小心，例如在学校附近、游乐场和居住区域。",
    "image_name": "ABMW0296RU23.png"
  },
  {
    "index": 381,
    "id": "ABMW0304R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该注意什么？",
    "options": [
      "前方有个右侧的次要道路",
      "前方有个危险的右弯",
      "前方道路有急剧下降",
      "前方有个左侧的次要道路"
    ],
    "correct_answer": 1,
    "explanation": "您应该始终阅读前方道路并做好准备以应对交通状况的变化 在这种情况下，应特别注意明确指示前方右转弯的警告标志。",
    "image_name": "ABMW0304R.png"
  },
  {
    "index": 382,
    "id": "ABMW0314RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在前方道路出现急剧下降时应该做什么？",
    "options": [
      "靠边停车，打开危险警示灯",
      "加速通过低洼处",
      "减速，靠左行驶，注意前方危险",
      "为避免左侧停放的车辆，向路中央移动"
    ],
    "correct_answer": 2,
    "explanation": "当您接近道路上的陡坡时，您应该意识到前方可能存在隐藏的危险。例如，可能会有行人、骑自行车的人或其他逼近的交通，或者路面可能在坡度处发生了积水。您应该始终观察前方道路并做好对不断变化的交通情况做出反应的准备 您可能需要减速并特别小心地驾驶。",
    "image_name": ""
  },
  {
    "index": 383,
    "id": "ABMW0315R",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员在道路上看到红色警告三角形，应该怎么做？",
    "options": [
      "驾驶员应保持速度、继续前行，避免三角形",
      "驾驶员应减速并预料前方有危险",
      "驾驶员应移开三角形，因为它在道路上造成障碍",
      "驾驶员应停下来等待指示"
    ],
    "correct_answer": 1,
    "explanation": "警示三角标志用于警示前方有车辆故障或碰撞。当你遇到警示三角标志时，应减速并做好随时停车的准备。不要让自己被事故分散注意力。",
    "image_name": ""
  },
  {
    "index": 384,
    "id": "ABMW0316RU19",
    "section": "安全与负责驾驶",
    "question": "司机正接近他们知道已经亮绿灯一段时间的交通信号灯。司机应该怎么做？\n\nTranslation: 驾驶员正接近他们知道已经亮绿灯一段时间的交通信号灯。驾驶员应该怎么做？",
    "options": [
      "驾驶员应该保持车速直到信号灯变成琥珀色",
      "驾驶员应该意识到信号灯可能会变化，加速通过信号灯之前将其清空",
      "驾驶员应该注意信号灯可能在他们到达之前改变，并准备停车",
      "驾驶员应该在信号灯即将变成红色时停车"
    ],
    "correct_answer": 2,
    "explanation": "您应该始终注意路况并准备应对不断变化的交通情况。当交通灯一直为绿色时，您应该做好准备停车，因为交通灯可能即将变为黄色。",
    "image_name": ""
  },
  {
    "index": 385,
    "id": "ABMW0317RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员接近一般由交通信号灯控制的十字路口，但交通信号灯未亮时，驾驶员应该怎么做？",
    "options": [
      "以智慧通過路口，避免延誤",
      "開啟車頭燈，移動至路口中心，盡快通過",
      "在路口處停車，給左邊來的車輛讓路",
      "將其視為無標誌路口，並在注意其他車輛的情況下小心通過"
    ],
    "correct_answer": 3,
    "explanation": "你应该始终预先观察路况并准备应对不断变化的交通状况。如果交通信号灯不起作用，你应该特别谨慎地接近路口，只有在确保安全的情况下才能继续前行。",
    "image_name": ""
  },
  {
    "index": 386,
    "id": "ABMW0318RU19",
    "section": "安全与负责驾驶",
    "question": "如果前方道路上有牛，司机应该怎么做？",
    "options": [
      "驾驶员应该按喇叭试图让牲畜让路",
      "驾驶员应减速小心通过它们",
      "驾驶员应该打开车头灯并尽快通过",
      "驾驶员应该按喇叭，打开车头灯，减速小心通过"
    ],
    "correct_answer": 1,
    "explanation": "您应始终注意前方道路并做好准备以应对交通状况的变化。如果在路上遇到牲畜或其他动物，您应减速并做好停车的准备。不要按喇叭或做任何可能使动物受惊的事情。如果有动物负责人指示停车，您必须停车。",
    "image_name": ""
  },
  {
    "index": 387,
    "id": "ABMW0319RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机看到前方有骑马者，应该怎么做？",
    "options": [
      "司机应增加速度并保持额外的安全距离",
      "司机应减速，保持额外的安全距离，并谨慎超车",
      "司机应减速并拉响喇叭",
      "司机应打开危险警示灯并以正常速度继续行驶"
    ],
    "correct_answer": 1,
    "explanation": "在驾驶过程中，您应始终注意前方路况，准备应对交通情况的变化。如果在路上遇到马匹或其他动物，您应减速并做好停车的准备。不要使用喇叭或做任何可能吓到动物的行为。如果有负责动物的人指示停车，您必须停车。",
    "image_name": ""
  },
  {
    "index": 388,
    "id": "ABMW0320R",
    "section": "安全与负责驾驶",
    "question": "遇到马匹骑手在路上时，驾驶员应注意什么？",
    "options": [
      "驾驶员应该意识到，车辆发出的噪音不会吓到马匹",
      "驾驶员应该知道，马骑手在车辆经过时有义务下马控制马匹",
      "驾驶员应该意识到，车辆发出的噪音可能会吓到马匹并导致其狂奔",
      "驾驶员应该明白，并非所有马骑手都具备处理马匹的经验"
    ],
    "correct_answer": 2,
    "explanation": "你必须了解你在道路上对待动物交通的责任。马容易受到惊吓，任何突然的噪音或活动都可能使它们猛然奔跑。",
    "image_name": ""
  },
  {
    "index": 389,
    "id": "ABMW0321RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在接近驼峰时应该怎么做？",
    "options": [
      "司机应该减速，靠左行驶，并提高对前方危险的警惕性",
      "司机应保持正常速度和道路位置",
      "司机应加速通过驼峰丘陵",
      "司机应移至中间以避免可能停在左侧的车辆"
    ],
    "correct_answer": 0,
    "explanation": "當您接近一座驼峰桥或山丘時，您應意識到可能會有潛在的危險，例如，對向而來的超車車輛。您應該時刻閱讀前方道路，準備應對這樣的交通情況變化。",
    "image_name": ""
  },
  {
    "index": 390,
    "id": "ABMW0339RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员进入被悬挂树木阴影深深覆盖的区域时，白天可能会出现什么危险？",
    "options": [
      "能见度突然降低",
      "车辆引擎可能突然变冷",
      "轮胎气压可能会下降",
      "车辆的挡风玻璃可能会起雾"
    ],
    "correct_answer": 0,
    "explanation": "当您从阳光明媚的地方进入阴影深处时，您的眼睛可能需要一段时间来适应这种变化，您可能不会立即看到前方的危险。",
    "image_name": ""
  },
  {
    "index": 391,
    "id": "ABMW0343RU23",
    "section": "安全与负责驾驶",
    "question": "给出晚了的转向信号会如何影响其他道路使用者？",
    "options": [
      "它们不受影响",
      "它只影响其他驾驶员在红绿灯处",
      "它只对其他驾驶员在环岛处有影响",
      "他们可能没有被给予足够的时间来反应"
    ],
    "correct_answer": 3,
    "explanation": "发出信号是告诉其他道路使用者你的意图的一种方式。因此，在启动、右转或左转、变道、超车、减速或停车之前，你应该适当地发出信号。清晰而及时地发出信号，并记住发出信号并不赋予你优先通行权。迟发信号可能会使其他道路使用者感到困惑。",
    "image_name": ""
  },
  {
    "index": 392,
    "id": "ABMW0345RU23",
    "section": "安全与负责驾驶",
    "question": "当司机处于能见度极为有限的十字路口时，司机应该做什么？",
    "options": [
      "鸣笛并迅速前行",
      "将车辆驶出道路，让其他驾驶员能看到你",
      "要极度小心地驶出，仔细观察左右两侧"
    ],
    "correct_answer": 2,
    "explanation": "在路口视线受阻时，您应该小心地移动到一个可以看到却不干扰其他道路使用者的位置。然后再继续前行之前评估情况。",
    "image_name": ""
  },
  {
    "index": 393,
    "id": "ABMW0348RU19",
    "section": "安全与负责驾驶",
    "question": "接近红灯亮起时，驾驶员应该怎么做？",
    "options": [
      "转向并加速",
      "停下来，然后非常谨慎地继续前行",
      "按一下喇叭然后前进",
      "检查没有对向车辆后加速"
    ],
    "correct_answer": 1,
    "explanation": "靠近红灯时，司机应停车，并在道路畅通时谨慎前行。",
    "image_name": ""
  },
  {
    "index": 394,
    "id": "ABMW0464RU23",
    "section": "安全与负责驾驶",
    "question": "骑车人在穿越道路标线（如线条或箭头）时应注意什么？",
    "options": [
      "转向更灵活",
      "轮胎抓地力降低",
      "轮胎抓地力不受影响"
    ],
    "correct_answer": 1,
    "explanation": "骑行只有2个轮子的车辆时，骑手需要时刻注意道路表面的不规则和其他问题。这可能包括所有的道路标线。",
    "image_name": ""
  },
  {
    "index": 395,
    "id": "ABMW0468RU23",
    "section": "安全与负责驾驶",
    "question": "驾驶员接近道路施工警示标志时应该做什么？",
    "options": [
      "保持速度，直到被信号旗手指示减速",
      "增加速度并移到道路中间",
      "减速，准备停下来让工程车辆或信号旗手通过"
    ],
    "correct_answer": 2,
    "explanation": "驾驶员在接近道路工程时应谨慎行驶，并降低车速，因为可能有许多潜在危险需要处理，包括道路工人、工程车辆、不平整的路面和临时交通控制。",
    "image_name": ""
  },
  {
    "index": 396,
    "id": "ABMW0560RU23",
    "section": "安全与负责驾驶",
    "question": "如果司机怀疑他们的车辆转向灯没有被看到，司机应该怎么做？",
    "options": [
      "司机在道路上的位置就足以作为信号",
      "只要观察到位，就不需要发出信号",
      "此外，也可以使用清晰明确的手势信号"
    ],
    "correct_answer": 2,
    "explanation": "如果驾驶员担心无论出于什么原因指示灯没有提供充分的信号，他们应该清晰有力地使用手势信号，以告知其他道路使用者他们的意图。",
    "image_name": ""
  },
  {
    "index": 397,
    "id": "ABMW0627RU23",
    "section": "安全与负责驾驶",
    "question": "司机应该怎么做才能避免需要急刹车？",
    "options": [
      "在离合器踏板上休息一只脚驾驶",
      "向前看，准备好别人可能会做的事情",
      "启用巡航控制驾驶",
      "在刹车踏板上休息一只脚驾驶"
    ],
    "correct_answer": 1,
    "explanation": "您应该知道您当前的行驶速度，并且您应该始终以适应您所行驶条件的速度行驶，并且您应该能够在您能清晰看到的距离内顺利且安全地停车。",
    "image_name": ""
  },
  {
    "index": 398,
    "id": "ABMW0380RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶时想使用手持手机时，司机应该怎么做？",
    "options": [
      "单手操控方向盘",
      "在安全位置停车后再使用手机",
      "将手机夹在头部和肩膀之间，双手操控方向盘",
      "根据需要移动手机，并且通话时间尽量控制在几分钟内"
    ],
    "correct_answer": 1,
    "explanation": "使用手持电话驾驶汽车或骑摩托车是一种违法行为，并且非常不安全，因为这会阻碍您全神贯注于驾驶。虽然使用免提手机套件不违法，在某些情况下也可能是危险的分心行为，并且您可能会因危险驾驶、粗心驾驶或无意谨慎驾驶而受到起诉。 如果驾驶员需要帮助，他们可以寻求吗？",
    "image_name": ""
  },
  {
    "index": 399,
    "id": "ABMW0337RU23",
    "section": "安全与负责驾驶",
    "question": "为什么尾随(靠得过近跟在前面车辆后面行驶)很危险？",
    "options": [
      "车辆将超速",
      "车辆在紧急情况下无法安全停车",
      "由于车辆引擎上空气流量受限，引擎可能会过热",
      "刹车系统在前方车辆的空气流中效率较低"
    ],
    "correct_answer": 1,
    "explanation": "如果您开车跟前方车辆太近，而它突然刹车，您就没有足够的时间做出反应。因此，您应该始终与前方车辆保持安全距离。在干燥天气中计算安全距离的一种方法是二秒规则：至少要在您的车辆与前方车辆通过一个固定点（如路灯或路标）之间留出两秒钟的时间。",
    "image_name": ""
  },
  {
    "index": 400,
    "id": "ABMW0338RU19",
    "section": "安全与负责驾驶",
    "question": "在高速公路或双车道上允许贴尾吗？",
    "options": [
      "是的，因为有对向车流",
      "是的，因为所有车辆同时朝一个方向行驶",
      "不，因为前方车辆可能会突然停下来",
      "不，因为其他车辆无法超车"
    ],
    "correct_answer": 2,
    "explanation": "如果你开车离前方车辆太近，而它突然刹车，你将没有足够的时间来做出反应。因此，你应该始终与前方车辆保持安全距离。在干燥天气中计算安全距离的一种方法是两秒规则：确保前车和你的车辆经过固定点（如灯柱或路标）时至少间隔两秒。",
    "image_name": ""
  },
  {
    "index": 401,
    "id": "ABMW0382RU19",
    "section": "安全与负责驾驶",
    "question": "如果另一辆车在路口挡住了驾驶员的通行权，驾驶员应该怎么做？",
    "options": [
      "闪灯表示不满",
      "追车并表示不满",
      "要耐心克制",
      "按喇叭并闪灯以表达你的挫败感"
    ],
    "correct_answer": 2,
    "explanation": "您应该始终保持克制。重要的是要明白，优先通行权并非绝对的通行权，您必须始终谨慎行驶，并考虑其他道路使用者的安全。这样更安全、更具社会责任感。",
    "image_name": ""
  },
  {
    "index": 402,
    "id": "ABMW0383RU23",
    "section": "安全与负责驾驶",
    "question": "一个即将开始旅程的驾驶员感到沮丧或愤怒。他们应该怎么做？",
    "options": [
      "一名司机不应该在情绪平静之前驾驶",
      "在一段距离内以比平时更慢的速度行驶",
      "生气或愤怒并不会影响驾驶"
    ],
    "correct_answer": 0,
    "explanation": "如果你在愤怒或心烦意乱时驾驶，你更容易卷入碰撞事故，并更可能对其他驾驶员的不良行为做出反应。在出发旅行之前，花点时间冷静下来，使自己冷静。",
    "image_name": ""
  },
  {
    "index": 403,
    "id": "ABMW0384RU19",
    "section": "安全与负责驾驶",
    "question": "被超车时，对面有来车时，司机应该怎么做？",
    "options": [
      "加速，以便无法超车来车",
      "让超车车辆通过，安全返回道路左侧",
      "保持位置，向前方车辆示意灯光以警告对向来车",
      "保持位置，因为其他驾驶员不应尝试超车"
    ],
    "correct_answer": 1,
    "explanation": "当您正在被超车而且有对向车辆时，您应该考虑其他所有交通情况，并让超车车辆在你前面行驶，以避免碰撞的风险。",
    "image_name": ""
  },
  {
    "index": 404,
    "id": "ABMW0385RU23",
    "section": "安全与负责驾驶",
    "question": "当另一名司机急于前行并插队时，司机应该怎么做？",
    "options": [
      "保持耐心，不要做出反应",
      "加速行驶以弥补耽误的时间",
      "紧跟其后，使其他车辆无法做同样的事情",
      "闪灯表示他们的恼怒"
    ],
    "correct_answer": 0,
    "explanation": "如果另一位驾驶员行为不当，你不应该让自己感到恼火 保持克制，不要做出反应。道路愤怒只会增加碰撞的风险。",
    "image_name": ""
  },
  {
    "index": 405,
    "id": "ABMW0469RU23",
    "section": "安全与负责驾驶",
    "question": "驾驶员在通过正在进行道路施工的路段时应该注意什么？",
    "options": [
      "比平常更窄的车道和限制肩膀区域",
      "道路工人始终注意交通流动",
      "确保空出区域供驾驶员通过，以避免交通延误"
    ],
    "correct_answer": 0,
    "explanation": "當通過施工區域時，駕駛員需要格外小心，因為道路表面積可能會大幅減少。它可能更窄、不平整、滑溜或可能有鬆動的碎石，這可能對道路工人和其他道路使用者構成危險。",
    "image_name": ""
  },
  {
    "index": 406,
    "id": "CPC1348U19",
    "section": "安全与负责驾驶",
    "question": "司机应该向谁报告激进行为？",
    "options": [
      "健康和安全管理局",
      "道路安全管理局",
      "当地警察局或交通监控",
      "运输基础设施爱尔兰"
    ],
    "correct_answer": 2,
    "explanation": "向交通监控或警察局举报所有有攻击性驾驶行为的事件。他们是最适合处理有攻击性驾驶行为的人员。",
    "image_name": ""
  },
  {
    "index": 407,
    "id": "ABMW0285R",
    "section": "安全与负责驾驶",
    "question": "在鹅卵石路上驾驶时，为什么要格外小心？",
    "options": [
      "道路表面尤其平坦，轮胎抓地力得到提升",
      "鹅卵石的平整度有助于改善抓地力",
      "道路表面不平整，路面抓地力不一",
      "石头之间的间隙有助于提高路面抓地力和抓地力得到提升"
    ],
    "correct_answer": 2,
    "explanation": "不同的道路表面可能会影响您的车辆在路上的抓地力和制动距离。在不同的路面上驾驶时，您应该注意这一点。",
    "image_name": "ABMW0285R.png"
  },
  {
    "index": 408,
    "id": "ABMW0289R",
    "section": "安全与负责驾驶",
    "question": "这个地方为什么司机要特别小心？",
    "options": [
      "因为有可能有车辆从左边而来",
      "来自右侧的车辆有通行权",
      "因为滑车的危险性增加",
      "来自右侧的车辆不需要发出信号"
    ],
    "correct_answer": 2,
    "explanation": "在道路上有落叶时，您的轮胎可能在路面上的抓地力降低，您的制动距离可能会变长。",
    "image_name": "ABMW0289R.png"
  },
  {
    "index": 409,
    "id": "ABMW0322RU23",
    "section": "安全与负责驾驶",
    "question": "如果路上有大面积的油污，司机应该怎么做？",
    "options": [
      "在较低的挡位保持正常车速并打开危险警示灯",
      "迅速踩下离合器和刹车，并打开危险警示灯",
      "轻踩刹车减速，并打开危险警示灯",
      "保持正常车速并尝试用轮子沿撒出物行驶"
    ],
    "correct_answer": 2,
    "explanation": "当路面上发生油漏时，您的车轮将减少抓地力，如果急剎车，可能会发生打滑危险。如果您遇到路面油污，请轻踩制动并开启危险警告灯一小段时间，以提醒其他交通参与者注意该危险。",
    "image_name": ""
  },
  {
    "index": 410,
    "id": "ABMW0325RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在穿越铁路或有轨电车线之前应该注意什么？",
    "options": [
      "在穿越轨道时，路面可能不平整，轮胎抓地力可能会降低",
      "轮胎在穿越轨道时可能会提高抓地力",
      "车轮可能会被卡在轨道中，导致轮胎爆胎",
      "在穿越轨道时可能会减少轮胎噪音"
    ],
    "correct_answer": 0,
    "explanation": "你应该意识到道路表面变化可能带来的影响。例如，在铁路和有轨电车交叉口，不平整的路面或油渍可能会减少轮胎的抓地力。接近铁路或有轨电车交叉口时要减速，并与前方车辆保持一定距离。",
    "image_name": ""
  },
  {
    "index": 411,
    "id": "ABMW0378RU23",
    "section": "安全与负责驾驶",
    "question": "司机在接近道路工地并有土方机械作业时应该怎么做？",
    "options": [
      "在路面可能有碎石或泥浆时，减慢速度",
      "在道路上停车，将车辆调头并找到替代路线",
      "打开车头灯作为警示并继续前行"
    ],
    "correct_answer": 0,
    "explanation": "在搬运土方机械作业地区，道路上可能会有泥浆和碎石堆积。此外，这类机械的噪音可能会使道路工人难以听清来车的声音。当您遇到搬运土方机械时，请减速并极度小心地前行。",
    "image_name": ""
  },
  {
    "index": 412,
    "id": "ABMW0401RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机在路上遇到散落的石屑，应该怎么做？",
    "options": [
      "停车直到松散的碎石被清除",
      "减速并给其他车辆留出额外的空间",
      "驾驶员应该用手压在挡风玻璃上",
      "增加车速以避免对车辆造成损坏"
    ],
    "correct_answer": 1,
    "explanation": "在路面上有散落的碎石时，您应该减速并遵守任何降低的速度限制，并在您的车辆与其他车辆之间留出额外的空间。这样做还会让您有更多时间停车，帮助减少您的车辆掀起碎石对其他车辆造成的可能伤害与对行人的潜在伤害。",
    "image_name": ""
  },
  {
    "index": 413,
    "id": "ABMW0402RU23",
    "section": "安全与负责驾驶",
    "question": "柴油泄漏对路面有什么影响？",
    "options": [
      "它能提高车辆的制动能力",
      "它会使路面更加湿滑",
      "它会增加轮胎噪音"
    ],
    "correct_answer": 1,
    "explanation": "柴油泄漏在路面上会使路面变得非常滑，特别是在雨天的时候。",
    "image_name": ""
  },
  {
    "index": 414,
    "id": "ABMW12",
    "section": "安全与负责驾驶",
    "question": "在有电车轨道的道路上行驶时，驾驶员为什么需要格外小心？",
    "options": [
      "在轨道上行驶会降低轮胎抓地力",
      "在轨道上行驶可以改善制动",
      "在轨道上行驶可以改善转向",
      "在轨道上行驶可以改善轮胎抓地力"
    ],
    "correct_answer": 0,
    "explanation": "不同的路面会影响您的车辆在道路上的抓地力和制动距离。驾驶时应该注意这一点。",
    "image_name": ""
  },
  {
    "index": 415,
    "id": "ABMW0207RU19",
    "section": "安全与负责驾驶",
    "question": "司机应该在什么时候使用近光灯？",
    "options": [
      "当能见度小于200米时",
      "从黄昏后到黎明前",
      "当能见度小于300米时",
      "从00:00点到06:00点"
    ],
    "correct_answer": 1,
    "explanation": "照明时间被定义为驾驶员应该打开近光灯以便被看到的时间段。这段时间通常从日落后半小时开始，到日出前半小时结束。",
    "image_name": ""
  },
  {
    "index": 416,
    "id": "ABMW0208RU19",
    "section": "安全与负责驾驶",
    "question": "在黄昏时，车辆应该展示什么灯光？",
    "options": [
      "僅使用白天行车灯（DRLs）",
      "近光灯",
      "雾灯",
      "示宽灯"
    ],
    "correct_answer": 3,
    "explanation": "驾驶员在所有低光水平时期都需要看到和被看到 例如在黄昏和黎明时以及在某些恶劣天气条件下。在低光时段，您应该打开近光灯。道路安全局建议摩托车手和司机在白天开启近光灯或日间行车灯。",
    "image_name": ""
  },
  {
    "index": 417,
    "id": "ABMW0437RU19",
    "section": "安全与负责驾驶",
    "question": "在夜间行驶时，一辆典型汽车的远光灯应该能让驾驶员看到多远的距离？",
    "options": [
      "150米",
      "50米",
      "100米",
      "200米"
    ],
    "correct_answer": 2,
    "explanation": "在良好的驾驶条件下，晚上全灯照明的汽车通常能让您看到前方100米。因此，您应该以一种允许您在那个距离内停下来的速度行驶。",
    "image_name": ""
  },
  {
    "index": 418,
    "id": "ABMW0438RU19",
    "section": "安全与负责驾驶",
    "question": "夜间驾驶时，一辆典型汽车的近光灯应该能让驾驶员看到多远的距离？",
    "options": [
      "40 米",
      "30 米",
      "50 米",
      "20 米"
    ],
    "correct_answer": 1,
    "explanation": "在晚上驾驶，在良好的驾驶条件下，汽车的近光灯通常能让您看到前方30米。因此，您应该以适当的速度行驶，以便能够在那段距离内停下来。",
    "image_name": ""
  },
  {
    "index": 419,
    "id": "ABMW0439RU19",
    "section": "安全与负责驾驶",
    "question": "调整不正确的车前灯可能会导致什么后果？",
    "options": [
      "车头灯的瓦数可以减少",
      "车头灯可能会过热",
      "能见度可能会增加",
      "对向道路使用者可能会被眩光"
    ],
    "correct_answer": 3,
    "explanation": "您有责任确保您的车辆适合上路，并且其车头灯调整正确。如果车头灯不对准，它们会变得不那么有效，甚至在切换到近光时也可能会使对向车辆眼花。",
    "image_name": ""
  },
  {
    "index": 420,
    "id": "ABMW0440R",
    "section": "安全与负责驾驶",
    "question": "夜间驾驶时，司机什么时候必须将车辆的远光灯切换为近光灯？",
    "options": [
      "遇到其他交通时",
      "没有对向交通时",
      "以低于50公里每小时的速度行驶时",
      "进入高速公路时"
    ],
    "correct_answer": 0,
    "explanation": "夜间驾驶时，当遇到对向车辆时，应该将车头灯转为近光灯，以免眩目对方。同时，跟随其他车辆行驶时也应该将车头灯转为近光灯，避免你的灯光反射在他们的后视镜中使其眩目。",
    "image_name": ""
  },
  {
    "index": 421,
    "id": "ABMW0441RU19",
    "section": "安全与负责驾驶",
    "question": "夜间驾驶时被对向车辆的灯光照射时，驾驶员应该怎么做？",
    "options": [
      "反复闪烁大灯警告违规司机",
      "靠路左侧行驶，并保持正常速度",
      "向路肩方向看，并必要时减速停车",
      "减速并打开全灯"
    ],
    "correct_answer": 2,
    "explanation": "如果你被对向车辆的灯光弄得眼花缭乱，应该朝着路旁看，直到车辆通过。必要时减速并停车。",
    "image_name": ""
  },
  {
    "index": 422,
    "id": "ABMW0442RU19",
    "section": "安全与负责驾驶",
    "question": "一位司机经常在白天驾驶，现在必须在夜晚进行一次旅程。司机应该做什么？",
    "options": [
      "夜间行驶时，由于交通较轻，可以以较高的速度行驶",
      "要尽量减少困意，因此可以以白天时的速度更快行驶",
      "与白天相同的速度行驶，因为没有额外的危险。",
      "夜间行驶时的能见度较差，因此行驶速度应该比白天慢些",
    ],
    "correct_answer": 3,
    "explanation": "如果你不熟悉夜间驾驶，可能需要花很长时间来适应各种条件。因此，你可能需要开得更慢，直到你习惯了夜间能见度较低的情况。",
    "image_name": ""
  },
  {
    "index": 423,
    "id": "ABMW0443RU19",
    "section": "安全与负责驾驶",
    "question": "关于车速，在夜间驾驶时司机应该做什么？",
    "options": [
      "保持正常车速，全灯行驶",
      "晚间驾驶时，比白天驾驶时速度要快，以减少犯困的可能性",
      "夜间交通较轻时，加快车速",
      "保持车速，使驾驶员能够在前方视线清晰的距离内停车"
    ],
    "correct_answer": 3,
    "explanation": "在晚上驾驶在良好的驾驶条件下，一辆车的全灯通常能让您看到前方100米。因此，您应该以允许您在该距离停下来的速度行驶。",
    "image_name": ""
  },
  {
    "index": 424,
    "id": "ABMW0444RU19",
    "section": "安全与负责驾驶",
    "question": "在夜间驾驶时，驾驶员应采取哪种最安全的方法？",
    "options": [
      "以使司机能够停在其前方能看见明确的距离内的速度驾驶",
      "在最大速度限制下全灯亮起，以清晰地看到前方",
      "一直使用点灯在最大速度限制下驾驶",
      "全灯亮起一直驾驶"
    ],
    "correct_answer": 0,
    "explanation": "晚上在良好的行车条件下，汽车的近光灯通常能让你看到前方30米。因此，你应该以一种速度行驶，使你能够在那个距离内停下来。",
    "image_name": ""
  },
  {
    "index": 425,
    "id": "ABMW0445RU19",
    "section": "安全与负责驾驶",
    "question": "晚上遇到对向车辆时，司机应该怎么做？",
    "options": [
      "增加速度超越對向車輛",
      "避免直接看對向車輛的燈",
      "將目光集中在對向車輛的燈上",
      "將目光直接聚焦在方向盤上"
    ],
    "correct_answer": 1,
    "explanation": "如果被对向车辆的灯光刺眼，应该看向路边，直到车辆经过，如果必要的话可以减速停车。",
    "image_name": ""
  },
  {
    "index": 426,
    "id": "ABMW0446RU19",
    "section": "安全与负责驾驶",
    "question": "晚上驾驶时，司机何时可以使用远光灯？",
    "options": [
      "在緊跟車輛前面時，不允許這種做法",
      "當沒有對向交通時",
      "在有良好路燈的城市建成區內"
    ],
    "correct_answer": 2,
    "explanation": "驾驶员夜间在无照明的农村地区驾驶时，应该使用远光灯以提高能见度，这样能让他们看得尽可能远。然而，确保在必要时调暗这些灯光，以避免炫目或给其它道路使用者带来不便。",
    "image_name": ""
  },
  {
    "index": 427,
    "id": "ABMW0447RU19",
    "section": "安全与负责驾驶",
    "question": "夜间跟车行驶时，司机应当开启哪些灯光？",
    "options": [
      "远光灯",
      "前雾灯",
      "夜间行驶",
      "停车灯"
    ],
    "correct_answer": 0,
    "explanation": "当驾驶员跟车时，应该将车头灯调低，以免前方驾驶员在后视镜中被您的灯光弄得眼花缭乱。",
    "image_name": ""
  },
  {
    "index": 428,
    "id": "ABMW0448RU19",
    "section": "安全与负责驾驶",
    "question": "夜间驾驶时，司机在什么情况下必须使用近光灯？\n夜间驾驶时，司机何时必须使用近光灯？",
    "options": [
      "遇到其他车辆时或在车流后行驶时",
      "在以100km/h以上的速度行驶时",
      "当没有对向交通时",
      "在以50km/h以下的速度行驶时"
    ],
    "correct_answer": 0,
    "explanation": "夜间驾驶时，遇到其他车辆或跟车时应该将远光灯转为近光灯，以避免眩目或危及其他道路使用者的安全。",
    "image_name": ""
  },
  {
    "index": 429,
    "id": "ABMW0450RU19",
    "section": "安全与负责驾驶",
    "question": "受到对向车辆灯光眩目时，驾驶员应该怎么做？",
    "options": [
      "用手遮挡他们的眼睛",
      "瞥一眼仪表盘",
      "不要直接看灯光",
      "把头转向右边"
    ],
    "correct_answer": 2,
    "explanation": "如果被迎面而來車輛的燈光眩目，請不要直接看向迎面的燈光。而是朝向路旁瞥一眼，直到車輛通過和/或必要時減速停車。這將避免因迎面燈光亮度而導致的暫時性失明。",
    "image_name": ""
  },
  {
    "index": 430,
    "id": "ABMW0721RU19",
    "section": "安全与负责驾驶",
    "question": "在夜间驾驶时，驾驶员可以在城市建成区按喇叭吗？",
    "options": [
      "是的，在晚上11:30到早上7:00之间，只有在紧急情况下才能鸣笛",
      "是的，但仅供短暂使用",
      "不，晚上11:30到早上7:00之间在建筑密集区域内不得使用喇叭",
      "是的，但仅限于晚上11:30到早上7:00之间"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员在晚上11:30至早上7:00之间不得在城市建成区使用喇叭，除非有交通紧急情况。只能在道路危险时使用喇叭来警示其他道路使用者，或者在需要时让其注意您车辆的存在以确保安全。按喇叭并不赋予驾驶员自动让行权利。切勿用喇叭激起其他驾驶员的反应或责备。",
    "image_name": ""
  },
  {
    "index": 431,
    "id": "ABMW0723RU19",
    "section": "安全与负责驾驶",
    "question": "鸣喇叭的使用是在什么情况下被禁止的？",
    "options": [
      "在建制区域, 在晚上11:30 pm至凌晨7:00 am之间",
      "在任何道路上, 在晚上11:30 pm至凌晨6:00 am之间",
      "在建制区域, 在晚上10:00 pm至凌晨6:00 am之间",
      "始终在建制区域内"
    ],
    "correct_answer": 0,
    "explanation": "在晚上11点30分至早上7点之间，驾驶员不得在城市建成区按喇叭，除非有交通紧急情况。只有在需要警告其他道路使用者面临危险时，或者需要让他们注意到你的存在以确保安全时才可以按喇叭。按喇叭并不赋予驾驶员自动让行权利。不要按喇叭来挑衅或谴责其他驾驶员。",
    "image_name": ""
  },
  {
    "index": 432,
    "id": "ABMW0241RU23",
    "section": "安全与负责驾驶",
    "question": "在冰雪路面跟随公交车时，驾驶员应该留意什么？",
    "options": [
      "在潮湿的路况中具有相同的制动距离",
      "需要更长的制动距离",
      "需要更短的制动距离"
    ],
    "correct_answer": 1,
    "explanation": "在冰雪路况下驾驶时，您应始终减速，并保持与前方车辆的安全距离，以便必要时能安全停车。",
    "image_name": "ABMW0241RU23.png"
  },
  {
    "index": 433,
    "id": "ABMW0246RU19",
    "section": "安全与负责驾驶",
    "question": "在浓雾中，司机应该使用哪些灯光？",
    "options": [
      "前后雾灯以及危险警示灯",
      "前后雾灯以及侧灯",
      "前后雾灯以及远光灯",
      "前后雾灯以及近光灯"
    ],
    "correct_answer": 3,
    "explanation": "在行驶在浓雾中时，您应该打开前后雾灯以及近光灯。您不应该在雾中开启远光灯。",
    "image_name": "ABMW0246RU19.png"
  },
  {
    "index": 434,
    "id": "ABMW0286RU19",
    "section": "安全与负责驾驶",
    "question": "在暴雨过后，为什么司机应该与前方车辆保持更大的距离？",
    "options": [
      "因为雨后车轮转速更快",
      "因为雨后车轮转速较慢",
      "因为车轮溅起的水花可能影响能见度",
      "因为需要的制动距离缩短了"
    ],
    "correct_answer": 2,
    "explanation": "大雨会影响您的视野和其他道路使用者对您的看见程度。因此，在大雨中您应该放慢速度，并与前方车辆保持更远距离。",
    "image_name": "ABMW0286RU19.png"
  },
  {
    "index": 435,
    "id": "ABMW0326RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在潮湿天气穿越路标线和方向箭头时应注意什么？",
    "options": [
      "转向控制得到改善",
      "轮胎抓地力得到改善",
      "由于轮胎抓地力改善，需要的停车距离缩短",
      "由于轮胎抓地力减少，需要的停车距离增加"
    ],
    "correct_answer": 3,
    "explanation": "您应该了解道路表面变化的影响。例如，道路标线和方向箭头在潮湿时可能变得很滑。在可能的情况下，避免驾驶在道路标线上，并注意打滑的风险增加。",
    "image_name": ""
  },
  {
    "index": 436,
    "id": "ABMW0344R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，雨水会如何影响驾驶？",
    "options": [
      "它减少打滑的危险",
      "它增加打滑的危险",
      "它增加轮胎对路面的抓地力",
      "它增加能见度"
    ],
    "correct_answer": 1,
    "explanation": "当路面潮湿时，您的轮胎与干燥路面的附着力会下降，制动距离增加，容易打滑。因此，您应该在雨后减速行驶，并保持与前方车辆更大的距离。",
    "image_name": "ABMW0344R.png"
  },
  {
    "index": 437,
    "id": "ABMW0349RU19",
    "section": "安全与负责驾驶",
    "question": "在白天有乌云并且能见度降低时，驾驶员应该怎么做？",
    "options": [
      "行驶时点亮近光灯",
      "保持跟在前方任何车辆近而不开启灯光",
      "行驶时开启远光灯",
      "司机不应在照明时间之前打开灯光"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员在所有光线较暗的时段需要看到并被看到，例如在黄昏和黎明时以及在某些恶劣的天气条件下。在光线较暗的时候，您应该打开近光灯。",
    "image_name": ""
  },
  {
    "index": 438,
    "id": "ABMW0392RU19",
    "section": "安全与负责驾驶",
    "question": "潮濕的路面對車輛的制動能力有什麼影響？",
    "options": [
      "它缩短了在干燥路面上所需的制动距离",
      "它对所需的制动距离没有影响",
      "通常情况下，它会使制动距离是在干燥路面上所需的两倍",
      "现代轮胎在湿滑路面上提供的抓地力与在干燥路面上一样有效"
    ],
    "correct_answer": 2,
    "explanation": "当路面潮湿时，您的轮胎与干燥时的路面抓地力会减弱，并且您的制动距离也会增加。因此，在雨天期间或之后，您应该减速并保持与前方车辆更大的距离。",
    "image_name": ""
  },
  {
    "index": 439,
    "id": "ABMW0397RU19",
    "section": "安全与负责驾驶",
    "question": "在雪地或结冰路面行驶时，驾驶员应该允许多少制动距离？",
    "options": [
      "最多是正常距离的十倍",
      "正常距离的两倍",
      "正常距离",
      "最多是正常距离的一半"
    ],
    "correct_answer": 0,
    "explanation": "在雪地或结冰路况下驾驶时，驾驶员应该与前方车辆保持更大的车距，因为制动距离可能增加至正常情况下的十倍。",
    "image_name": ""
  },
  {
    "index": 440,
    "id": "ABMW0399AU19",
    "section": "安全与负责驾驶",
    "question": "在潮湿的道路上，为什么车辆需要更长的时间才能停下来？",
    "options": [
      "制动液在潮湿天气下效果较差",
      "轮胎在潮湿天气下的路面附着力较少",
      "车辆的悬挂在潮湿天气下较轻",
      "轮胎比在干燥天气下有更好的附着力"
    ],
    "correct_answer": 1,
    "explanation": "当在潮湿的路面上行驶时，轮胎的抓地力会减少，这可能导致明显延长的制动距离。驾驶员应意识到这些条件并减速，因为迅速制动可能导致打滑。",
    "image_name": ""
  },
  {
    "index": 441,
    "id": "ABMW0400RU19",
    "section": "安全与负责驾驶",
    "question": "如果车辆的轮胎和路面之间有一层水膜，对车辆的控制有什么影响？",
    "options": [
      "转向效果更佳",
      "仅刹车效果较差",
      "转向和刹车效果较差",
      "转向和刹车效果更佳"
    ],
    "correct_answer": 2,
    "explanation": "當行駛在有很多積水的道路上時，輪胎和路面之間會積聚一層水膜。當發生這種情況時，稱為水漂，會降低輪胎對路面的抓地力，可能導致完全失控，無法控制車輛的轉向和制動。",
    "image_name": ""
  },
  {
    "index": 442,
    "id": "ABMW0403RU19",
    "section": "安全与负责驾驶",
    "question": "在行驶在湿滑的道路条件下，司机应该做什么？",
    "options": [
      "以较低速行驶，缓和加速和刹车",
      "与前方车辆保持正常距离",
      "不时急刹车以测试路面情况",
      "保持正常车速但确保留有额外制动距离"
    ],
    "correct_answer": 0,
    "explanation": "在潮湿路况下驾驶时，驾驶员应该特别注意加速和刹车时要平稳和逐渐。这样有助于避免打滑或侧滑，并有助于保持车辆控制。",
    "image_name": ""
  },
  {
    "index": 443,
    "id": "ABMW0404RU19",
    "section": "安全与负责驾驶",
    "question": "司机在雪地或冰面下坡行驶时应该怎么做？",
    "options": [
      "选择适当的档位并轻踩刹车来控制速度",
      "为避免轮胎打滑，使用比平时更高的档位",
      "避免踩刹车，选择高档位行驶",
      "靠近左侧行驶并轻踩刹车减速"
    ],
    "correct_answer": 0,
    "explanation": "在雪地或冰面行车时，您应选择较低的挡位以利用发动机制动，并在需要时非常轻柔地使用刹车。",
    "image_name": ""
  },
  {
    "index": 444,
    "id": "ABMW0428RU19",
    "section": "安全与负责驾驶",
    "question": "在下雨天气中，司机如何判断与前方车辆的安全跟车距离？",
    "options": [
      "通过在车辆之间保持四个车长的距离",
      "通过在车辆之间保持两个车长的距离",
      "确保驾驶员自己的车辆经过固定点时，至少让前方车辆与驾驶员自己的车辆之间至少间隔两秒",
      "确保驾驶员自己的车辆经过固定点时，至少让前方车辆与驾驶员自己的车辆之间至少间隔四秒"
    ],
    "correct_answer": 3,
    "explanation": "在潮湿的条件下，您应该保持至少四秒钟的距离与前方车辆保持距离——至少是干燥条件下的两倍长度。",
    "image_name": ""
  },
  {
    "index": 445,
    "id": "ABMW0435RU19",
    "section": "安全与负责驾驶",
    "question": "在行驶在浓雾中时，驾驶员应该使用哪种灯光？",
    "options": [
      "使用侧灯和危险警示灯驾驶",
      "使用全灯和雾灯驾驶",
      "使用近光灯和雾灯驾驶",
      "使用示廓灯和雾灯驾驶"
    ],
    "correct_answer": 2,
    "explanation": "在浓雾中，您应该使用近光灯和雾灯（如果配备了的话）。在浓雾中，示廓灯不够亮，全灯会反射浓雾，使得看清前方道路变得更加困难。",
    "image_name": ""
  },
  {
    "index": 446,
    "id": "ABMW0436R",
    "section": "安全与负责驾驶",
    "question": "在行驶密雾天气时，驾驶员应该做什么？",
    "options": [
      "减速并使用远光灯",
      "减速并使用近光灯",
      "沿着中央隔离线行驶，注意反光标记",
      "沿着硬路肩行驶，注意反光标记"
    ],
    "correct_answer": 1,
    "explanation": "在浓雾中，您应该减速并使用点灯和雾灯（如果配备的话）。侧灯在雾中不够明亮，全灯会反射在雾中，使看清您的行驶方向更加困难。",
    "image_name": ""
  },
  {
    "index": 447,
    "id": "ABMW0451RU19",
    "section": "安全与负责驾驶",
    "question": "司机应该在什么情况下使用车辆的雾灯？",
    "options": [
      "只在浓雾和大雪天气下使用雾灯",
      "将雾灯开启作为对行人的警告",
      "在照明不足的乡村道路上使用雾灯",
      "在小雨天气中提高能见度时使用雾灯"
    ],
    "correct_answer": 0,
    "explanation": "司机应仅在浓雾或大雪时使用雾灯。在其他时间必须关闭雾灯。",
    "image_name": ""
  },
  {
    "index": 448,
    "id": "ABMW0452RU19",
    "section": "安全与负责驾驶",
    "question": "司机什么时候可能会遇到黑冰？",
    "options": [
      "气温接近冰点时",
      "黑冰只会出现在高速公路上",
      "这种情况只会发生在清晨",
      "这种情况只会发生在深夜"
    ],
    "correct_answer": 0,
    "explanation": "黑冰是路面上几乎看不见的薄冰层。有时它看起来像一层水，或者就像路面潮湿一样。",
    "image_name": ""
  },
  {
    "index": 449,
    "id": "ABMW0453RU19",
    "section": "安全与负责驾驶",
    "question": "如果路面上有黑冰，司机应该怎么做？",
    "options": [
      "定期踩刹车，以防止刹车系统冻结",
      "避免急刹车、急转向和猛加速",
      "定期踩刹车以检查路面状况",
      "只需使用低档位来增加牵引力"
    ],
    "correct_answer": 1,
    "explanation": "如果司机怀疑有结冰现象，他们应当避免急刹车、急转向和急加速。这将有助于减少打滑的风险。",
    "image_name": ""
  },
  {
    "index": 450,
    "id": "ABMW0454RU19",
    "section": "安全与负责驾驶",
    "question": "道路上哪些地方容易出现黑冰？",
    "options": [
      "仅限于市区地区",
      "仅限于硬路肩",
      "在有庇荫或阴凉处",
      "在沿海道路上，天气温和时"
    ],
    "correct_answer": 2,
    "explanation": "黑冰是指在非常寒冷的表面上结冰的现象。暴露的道路和桥梁可能有黑冰，而同一条道路的其他部分可能是干净的。黑冰几乎是看不见的，因此对摩托车手和司机构成特殊危险。在冬季条件下，如果您注意到轮胎噪音减少或转向变得更轻，您应当怀疑可能有黑冰。",
    "image_name": ""
  },
  {
    "index": 451,
    "id": "ABMW0455RU19",
    "section": "安全与负责驾驶",
    "question": "在冰雪路面行驶时，何为最安全的做法？",
    "options": [
      "完全依赖ABS或其他先进的驾驶员辅助系统",
      "以正常速度行驶，但不时踩刹车以检查抓地力",
      "以比平时更慢的速度行驶，使用轻踩油门和刹车",
      "始终在低速挡行驶，并使用最大加速度"
    ],
    "correct_answer": 2,
    "explanation": "在冰路上行驶时，驾驶员应避免急刹车、急转向和急加速。这样可以帮助减少打滑的风险。",
    "image_name": ""
  },
  {
    "index": 452,
    "id": "ABMW0456RU19",
    "section": "安全与负责驾驶",
    "question": "在驾驶时，结冰路面会对车辆产生什么影响？",
    "options": [
      "后轮胎压增加后",
      "在较低温度下会提高胎面附着力",
      "车辆更容易打滑",
      "前轮胎压增加"
    ],
    "correct_answer": 2,
    "explanation": "冰路会显著影响车辆的操控，容易出现打滑的风险增加。在冰路上驾驶时，司机应避免急刹车、急转向和猛踩油门，以降低打滑风险。",
    "image_name": ""
  },
  {
    "index": 453,
    "id": "ABMW0457RU19",
    "section": "安全与负责驾驶",
    "question": "在行驶路面湿滑的情况下，司机应该怎么做？\n",
    "options": [
      "只使用低档位加速",
      "定期刹车以提高轮胎抓地力",
      "轻踩油门和刹车",
      "比平常速度慢，保持紧跟前方车辆的距离"
    ],
    "correct_answer": 2,
    "explanation": "路面潮湿或结冰时车轮与路面的抓地力较小。在湿滑的路况下减速行驶，并保持与前方车辆的距离更远。",
    "image_name": ""
  },
  {
    "index": 454,
    "id": "ABMW0458RU23",
    "section": "安全与负责驾驶",
    "question": "司机在路面湿滑时如何应对陡坡或驼峰桥？",
    "options": [
      "选择空挡位置",
      "只踩离合器",
      "同时踩离合器和刹车",
      "极度小心驾驶"
    ],
    "correct_answer": 3,
    "explanation": "在湿滑的条件下通过陡坡或驼背桥时要格外小心。在接近时缓慢减速，选择适合车速的合适挡位，并采用轻柔的转向和加速。",
    "image_name": ""
  },
  {
    "index": 455,
    "id": "ABMW0459RU19",
    "section": "安全与负责驾驶",
    "question": "除了滑行的风险之外，司机驾驶车辆在雪天时还应注意什么？",
    "options": [
      "轮胎中的空气可能会冻结，导致爆胎",
      "刹车液可能会冻结，导致刹车失灵",
      "道路标志和道路标线可能会变得模糊",
      "动力转向液可能会冻结，导致转向失效"
    ],
    "correct_answer": 2,
    "explanation": "路标和路面标线可能会被雪覆盖。如果发生这种情况，您可能会难以阅读规定、警告和信息标志。这就是为什么这些标志具有不同形状的主要原因。驾驶员在这些条件下行驶时应格外注意。",
    "image_name": ""
  },
  {
    "index": 456,
    "id": "ABMW0460RU19",
    "section": "安全与负责驾驶",
    "question": "在大雨天驾驶时，司机应该怎么做？",
    "options": [
      "注意车辆可能会出现打滑或“水漂”现象",
      "增加速度，使车辆能够滑过任何积水",
      "稍微摆动车辆，以提高轮胎抓地力",
      "保持与干燥路面相同的正常速度"
    ],
    "correct_answer": 0,
    "explanation": "在潮濕的道路上，輪胎與路面之間可能會形成一層水膜。這稱為滑水，會減少輪胎對路面的抓地力，進而影響轉向和制動。出於這些原因，駕駛應該在雨天期間減速，雨後也要緩慢行駛，並與前方車輛保持較大距離。",
    "image_name": ""
  },
  {
    "index": 457,
    "id": "ABMW0461RU19",
    "section": "安全与负责驾驶",
    "question": "在潮湿的道路上高速驾驶会带来哪些危险？",
    "options": [
      "轮胎压力会自动增加的危险",
      "只要考虑到天气条件增加了轮胎压力，就不会有危险",
      "轮胎压力未考虑天气条件而减少时会发生“水漂”或滑过路面的危险",
      "只要考虑到天气条件降低了轮胎压力，就不会有危险"
    ],
    "correct_answer": 2,
    "explanation": "在大雨和道路上积水的情况下，司机应该适度减速。这有助于避免“水母现象”，这种现象会降低轮胎对道路的抓地力，影响车辆的转向和制动。因此，司机应该在雨天和雨后减速，并保持和前方车辆更大的距离。",
    "image_name": ""
  },
  {
    "index": 458,
    "id": "ABMW0465RU19",
    "section": "安全与负责驾驶",
    "question": "司机在通过被淹没的路段后应该做什么？",
    "options": [
      "逐渐拉紧手刹，以干燥后部制动器",
      "增加车速以干燥制动器",
      "以较低速度轻踩刹车踏板短距离，以干燥制动器",
      "牢牢踩下刹车以检查它们是否仍有效"
    ],
    "correct_answer": 2,
    "explanation": "驾驶车辆通过被淹水的路段时，制动器可能会变得不太有效。如果发生这种情况，请测试制动器，确保它们没有受到水的影响 在这之前请查看后视镜。如果受到影响，请在行驶时轻轻踩刹车踏板，直到它们干燥并恢复正常。",
    "image_name": ""
  },
  {
    "index": 459,
    "id": "ABMW0467RU19",
    "section": "安全与负责驾驶",
    "question": "在道路前方出现浅水积的路段时，司机应该怎么做？",
    "options": [
      "减速并使用更高的挡位",
      "增加速度并使用更高的挡位",
      "以尽可能慢的速度在低挡行驶，保持转速高",
      "使用高挡并保持相同速度，保持发动机转速较低"
    ],
    "correct_answer": 2,
    "explanation": "接近有浅水积水的路段时，减速并评估区域是否存在危险。驶过水面时，选择低档位，尽量慢行，保持高转速，避免熄火。",
    "image_name": ""
  },
  {
    "index": 460,
    "id": "ABMW13U19",
    "section": "安全与负责驾驶",
    "question": "大雨过后，为什么司机应该与前面的车辆保持更大的距离？",
    "options": [
      "因为轮胎在潮湿时的抓地力会改善",
      "因为雨后车轮转动的速度更快",
      "因为雨后车轮转动的速度更慢",
      "因为所需的制动距离更长"
    ],
    "correct_answer": 3,
    "explanation": "在潮湿的道路表面，您的轮胎无法像在干燥条件下那样紧贴道路表面，您的制动距离会增加。因此，在雨天期间或之后，您应该减速行驶，并与前方车辆保持更大的距离。",
    "image_name": ""
  },
  {
    "index": 461,
    "id": "ABMW0515RU19",
    "section": "安全与负责驾驶",
    "question": "一般来说，驾驶员在进入隧道之前应该做以下哪项措施？",
    "options": [
      "打开危险警示灯以警示其他车辆",
      "确保打开全部的前照灯",
      "只在隧道内有其他车辆时使用近光灯",
      "确保打开近光灯"
    ],
    "correct_answer": 3,
    "explanation": "通常，在进入隧道之前，驾驶员应该打开近光灯。",
    "image_name": ""
  },
  {
    "index": 462,
    "id": "ABMW0516RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员进入隧道时应该怎么做？",
    "options": [
      "始终关闭收音机以避免分心",
      "保持与前方车辆的安全距离",
      "靠近前方车辆驾驶",
      "永远不要低于标志速度限制"
    ],
    "correct_answer": 1,
    "explanation": "驾驶员在进入隧道时应与前方车辆保持安全距离，切记不要尾随，以免产生紧急情况。汽车或摩托车的最低推荐安全距离为50米，所有其他车辆为100米。永远记住2秒规则。",
    "image_name": ""
  },
  {
    "index": 463,
    "id": "ABMW0520RU19",
    "section": "安全与负责驾驶",
    "question": "如果隧道内交通非常拥堵，司机应该怎么办？",
    "options": [
      "保持跟随前方车辆的距离",
      "停车",
      "打开危险警示灯",
      "停在最近的紧急出口处"
    ],
    "correct_answer": 2,
    "explanation": "如果隧道拥堵，您应该打开危险警示灯并保持耐心。即使在缓慢移动的交通中，也要与前方车辆保持安全距离。如果有的话，请收听隧道广播电台的交通信息。",
    "image_name": ""
  },
  {
    "index": 464,
    "id": "ABMW0521RU23",
    "section": "安全与负责驾驶",
    "question": "司机如果在隧道內遇到交通堵塞應該怎麼辦？",
    "options": [
      "选择低挡并保持发动机运转",
      "关闭发动机",
      "打开前后雾灯"
    ],
    "correct_answer": 1,
    "explanation": "如果交通在隧道里停顿不前，要熄灭引擎以防止隧道内烟气积聚。保持耐心，遵循隧道操作员的指示。",
    "image_name": ""
  },
  {
    "index": 465,
    "id": "ABMW0522R",
    "section": "安全与负责驾驶",
    "question": "如果一个驾驶员的车辆在隧道内抛锚或者遇到碰撞，应该怎么做？",
    "options": [
      "发信号让所有其他交通停下来",
      "示意其他交通超车",
      "关闭所有灯光并留在车辆内，直到救援到达",
      "打开危险警示灯，步行到紧急站点寻求帮助"
    ],
    "correct_answer": 3,
    "explanation": "如果您的车辆在隧道内发生故障或碰撞，请打开危险警示灯，关闭发动机，前往应急站并使用应急电话通知隧道操作员。",
    "image_name": ""
  },
  {
    "index": 466,
    "id": "ABMW0523R",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆在隧道内抛锚了，司机应该怎么办？",
    "options": [
      "使用紧急电话寻求帮助",
      "走到隧道尽头并拨打警察电话",
      "在车辆内等待帮助到来",
      "拦下路过的汽车并请求帮助"
    ],
    "correct_answer": 0,
    "explanation": "如果你的车辆在隧道中抛锚或遇到碰撞，应打开警示闪光灯，关闭发动机，前往应急站，并使用应急电话联系隧道操作员。",
    "image_name": ""
  },
  {
    "index": 467,
    "id": "ABMW0524RU19",
    "section": "安全与负责驾驶",
    "question": "司机在隧道内发生故障或事件时应该怎么做？",
    "options": [
      "熄火并打开危险报警灯",
      "如果需要的话，倒车让行超车的车辆",
      "示意其他车辆超车",
      "向后方的车辆发出停车信号，并请驾驶员在隧道另一端寻求帮助"
    ],
    "correct_answer": 0,
    "explanation": "如果您的车辆在隧道内发生故障或发生碰撞，请打开警示灯，熄灭引擎，前往紧急站点，并使用紧急电话联系隧道操作员。",
    "image_name": ""
  },
  {
    "index": 468,
    "id": "ABMW0525R",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员的车辆在隧道内起火，应该做什么？",
    "options": [
      "离开车辆，使用隧道内提供的灭火器扑灭火灾",
      "离开车辆，按照紧急逃生路线行动",
      "驾驶至最近的应急站",
      "驾驶至最近的消防安全出口"
    ],
    "correct_answer": 1,
    "explanation": "如果您的车辆在隧道内着火，您应尽快停车，疏散乘客到安全地点，前往应急站并使用应急电话通知隧道操作员。",
    "image_name": ""
  },
  {
    "index": 469,
    "id": "ABMW0462RU19",
    "section": "安全与负责驾驶",
    "question": "当司机在路上遇到泥浆时，应该怎么做？",
    "options": [
      "逐渐增加速度，使路上的泥土不会粘在轮胎上",
      "立即踩刹车并打开危险警告灯",
      "降低车速，并注意路上的农场或工作车辆",
      "换成低档并反复踩刹车以检查路面的滑动程度"
    ],
    "correct_answer": 2,
    "explanation": "在路上有泥泞时，你应该减速并意识到可能会打滑的危险。在路上有泥泞时，你的刹车距离也会变得更长。",
    "image_name": ""
  },
  {
    "index": 470,
    "id": "ABMW0662RU19",
    "section": "安全与负责驾驶",
    "question": "这个刻度盘提供什么信息？",
    "options": [
      "变速箱转速",
      "燃油水平",
      "引擎速度",
      "油位"
    ],
    "correct_answer": 2,
    "explanation": "转速表测量发动机每分钟的转速。一般来说，转速越高，发动机使用的燃油就越多，因此驾驶员应该留意转速表，以帮助更环保地驾驶。",
    "image_name": "ABMW0662RU19.png"
  },
  {
    "index": 471,
    "id": "ABMW0663RU19",
    "section": "安全与负责驾驶",
    "question": "转速表提供哪些信息？",
    "options": [
      "引擎转速",
      "车轮转速",
      "暖风扇转速",
      "变速箱转速"
    ],
    "correct_answer": 0,
    "explanation": "转速表测量发动机每分钟的转速。一般来说，转速越高，发动机使用的燃料就越多，因此驾驶员应该密切关注转速表，以帮助更加环保地驾驶。",
    "image_name": "ABMW0662RU19.png"
  },
  {
    "index": 472,
    "id": "ABMW0688RU19",
    "section": "安全与负责驾驶",
    "question": "车辆排气管冒出蓝色烟雾通常意味着什么？",
    "options": [
      "催化转换器磨损",
      "引擎过热",
      "引擎在燃烧机油",
      "需要更换空气滤清器"
    ],
    "correct_answer": 2,
    "explanation": "当汽车燃烧机油时，排气管可能会冒出蓝烟。糟糕的维护和磨损的发动机是典型的原因。这种蓝烟对环境有害，可能代价高昂。驾驶员应当让有经验的人员检查车辆。",
    "image_name": ""
  },
  {
    "index": 473,
    "id": "ABMW0689RU19",
    "section": "安全与负责驾驶",
    "question": "磨损的排气管会导致什么影响？",
    "options": [
      "燃油效率随着排放更快而增加",
      "尾气过滤减少，发动机噪音更大",
      "换挡更困难",
      "发动机会过热"
    ],
    "correct_answer": 1,
    "explanation": "车辆排气系统磨损会导致一系列问题，包括发动机噪音增加以及对环境造成更多伤害（因为废气无法得到有效过滤）。根据欧盟和爱尔兰法规，车辆需要符合一定要求。在道路车辆检验中，会对车辆进行合规性测试。",
    "image_name": ""
  },
  {
    "index": 474,
    "id": "ABMW0690RU19",
    "section": "安全与负责驾驶",
    "question": "一个故障的排气系统会有什么影响？",
    "options": [
      "它会增加车辆发动机的磨损",
      "它会降低车辆的发动机噪音",
      "它可以提高车辆的燃油消耗",
      "它会增加车辆的噪音和污染水平"
    ],
    "correct_answer": 3,
    "explanation": "车辆的排气系统磨损严重可能会带来多种负面影响，包括发动机噪音增加以及环境污染物排放增加（因未能得到正确过滤）。确保车辆符合欧盟和爱尔兰法规的要求。车辆在道路适应性测试期间会接受合规性测试。",
    "image_name": ""
  },
  {
    "index": 475,
    "id": "ABMW0691U19",
    "section": "安全与负责驾驶",
    "question": "催化轉換器的目的是什麼？",
    "options": [
      "它增加引擎动力",
      "它减少引擎动力",
      "它过滤排气并减少空气污染",
      "它使引擎能够快速达到正常工作温度"
    ],
    "correct_answer": 2,
    "explanation": "催化轉換器（CAT）的作用是從排氣中去除有毒或污染氣體，例如一氧化碳、氮氧化物和未完全燃燒的碳氫化合物。當催化轉換器發生故障時，引擎管理警示燈會亮起在儀表板上，駕駛應該尋求合格人員的建議。",
    "image_name": ""
  },
  {
    "index": 476,
    "id": "ABMW0715U19",
    "section": "安全与负责驾驶",
    "question": "激烈的加速会如何影响燃油消耗？",
    "options": [
      "燃油消耗降低",
      "只要发动机调校正确，不会有影响",
      "燃油消耗增加",
      "如果挂入高档位，不会有影响"
    ],
    "correct_answer": 2,
    "explanation": "急加速会增加燃油消耗。平稳加速有助于降低燃油消耗和车辆排放。尽量不要过度转速发动机，根据车速使用适当的挡位。减速时，松开加速踏板，让车辆逐渐减速后再刹车。",
    "image_name": ""
  },
  {
    "index": 477,
    "id": "ABMW0716RU23",
    "section": "安全与负责驾驶",
    "question": "司机应该怎么做才能尽量减少车辆的燃料消耗？",
    "options": [
      "使用轻踏油门和刹车",
      "在换挡时使用最大加速",
      "在低档位轻盈驾驶"
    ],
    "correct_answer": 0,
    "explanation": "平稳驾驶有助于降低燃料消耗。提前观察道路情况，及时调整车速，避免急加速和晚刹车。",
    "image_name": ""
  },
  {
    "index": 478,
    "id": "ABMW0717RU19",
    "section": "安全与负责驾驶",
    "question": "持续高速驾驶如何影响燃油消耗？",
    "options": [
      "它在道路保持直线时会降低燃油消耗",
      "它会增加燃油消耗",
      "它与较低速度驾驶一样耗费燃油",
      "它会降低燃油消耗"
    ],
    "correct_answer": 1,
    "explanation": "在高速行驶时会增加燃油消耗。以112km/h行驶的车辆大约比以80km/h行驶的车辆多消耗约30%的燃油。",
    "image_name": ""
  },
  {
    "index": 479,
    "id": "ABMW0718R",
    "section": "安全与负责驾驶",
    "question": "为了确保车辆更高燃油效率，司机应该做什么？",
    "options": [
      "确保车辆定期保养",
      "确保重物在车辆后部携带",
      "为了减少在路上的时间，以较高的速度驾驶",
      "确保车辆上携带的任何负载均匀分布"
    ],
    "correct_answer": 0,
    "explanation": "保持良好燃油效率的关键之一是确保车辆保养良好。应按制造商的建议定期进行汽车维护保养。定期检查轮胎气压也有助于保持良好的燃油效率。",
    "image_name": ""
  },
  {
    "index": 480,
    "id": "ABMW0719RU19",
    "section": "安全与负责驾驶",
    "question": "如何提高燃油效率？",
    "options": [
      "只有在寒冷条件下使用防结冰剂",
      "通过轻踩油门，并根据速度适时换挡",
      "通过加速到达所需速度为目的，尽可能快地完成上升档操作",
      "尽可能长时间保持车辆在较低挡以驾驶"
    ],
    "correct_answer": 1,
    "explanation": "司机可以通過提前閱讀路況並平穩駕駛來提高車輛的燃油效率。這可以通過溫和加速、根據自己當前行駛速度使用最適合的擋位，並避免急剎車來實現。",
    "image_name": ""
  },
  {
    "index": 481,
    "id": "ABMW0720RU19",
    "section": "安全与负责驾驶",
    "question": "一辆车辆使用磨损的排气系统会产生什么影响？",
    "options": [
      "这会导致噪音和尾气污染水平上升",
      "这会导致发动机冷却液泄漏",
      "这会减少燃油消耗",
      "这会导致机油泄漏在路上"
    ],
    "correct_answer": 0,
    "explanation": "一辆排气系统磨损的车辆可能会比较吵，也会产生更多污染排放物。车辆的噪音和排放物水平受到严格监管，这些在车辆的NCT时进行了严格检查。",
    "image_name": ""
  },
  {
    "index": 482,
    "id": "ABMW0725R",
    "section": "安全与负责驾驶",
    "question": "机动车辆以何种方式对环境造成伤害？",
    "options": [
      "透过增加一氧化碳水平",
      "透过减少氡水平",
      "透过减少一氧化碳水平",
      "透过增加氡水平"
    ],
    "correct_answer": 0,
    "explanation": "一氧化碳是由车辆排气排放到大气中的有毒气体。经济驾驶和保持车辆良好维护可以降低一氧化碳排放水平。",
    "image_name": ""
  },
  {
    "index": 483,
    "id": "ABMW0727RU19",
    "section": "安全与负责驾驶",
    "question": "在驾驶时，司机可以做些什么来最大限度地提高燃油效率？",
    "options": [
      "提高路速",
      "安装车顶行李架",
      "减少所有轮胎的气压",
      "避免携带不必要的重量"
    ],
    "correct_answer": 3,
    "explanation": "车辆额外负重越多，燃料消耗就会越大。安装车顶行李架或行李箱会增加风阻，从而增加燃料消耗——最多可达15%。不使用时请拆除车顶行李架和行李箱。",
    "image_name": ""
  },
  {
    "index": 484,
    "id": "ABMW0728RU19",
    "section": "安全与负责驾驶",
    "question": "哪项行为可能会导致燃油消耗增加？",
    "options": [
      "保持恒定速度",
      "关闭空调",
      "急加速",
      "提前观察并预测交通流量"
    ],
    "correct_answer": 2,
    "explanation": "激烈加速会增加燃油消耗。平稳驾驶可减少磨损并改善燃油消耗。在不使引擎过载的情况下使用尽可能高的挡位。",
    "image_name": ""
  },
  {
    "index": 485,
    "id": "ABMW0729RU23",
    "section": "安全与负责驾驶",
    "question": "司机可以采取哪些措施来帮助保护环境？",
    "options": [
      "只使用低档位",
      "在行驶过程中急加速和急刹车",
      "使用公共交通工具"
    ],
    "correct_answer": 2,
    "explanation": "乘坐公共交通有助于保护环境。公交车、有轨电车和火车是在城市地区特别是搬运大量人口更环保的方式。在可能的情况下请考虑使用公共交通 这不仅更环保，而且考虑到燃油费和停车费用，还可能更划算。",
    "image_name": ""
  },
  {
    "index": 486,
    "id": "ABMW0730R",
    "section": "安全与负责驾驶",
    "question": "“‘Eco-Driving’ 这种驾驶风格能够实现什么？”",
    "options": [
      "增加行程时间",
      "增加燃油消耗",
      "减少燃油消耗",
      "减少行程时间"
    ],
    "correct_answer": 2,
    "explanation": "生态驾驶的优势包括提高道路安全、改善燃油消耗以及减少排放。环保意识的驾驶员变得更加高效，因为他们学会了提前阅读道路，并展现出更好的预判能力。这减少了急加速和急刹车的需要，从而实现更经济的驾驶风格和更顺畅的行驶。",
    "image_name": ""
  },
  {
    "index": 487,
    "id": "ABMW0731R",
    "section": "安全与负责驾驶",
    "question": "哪个动作有助于生态驾驶？",
    "options": [
      "急刹车",
      "安装车顶行李架",
      "低档高速行驶",
      "尽快挂高档"
    ],
    "correct_answer": 3,
    "explanation": "生态驾驶有助于道路安全，同时还能减少燃油消耗和有害排放。注重环保的驾驶员会提前阅读道路并避免急加速和急刹车。为减少燃油消耗，可尽量使用最高档位，避免发动机过度劳累。",
    "image_name": ""
  },
  {
    "index": 488,
    "id": "ABMW0732R",
    "section": "安全与负责驾驶",
    "question": "司机如何可以帮助环境？",
    "options": [
      "通过急刹车",
      "通过急加速",
      "通过减速",
      "通过增加速度"
    ],
    "correct_answer": 2,
    "explanation": "作为驾驶员，如果您平稳驾驶，避免急加速和急刹车，就可以减少对环境造成的损害。行驶速度为 110 km/h的车辆比行驶速度为 80 km/h的车辆使用的燃油高出多达 30%。然而，您不应该开得太慢以至于影响其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 489,
    "id": "ABMW279U19",
    "section": "安全与负责驾驶",
    "question": "“Eco-Driving” 这种驾驶风格能带来什么好处？",
    "options": [
      "延长行程时间",
      "提高道路安全性",
      "缩短行程时间",
      "增加排放"
    ],
    "correct_answer": 1,
    "explanation": "生态驾驶的优势包括提高道路安全、改善燃油消耗和减少排放。生态意识的驾驶者会变得更加高效，因为他们学会提前看路，并展现出更好的预见技巧。这减少了对急加速和急刹车的需要，从而实现更节省的驾驶风格和更顺畅的驾驶。",
    "image_name": ""
  },
  {
    "index": 490,
    "id": "ABMW28U19",
    "section": "安全与负责驾驶",
    "question": "“经济驾驶”这种驾驶风格能够达到什么效果？",
    "options": [
      "增加的燃料消耗",
      "增加的行驶时间",
      "增加的燃料效率",
      "增加的排放"
    ],
    "correct_answer": 2,
    "explanation": "生态驾驶风格的许多优点之一包括：提高燃油效率，减少排放和提高驾驶员安全。具有生态意识的驾驶员变得更加高效，因为他们学会提前看路并展现出更好的预判技能。这减少了对急加速和刹车的需求，从而实现更经济的驾驶风格和更顺畅的行驶方式。",
    "image_name": ""
  },
  {
    "index": 491,
    "id": "ABMW29U19",
    "section": "安全与负责驾驶",
    "question": "什么行为有助于生态驾驶？",
    "options": [
      "急剎车",
      "开着车窗",
      "保持稳定速度",
      "低档高速行驶"
    ],
    "correct_answer": 2,
    "explanation": "保持稳定速度的许多优点之一是: 增加燃油效率，减少排放，提高驾驶安全性。环保意识强的驾驶员会变得更高效，因为他们学会提前观察道路并展现更好的预判能力。这样就减少了急加速和刹车的需要，从而实现更经济的驾驶风格，并更加平稳。",
    "image_name": ""
  },
  {
    "index": 492,
    "id": "ABMW30U19",
    "section": "安全与负责驾驶",
    "question": "哪种行为有助于生态驾驶？",
    "options": [
      "急刹车",
      "注视前方并提前预判",
      "低速高挡行驶",
      "减少轮胎压力"
    ],
    "correct_answer": 1,
    "explanation": "生态驾驶风格的许多优点之一包括：提高燃油效率、减少排放和提高驾驶安全性。有环保意识的驾驶员会变得更加高效，因为他们学会提前阅读道路并展现更好的预判能力。这减少了对急加速和急刹车的需求，从而实现更经济的驾驶风格和更平稳的行驶。",
    "image_name": ""
  },
  {
    "index": 493,
    "id": "ABMW0359R",
    "section": "安全与负责驾驶",
    "question": "司机在驾驶时感到昏昏欲睡应该怎么办？",
    "options": [
      "调高暖气",
      "停下来，休息一下，尽可能包括一小段步行",
      "打开车窗或者打开空调让凉爽的空气进入车内",
      "停下来吃顿美好的餐点来提升能量水平"
    ],
    "correct_answer": 1,
    "explanation": "開車時感到疲勞是非常危險的，疲勞是造成嚴重道路碰撞的主要原因之一。如果在開車時感到昏昏欲睡，應在安全的地方停車短暫小睡一下。然後出去呼吸新鮮空氣，伸展一下腿部幾分鐘再次啟程。喝一些含咖啡因的飲料，如咖啡，也可能有所幫助。",
    "image_name": ""
  },
  {
    "index": 494,
    "id": "ABMW0360RU23",
    "section": "安全与负责驾驶",
    "question": "司机如果感到疲劳时应该怎么办？\nAnswer: 如果司机在驾驶过程中感到疲劳，应立即停车休息。",
    "options": [
      "司机应沿着路中间行驶并减速",
      "司机应停车休息一会儿",
      "司机应在有硬路肩的地方行驶"
    ],
    "correct_answer": 1,
    "explanation": "在疲劳驾驶时是非常危险的，可能导致您出现微睡（或瞌睡片刻）。在每小时100公里的时速下，您每秒行驶28米，所以如果您微睡仅4秒，您将在没有控制车辆的情况下行驶超过100米。如果您感到困倦，千万不要驾驶。",
    "image_name": ""
  },
  {
    "index": 495,
    "id": "ABMW0388RU19",
    "section": "安全与负责驾驶",
    "question": "酗酒对驾驶员行为有何影响？",
    "options": [
      "它会减慢驾驶员的反应速度",
      "它可以提高感知和意识",
      "它可能降低驾驶员的信心",
      "它不会影响驾驶员的行为或能力"
    ],
    "correct_answer": 0,
    "explanation": "酒精是导致可能导致死亡和受伤的碰撞的主要因素。即使是少量的酒精也会影响您的判断力和驾驶能力。",
    "image_name": ""
  },
  {
    "index": 496,
    "id": "ABMW0389RU19",
    "section": "安全与负责驾驶",
    "question": "饮酒会对驾驶员产生什么影响？",
    "options": [
      "它提高了注意力",
      "它改善了协调能力",
      "它降低了注意力",
      "它增加了警觉性"
    ],
    "correct_answer": 2,
    "explanation": "酒精是导致死亡和受伤的碰撞的主要因素。即使少量酒精也会影响您的判断力、注意力和应对危险的能力。驾驶者永远不应酒后驾车。",
    "image_name": ""
  },
  {
    "index": 497,
    "id": "ABMW0390RU19",
    "section": "安全与负责驾驶",
    "question": "如果一位机动车驾驶者或摩托车骑手正在服用可能影响驾驶的药物，他们应该怎么做？",
    "options": [
      "只能短距离驾驶",
      "在服用影响驾驶的药物时要减慢速度",
      "驾驶时要多喝水",
      "有关驾驶问题需征求医学建议"
    ],
    "correct_answer": 3,
    "explanation": "有些药物可能影响驾驶者的安全驾驶能力。如果您正在服用任何药物，应该询问您的医生或药剂师是否在服药期间安全驾驶。阅读随药物提供的患者信息传单。",
    "image_name": ""
  },
  {
    "index": 498,
    "id": "ABMW0449RU19",
    "section": "安全与负责驾驶",
    "question": "夜间驾驶时司机应该注意什么？",
    "options": [
      "凌晨十二点至早上六点之间不适用速限",
      "所有行人将穿着高能见度服装",
      "提醒可能有自己或其他司机会犯困",
      "卡车可能在高速公路的外侧车道行驶"
    ],
    "correct_answer": 2,
    "explanation": "疲劳驾驶非常危险，驾驶员疲劳是严重道路碰撞的主要原因之一。如果驾驶员在驾驶过程中感到困倦，他们应该在一个安全的地方停下来，喝一些含咖啡因的饮料并小睡片刻。之后，他们应该出去呼吸新鲜空气，伸展一下双腿几分钟，然后再次出发。疲劳的唯一治疗方法是适当的睡眠。永远不要疲劳驾驶。",
    "image_name": ""
  },
  {
    "index": 499,
    "id": "RSA00045A",
    "section": "安全与负责驾驶",
    "question": "如果在第一次犯罪时，司机拒绝向警察提供血液、尿液或呼吸样本，他们将被自动取消驾驶资格多长时间？",
    "options": [
      "4年",
      "3年",
      "2年",
      "1年"
    ],
    "correct_answer": 0,
    "explanation": "不遵守阿尔·加达·雪肖纳成员要求提供呼吸、尿液或血液样本是一种犯罪行为。",
    "image_name": ""
  },
  {
    "index": 500,
    "id": "RSA00046AU19",
    "section": "安全与负责驾驶",
    "question": "如果一个学习驾驶员饮酒后驾驶，即使只喝了一单位酒，可能会面临哪些后果？",
    "options": [
      "一项90欧元罚款",
      "一项60欧元罚款",
      "三个月停驾",
      "一个月停驾"
    ],
    "correct_answer": 2,
    "explanation": "新手/学习驾驶员的血液酒精浓度限制比持有超过两年完整驾照的驾驶员（非新手驾驶员）低得多。 因此，即使饮用小于一个单位的酒精也会导致驾驶员超过较低的限制。",
    "image_name": ""
  },
  {
    "index": 501,
    "id": "RSA00049A",
    "section": "安全与负责驾驶",
    "question": "在法庭上，学习驾驶员血液酒精浓度超过80mg时，最高的停驾期是多久？",
    "options": [
      "一年",
      "四年",
      "六年",
      "两年"
    ],
    "correct_answer": 2,
    "explanation": "如果一名学员驾驶员未能支付罚款通知，他们将被传唤到法庭，法官可对其实施1-6年的停驶期。",
    "image_name": ""
  },
  {
    "index": 502,
    "id": "RSA0200",
    "section": "安全与负责驾驶",
    "question": "酒后驾驶惩罚对于血液酒精浓度（BAC）在20毫克到80毫克每100毫升血液的学员驾驶者是什么？",
    "options": [
      "200欧元罚款和3分扣分",
      "200欧元罚款和6个月驾驶资格停止",
      "200欧元罚款和3个月驾驶资格停止",
      "200欧元罚款和5分扣分"
    ],
    "correct_answer": 2,
    "explanation": "酒精是导致死亡和受伤事故的主要因素。研究证明，即使饮用少量酒精也会影响您的判断力和驾驶能力。驾驶时血液中酒精含量超过法定限值是违法行为。",
    "image_name": ""
  },
  {
    "index": 503,
    "id": "RSA0201",
    "section": "安全与负责驾驶",
    "question": "一个持有全驾车牌照的专业司机，如果被发现血液中的酒精浓度为100毫升血液中20毫克至80毫克，会面临什么喝酒驾驶处罚？",
    "options": [
      "罚款200欧元和驾驶暂扣3个月",
      "50毫克/升（BAC）以下不会受到处罚",
      "处罚仅适用于80毫克/升（BAC）以上",
      "罚款100欧元和驾驶暂扣6个月"
    ],
    "correct_answer": 0,
    "explanation": "酒精是导致致命和受伤事故的主要因素。研究证明，即使是少量的酒精也会影响您的判断能力和驾驶能力。驾驶时酒精含量超过法定限制是违法的。",
    "image_name": ""
  },
  {
    "index": 504,
    "id": "RSA0202",
    "section": "安全与负责驾驶",
    "question": "80毫克至100毫升血液中含有酒精浓度的驾驶员的酒后驾驶处罚是什么？",
    "options": [
      "€400罚款和6个月驾驶禁令",
      "€400罚款和3个月驾驶禁令",
      "€200罚款和3个月驾驶禁令",
      "€200罚款和6个月驾驶禁令"
    ],
    "correct_answer": 0,
    "explanation": "酒精是导致致命和受伤事故的主要因素。研究证明，即使少量酒精也会影响您的判断力和驾驶能力。酒精含量超过法定限制驾驶是违法的。",
    "image_name": ""
  },
  {
    "index": 505,
    "id": "RSA0203",
    "section": "安全与负责驾驶",
    "question": "司机第二次拒绝提供呼吸、血液或尿液样本作为證據给爱尔兰警察局的处罚是什么？",
    "options": [
      "自动停权4年",
      "自动停权6年",
      "自动停权3个月",
      "自动停权12个月"
    ],
    "correct_answer": 1,
    "explanation": "酒精是导致致命和受伤事故的主要因素。研究证明，即使是少量的酒精或药物也会影响您的判断力和驾驶能力。驾驶时酒精含量超过法定限制，或者在服用药物的情况下是违法的。拒绝提供呼气、血液或尿样本是犯罪行为。",
    "image_name": ""
  },
  {
    "index": 506,
    "id": "RSA0204",
    "section": "安全与负责驾驶",
    "question": "*An Gárda Síochána* 是否可以在早上进行路边毒品和酒精测试？",
    "options": [
      "他们只能检查毒品",
      "不，他们中午后才能检查",
      "是的，他们随时都可以检查",
      "他们只能检查酒精"
    ],
    "correct_answer": 2,
    "explanation": "酒后驾驶汽车、摩托车、卡车、公共汽车、脚踏车或牵引动物的车辆是违法的，因为“受酒精或其他致幻物影响至无法控制车辆”。致幻物包括酒精和毒品，不论单独使用还是混合使用。这里的“毒品”包括合法的处方药和非处方药（OTC药物）。",
    "image_name": ""
  },
  {
    "index": 507,
    "id": "RSA0205",
    "section": "安全与负责驾驶",
    "question": "除了进行损伤测试外，如果警察怀疑驾驶员受到药物影响驾驶，警察可能会要求进行药物测试。",
    "options": [
      "驾驶执照",
      "唾液样本",
      "呼气样本",
      "保险证书"
    ],
    "correct_answer": 1,
    "explanation": "如果司机在路边检查时被拦下，他们应该意识到，除了进行酒精测试外，警察还可以要求唾液样本，如果他们怀疑司机受毒品影响驾驶。",
    "image_name": ""
  },
  {
    "index": 508,
    "id": "RSA0206",
    "section": "安全与负责驾驶",
    "question": "毒品驾驶定罪的最高处罚是什么？",
    "options": [
      "€3,000欧元罚款和12个月驾驶停权",
      "€3,000欧元罚款和12个月监禁",
      "€5,000欧元罚款和6个月监禁",
      "€5,000欧元罚款和6个月驾驶停权"
    ],
    "correct_answer": 2,
    "explanation": "驾驶人应该意识到，如果他们选择在服用药物后驾驶并被检测到，将面临严厉处罚。毒驾非常危险，因为药物对大脑的影响。",
    "image_name": ""
  },
  {
    "index": 509,
    "id": "RSA0207",
    "section": "安全与负责驾驶",
    "question": "在早上被检测出酒驾和毒驾的限制是否有所不同？",
    "options": [
      "不，它们在任何时候都是相同的",
      "不，除非在上午10点后经过测试",
      "是的，它们在早晨较低",
      "是的，它们在晚上较高"
    ],
    "correct_answer": 0,
    "explanation": "酒后驾车和药物驾驶的限制并不根据司机被检查的时间而变化。酒精和药物会在体内停留一段时间。司机应该在饮酒或吸毒后的第二天早晨仔细考虑是否驾驶车辆，并意识到他们仍可能远超限制。",
    "image_name": ""
  },
  {
    "index": 510,
    "id": "RSA225300",
    "section": "安全与负责驾驶",
    "question": "在开始旅程前，司机感到疲倦时应该怎么做？",
    "options": [
      "在他们开始旅程前打开车辆的窗户",
      "在他们休息好之前不要开始旅程",
      "在旅程中带一杯浓咖啡"
    ],
    "correct_answer": 1,
    "explanation": "司机在感到疲劳时不应驾驶或开始旅程。研究表明，疲劳驾驶对他们自己以及他人都构成重大道路安全风险。",
    "image_name": ""
  },
  {
    "index": 511,
    "id": "RSA225301",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员在驾驶过程中出现微睡，应该怎么办？",
    "options": [
      "在抵达目的地后，休息20分钟",
      "停在安全的地方",
      "打开所有车窗以降低温度"
    ],
    "correct_answer": 1,
    "explanation": "司机不应该在疲劳或劳累时驾驶。研究表明，疲劳驾驶者是道路安全的重大风险，对自己和他人都构成威胁。如果司机感到疲劳并且在与睡意作斗争，他们可能会出现“微睡”现象，这种情况持续时间长达10秒，甚至在睁着眼睛的情况下也会发生。即使是4秒的微睡，车辆也可以行驶100米（超过了）。",
    "image_name": ""
  },
  {
    "index": 512,
    "id": "RSA225302",
    "section": "安全与负责驾驶",
    "question": "如果司机正在服用可能会让他们感到昏昏欲睡的药物，应该怎么办？",
    "options": [
      "继续驾驶直到开始感到昏昏入睡",
      "只在白天驾驶",
      "不要驾驶车辆"
    ],
    "correct_answer": 2,
    "explanation": "在酒精或药物的影响下驾驶车辆，以致无法对车辆进行控制是违法的。酒精和药物都属于致醉物，无论是单独服用还是混合服用。药物包括法律处方药物或非处方药。",
    "image_name": ""
  },
  {
    "index": 513,
    "id": "ABMW0379U19",
    "section": "安全与负责驾驶",
    "question": "根据速度限制，驾驶最“安全”的速度是多少？",
    "options": [
      "司机应始终尽量以道路规定的限速行驶",
      "这个速度可以让司机在能清晰看到的前方距离内停下车辆",
      "司机应始终努力与其他道路使用者以相同速度行驶，不论限速为何",
      "是路上最慢车辆的速度"
    ],
    "correct_answer": 1,
    "explanation": "你应该始终以能够在你能清晰看到的距离内停车的速度驾驶。如果你认为无法安全地在你所能看到的范围内停车，那么你就开得太快了 慢下来。",
    "image_name": ""
  },
  {
    "index": 514,
    "id": "ABMW0406RAU19",
    "section": "安全与负责驾驶",
    "question": "在干燥的道路上，以每小时50公里的速度行驶的汽车的推荐最小制动距离是多少？",
    "options": [
      "Translate 55 metres.",
      "15 metres.",
      "5 metres.",
      "25 metres. to Simplified Chinese:\n\n55 米",
      "15 米",
      "5 米",
      "25 米"
    ],
    "correct_answer": 3,
    "explanation": "车辆的总最小制动距离取决于四个因素：感知时间、反应时间、车辆的速度和车辆的制动能力。在干燥条件下，驾驶车辆以每小时50公里的速度建议的最小制动距离为25米。",
    "image_name": ""
  },
  {
    "index": 515,
    "id": "ABMW0407RAU19",
    "section": "安全与负责驾驶",
    "question": "汽车在潮湿路面上以每小时50公里的速度行驶时，建议的最小停车距离是多少？",
    "options": [
      "36 metres.  --> 36米",
      "16 metres.  --> 16米",
      "56 metres.  --> 56米",
      "76 metres.  --> 76米"
    ],
    "correct_answer": 0,
    "explanation": "车辆的总最小制动距离取决于四个因素：感知时间、反应时间、车辆速度以及车辆的制动能力。在潮湿条件下，以50km/h行驶的汽车建议最小制动距离为36米。",
    "image_name": ""
  },
  {
    "index": 516,
    "id": "ABMW0408RAU19",
    "section": "安全与负责驾驶",
    "question": "汽车在干燥路面上以每小时100公里的速度行驶时，推荐的最小停车距离是多少？",
    "options": [
      "将 120 米",
      "30 米",
      "90 米",
      "70 米",
      "翻译为简体中文"
    ],
    "correct_answer": 3,
    "explanation": "车辆的总最小制动距离取决于四个因素：感知时间、反应时间、车辆速度和车辆的制动能力。在干燥条件下，以100km/h行驶的汽车建议最小停车距离为70米。",
    "image_name": ""
  },
  {
    "index": 517,
    "id": "ABMW0426R",
    "section": "安全与负责驾驶",
    "question": "以下哪些因素会影响车辆的制动距离？",
    "options": [
      "车辆的速度和重量",
      "使用无铅燃料",
      "发动机的功率",
      "刹车片间隙"
    ],
    "correct_answer": 0,
    "explanation": "您的车辆总制动距离取决于其速度和重量 更快和更重的车辆需要更长的制动距离。",
    "image_name": ""
  },
  {
    "index": 518,
    "id": "ABMW0488RU19",
    "section": "安全与负责驾驶",
    "question": "司机在从匝道进入高速公路时应该怎么做？",
    "options": [
      "尝试将车辆速度与已经在高速公路上的交通匹配，并在合适的间隙中并入其中",
      "在加速车道上直接驶入高速公路，因为加速车道的驾驶员具有通行权",
      "始终在加速车道的尽头停车，并礼让高速公路上的交通",
      "沿着硬肩道行驶，直到高速公路交通出现适当的间隙，让驾驶员并入其中"
    ],
    "correct_answer": 0,
    "explanation": "当驶入高速公路时，驾驶员应尽力使车速与高速公路交通保持一致，并在合适的空隙处并入其中，避免在紧急停车带行驶，同时礼让已经在高速公路上行驶的交通。",
    "image_name": ""
  },
  {
    "index": 519,
    "id": "ABMW0490RU19",
    "section": "安全与负责驾驶",
    "question": "在高速公路上行驶时，如果驾驶员错过了他们的出口，应该怎么做？",
    "options": [
      "在硬肩膀等待，直到从两个方向都有合适间隙在交通中出现，然后穿过高速公路到对面",
      "接下来的出口离开高速公路，并使用天桥（或地下通道）穿过到另一侧",
      "当对面交通有合适间隙时，穿过到高速公路的对面",
      "停在硬肩膀上，打开危险灯，并倒车回到所需的出口"
    ],
    "correct_answer": 1,
    "explanation": "如果一名驾驶员在高速公路上错过了他们预定的出口，他们应该继续前往下一个立交桥出口，从那里他们可以离开高速公路，然后在高速公路的对面重新加入。",
    "image_name": ""
  },
  {
    "index": 520,
    "id": "ABMW0492RU19",
    "section": "安全与负责驾驶",
    "question": "离开高速公路后进入匝道时，司机应该怎么做？",
    "options": [
      "在加入道路时，应遵守限速",
      "一直逐渐减速几公里",
      "在匝道上时永远不需要调整速度",
      "进入匝道时应急刹车以减速"
    ],
    "correct_answer": 0,
    "explanation": "当驾驶员离开高速公路时，他们应该进入减速车道并减慢速度。他们应该遵守他们进入道路的限速。",
    "image_name": ""
  },
  {
    "index": 521,
    "id": "ABMW0493RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机错误驶过了他们原本预定的出口，他们应该怎么做？",
    "options": [
      "使用紧急电话寻求建议",
      "停在硬路肩上，倒车返回出口",
      "继续驾驶并在下一个出口离开",
      "小心完成一个 U 形转弯"
    ],
    "correct_answer": 2,
    "explanation": "如果司机在高速公路上错过了他们原打算的出口，他们应该继续前往下一个出口，在那里可以离开高速公路，然后以相反方向重新加入。",
    "image_name": ""
  },
  {
    "index": 522,
    "id": "ABMW0494RU19",
    "section": "安全与负责驾驶",
    "question": "在高速公路驾驶和在其他类型道路上驾驶的主要区别是什么？",
    "options": [
      "在高速公路上，交通通常被允许以更高的速度行驶",
      "持有学习许可证的驾驶人必须由完整驾照持有人陪同",
      "交通在高速公路上通常以比双向车道更低的速度行驶",
      "以120km/h行驶的交通只能使用高速公路的外侧车道"
    ],
    "correct_answer": 0,
    "explanation": "高速公路的设计是为了让交通更快速、更自由地行驶，避免交通灯、十字路口、水平道口和其他可能减速交通的道路特征。对于谁可以使用高速公路也有所限制，例如禁止学习驾驶的司机和排量低于50 cc的摩托车。",
    "image_name": ""
  },
  {
    "index": 523,
    "id": "ABMW0495RU19",
    "section": "安全与负责驾驶",
    "question": "在双车道高速公路上，驾驶员希望安全超车时应采取什么程序？",
    "options": [
      "在安全时使用后视镜、转向灯并超车于右车道",
      "使用转向灯、后视镜并在任何可用车道超车时请确保安全",
      "仅在左车道使用后视镜、转向灯并超车",
      "检查后方交通并在任一车道超车"
    ],
    "correct_answer": 0,
    "explanation": "当司机想在高速公路上超车时，他们通常只应在右侧超车，除非交通以缓慢移动的队列形式行驶。司机应该使用“后视镜-转向灯-后视镜（盲点）-操纵”常规程序。检查后视镜，打开转向灯表示意图，在安全完成超车时再次检查后视镜（和盲点），并完成操纵。他们应特别注意交通的速度。",
    "image_name": ""
  },
  {
    "index": 524,
    "id": "RSA225170",
    "section": "安全与负责驾驶",
    "question": "在双车道上，司机什么时候可以行驶在右侧车道？",
    "options": [
      "在左侧车道超车时，为了与路肩保持更大的距离",
      "在右侧车道跟随其他车辆时"
    ],
    "correct_answer": 0,
    "explanation": "在雙向行車道上，你通常應該開在左邊車道。不應將右邊車道當作行車車道。當超車或打算在短距離內右轉時，可以使用右邊車道。",
    "image_name": ""
  },
  {
    "index": 525,
    "id": "RSA225191",
    "section": "安全与负责驾驶",
    "question": "司机应该在何时驶入高速公路的辅助车道？",
    "options": [
      "離開高速公路",
      "在其他車道超車慢速車輛",
      "讓其他車輛超越"
    ],
    "correct_answer": 0,
    "explanation": "在一些高速公路上会设有辅助车道，位于主要高速公路车道的左侧。它们连接您驶离的道路出口与下一个可用的出口或出口。如果驾驶员已经在高速公路的1号车道，并打算驶离下一个出口，则应该进入辅助车道。辅助车道通常由车道右侧的间断白线标识。",
    "image_name": ""
  },
  {
    "index": 526,
    "id": "ABMW0222RU23",
    "section": "安全与负责驾驶",
    "question": "这种情况下应该采取什么正确的行动？",
    "options": [
      "时刻注意小孩并做好及时刹车的准备",
      "靠近左侧（靠近路边）并按喇叭",
      "继续以相同速度行驶"
    ],
    "correct_answer": 0,
    "explanation": "由于很难预测儿童的行为，您应该时刻准备好对交通情况的变化做出反应或停车。",
    "image_name": "ABMW0222RU23.png"
  },
  {
    "index": 527,
    "id": "ABMW0249RU19",
    "section": "安全与负责驾驶",
    "question": "接近此情况时，驾驶员应该怎么做？",
    "options": [
      "司机应保持当前速度，并减小与银色车辆的距离",
      "司机应准备好前方车辆增加速度",
      "司机可以超越车辆和女孩，因为道路上标有一条破碎的白线",
      "减速并保持准备刹车，因为人行道上的女孩可能会突然过马路"
    ],
    "correct_answer": 3,
    "explanation": "其他道路使用者的行为往往难以预测。你应该做好准备，以防行人突然踏上马路，银色汽车突然停下来。",
    "image_name": "ABMW0249RU19.png"
  },
  {
    "index": 528,
    "id": "ABMW0346R",
    "section": "安全与负责驾驶",
    "question": "司机應該在什麼時候使用車輛的後視鏡？translates to Simplified Chinese as:\n\n司机应该在什么时候使用车辆的后视镜？",
    "options": [
      "在打开后窗除雾器之前",
      "只有后退之前",
      "只有启动之前",
      "改变方向之前"
    ],
    "correct_answer": 3,
    "explanation": "您应该使用后视镜保持对周围和身后交通状况的警觉。在道路上改变方向、打转向灯或开始操作前，一定要先检查后视镜。",
    "image_name": ""
  },
  {
    "index": 529,
    "id": "ABMW0347RU23",
    "section": "安全与负责驾驶",
    "question": "司机在路口视线被阻挡时应该如何操作？",
    "options": [
      "请向路人寻求指引以前往另一条道路",
      "缓慢驶入道路，注意周围的交通情况",
      "鸣笛数次然后前进",
      "闪烁前灯后才驶出"
    ],
    "correct_answer": 1,
    "explanation": "在视线受阻的路口，小心地移动到一个可以看清楚而不干扰其他道路使用者的位置。然后评估情况后再继续前行。",
    "image_name": ""
  },
  {
    "index": 530,
    "id": "ABMW0354RU23",
    "section": "安全与负责驾驶",
    "question": "司机在拖曳带载拖车时需要注意哪些盲点位于哪里？",
    "options": [
      "拖车后部的货物或货物区域",
      "车辆和拖车侧面和后部司机看不见的区域",
      "被其他大型车辆挡住的前方道路部分",
      "遮阳板遮挡住的前方视野"
    ],
    "correct_answer": 1,
    "explanation": "盲点是指驾驶员在向前看或在照镜时无法看到的区域。在改变方向或变换车道前，你应该检查你的盲点。车辆越大，盲点就越大，如果你在大型车辆后面驾驶，比如拖载装载货物的车辆，你应该牢记这一点。在这种情况下，如果你无法看见牵引车辆的后视镜，那么在这",
    "image_name": ""
  },
  {
    "index": 531,
    "id": "ABMW0357RU19",
    "section": "安全与负责驾驶",
    "question": "想要执行掉头的驾驶员应该做什么？",
    "options": [
      "只有在城市限速区外才能进行掉头",
      "检查后方是否有接近的车辆并示意它们停下",
      "检查道路是否是单行道",
      "检查前方是否有接近的车辆并示意它们停下"
    ],
    "correct_answer": 2,
    "explanation": "如果您想掉头，必须首先选择一个安全合法的地点。四周查看其他道路使用者，不要妨碍他们的通行权。高效安全地完成动作。",
    "image_name": ""
  },
  {
    "index": 532,
    "id": "ABMW0358RU23",
    "section": "安全与负责驾驶",
    "question": "想要在道路上掉头的司机应该怎么做？",
    "options": [
      "必要时，驾驶员可以驶入人行道，以确保有足够的空间转弯",
      "检查前方和后方是否有过来的车辆，并在转弯时继续保持警惕",
      "在任何情况下都不允许在道路上调头",
      "驶入某人的车道，然后倒车返回到道路上"
    ],
    "correct_answer": 1,
    "explanation": "如果您想在道路上掉头，必须首先选择一个安全和合法的地点。检查四周是否有其他道路使用者，并不要妨碍他们通行权。高效而安全地完成动作。",
    "image_name": ""
  },
  {
    "index": 533,
    "id": "ABMW0387RU19",
    "section": "安全与负责驾驶",
    "question": "司机在想要安全地变道到右侧有其他车辆的车道时应该怎么做？",
    "options": [
      "在右侧车道出现合适间隙时，请使用镜子、信号和换道",
      "拉近车身并停下，等待合适的间隙，然后切换到右侧车道",
      "增加速度，直到与右侧车道的车流速度相同，然后换道并检查后视镜",
      "逐渐移入右侧车道，打转向灯，然后检查后视镜"
    ],
    "correct_answer": 0,
    "explanation": "任何时候变换车道时，您应该使用“观察后视镜-打灯-再观察后视镜（盲区）-执行”程序。检查您的后视镜，打开转向灯表示您的意图，再次检查后视镜（和盲区），当有合适的缝隙时将车辆转入下一个车道，给予已在该车道的车辆让行。",
    "image_name": ""
  },
  {
    "index": 534,
    "id": "ABMW0683RU19",
    "section": "安全与负责驾驶",
    "question": "正确调整后，司机应当能够看到车辆后视镜中的什么内容？",
    "options": [
      "车辆后方和两侧区域",
      "车辆的乘客区域",
      "所有车轮的位置",
      "左侧车轮的位置"
    ],
    "correct_answer": 0,
    "explanation": "正确调整的车辆后视镜使驾驶员能够看到车辆后方和两侧的道路。这有助于驾驶员考虑车辆后方发生的情况，从而能够做出明智、正确和更安全的决策。",
    "image_name": ""
  },
  {
    "index": 535,
    "id": "ABMW0684RU19",
    "section": "安全与负责驾驶",
    "question": "当外部镜子被正确调整时，驾驶员应该能看到什么？",
    "options": [
      "车辆的两侧",
      "车辆两侧的区域",
      "60%向车辆倾斜，40%向道路倾斜",
      "车辆的后部"
    ],
    "correct_answer": 1,
    "explanation": "外部镜子能够让驾驶员看到车辆两侧的区域。驾驶员必须考虑所有可见的危险，以便做出明智、正确和更安全的决定。\n\nTranslated to Simplified Chinese:\n外部镜子让驾驶员能够看到车辆两侧的区域。驾驶员必须考虑所有可见的危险，才能做出明智、正确和更安全的决定。",
    "image_name": ""
  },
  {
    "index": 536,
    "id": "ABMW0685U19",
    "section": "安全与负责驾驶",
    "question": "车辆的外部镜子被一层泥浆和灰尘覆盖了。驾驶员应该怎么做？",
    "options": [
      "随车辆的气流行驶，这样最终会清洁镜子",
      "到达目的地后再清洁它们",
      "调整镜子朝向前方一段距离以清洁它们",
      "在出发前用布或纸巾清洁它们"
    ],
    "correct_answer": 3,
    "explanation": "车镜的目的是扩大驾驶员对车辆后方和侧面的视野，使他们能够考虑所有可见的危险。正确使用将使驾驶员能够做出明智、正确和更安全的决策。驾驶员应始终确保所有车镜，包括外部车镜，保持清洁和适当调整，以确保视野最佳。",
    "image_name": ""
  },
  {
    "index": 537,
    "id": "ABMW0687U19",
    "section": "安全与负责驾驶",
    "question": "潮湿的天气会对车辆的外后视镜产生什么影响？",
    "options": [
      "水滴有助于保持其清洁",
      "水滴可能会遮挡反射的图像",
      "水可能会导致电加热镜的短路",
      "水滴可能会使反射的物体看起来比实际距离更近"
    ],
    "correct_answer": 1,
    "explanation": "在潮湿的天气条件下驾驶时，外部镜子的玻璃上可能会形成小水滴。这可能会使看到后面和侧面的道路更加困难。如果安装了镜子除雾器，打开它们。如有必要，停车清理清除。",
    "image_name": ""
  },
  {
    "index": 538,
    "id": "ABMW0212RU23",
    "section": "安全与负责驾驶",
    "question": "何时可以从左侧超越另一辆车？",
    "options": [
      "当驾驶员由于对向交通而无法从右侧超车时",
      "当前方车辆正在打右转向灯或在交通缓慢行驶车道时",
      "驾驶员绝对不可从左侧超车",
      "当有足够的空间时"
    ],
    "correct_answer": 1,
    "explanation": "通常情况下，您必须从右侧超车。然而，在某些情况下，您可以从左侧超车，例如，当车辆已经移出并打信号要向右转时。",
    "image_name": ""
  },
  {
    "index": 539,
    "id": "ABMW0396RU23",
    "section": "安全与负责驾驶",
    "question": "司机在通过停放在住宅区的车辆时应该采取什么措施？",
    "options": [
      "超车时要留足够的空间",
      "尽量靠近停放的车辆，为对向车辆留下最大的空间",
      "增加速度以尽快超越车辆",
      "尽量靠右侧行驶"
    ],
    "correct_answer": 0,
    "explanation": "在通过停放在居住区域的车辆时，及时移入安全超车位置并留出充足的空间，以增加对区域内小孩的可见性，并防止有人在你车前打开车门。",
    "image_name": ""
  },
  {
    "index": 540,
    "id": "RSA225272",
    "section": "安全与负责驾驶",
    "question": "超车骑自行车时，司机应该注意什么？",
    "options": [
      "骑自行车的人可能会突然改变方向",
      "骑自行车的人未戴安全头盔",
      "骑自行车的人只允许使用公交车道"
    ],
    "correct_answer": 0,
    "explanation": "骑自行车的人和其他车辆一样有权使用道路，驾驶员需要特别注意他们。骑自行车的人是道路上的弱势用户，有时会突然改变行驶方向 例如，为了避开坑洞、玻璃碎片或道路上的其他杂物。超车时应给予足够的空间，以减少可能的危险。",
    "image_name": ""
  },
  {
    "index": 541,
    "id": "RSA225310",
    "section": "安全与负责驾驶",
    "question": "超越骑自行车者时，驾驶员应确保什么？",
    "options": [
      "当骑自行车的人靠边停下时超车",
      "只有当骑自行车的人在自行车道内时超车",
      "超车时要给他们足够的空间"
    ],
    "correct_answer": 2,
    "explanation": "自行车骑行者是易受伤害的道路使用者。汽车驾驶员在超越骑行者时必须给予充分的空间。",
    "image_name": ""
  },
  {
    "index": 542,
    "id": "RSA225311",
    "section": "安全与负责驾驶",
    "question": "在超车时，驾驶员可以超速吗？",
    "options": [
      "驾驶员可能会在短暂时间内超速完成动作",
      "驾驶员在超车时不得超速",
      "如果前方车辆正在左转，驾驶员可以超过限速"
    ],
    "correct_answer": 1,
    "explanation": "在超车时，驾驶员不得超过限速。",
    "image_name": ""
  },
  {
    "index": 543,
    "id": "RSA225312",
    "section": "安全与负责驾驶",
    "question": "司机何时允许从左侧超车？",
    "options": [
      "驾驶员在高速行车道上绝不允许左侧超车",
      "在高速公路上的流量快速行驶时。",
      "当驾驶员向左转时。"
    ],
    "correct_answer": 2,
    "explanation": "駕駛員通常應該在右側超車，但如果他們已經示意準備左轉並且在交通狀況下安全時，可以在左側超車。",
    "image_name": ""
  },
  {
    "index": 544,
    "id": "ABMW0507RU23",
    "section": "安全与负责驾驶",
    "question": "接近环形交叉路口时，司机应给谁让路？",
    "options": [
      "汽车驶入环形交叉路口时，必须让行右侧接近的车辆或已经在环形交叉路口内的车辆",
      "驾驶员只需让行环形交叉路口上的行人和骑车人"
    ],
    "correct_answer": 1,
    "explanation": "司机在接近环形交叉路口时应该保持谨慎。他们应该准备给右侧交通让路，给已经在环形交叉路口的交通让路，给已经在横穿斑马线的行人让路，并在必要时始终停车。",
    "image_name": ""
  },
  {
    "index": 545,
    "id": "ABMW0508R",
    "section": "安全与负责驾驶",
    "question": "驾驶员进入环形交叉路口时应该向哪个方向转弯？",
    "options": [
      "向右转",
      "向左或向右转",
      "受交通灯控制时向右转",
      "向左转"
    ],
    "correct_answer": 3,
    "explanation": "根据法律规定，您必须向左转驶入环形交叉路口，并让已经在环形交叉路口内的车辆先行。",
    "image_name": ""
  },
  {
    "index": 546,
    "id": "ABMW0509RU19",
    "section": "安全与负责驾驶",
    "question": "通常情况下，在接近环形交叉路口时提供两条车道，当司机打算从环形交叉路口向右侧（12点钟位置后）驶出时，应选择哪条车道？",
    "options": [
      "跨越两条车道",
      "左车道",
      "任一车道",
      "右车道"
    ],
    "correct_answer": 3,
    "explanation": "当驾驶员接近一个设有两条车道的环形交叉路口时，他们应该根据道路标线和他们打算驶离环形交叉路口的出口选择最合适的车道。左车道通常用于驶出到左侧（9点钟）或直行（12点钟）的车辆，右车道则用于驶出到12点钟后的任何出口的车辆。",
    "image_name": ""
  },
  {
    "index": 547,
    "id": "ABMW0510RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在接近环岛并打算驶入左侧第一个出口时，通常应采取什么位置？",
    "options": [
      "以跨越两条车道的方式接近",
      "在右侧车道接近",
      "在任何可用车道接近",
      "在左侧车道接近"
    ],
    "correct_answer": 3,
    "explanation": "当驾驶员打算从6点到12点位置之间的任何出口驶出时，他们通常应该在左边车道接近环形交叉口，除非路标另有规定。",
    "image_name": ""
  },
  {
    "index": 548,
    "id": "ABMW0224R",
    "section": "安全与负责驾驶",
    "question": "作为汽车驾驶员，以下哪种行为是正确的？",
    "options": [
      "司机必须在右侧行驶，以给摩托车手让出空间",
      "司机必须让左侧的交通流通",
      "减速并示意摩托车手过马路",
      "司机可以谨慎前行"
    ],
    "correct_answer": 3,
    "explanation": "你可以继续前行，但请注意摩托车手的存在。您应该随时准备应对交通状况的变化 例如，摩托车手可能没有看到您的车辆。",
    "image_name": "ABMW0224R.png"
  },
  {
    "index": 549,
    "id": "ABMW0228R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，驾驶员应该怎么做？",
    "options": [
      "司机可以驶入前面的黄色车辆所在的环岛",
      "当司机驶入环岛时，他们具有通行权",
      "司机必须让行给环岛上的黄色车辆",
      "司机必须等待黄色车辆停下"
    ],
    "correct_answer": 2,
    "explanation": "当您到达环岛时，您必须让右侧靠近的交通流通—除非有标志、道路标记或交通灯告诉您相反。",
    "image_name": "ABMW0228R.png"
  },
  {
    "index": 550,
    "id": "ABMW0230R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，驾驶员应该怎么做？",
    "options": [
      "驾驶员必须让红车通行",
      "驾驶员必须停下让其他所有车辆继续通行",
      "驾驶员必须让蓝车通行",
      "驾驶员可以在另外两辆车的前面转弯"
    ],
    "correct_answer": 3,
    "explanation": "当您从主要道路右转到次要道路时，您必须让对向车辆先行，只有在安全的情况下才能继续前行。然而，次要道路上的驾驶员必须给主要道路上的交通让路。",
    "image_name": "ABMW0230R.png"
  },
  {
    "index": 551,
    "id": "ABMW0233RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该怎么做？",
    "options": [
      "驾驶员可以小心前行",
      "驾驶员必须让货车通过路口",
      "骑自行车者必须让其他车辆通过",
      "骑自行车者必须首先通过"
    ],
    "correct_answer": 0,
    "explanation": "接近十字路口时，您应该检查路标，看哪一辆车辆有优先通行权，并准备好应对两侧出现的交通。车辆在道路上并没有自动让行权。最重要的规则是在任何情况下都要谨慎前行。",
    "image_name": "ABMW0233RU19.png"
  },
  {
    "index": 552,
    "id": "ABMW0234RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该怎么做？",
    "options": [
      "驾驶员必须向左转",
      "驾驶员必须让橙色车辆通过",
      "驾驶员不得向右转",
      "驾驶员可以向右转"
    ],
    "correct_answer": 3,
    "explanation": "在没有对向车辆的情况下，您可以右转，但也应注意可能会有车辆从次要道路驶出。",
    "image_name": "ABMW0234RU19.png"
  },
  {
    "index": 553,
    "id": "ABMW0235R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该怎么做？",
    "options": [
      "司机可以先行",
      "司机必须让蓝色卡车先行",
      "司机必须让红色轿车先行"
    ],
    "correct_answer": 1,
    "explanation": "當您從主要道路右轉到次要道路時，您必須讓對面來車，只有在安全的情況下才能繼續前行。您還應該注意可能從次要道路開出的車輛。",
    "image_name": "ABMW0235R.png"
  },
  {
    "index": 554,
    "id": "ABMW0250R",
    "section": "安全与负责驾驶",
    "question": "司机应该做什么？",
    "options": [
      "驾驶员必须停车让行所有车辆",
      "驾驶员应该让对向的骑车人先转弯",
      "驾驶员应该让黄色车辆先通行",
      "驾驶员可以先左转"
    ],
    "correct_answer": 2,
    "explanation": "在同等重要的十字路口，从右侧接近的交通享有优先权。重要的是要明白，通行权不是绝对的权利。您必须在为其他道路使用者考虑的同时谨慎前行。",
    "image_name": "ABMW0250R.png"
  },
  {
    "index": 555,
    "id": "ABMW0254R",
    "section": "安全与负责驾驶",
    "question": "司机应该采取什么行动？",
    "options": [
      "在停车线停车",
      "在公交车前面继续行驶",
      "在骑车者前面继续行驶",
      "向公交车发出信号让其继续前行"
    ],
    "correct_answer": 0,
    "explanation": "根据法律规定，你必须停在停线处（或者在没有停线的情况下停在停止标志处），等待其他车辆通过后再继续前行。",
    "image_name": "ABMW0254R.png"
  },
  {
    "index": 556,
    "id": "ABMW0261R",
    "section": "安全与负责驾驶",
    "question": "司机打算在这个路口左转 司机应该怎么做？",
    "options": [
      "让自行车手左转前继续前行",
      "让面包车让路",
      "让面包车和自行车手继续前行",
      "在自行车手前左转"
    ],
    "correct_answer": 0,
    "explanation": "在你接近一个你要左转的十字路口时不要超越骑自行车的人。骑自行车的人有可能会继续前行。骑自行车的人是道路上易受伤害的用户，可能在缓慢行驶的交通和十字路口处不稳定。给他们更多空间。",
    "image_name": "ABMW0261R.png"
  },
  {
    "index": 557,
    "id": "ABMW0264RU19",
    "section": "安全与负责驾驶",
    "question": "司机打算在这个路口右转 司机应该怎么做？",
    "options": [
      "在摩托车和公共汽车通过之后继续前行",
      "只在公共汽车前面继续前行",
      "只在摩托车通过后继续前行",
      "在公共汽车和摩托车前面继续前行"
    ],
    "correct_answer": 0,
    "explanation": "转弯时，应礼让主干道上的交通以及路口的对向车辆。",
    "image_name": "ABMW0264RU19.png"
  },
  {
    "index": 558,
    "id": "ABMW0265RU23",
    "section": "安全与负责驾驶",
    "question": "驾驶员打算在这个路口右转 驾驶员应该怎么做？",
    "options": [
      "停在公交车前",
      "停在线前",
      "停在摩托车前"
    ],
    "correct_answer": 1,
    "explanation": "您必须停在由停车标志和停车线控制的交叉路口处，直到安全可行时才能前行。",
    "image_name": "ABMW0265RU23.png"
  },
  {
    "index": 559,
    "id": "ABMW0270RU19",
    "section": "安全与负责驾驶",
    "question": "當打算向右轉彎時，車輛駕駛員應該做什麼？",
    "options": [
      "继续小心行驶，因为司机有通行权",
      "等待，让对向车辆通过",
      "等待，让卡车和对向车辆先行",
      "等待，让卡车先行"
    ],
    "correct_answer": 1,
    "explanation": "在从主要道路向侧边道路右转时，必须依法让主要道路上的对向交通先行。",
    "image_name": "ABMW0270RU19.png"
  },
  {
    "index": 560,
    "id": "ABMW0272RU23",
    "section": "安全与负责驾驶",
    "question": "Approaching a hilltop, what should a driver do?\n接近山顶时，司机应该采取什么行动？",
    "options": [
      "减速以应对可能出现的危险",
      "遵守道路标线",
      "保持正常车速"
    ],
    "correct_answer": 0,
    "explanation": "在驶近坡顶时，您应格外小心，并做好准备应对交通状况的变化。",
    "image_name": "ABMW0272R.png"
  },
  {
    "index": 561,
    "id": "ABMW0279R",
    "section": "安全与负责驾驶",
    "question": "當司机在中間車道繼續行駛時應該怎麼做？",
    "options": [
      "在右侧迅速超越其他车辆",
      "选择任何方便的车道",
      "即使直行，也要在右侧车道驶入位置",
      "减速，让前方驾驶员换道"
    ],
    "correct_answer": 3,
    "explanation": "您应该始终与前方车辆保持安全距离，特别是当它减速或停车时。",
    "image_name": "ABMW0279R.png"
  },
  {
    "index": 562,
    "id": "ABMW0282RU19",
    "section": "安全与负责驾驶",
    "question": "当跟随摩托车手时, 一辆白色车辆正在倒车上路时, 司机应该注意什么？",
    "options": [
      "逆行的司机在看到摩托车手时会停下来",
      "摩托车手可能会示意逆行的司机停下来",
      "跟随摩托车的司机可能需要比正常情况下更长的刹车距离",
      "摩托车上的刹车灯可能损坏了"
    ],
    "correct_answer": 2,
    "explanation": "你应该始终保持与前方车辆的安全距离，如果它正在减速或停车。始终留意路况并准备好正确应对前方交通的变化。",
    "image_name": "ABMW0282RU19.png"
  },
  {
    "index": 563,
    "id": "ABMW0283R",
    "section": "安全与负责驾驶",
    "question": "在接近这种情况时，司机应该做什么？",
    "options": [
      "减速并必要时停车",
      "如果对面来车必须等待，请继续行驶",
      "只有在拖曳拖车或房车时让行",
      "增加速度以在对面车辆到来前通过桥梁"
    ],
    "correct_answer": 0,
    "explanation": "在道路优先权不明确的情况下，您可能需要让行驶中的车辆先行。永远不要开车进入可能无法通过或会造成阻塞或瓶颈的区域。",
    "image_name": "ABMW0283R.png"
  },
  {
    "index": 564,
    "id": "ABMW0288RU23",
    "section": "安全与负责驾驶",
    "question": "在这条双向停车的单行道上驾驶时，司机应该准备好迎接什么？",
    "options": [
      "车辆间行人横穿",
      "司机超越卡车时对向车流",
      "卡车可能是左舵车辆"
    ],
    "correct_answer": 0,
    "explanation": "当驾驶在单行道上时，您应当格外小心，随时准备对交通状况的变化做出反应。",
    "image_name": "ABMW0288R.png"
  },
  {
    "index": 565,
    "id": "ABMW0290RU23",
    "section": "安全与负责驾驶",
    "question": "在打算左转时，驾驶员应该怎么做？",
    "options": [
      "礼让正在过马路的行人",
      "停下来并示意两名行人过马路",
      "在两名行人之间继续前行"
    ],
    "correct_answer": 0,
    "explanation": "根据法律，您必须让步给已经在十字路口过马路的行人。行人是易受伤的道路使用者，在行人试图穿过马路的地方驾驶时，您应该格外小心。",
    "image_name": "ABMW0290RU23.png"
  },
  {
    "index": 566,
    "id": "ABMW0291R",
    "section": "安全与负责驾驶",
    "question": "在这个路口右转时，司机应该怎么做？",
    "options": [
      "让红车先行",
      "在两辆车前面行驶",
      "让蓝车先行",
      "让两辆车都通过"
    ],
    "correct_answer": 0,
    "explanation": "當您從主要道路右轉到支路時，必須給予主要道路上的對向車輛讓路，即使他們正在向左轉進同一條支路。",
    "image_name": "ABMW0291R.png"
  },
  {
    "index": 567,
    "id": "ABMW0297R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，谁应该等待？",
    "options": [
      "不应有任何车辆等待",
      "距离货车最远的车辆应等待",
      "停在货车后面的驾驶员应等待",
      "对面来车必须等待"
    ],
    "correct_answer": 2,
    "explanation": "當你超車時，應該讓對向來車通過，這樣他們就不必減速或採取迴避動作。",
    "image_name": "ABMW0297R.png"
  },
  {
    "index": 568,
    "id": "ABMW0298R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，谁应该等待？",
    "options": [
      "主干道上的司机应该等待",
      "两位司机都应该等待",
      "红色车辆的司机应该等待",
      "两位司机都不应该等待"
    ],
    "correct_answer": 2,
    "explanation": "在主干道上行驶的车辆优先于从辅路驶出的车辆。然而，您必须明白，行车权并非绝对的行车权，您应时刻体谅其他道路使用者。",
    "image_name": "ABMW0298R.png"
  },
  {
    "index": 569,
    "id": "ABMW0306RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，想要右转的驾驶员应该怎么做？",
    "options": [
      "倒車並行駛到右邊車道",
      "繼續直行或左轉",
      "繼續直行並靠右寬轉彎",
      "從左車道右轉"
    ],
    "correct_answer": 1,
    "explanation": "当您接近一个您想右转的交叉路口时，您应该提前阅读前方道路并及时占据正确的右转位置。",
    "image_name": "ABMW0306RU19.png"
  },
  {
    "index": 570,
    "id": "ABMW0307R",
    "section": "安全与负责驾驶",
    "question": "在主要道路上右转进入次要道路，哪辆车辆处于正确位置？",
    "options": [
      "1",
      "4",
      "3",
      "2"
    ],
    "correct_answer": 2,
    "explanation": "从主要道路向次要道路右转的正确位置是靠近中心线的左侧。您应该提前占据正确位置，避免切角或天鹅颈转弯-也就是过了转弯点，图片中显示汽车2。",
    "image_name": "ABMW0307R.png"
  },
  {
    "index": 571,
    "id": "ABMW0312R",
    "section": "安全与负责驾驶",
    "question": "以下哪辆车处于正确位置，可以从次要道路右转进入主要道路？\n",
    "options": [
      "1",
      "4",
      "2",
      "3"
    ],
    "correct_answer": 0,
    "explanation": "从次要道转右到主要道路的正确位置是位于路中偏左。您应及时占据正确位置，并通过进入主要道路的左侧完成转弯。",
    "image_name": "ABMW0312R.png"
  },
  {
    "index": 572,
    "id": "ABMW0323RU19",
    "section": "安全与负责驾驶",
    "question": "对向车辆上闪烁的琥珀色信标向驾驶员发出什么警示信号？",
    "options": [
      "对面来车是一辆军用车辆",
      "对面来车可能行驶缓慢或宽度超过标准",
      "对面来车是一辆紧急救援车辆",
      "对面来车是一辆快速行驶车辆"
    ],
    "correct_answer": 1,
    "explanation": "闪烁的琥珀色信标被救援车辆和搭载异常货物的车辆使用。您应该意识到这些车辆可能需要额外的空间，并且可能会掩盖后方交通。当遇到这些车辆时，请减速并做好准备，有必要时停车。",
    "image_name": ""
  },
  {
    "index": 573,
    "id": "ABMW0324RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机遇到闪烁的琥珀色信标的车辆，应该怎么做？",
    "options": [
      "闪烁大灯以示对道路标志的认可",
      "保持左侧行驶时增加速度",
      "减速并准备停车",
      "停下来，因为这是一辆紧急车辆"
    ],
    "correct_answer": 2,
    "explanation": "警示灯会在救援车辆和运载异常货物的车辆上使用。你应该意识到这些车辆可能需要额外的空间，且可能会掩盖后方车辆。当你遇到这样的车辆时，减速并准备随时停车。",
    "image_name": ""
  },
  {
    "index": 574,
    "id": "ABMW0328R",
    "section": "安全与负责驾驶",
    "question": "准备停车时，司机注意到后面的车辆正在拖车。司机应该怎么做？",
    "options": [
      "使用手刹来减速和停车",
      "提前表明意图并逐渐减速，给后方车辆提供额外的停车距离",
      "快速停车时要密切关注后视镜",
      "暂时加速，让车辆与后方车辆之间保持一定距离"
    ],
    "correct_answer": 1,
    "explanation": "当您减速或停车时，您应该注意跟随您的车辆类型。例如，如果跟随您的车辆是大型车辆或拖车，您应考虑比平时提前一点示意，以便让跟随车辆有足够的时间安全反应。",
    "image_name": ""
  },
  {
    "index": 575,
    "id": "ABMW0329RU23",
    "section": "安全与负责驾驶",
    "question": "接近前方信号要启动从公共汽车站出发的公共汽车时，驾驶员应该怎么做？",
    "options": [
      "减速让其离开",
      "指示并迅速超过它",
      "立即停车，因为公交车有优先通行权"
    ],
    "correct_answer": 0,
    "explanation": "司机在公交车从停车位置驶出时应该让公交车重新融入交通流。要注意下车上车的行人，尤其是在学校附近的孩子。",
    "image_name": ""
  },
  {
    "index": 576,
    "id": "ABMW0330RU19",
    "section": "安全与负责驾驶",
    "question": "當另一輛車從對向而來時，在窄路上行駛的駕駛應該怎麼做？",
    "options": [
      "保持位置并期待对方车辆让道",
      "减速并在继续前行之前确保车辆与对向车辆之间保持合理的间距",
      "将您的车辆放置在道路中间，以鼓励对方驾驶员让道",
      "保持道路位置和速度",
      "然后闪烁车灯以提醒对方驾驶员注意到您的存在"
    ],
    "correct_answer": 1,
    "explanation": "您应该时刻准备应对前方的危险情况。当您在狭窄道路上遇到对面来车时，您应该表现出礼貌，减速到适当的速度，以确保两辆车能够安全地相互超车。",
    "image_name": ""
  },
  {
    "index": 577,
    "id": "ABMW0332RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员驾驶在另一辆车后面，而不打算超车时，驾驶员应该怎么做？",
    "options": [
      "保持距离并行驶在道路中央",
      "跟车紧贴以便让后方车辆超车",
      "保持距离让后车超车",
      "向后方车辆示意让其超车"
    ],
    "correct_answer": 2,
    "explanation": "您应该始终确保您的车辆和前方车辆之间保持足够的距离。这样可以确保您能够安全地停车（在您能看清的距离内）。这也将为超车车辆在超越您后安全地回到左车道提供足够的空间。",
    "image_name": ""
  },
  {
    "index": 578,
    "id": "ABMW0333RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员在车流中行驶且不打算超车时，驾驶员应该做什么？",
    "options": [
      "示意后方车辆超车",
      "紧跟前方车辆",
      "保持距离，留出空间供其他司机超车",
      "打左转向灯示意后方车辆超车"
    ],
    "correct_answer": 2,
    "explanation": "您应始终保持足够的车距与前方车辆。这将使您能够安全停车（在您可见清晰范围内）。这也会给超车车辆足够的空间，在超越您后可以安全地回到左车道。",
    "image_name": ""
  },
  {
    "index": 579,
    "id": "ABMW0340R",
    "section": "安全与负责驾驶",
    "question": "被其他车辆超车时，驾驶员应该怎么做？",
    "options": [
      "向右移动",
      "保持相同速度",
      "增加速度",
      "迅速减速"
    ],
    "correct_answer": 1,
    "explanation": "当你被另一辆车超车时，你应该保持相同的速度，但要保持警惕，以防超车车辆突然再次超前。",
    "image_name": ""
  },
  {
    "index": 580,
    "id": "ABMW0342RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员驾驶车辆驶入窄缝时，应该怎么做？",
    "options": [
      "在强调您的优先权时，请打转向灯并行驶",
      "始终减速，停下并等待示意前进",
      "右转灯开启，必要时停下，直到对向车辆通过为止",
      "向对向车辆示意停车，然后向右移动，正常驾驶"
    ],
    "correct_answer": 2,
    "explanation": "当您在窄缝遇到对向车辆时，您应该显示礼貌，减速到适当速度，以确保您和其他车辆可以安全地相互超车。必要时，让其他车辆先行。",
    "image_name": ""
  },
  {
    "index": 581,
    "id": "ABMW0350RU23",
    "section": "安全与负责驾驶",
    "question": "当驾驶员跟随一个打右转向灯的大型货车行驶时，驾驶员应该怎么做？",
    "options": [
      "保持在后面，直到有足够的空间在内侧超车，或者直到它完成转弯",
      "按喇叭超过右侧的重型货车",
      "必要时可以在人行道上行驶一部分，慢慢地在内侧超车",
      "看看车辆是否可以完成转弯而不停下来，如果不能，你就超过它"
    ],
    "correct_answer": 0,
    "explanation": "重型货车需要在道路上额外腾出空间，当它们转弯时，车辆的悬挂部分可能会摆动到超车或向外行驶的车辆路径中。因此，最好保持距离，让重型货车完成转弯，除非有足够空间安全超车。",
    "image_name": ""
  },
  {
    "index": 582,
    "id": "ABMW0351RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员在后面跟随一辆打左转信号的公共汽车且有对向车流时，该怎么做？",
    "options": [
      "在左侧超车",
      "在左侧行驶并等待它完成转弯",
      "轻踩刹车并按喇叭示意其他车辆减速",
      "在右侧超车"
    ],
    "correct_answer": 1,
    "explanation": "始终允许公共汽车完成左转，因为你的视野受限，尝试超车可能会很危险。",
    "image_name": ""
  },
  {
    "index": 583,
    "id": "ABMW0355RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员在宽阔的道路上跟在一辆车后面，而该车已经打信号表示将在前方右转时，驾驶员应该怎么做？",
    "options": [
      "在右侧超车后继续前行",
      "在左侧超车，如果安全的话继续前行",
      "在左侧超车，但只有在前方短距离转弯时才可以",
      "留在后方并轻踩刹车以示意其他驾驶员减速"
    ],
    "correct_answer": 1,
    "explanation": "当前方驾驶员已经移出并发出右转信号时，您可以在左侧超车，而且您打算直行 前提是有足够的空间可以安全地这样做，而且您的行进路径不会被右转的大型车辆的摆动阻碍。",
    "image_name": ""
  },
  {
    "index": 584,
    "id": "ABMW0356RU19",
    "section": "安全与负责驾驶",
    "question": "何时可以从靠近一侧（左侧）超车？",
    "options": [
      "当前车辆正在向右转弯时",
      "驾驶员决不能从左侧超车",
      "当快速行驶的交通中有三条车道可用时",
      "只有在没有自行车道的情况下才可以超车"
    ],
    "correct_answer": 0,
    "explanation": "当前面的驾驶员已经驶出并且打出了右转信号，而你打算直行时，你可以在左侧超车 前提是有足够的空间可以安全地这样做，并且你的行驶路线不会受到右转大型车辆摆动的阻碍。",
    "image_name": ""
  },
  {
    "index": 585,
    "id": "ABMW0361RU23",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员在规定的时间内迟到，该怎么办？",
    "options": [
      "请耐心驾驶，不要超速，确保安全到达",
      "必要时超速以赶时间",
      "使用危险警示灯鼓励其他道路使用者让你通过"
    ],
    "correct_answer": 0,
    "explanation": "您应始终以安全停车距离内可见的范围内停车的速度行驶。错过约会时间不是超速或以不安全速度驾驶的借口。安全抵达。",
    "image_name": ""
  },
  {
    "index": 586,
    "id": "ABMW0362RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机没有跟上前方车辆的速度，他们应该怎么做？",
    "options": [
      "驾驶员应保持车辆位置，不允许后方车辆超车",
      "驾驶员应靠左行驶，若有需要，允许其他车辆超车",
      "驾驶员应开启危险警示灯并靠左行驶",
      "驾驶员应通过手势示意其他车辆超车"
    ],
    "correct_answer": 1,
    "explanation": "始终审视前方道路并准备好应对任何交通情况。不要开车太慢，以至于你的车辆无故地阻碍其他道路使用者。保持靠近左侧，只要安全就让其他车辆安全超车。",
    "image_name": ""
  },
  {
    "index": 587,
    "id": "ABMW0365RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机希望驾驶穿过繁忙道路，而平时控制路口的交通灯暂时失效，司机应该怎么做？",
    "options": [
      "打开车头灯并使用手势向其他驾驶员表明他们打算穿过，然后继续前行",
      "按喇叭，缓慢前行穿过马路",
      "仔细观察，等待交通流畅的间隙，安全地穿过马路",
      "如有必要，缓慢穿过并使用危险警示灯"
    ],
    "correct_answer": 2,
    "explanation": "始终阅读前方道路并准备应对任何交通状况。在这种情况下，在确保道路畅通和安全的情况下才可以继续前行。不要假设自己拥有通行权。",
    "image_name": ""
  },
  {
    "index": 588,
    "id": "ABMW0366RU19",
    "section": "安全与负责驾驶",
    "question": "当司机看到一辆停在前方靠近车道左侧的校车时，应该怎么做？",
    "options": [
      "鸣喇叭作为警告，并继续前行",
      "减速并谨慎超车",
      "打开危险警告灯并停在公共汽车后面",
      "打信号并保持当前车速"
    ],
    "correct_answer": 1,
    "explanation": "始终注意道路情况，并做好准备以应对任何交通情况 在这种情况下，要注意易受伤害的道路使用者，比如上下校车的学生。",
    "image_name": ""
  },
  {
    "index": 589,
    "id": "ABMW0367RU19",
    "section": "安全与负责驾驶",
    "question": "当司机在驾驶途中跟在一辆车后，该车不安全地在道路上左右摇晃时，司机应该怎么做？",
    "options": [
      "驾驶员应该打信号，绕过车辆的左侧",
      "驾驶员应该打信号，绕过车辆的右侧",
      "驾驶员应该紧跟在车辆后面以准备超车",
      "驾驶员应该保持安全距离并停在安全位置"
    ],
    "correct_answer": 3,
    "explanation": "你应该时刻准备对前方的危险做出反应。如果前方车辆来回晃动，可能表明驾驶员没有全神贯注或受到饮酒、毒品或疲劳的影响。如果你认为该车辆对公众安全构成风险，应当向警察局或交通观察组（低费用电话 1890 205 805）报告，但不要在驾驶时报告。",
    "image_name": ""
  },
  {
    "index": 590,
    "id": "ABMW0368RU19",
    "section": "安全与负责驾驶",
    "question": "如果前面的重型货车已经挪到前方打算左转，司机应该怎么做？",
    "options": [
      "立即移出并尽快超车",
      "向右移动但不要超车",
      "驶入其左侧的空间",
      "留在它后面，让它完成转弯"
    ],
    "correct_answer": 3,
    "explanation": "始終要提前看路並準備應對任何交通狀況。在這種情況下，您應該意識到大貨車需要額外的空間才能完成左轉，並應該一直保持在車輛後方，直到它完成轉彎。",
    "image_name": ""
  },
  {
    "index": 591,
    "id": "ABMW0369RU19",
    "section": "安全与负责驾驶",
    "question": "如果前方的公交车已经移出来左转并且有对向车辆，司机应该怎么办？",
    "options": [
      "保持距离让公交车完成转弯",
      "在靠近公交车时保持速度",
      "在左侧超车",
      "在右侧路超车"
    ],
    "correct_answer": 0,
    "explanation": "始终留意前方道路并做好准备，以便对任何交通情况做出反应。在这种情况下，您应该意识到巴士需要额外的空间来转弯。因此，如果超车会导致对向交通改变速度或方向，您就不应超车。请记住，在接近路口时永远不要超车。",
    "image_name": ""
  },
  {
    "index": 592,
    "id": "ABMW0370RU23",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员看到卡车倒车进入前方道路左侧的侧门，应该采取什么措施？",
    "options": [
      "尝试超越它以避免影响后方车辆",
      "停下来安全地等待，直到道路畅通为止",
      "按喇叭示意卡车司机停车"
    ],
    "correct_answer": 1,
    "explanation": "始终提前阅读道路并准备对任何交通状况作出反应。您应该意识到驾驶大型车辆可能在倒车到侧边通道时遇到的困难。在这种情况下，一辆大型车辆倒车可能会阻碍您的视线在您接近时，您应该给予卡车司机足够的操纵空间。",
    "image_name": ""
  },
  {
    "index": 593,
    "id": "ABMW0371RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机在交通灯显示绿灯且有对向车辆接近时，他们应该怎么做？",
    "options": [
      "在转弯之前，请留在停车线处，直到对面车流有合适的间隙",
      "在停车线处等待灯变成琥珀色，然后转弯",
      "保持在停车线处，直到绿色箭头亮起",
      "向前行驶到十字路口中心，当有适当间隙时安全转弯"
    ],
    "correct_answer": 3,
    "explanation": "如果您希望在交通灯路口右转，请在看到绿灯时驶入路口，注意不要阻碍任何对向车辆。然后在安全情况下完成转弯。",
    "image_name": ""
  },
  {
    "index": 594,
    "id": "ABMW0372R",
    "section": "安全与负责驾驶",
    "question": "什么时候允许在超车时强迫对向车辆驶入对面道路的硬路肩？",
    "options": [
      "当被超车的车辆行驶太慢时",
      "在超车过程中不允许强迫对向车辆驶入硬路肩",
      "当没有对向车辆在超车时",
      "当硬路肩宽度足够时"
    ],
    "correct_answer": 1,
    "explanation": "按照这里描述的方式超车是危险的。只有在确保对你和所有其他交通都安全的情况下，你才应该超车。在超车之前，确保前方的道路畅通无阻，并有足够的空间完成超车操作并回到自己车道，而不会迫使其他道路使用者改变速度或路线。",
    "image_name": ""
  },
  {
    "index": 595,
    "id": "ABMW0374RU19",
    "section": "安全与负责驾驶",
    "question": "在国家道路上遇到对向车辆时，可以驶入硬路肩让后方车辆超车吗？",
    "options": [
      "不可以，在“2加1道路”上除外",
      "除非紧急情况，否则不允许在硬路肩上行驶",
      "是的，在有大货车或公交车逆向行驶时",
      "是的，临时当硬路肩通畅且安全时"
    ],
    "correct_answer": 3,
    "explanation": "在国家公路上，硬路肩通常仅供行人和骑车者使用。如果您希望允许后面的车辆超车，可以暂时驶入硬路肩，前提是没有行人或骑车者使用，并且附近没有路口或入口。然而，在高速公路上，除非出现紧急情况，否则不能行驶在硬路肩上。",
    "image_name": ""
  },
  {
    "index": 596,
    "id": "ABMW0375RU19",
    "section": "安全与负责驾驶",
    "question": "在国道上行驶时，允许驶入硬路肩让速度更快的车辆超车吗？",
    "options": [
      "是的，在硬肩膀通航且安全时可以暂时开车在那里",
      "仅限在双车道上驾驶时",
      "不可以，除非在行驶在“2+1道路”上",
      "仅当卡车或公共汽车要超车时"
    ],
    "correct_answer": 0,
    "explanation": "在国道上，紧急停车带通常只供行人和骑自行车者使用。如果你想让后面的车辆超车，只要没有行人或骑自行车者使用，且附近没有路口或入口，你可以暂时驶入紧急停车带。然而，在高速公路的情况下，除非出现紧急情况，你不应驾驶车辆进入紧急停车带。",
    "image_name": ""
  },
  {
    "index": 597,
    "id": "ABMW0376RU19",
    "section": "安全与负责驾驶",
    "question": "在受交通信號控制的交通隊列中，駕駛員應該做什麼？",
    "options": [
      "在左侧超车，如果有空间的话，移到队伍前头",
      "在右侧超车，如果有空间的话，移到队伍前头",
      "驾驶员应保持在队伍中的位置",
      "打开右侧方向指示灯，以防止跟车辆超车"
    ],
    "correct_answer": 2,
    "explanation": "始终注意前方道路并准备应对任何交通状况。有时您可能需要在交通中排队。在这种情况下，您应尽量保持耐心，并考虑其他道路使用者。插队是不考虑他人的行为，可能会带来危险，甚至可能引发路怒事件或造成碰撞。",
    "image_name": ""
  },
  {
    "index": 598,
    "id": "ABMW0377RU23",
    "section": "安全与负责驾驶",
    "question": "司机驾驶陌生车辆时应该做什么？",
    "options": [
      "在完全熟悉车辆之前，开启危险灯进行驾驶",
      "最初需谨慎驾驶，并以较低速度行驶，直至完全熟悉车辆",
      "由于所有车辆功能相同，以正常速度行驶"
    ],
    "correct_answer": 1,
    "explanation": "您应该知道在您的车辆上如何找到并操作所有的控制装置，包括所有的安全功能和警示灯。当您驾驶时，您需要能够集中精力关注周围发生的事情，操作车辆控制装置应该是您第二天性的能力。当您坐到一个您不熟悉的车辆的驾驶座上时，您应该在开始行驶之前做一次全面的驾驶舱检查。",
    "image_name": ""
  },
  {
    "index": 599,
    "id": "ABMW0381RU19",
    "section": "安全与负责驾驶",
    "question": "当车辆停在红绿灯处，绿灯亮起时，司机应该做什么？",
    "options": [
      "加速超过其他驾驶员，以便促进超车",
      "确保其他道路使用者已经通过路口并谨慎启动",
      "缓慢启动然后检查后视镜",
      "快速启动然后检查后视镜"
    ],
    "correct_answer": 1,
    "explanation": "当在红绿灯处停车时，当绿灯亮起时，您应检查确保道路畅通，并仅在安全的情况下前行。",
    "image_name": ""
  },
  {
    "index": 600,
    "id": "ABMW0386RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在行驶中遇到爆胎时应该怎么做？",
    "options": [
      "继续您的行程，并在方便时安排维修",
      "保持速度，直到找到更换车轮的地方",
      "如果在高速公路上，立即停车更换车轮",
      "在安全的地方停车并更换车轮"
    ],
    "correct_answer": 3,
    "explanation": "如果您在行车途中爆胎，请找一个合适和安全的地方停下来换车轮。如果您无法立即找到合适的地方，请慢慢行驶（打开双闪灯）以避免进一步损坏轮胎或轮辋，直到找到一个安全的地方。",
    "image_name": ""
  },
  {
    "index": 601,
    "id": "ABMW0394RU19",
    "section": "安全与负责驾驶",
    "question": "超越另一辆车后，驾驶员应该做什么？",
    "options": [
      "继续向右信号转向一段距离",
      "在超过车辆后立即切入左侧",
      "重新回到车辆前方并减速",
      "当车辆已超越时逐渐向左移动"
    ],
    "correct_answer": 3,
    "explanation": "超车后，检查你的后视镜，打灯信号，尽快回到正常车道位置。采取平稳轻松的路线，逐渐移回车道，给其他车辆留足够的空间，不要急转弯驶入。",
    "image_name": ""
  },
  {
    "index": 602,
    "id": "ABMW0395AU19",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员在超车时过早变道，会发生什么情况？",
    "options": [
      "当转向时，驾驶员不需要打转向灯",
      "这会迫使对面来车突然减速，造成危险",
      "这将迫使其他车辆突然减速或改变方向，造成危险",
      "车辆之间的安全距离会增加"
    ],
    "correct_answer": 2,
    "explanation": "超车时，请确保前方道路畅通，以便有足够的距离超车并返回到自己车道，而不会强迫其他道路使用者调整速度或方向。当你完全超过另一辆车时，检查后视镜，打灯号然后逐渐回到原来的车道，确保不会横穿已经超过的车辆。",
    "image_name": ""
  },
  {
    "index": 603,
    "id": "ABMW0398RU19",
    "section": "安全与负责驾驶",
    "question": "司机通常在超越停放车辆时应该保留多少安全间距？",
    "options": [
      "一个普通人的宽度",
      "汽车的宽度",
      "侧镜的宽度",
      "车门的宽度"
    ],
    "correct_answer": 3,
    "explanation": "当您超越停放的车辆时，应至少保留一扇门的宽度空间，以防有人突然打开车门，这也将增加该区域行人的可见性。",
    "image_name": ""
  },
  {
    "index": 604,
    "id": "ABMW0427RU19",
    "section": "安全与负责驾驶",
    "question": "在晴天行驶时，司机应如何判断与前方车辆的安全跟车距离？",
    "options": [
      "与前方车辆保持相同速度",
      "通过使用固定点并应用两秒规则",
      "每小时至少允许两车长的距离",
      "通过在车辆间至少保持两车长的距离"
    ],
    "correct_answer": 1,
    "explanation": "司机可以使用兩秒規則來判斷與前方車輛的安全距離。這是通過選定一個固定點來測量的。當前方車輛通過該點時，開始說“只有傻瓜才會違反兩秒規則”。如果在你說完這句話之前就通過了固定點，那麼你的車輛距離太近了，應該安全地減速，增加與前方車輛的距離。",
    "image_name": ""
  },
  {
    "index": 605,
    "id": "ABMW0429RAU19",
    "section": "安全与负责驾驶",
    "question": "在干燥的道路上，建议驾驶员用哪个词组来帮助他们确定与前方车辆的安全距离？",
    "options": [
      "只有愚蠢的人会违反两秒规则",
      "只有愚蠢的人会违反一秒规则",
      "只有愚蠢的人会违反三秒规则",
      "只有愚蠢的人会违反四秒规则"
    ],
    "correct_answer": 0,
    "explanation": "司机可以通过使用两秒规则来判断与前方车辆的安全距离。这是通过选择一个固定点进行测量的。当前方车辆经过该点时，开始说“只有傻瓜才会违反两秒规则”。如果您在说完这句话之前就经过了这个固定点，那么您的车距离太近了。请安全减速并增加与前车的距离。",
    "image_name": ""
  },
  {
    "index": 606,
    "id": "ABMW0470RU19",
    "section": "安全与负责驾驶",
    "question": "在单行道的尽头想要右转时，驾驶员应该把车辆停在哪里？",
    "options": [
      "在没有对向车辆的情况下，可以在任意车道行驶",
      "在尽可能靠近道路左侧行驶",
      "在尽可能靠近道路右侧行驶",
      "在接近街道尽头时，占据两个车道行驶"
    ],
    "correct_answer": 2,
    "explanation": "當司机想在單行道右轉時，應該檢查後視鏡，打右轉向燈，並在安全的情況下進入右側，然後完成轉彎，進入所要進入的道路車道。",
    "image_name": ""
  },
  {
    "index": 607,
    "id": "ABMW0472RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员想要向左转进入一处地产，并且左侧有公交车道时，驾驶员应该怎么做？",
    "options": [
      "让行给可能使用公交车道的自行车，出租车",
      "司机应该让公交车通行",
      "司机绝对不能左转穿越公交车道",
      "让行给可能使用公交车道的自行车和出租车"
    ],
    "correct_answer": 0,
    "explanation": "如果驾驶员需要穿过左侧的公交车道进入某处物业，他们应特别注意确保在公交车道内没有公交车、出租车或骑自行车的人。他们应该检查后视镜，打灯号，等安全时将车辆转入物业内。",
    "image_name": ""
  },
  {
    "index": 608,
    "id": "ABMW0474U19",
    "section": "安全与负责驾驶",
    "question": "哪些交通工具可以使用逆向公交专用道？",
    "options": [
      "公共汽车、出租车和摩托车",
      "公共汽车和机动轮椅",
      "公共汽车、出租车和骑自行车的人",
      "定期服务的公共汽车"
    ],
    "correct_answer": 3,
    "explanation": "逆向公交车道是指沿着其旁边的交通方向相反行驶的车道。只有按时运营的公交车可以使用逆向公交车道。",
    "image_name": ""
  },
  {
    "index": 609,
    "id": "ABMW0475RU19",
    "section": "安全与负责驾驶",
    "question": "在指定时间限制内，哪些交通工具可以使用流向与公交车道同向的车道上的信息牌？",
    "options": [
      "所有车辆",
      "多于一个乘客的车辆",
      "仅限巴士",
      "公交车、出租车和骑自行车的人"
    ],
    "correct_answer": 3,
    "explanation": "巴士专用车道是供公共汽车使用的专用车道。与流向巴士车道是与旁边车流方向相同的车道。出租车和骑自行车的人也可以在与流向巴士车道上行驶。其他车辆可以在附带牌子上标明的时间外使用这些车道。",
    "image_name": ""
  },
  {
    "index": 610,
    "id": "ABMW0477RU19",
    "section": "安全与负责驾驶",
    "question": "在正常行驶条件下，驾驶员应该在双车道上处于哪条车道？",
    "options": [
      "在任意车道内",
      "在右侧车道",
      "在右侧车道，除非驾驶工程车辆或重型货车",
      "在左侧车道，除非驾驶员希望超车或右转"
    ],
    "correct_answer": 3,
    "explanation": "在雙程道上，你通常應該開在左邊車道，除非超車或即將轉彎到較短的距離。",
    "image_name": ""
  },
  {
    "index": 611,
    "id": "ABMW0480R",
    "section": "安全与负责驾驶",
    "question": "2+1路段有什么特点？",
    "options": [
      "两条高速公路车道和一条非高速公路车道，分向而行",
      "两条高速公路车道向同一方向行驶，一条非高速公路车道向相反方向行驶",
      "两条非高速公路车道向同一方向行驶，一条非高速公路车道向相反方向行驶",
      "两条非高速公路车道和一条高速公路车道，分向而行"
    ],
    "correct_answer": 2,
    "explanation": "一条2+1道路由两条单向行驶车道和一条反向行驶车道组成。这两条车道的部分可用于安全超车，并且大约每2公里会与一条单车道部分交替。",
    "image_name": ""
  },
  {
    "index": 612,
    "id": "ABMW0482RU19",
    "section": "安全与负责驾驶",
    "question": "2+1 道路具有什么特点？",
    "options": [
      "硬肩膀和路基之间的屏障",
      "两车道供汽车使用，一车道供卡车和公共汽车使用",
      "一方向两车道，另一方向一车道",
      "在同一方向行驶的车道之间设置屏障"
    ],
    "correct_answer": 2,
    "explanation": "一条2+1道路包括两条单向行驶的车道和一条反向行驶的车道。两条车道的部分可以安全地超车，并且大约每2公里交替出现一次单车道的部分。",
    "image_name": ""
  },
  {
    "index": 613,
    "id": "ABMW0483R",
    "section": "安全与负责驾驶",
    "question": "在二车道双车道公路上，司机可以在哪里超车？",
    "options": [
      "在单车道区间，如果没有对向交通",
      "在单车道区间",
      "无论是在单车道区间还是双车道区间",
      "在双车道区间"
    ],
    "correct_answer": 3,
    "explanation": "一条 2+1 道路由一边两条车道和另一边一条车道组成。当您需要超车时，应等待到达每隔约 2 公里出现一次的双车道路段。",
    "image_name": ""
  },
  {
    "index": 614,
    "id": "ABMW0484RU19",
    "section": "安全与负责驾驶",
    "question": "在高速公路或双车道上行驶时，驾驶员应该做什么？",
    "options": [
      "放松，因为将不会有对向的交通",
      "警惕其他可能会突然变道或减速的驾驶员",
      "将车速与相邻车道的车辆匹配",
      "将车速与前方车辆的车速匹配"
    ],
    "correct_answer": 1,
    "explanation": "机动车道和双向车道旨在帮助交通更快、更安全地在目的地之间行驶。由于车速加快和车流量增加，交通状况可能会迅速变化，你需要特别注意其他司机变道或减速的情况。",
    "image_name": ""
  },
  {
    "index": 615,
    "id": "ABMW0485RU19",
    "section": "安全与负责驾驶",
    "question": "在高速公路的正常行驶情况下，驾驶员应该驶入哪条车道？",
    "options": [
      "在没有意图驶入左侧出口时，请在右侧（外侧）车道行驶",
      "在左侧（内侧）车道仅供重型货车和公交车使用",
      "持续在交通流量较少的车道之间进行机动",
      "在没有意图超车时，请在左侧（内侧）车道行驶"
    ],
    "correct_answer": 3,
    "explanation": "在高速公路上行驶时，适用普通的靠左规则 驾驶员应该保持在靠近道路左侧的车道，除非他们正在超车。",
    "image_name": ""
  },
  {
    "index": 616,
    "id": "ABMW0496RU19",
    "section": "安全与负责驾驶",
    "question": "高速公路的硬路肩可用于什么？",
    "options": [
      "进入高速公路",
      "离开高速公路",
      "紧急停车",
      "停车使用手机"
    ],
    "correct_answer": 2,
    "explanation": "在高速公路上驾驶存在额外危险，因为交通量增加且车速更快。为了安全起见，司机除非遇到紧急情况或发生故障，否则不应在高速公路的硬肩停车或驾驶。",
    "image_name": ""
  },
  {
    "index": 617,
    "id": "ABMW0497RU19",
    "section": "安全与负责驾驶",
    "question": "在驶出高速公路，进入加减速车道朝向行车道尽头的路口时，司机应该怎么做？",
    "options": [
      "保持高速行驶至匝道尽头",
      "注意匝道尽头有来往车辆",
      "驾驶员必须始终停在匝道尽头",
      "驾驶员应继续通过交叉口，因为匝道上的交通享有通行权"
    ],
    "correct_answer": 1,
    "explanation": "司机应检查显示降低速度的标志；使用速度表确保他们遐守降低的速度限制；记住高速公路之间的匝道和连接道可能包括急转弯，同时可能遇到连接路口和其他车辆。记住高速公路规则不再适用。",
    "image_name": ""
  },
  {
    "index": 618,
    "id": "ABMW0499RU19",
    "section": "安全与负责驾驶",
    "question": "一个司机希望在等同重要的十字路口直行。如果他们遇到其他车辆，适用的一般规则是什么？",
    "options": [
      "来自司机右侧方向的交通拥有通行权",
      "继续按照平时一样通行",
      "优先让从左侧接近的交通通行，然后再是右侧",
      "仅让从左侧接近的交通通行"
    ],
    "correct_answer": 0,
    "explanation": "如果一名驾驶员在道路具有相同重要性的交叉口，右侧道路的交通享有通行权。驾驶员必须让这些交通通过后再继续前行。重要的是要了解通行权并非绝对的权利。驾驶员必须谨慎前行，同时尊重其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 619,
    "id": "ABMW0513RU19",
    "section": "安全与负责驾驶",
    "question": "一般情况下，在双向道路上右转时，司机应该把车辆停在什么位置？",
    "options": [
      "在道路中間的任一側",
      "在道路的最左側",
      "在道路的最右側",
      "在道路中間稍微向左側"
    ],
    "correct_answer": 3,
    "explanation": "一般情况下，在右转弯之前正确的位置是在道路中心线的左侧。在道路足够宽的情况下，这个位置允许从后方驶来且直行的交通安全地通过左侧。驾驶员应警惕指示其按照特定路线行驶的道路标线。",
    "image_name": ""
  },
  {
    "index": 620,
    "id": "ABMW0514RU19",
    "section": "安全与负责驾驶",
    "question": "一名司机在从主要道路转向次要道路前应该做什么？",
    "options": [
      "停下来并示意交通车辆从次要道路左转",
      "向来车交通和路口处正在穿越的行人让行",
      "在来车交通前开始转弯，因为他们必须让右转车辆通过",
      "停下来并示意交通车辆从次要道路右转"
    ],
    "correct_answer": 1,
    "explanation": "司机必须在从主要道路右转到次要道路时让行对面来车以及已经横穿马路的行人。",
    "image_name": ""
  },
  {
    "index": 621,
    "id": "RSA0208",
    "section": "安全与负责驾驶",
    "question": "当紧急服务车辆以闪烁的蓝灯接近时，司机应该怎么做？",
    "options": [
      "紧急情况下刹车让救护车通过",
      "不要做任何事情，忽视救护车",
      "快速、安全、小心地反应让救护车通过",
      "增加速度以防止阻碍救护车"
    ],
    "correct_answer": 2,
    "explanation": "司机需要了解当他们看到紧急车辆时该怎么做。司机必须快速、安全、小心地做出反应，以便让紧急服务车辆通过。时刻保持警惕和专注是非常重要的。",
    "image_name": ""
  },
  {
    "index": 622,
    "id": "RSA0209",
    "section": "安全与负责驾驶",
    "question": "应急服务车辆接近并闪烁蓝灯时，司机绝对不能做什么？",
    "options": [
      "迅速、安全、小心地让紧急服务车辆通过",
      "突然刹车或者挡住道路",
      "在能够让紧急服务车辆安全通过的地方停靠",
      "尽快让路"
    ],
    "correct_answer": 1,
    "explanation": "司机需要知道当他们看到紧急车辆时该怎么做。司机必须迅速、安全、小心地做出反应，以便让紧急服务车辆通过。时刻保持警觉和专注是非常重要的。",
    "image_name": ""
  },
  {
    "index": 623,
    "id": "RSA0210",
    "section": "安全与负责驾驶",
    "question": "在中国，驾驶员可以闯红灯或超速让紧急服务车辆通过吗？",
    "options": [
      "不，驾驶员绝对不应该闯红灯或加速让紧急服务车辆通过",
      "是的，驾驶员可以超速让紧急服务车辆通过",
      "是的，驾驶员可以合法地闯红灯让紧急服务车辆通过",
      "不，除非路口或道路畅通无阻，那么驾驶员可以闯红灯或加速让紧急服务车辆通过"
    ],
    "correct_answer": 0,
    "explanation": "司机需要知道当他们看到紧急车辆时该怎么做。司机必须迅速、安全、谨慎地反应，以便让紧急服务车辆通过。时刻保持警觉和专注是非常重要的。",
    "image_name": ""
  },
  {
    "index": 624,
    "id": "RSAO215",
    "section": "安全与负责驾驶",
    "question": "车辆驾驶员在交通事故现场“rubbernecking”可能会产生什么影响？",
    "options": [
      "它允许交通改变方向而不注意",
      "它允许交通在不注意的情况下改变速度",
      "它可能导致司机分心而引起额外事故",
      "它可能增加事故附近的交通流量"
    ],
    "correct_answer": 2,
    "explanation": "接近或接近事故现场时，经常可以看到汽车司机会出现“橡胶颈”的情况。这意味着扭头和伸长脖子以获得更好的视野。这可能导致交通堵塞，因为司机们减速进行“橡胶颈”观看。它还可能导致道路事故，因为司机会因分心而在其他司机也分心的情况下改变速度和/或方向。",
    "image_name": ""
  },
  {
    "index": 625,
    "id": "RSA0216",
    "section": "安全与负责驾驶",
    "question": "司机应该如何对待开启警灯和/或警笛的急救车辆？",
    "options": [
      "突然刹车并停下以避免造成阻碍",
      "沿路右侧上山脊以让出空间",
      "只有在紧急车辆时侧身让路",
      "在寻找让路空间之前，检查他们的后视镜"
    ],
    "correct_answer": 3,
    "explanation": "如果您看到任何开启灯光和/或警报器的紧急车辆接近，请检查您的后视镜以判断紧急车辆的速度，还要注意行人、骑自行车的人、骑摩托车的人和其他道路使用者。表明您打算靠边停车的意图。只在有足够空间让紧急车辆安全通过的地方停车。做好适当的观察后安全地驶离。",
    "image_name": ""
  },
  {
    "index": 626,
    "id": "ABMW0605RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员在行驶时前轮爆胎时应该怎么做？",
    "options": [
      "松开对方向盘的握紧",
      "紧急而迅速刹车",
      "紧握方向盘",
      "立即拉紧手刹"
    ],
    "correct_answer": 2,
    "explanation": "如果车辆的前轮爆胎，车辆的转向会变得不稳定。不要惊慌 保持对方向盘的牢固控制，逐渐减速。在安全的地方停下来更换轮胎，并通过打开危险警示灯来警告其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 627,
    "id": "ABMW0606R",
    "section": "安全与负责驾驶",
    "question": "如果司机在高速公路上车辆爆胎了，该怎么办？",
    "options": [
      "在安全的硬肩停车并寻求协助",
      "开到下一个服务区并寻求协助",
      "在硬肩停车并让乘客警告交通",
      "在交通道停车并打开危险警示灯"
    ],
    "correct_answer": 0,
    "explanation": "不要试图在高速公路上更换车轮，因为这样可能非常危险。将车驶入硬路肩，当安全时，下车并移动到护栏后面。使用高速公路紧急电话或移动电话（拨打警方）寻求援助。",
    "image_name": ""
  },
  {
    "index": 628,
    "id": "ABMW0607RU19",
    "section": "安全与负责驾驶",
    "question": "司机可以采取哪些预防措施来防范车辆起火的风险？",
    "options": [
      "在车辆中携带合适的灭火器",
      "随时保持所有水位填满",
      "在车辆中使用低辛烷值无铅汽油",
      "避免驾驶车辆时油箱装满燃料"
    ],
    "correct_answer": 0,
    "explanation": "燃油味道浓烈通常表示出现问题，你应该立即停下来并尽快调查。汽油泄漏或溢出很危险，因为它易燃。在车辆上携带灭火器是个不错的做法，这样你可以处理任何小火灾。",
    "image_name": ""
  },
  {
    "index": 629,
    "id": "ABMW0609R",
    "section": "安全与负责驾驶",
    "question": "司机何时应在高速公路上使用危险警示灯？",
    "options": [
      "当另一辆车跟车太近时",
      "当车辆牵引拖车时",
      "当在硬路肩上行驶时",
      "当车辆抛锚时"
    ],
    "correct_answer": 3,
    "explanation": "如果您的车辆在高速公路上抛锚，应将其开到硬肩上并打开危险警示灯以警示后方车辆。当安全时，下车并移至护栏后面。通过高速公路紧急电话或使用手机（致电警察）寻求帮助。",
    "image_name": ""
  },
  {
    "index": 630,
    "id": "ABMW0610U19",
    "section": "安全与负责驾驶",
    "question": "如果驾驶员的车辆在高速公路上抛锚等待救援，应该怎么做？",
    "options": [
      "试图从车后拦截其他交通协助",
      "打开车辆警示灯，下车并安全站在车辆旁边",
      "下车并在车后等候",
      "站在道路上引导交通通过"
    ],
    "correct_answer": 1,
    "explanation": "如果您的车辆在路上抛锚，一定要打开危险警告灯，并远离车辆等待援助 这样会警示其他车辆有车辆在路上停车。",
    "image_name": ""
  },
  {
    "index": 631,
    "id": "ABMW0735RU23",
    "section": "安全与负责驾驶",
    "question": "當駕駛人看到前方施工區域有植物或機械穿越道路時，應該採取什麼行動？",
    "options": [
      "在前方道路阻塞时离开车道",
      "沿着道路保持相同速度",
      "减速并准备停车"
    ],
    "correct_answer": 2,
    "explanation": "當您注意到前方有工程車輛時，減速並準備停車以應對道路施工。如果有機械正在橫越，如果受到指示，您必須停車。",
    "image_name": ""
  },
  {
    "index": 632,
    "id": "ABMW0736R",
    "section": "安全与负责驾驶",
    "question": "当司机遇到闪烁蓝灯的车辆时，应该采取什么行动？",
    "options": [
      "闪烁前灯，并驶上左侧人行道",
      "打开车辆危险警示灯",
      "闪烁前灯并立即停车",
      "向左转，减速并必要时停车"
    ],
    "correct_answer": 3,
    "explanation": "當駕駛員注意到遠處有緊急車輛接近時，應該檢查後視鏡並向左移動，讓車輛通過。在某些情況下可能需要停車。",
    "image_name": ""
  },
  {
    "index": 633,
    "id": "ABMW0737",
    "section": "安全与负责驾驶",
    "question": "如果前方救护车停在那里并且启动了闪烁的蓝灯，司机应该怎么做？",
    "options": [
      "减速并做好准备停车",
      "如果必要，移至道路中间以阻止其他车辆超车",
      "立即停车查看情况",
      "停车并提供帮助"
    ],
    "correct_answer": 0,
    "explanation": "当你遇到在道路上停下的紧急车辆时，你应该减速并准备停车。不要停下来看发生了什么，因为这可能很危险，而且你可能会阻碍交通流动。",
    "image_name": ""
  },
  {
    "index": 634,
    "id": "ABMW0738RU19",
    "section": "安全与负责驾驶",
    "question": "应急车辆如何被识别？",
    "options": [
      "通过闪烁红色或蓝色灯光",
      "通过闪烁绿色灯光",
      "通过持续点亮的红色灯光",
      "通过闪烁琥珀色和白色灯光"
    ],
    "correct_answer": 0,
    "explanation": "如果你听到或看见一辆紧急车辆正在鸣笛或闪灯接近，请格外小心，如果安全的话，请让路。",
    "image_name": ""
  },
  {
    "index": 635,
    "id": "RSA0217",
    "section": "安全与负责驾驶",
    "question": "允许学习驾驶员单独驾驶车辆的车主会被处以何种处罚？",
    "options": [
      "车辆将被扣押",
      "他们的驾驶执照将被记 2 分",
      "他们将被罚款 €2,000",
      "他们将失去驾驶执照"
    ],
    "correct_answer": 0,
    "explanation": "一名学习驾驶员需要意识到，即使车主已经同意让其驾驶，独自驾驶车辆可能导致车辆被扣押。",
    "image_name": ""
  },
  {
    "index": 636,
    "id": "RSA0218",
    "section": "安全与负责驾驶",
    "question": "36個月（三年）內累計7分的學習許可駕駛員將被停駕多少個月？",
    "options": [
      "3个月",
      "6个月",
      "12个月",
      "9个月"
    ],
    "correct_answer": 1,
    "explanation": "一名学习驾驶员需要意识到学员或新手驾驶员的处罚点阈值较低。",
    "image_name": ""
  },
  {
    "index": 637,
    "id": "ABMW0199R",
    "section": "安全与负责驾驶",
    "question": "如果没有人行道，行人必须走在哪里？",
    "options": [
      "沒有規定",
      "離路邊1米",
      "道路的右側",
      "道路的左側"
    ],
    "correct_answer": 2,
    "explanation": "在没有人行道的情况下，行人应该在道路的右侧行走，面对迎面而来的交通。驾驶员应该了解行人的交通规则，谨慎驾驶并准备好应对交通状况的任何变化。",
    "image_name": ""
  },
  {
    "index": 638,
    "id": "ABMW0203RU19",
    "section": "安全与负责驾驶",
    "question": "在狭窄繁忙的道路上，行人走路时应该怎么做？",
    "options": [
      "走时保持不超过三人並排",
      "一个人侧走",
      "两人並排走",
      "单行走"
    ],
    "correct_answer": 3,
    "explanation": "繁忙狭窄道路上，行人应单行行走。驾驶员应了解行人道路规则，小心驾驶，并准备应对交通状况的任何变化。",
    "image_name": ""
  },
  {
    "index": 639,
    "id": "ABMW0204RU19",
    "section": "安全与负责驾驶",
    "question": "夜晚行人应何时穿反光服装？",
    "options": [
      "在夜晚在非建筑区域外行走时",
      "在两人并肩行走时",
      "只有在下雨时",
      "在城市地区时"
    ],
    "correct_answer": 0,
    "explanation": "在建制区外，行人夜间行走时应始终穿着反光服装。这在没有街灯和行人通道的地方尤为重要。",
    "image_name": ""
  },
  {
    "index": 640,
    "id": "ABMW0225RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，汽车司机应该怎么做？",
    "options": [
      "司机必须让自行车手通行",
      "司机可以在自行车手之前右转",
      "司机必须让摩托车手通行",
      "司机必须停车并让其他道路使用者让路"
    ],
    "correct_answer": 0,
    "explanation": "當您從主要道路右轉至次要道路時，必須讓對向來車通行，只有在安全的情況下才能繼續前進。",
    "image_name": "ABMW0225RU19.png"
  },
  {
    "index": 641,
    "id": "ABMW0229R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，汽车驾驶员应该怎么做？",
    "options": [
      "汽车驾驶员不允许向右转",
      "汽车驾驶员必须让公共汽车先行",
      "汽车驾驶员可以先行",
      "汽车驾驶员必须让摩托车先行"
    ],
    "correct_answer": 3,
    "explanation": "当您从主要道路转向次要道路时，您必须让向来的车辆先行。只有在安全的情况下才可以继续前行。",
    "image_name": "ABMW0229R.png"
  },
  {
    "index": 642,
    "id": "ABMW0231R",
    "section": "安全与负责驾驶",
    "question": "在这个区域，驾驶员应该注意什么？",
    "options": [
      "停着的车辆可能连接有拖车",
      "停着的车辆之间可能放置有垃圾箱",
      "行人可能在搭便车",
      "行人可能在停着的车辆之间穿过"
    ],
    "correct_answer": 3,
    "explanation": "在城市建成区驾驶时，您应该谨慎驾驶，并做好准备以对从停放的车辆之间穿过的行人做出反应。",
    "image_name": "ABMW0231R.png"
  },
  {
    "index": 643,
    "id": "ABMW0242R",
    "section": "安全与负责驾驶",
    "question": "银色汽车的司机在左转之前应该做什么？",
    "options": [
      "增加速度以在骑自行车者之前完成左转弯",
      "按喇叭以提醒骑车者车辆的存在",
      "从左侧超车骑车者完成转弯",
      "让直行的骑车者通过"
    ],
    "correct_answer": 3,
    "explanation": "在接近左转路口时，不要超越骑自行车的人。骑自行车的人可能会继续直行。骑自行车的人是易受伤的道路使用者，在缓慢移动的交通和路口可能会不稳定。给予他们更多空间。",
    "image_name": "ABMW0242R.png"
  },
  {
    "index": 644,
    "id": "ABMW0252RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应注意什么？",
    "options": [
      "自行车骑手将停在自行车道的尽头让交通通过",
      "自行车骑手将留在自行车道上",
      "驾驶员应该靠向左侧（靠近道边），以防自行车骑手突然并出",
      "自行车骑手可能会不注意移动的交通而进入道路"
    ],
    "correct_answer": 3,
    "explanation": "在接近即将从自行车道驶出并驶入道路的骑自行车者时，您应该格外小心。",
    "image_name": "ABMW0252RU19.png"
  },
  {
    "index": 645,
    "id": "ABMW0253RU23",
    "section": "安全与负责驾驶",
    "question": "一名驾驶员想从车道驶出，向右转上路。与此同时，一名骑自行车的人从右边靠近，还有一名行人想要横穿马路。谁必须等待？",
    "options": [
      "驾驶员必须等待",
      "行人和骑车者必须等待",
      "行人必须等待"
    ],
    "correct_answer": 0,
    "explanation": "根据法律规定，当您驶入或驶出私人车道时，必须礼让其他道路使用者，包括行人和骑车者。",
    "image_name": "ABMW0253RU23.png"
  },
  {
    "index": 646,
    "id": "ABMW0257R",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该如何超越骑自行车的人？",
    "options": [
      "通过跨越破损的白色线来超越",
      "通过跨越两条线并保持靠近骑行者",
      "超越骑行者，但不得越过任何线",
      "通过按喇叭警告骑行者他们打算超越"
    ],
    "correct_answer": 0,
    "explanation": "当道路中央有两条线时，您必须遵守最靠近您的那条线。因此，如果最近的线是一条断裂的白线，根据法律，只要安全，您可以超车。",
    "image_name": "ABMW0257R.png"
  },
  {
    "index": 647,
    "id": "ABMW0302RU23",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，司机应该怎么做？",
    "options": [
      "允许行人过马路",
      "按喇叭警示行人",
      "迅速通过以清理路口"
    ],
    "correct_answer": 0,
    "explanation": "接近斑马线时，必须让步给已经在横穿或即将横穿马路的行人。",
    "image_name": "ABMW0302RU23.png"
  },
  {
    "index": 648,
    "id": "ABMW0327R",
    "section": "安全与负责驾驶",
    "question": "前方人行道上有行人，路上有积水。司机应该怎么做？",
    "options": [
      "闪灯向行人发出警告信号",
      "接近积水时突然刹车",
      "减速并尽量避开积水，以免溅湿行人",
      "按喇叭向行人发出警告信号，然后继续前行"
    ],
    "correct_answer": 2,
    "explanation": "在潮湿条件下，您应该注意到地面积水会影响车辆的稳定性。尤其是在积水的地方。当您驾驶穿过地面积水时，您应该考虑到行人和骑自行车的人，尽量避免在经过时将水溅起来。",
    "image_name": ""
  },
  {
    "index": 649,
    "id": "ABMW0528RU19",
    "section": "安全与负责驾驶",
    "question": "當停在紅綠燈處，綠燈亮起但行人仍在穿越馬路時，駕駛員應該做什麼？",
    "options": [
      "按喇叭警告他們燈已經變了",
      "前進鼓勵他們儘快完成穿越",
      "等待足夠時間讓他們完成穿越",
      "告知行人燈已經變了並開車前進"
    ],
    "correct_answer": 2,
    "explanation": "翻译:\n绿色交通灯意味着你可以通行，如果道路畅通无阻。如果有行人正在穿越，请让路给他们，等他们安全过马路后再继续前行。",
    "image_name": ""
  },
  {
    "index": 650,
    "id": "ABMW0531RU23",
    "section": "安全与负责驾驶",
    "question": "当司机看到前面有由初学驾驶员驾驶的缓行车辆时，应该怎么做？",
    "options": [
      "尽快超过该车辆",
      "保持一定距离以避免不必要的压力",
      "靠近该车以显示你打算超车的意图"
    ],
    "correct_answer": 1,
    "explanation": "在跟随学习驾驶人员时要保持耐心和礼貌。学习驾驶人员没有其他道路使用者那么有经验，受到压力时可能会驾驶不稳。",
    "image_name": ""
  },
  {
    "index": 651,
    "id": "ABMW0532RU19",
    "section": "安全与负责驾驶",
    "question": "学员司机在不寻常的交通情况下可能会作何反应？",
    "options": [
      "慢于经验丰富的驾驶员",
      "快于经验丰富的驾驶员",
      "与经验丰富的驾驶员相同",
      "优于经验丰富的驾驶员"
    ],
    "correct_answer": 0,
    "explanation": "在跟随学习驾驶员驾驶时，你应该保持耐心。学习驾驶员可能无法像经验丰富的驾驶员那样预见并应对不寻常的交通情况。",
    "image_name": ""
  },
  {
    "index": 652,
    "id": "ABMW0535RU19",
    "section": "安全与负责驾驶",
    "question": "在交叉路口时，哪些道路使用者尤为脆弱？",
    "options": [
      "拖拉机司机",
      "小型巴士司机",
      "摩托车骑手",
      "货车司机"
    ],
    "correct_answer": 2,
    "explanation": "驾驶员应意识到在路口没有任何车辆有自动让行权利。驾驶员必须特别注意易受伤害的道路使用者，如摩托车手，因为他们在道路上的存在可能比其他车辆类型不太明显，这是因为他们的尺寸较小或有遮挡物。",
    "image_name": ""
  },
  {
    "index": 653,
    "id": "ABMW0536RU23",
    "section": "安全与负责驾驶",
    "question": "在交通灯处停车时，驾驶员应特别注意哪些来自左侧的道路使用者？",
    "options": [
      "自行车",
      "汽车",
      "拖拉机"
    ],
    "correct_answer": 0,
    "explanation": "在交通灯变绿之前，尤其在左转时，您应注意左侧可能有自行车骑手和摩托车骑手靠近，特别是在自行车有独立停车线的地方。",
    "image_name": ""
  },
  {
    "index": 654,
    "id": "ABMW0539RU19",
    "section": "安全与负责驾驶",
    "question": "在行驶缓慢的城市交通中，驾驶员应该不时检查其盲点，特别是哪些道路使用者？",
    "options": [
      "骑自行车",
      "汽车",
      "货车",
      "出租车"
    ],
    "correct_answer": 0,
    "explanation": "司机在启动和改变方向前，应意识到并检查盲区，必要时也要这样做。自行车骑手很容易隐藏在盲区中，在交通缓慢的情况下，他们的速度可能比您快。",
    "image_name": ""
  },
  {
    "index": 655,
    "id": "ABMW0541U23",
    "section": "安全与负责驾驶",
    "question": "在交通灯处，司机应特别注意从左侧（靠近路边）靠近的哪些道路使用者？",
    "options": [
      "摩托车",
      "汽车",
      "卡车"
    ],
    "correct_answer": 0,
    "explanation": "在绿灯前启动之前，您应该注意到摩托车可能会突然从左侧（靠近车边）靠近。",
    "image_name": ""
  },
  {
    "index": 656,
    "id": "ABMW0549RU23",
    "section": "安全与负责驾驶",
    "question": "当司机在左侧看到慢跑者时应该怎么做？",
    "options": [
      "检查后视镜，打转向灯并超车，在给予他们足够空间的同时",
      "预计他们会在驾驶员的路径内外移动",
      "打转向灯并超车，确保留足够的间隔",
      "按喇叭并闪灯以警示他们注意你的存在"
    ],
    "correct_answer": 0,
    "explanation": "路上的行人比车辆更加脆弱，所以您应该更加小心地对待他们。如果您看到前方有人在慢跑，请使用“后视镜-信号-操控”的程序，并在超车时给跑步者留足够的空间。",
    "image_name": ""
  },
  {
    "index": 657,
    "id": "ABMW0550RU19",
    "section": "安全与负责驾驶",
    "question": "在行驶在路面破损、前方有骑自行车的骑手时，司机应该怎么做？",
    "options": [
      "切换到较低挡位并快速超车",
      "在骑自行车的人为了避开坑洞而变道时，要留出额外空间",
      "预计骑自行车的人会靠左并保持速度",
      "保持车辆方向并按喇叭提醒骑自行车的人他们的到来"
    ],
    "correct_answer": 1,
    "explanation": "你应该时刻意识到骑自行车者的脆弱性。当你驾驶车辆行驶在坑洼路面或者破损路面时，超越骑车者时要给予他们充足的空间。要考虑到他们可能会突然避开坑洼。",
    "image_name": ""
  },
  {
    "index": 658,
    "id": "ABMW0552RU19",
    "section": "安全与负责驾驶",
    "question": "司机在左转进入侧路时应该注意什么？",
    "options": [
      "自行车可能会靠左（靠近路边）",
      "需要靠近路缘尽可能近",
      "跟随的车辆必须留有超车的空间",
      "骑自行车的人可能会靠右（远离路边）"
    ],
    "correct_answer": 0,
    "explanation": "转弯左时，驾驶员应注意可能会有骑车人和行人靠近左侧（靠近车边）。在左转弯之前，始终要向左侧（靠近车边）检查。",
    "image_name": ""
  },
  {
    "index": 659,
    "id": "ABMW0556RU19",
    "section": "安全与负责驾驶",
    "question": "在没有人行道的乡间道路上行驶时，司机应该期待什么会朝向他们驶来于他们所在的道路一侧？",
    "options": [
      "自行车骑手",
      "行人",
      "摩托车骑手",
      "拖拉机"
    ],
    "correct_answer": 1,
    "explanation": "在没有人行道的地方，行人需要走在对向车流的一侧，驾驶员应该注意到这一点。行人是弱势道路使用者，所以驾驶员应始终注意他们的存在，尤其是在乡村道路上。",
    "image_name": ""
  },
  {
    "index": 660,
    "id": "ABMW0557RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在夜间行驶在没有路灯照明的道路上时应该做什么？",
    "options": [
      "靠近左侧行驶以避开对向车辆",
      "注意穿着深色衣服的行人",
      "尽可能靠近反光钉的线行驶",
      "在路的中间行驶"
    ],
    "correct_answer": 1,
    "explanation": "在夜间驾驶时，即使使用最好的车头灯，也可能很难看到所有可能遇到的危险，比如穿着深色衣物的行人。驾驶员应始终以一种速度驾驶，使其能够在他们能清晰看到的距离范围内安全停车。",
    "image_name": ""
  },
  {
    "index": 661,
    "id": "ABMW0558RU23",
    "section": "安全与负责驾驶",
    "question": "如果司机把车停在人行道上会发生什么事？",
    "options": [
      "轮胎会失去气压",
      "行人可能无法通过",
      "交通可能无法通过",
      "悬挂会变弱"
    ],
    "correct_answer": 1,
    "explanation": "您永远不应该停在人行道上。行人（包括推着婴儿车、手推车以及轮椅使用者的人）可能不得不走上马路绕过您的车，这可能会给他们带来危险。",
    "image_name": ""
  },
  {
    "index": 662,
    "id": "ABMW0559RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在打算超越前方同向行驶的骑车人时应当遵循哪些程序？",
    "options": [
      "打灯，驶出并检查后方交通情况",
      "打灯，检查后方情况后驶出超车",
      "检查后方情况，驶出超车而不打灯",
      "检查后方情况，打灯后驶出超车如果情况许可"
    ],
    "correct_answer": 3,
    "explanation": "司机在超车时应遵循“观察后视镜 示意 操控” 的程序。司机只有在安全的情况下才应该超车。在超越骑自行车的人时，请给予额外空间，因为他们可能需要绕过坑洼，或在风大的日子里被风刮到你的车道。",
    "image_name": ""
  },
  {
    "index": 663,
    "id": "ABMW0561RU19",
    "section": "安全与负责驾驶",
    "question": "**在乡村路上有跟车时，司机遇到行人应该怎么做？**\n\n司机在乡村路上有跟车时，碰到行人时应该怎么做？",
    "options": [
      "留下最少30厘米的空隙",
      "闪灯警示后方车辆有行人在路上",
      "示意行人远离路面",
      "示意打算超越行人"
    ],
    "correct_answer": 3,
    "explanation": "當您行駛在沒有人行道的道路上時，司机在遇到道路上的行人時應格外小心。當他們打算超車時，應及時檢查後視鏡並向後方交通發出信號，提醒後方車輛他們將改變行車方向以應對前方的危險。",
    "image_name": ""
  },
  {
    "index": 664,
    "id": "ABMW0562RU19",
    "section": "安全与负责驾驶",
    "question": "在黑暗的冬日清晨和傍晚行驶在无路灯的乡村道路上时，驾驶员应注意什么？",
    "options": [
      "逆向骑自行车的人永远不会被车辆的灯光迷惑而晃动到驾驶员的道路上",
      "在光线不佳的情况下，骑车者更容易受伤",
      "所有骑车者都佩戴反光腰带，车辆上装有正确的照明设施，且清晰可见",
      "在乡间道路上，骑车者有足够的空间在道路边缘，以便驾驶员可以在不减速或横穿的情况下超车"
    ],
    "correct_answer": 1,
    "explanation": "驾驶员在黑暗的冬季早晨和傍晚驾驶时应格外小心 脆弱的道路使用者，如骑车人和行人（尤其是学童），在低光条件下可能不那么容易被看见。",
    "image_name": ""
  },
  {
    "index": 665,
    "id": "ABMW0564RU19",
    "section": "安全与负责驾驶",
    "question": "在黑暗的冬日早晨和晚上行驶在未照明的乡间道路时，驾驶员应注意什么？",
    "options": [
      "可能会有易受伤的行人在路上行走",
      "所有行人都会佩戴反光臂章和鲜艳的服装",
      "缺乏光线不会影响司机看到易受伤的行人",
      "路上不会有行人行走"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员在黑暗的冬季早晨和晚上开车时应格外小心 脆弱的道路使用者，如骑自行车的人和行人（特别是学童），在低光条件下可能不那么容易被看到。",
    "image_name": ""
  },
  {
    "index": 666,
    "id": "ABMW0565RU19",
    "section": "安全与负责驾驶",
    "question": "在黑暗的冬季早晨和傍晚行驶在无路灯的乡村道路上时，司机应该注意什么？",
    "options": [
      "司机应始终开启侧灯，以便在无路灯照明的乡村道路上看到行人",
      "在黑暗的冬季早晨和晚上，学生在无路灯的乡村道路上更容易受到伤害",
      "缺乏光线不会影响司机看到路上的流浪动物",
      "司机应该预料到行人会在人行道上行走，并且不会有被撞到的危险"
    ],
    "correct_answer": 1,
    "explanation": "在黑暗的冬日早晨和晚上驾驶时，驾驶者应特别注意 易受伤害的道路使用者，如骑自行车的人和行人（尤其是学童），在光线较暗的情况下可能不那么容易被看见。",
    "image_name": ""
  },
  {
    "index": 667,
    "id": "ABMW16",
    "section": "安全与负责驾驶",
    "question": "在道路交叉口，哪种道路使用者特别容易受到伤害？",
    "options": [
      "行人",
      "货车司机",
      "轿车司机",
      "拖拉机司机",
    ],
    "correct_answer": 0,
    "explanation": "车辆在交叉口没有自动让行的权利。作为驾驶员，您应特别注意行人、骑车人和摩托车手等弱势道路使用者，并意识到他们有权安全地使用道路。",
    "image_name": ""
  },
  {
    "index": 668,
    "id": "ABMW18U19",
    "section": "安全与负责驾驶",
    "question": "在交通信号灯处，司机应特别注意哪些从左侧靠近的道路使用者？",
    "options": [
      "拖拉机",
      "摩托车",
      "汽车",
      "面包车"
    ],
    "correct_answer": 1,
    "explanation": "在交通灯变绿之前，驾驶员应当注意交通情况，尤其是靠左侧靠近的自行车和摩托车，特别是当自行车专用停车线在其他道路使用者的停车线之前时。",
    "image_name": ""
  },
  {
    "index": 669,
    "id": "ABMW19U19",
    "section": "安全与负责驾驶",
    "question": "当司机打算在十字路口左转时，有行人和骑自行车的情况下，司机应该怎么做？",
    "options": [
      "检查右侧镜子，转弯后打灯号",
      "打左灯号，观察右侧镜子并转弯",
      "检查你的镜子，并留意左侧的骑车者或行人",
      "在进行转弯时按喇叭警示其他道路使用者转弯的意图"
    ],
    "correct_answer": 2,
    "explanation": "车辆并没有比其他道路使用者更大的通行权。作为驾驶员，您应该特别关注行人、骑车者和摩托车骑手等弱势道路使用者，并意识到他们有权安全使用道路。",
    "image_name": ""
  },
  {
    "index": 670,
    "id": "ABMW21U19",
    "section": "安全与负责驾驶",
    "question": "在缓慢移动的城市交通中，以下哪种道路使用者最容易受到伤害？",
    "options": [
      "出租车",
      "汽车",
      "摩托车手",
      "货车"
    ],
    "correct_answer": 2,
    "explanation": "在缓慢移动的城市交通中，您应该在进行任何操作前留意并检查您的盲点。摩托车手很容易会隐藏在盲点中，在缓慢移动的交通中，他们可能比您移动得更快。",
    "image_name": ""
  },
  {
    "index": 671,
    "id": "ABMW22U19",
    "section": "安全与负责驾驶",
    "question": "在缓慢移动的城市交通中，以下哪种道路使用者最容易受到伤害？",
    "options": [
      "行人",
      "汽车",
      "货车",
      "出租车"
    ],
    "correct_answer": 0,
    "explanation": "在缓慢的城市交通中，进行任何操作前，你应该注意并检查盲点。行人很容易藏在盲点中，在缓慢的交通中，他们可能比你移动得更快。",
    "image_name": ""
  },
  {
    "index": 672,
    "id": "ABMW24U19",
    "section": "安全与负责驾驶",
    "question": "夜间行驶在未照明道路上时，驾驶员应该怎么做？",
    "options": [
      "靠近左侧行驶，并打开前雾灯",
      "行驶速度至少低于标志限速30km/h",
      "保持远离道路左侧",
      "注意未开灯的骑自行车人"
    ],
    "correct_answer": 3,
    "explanation": "夜间驾驶即使使用最好的车头灯，也可能很难看到所有可能遇到的危险，例如路上的流浪动物或牲畜。夜间驾驶时，您应该以一个能够让您在能够清晰看到的距离内安全停车的速度驾驶。",
    "image_name": ""
  },
  {
    "index": 673,
    "id": "AMBW0538RU19",
    "section": "安全与负责驾驶",
    "question": "在繁忙的市區街道十字路口，當駕駛員打算左轉，周圍有行人和騎自行車的人時，駕駛員應該怎樣做？",
    "options": [
      "保持靠右以为骑自行车的人让路",
      "留意可能会试图穿过车辆前面的自行车手或行人",
      "向左打信号，观察右侧镜子，当确认安全时转弯",
      "靠近左侧以防止自行车手或行人从您左侧接近"
    ],
    "correct_answer": 1,
    "explanation": "在繁忙的城市街道上左转时，司机应特别注意易受伤的道路使用者，如行人、骑自行车的人和骑摩托车的人，他们可能突然出现，可能不知道车辆的意图。",
    "image_name": ""
  },
  {
    "index": 674,
    "id": "RSA0211",
    "section": "安全与负责驾驶",
    "question": "在最高時速為50公里的區域超車單車時，建議的最小超車距離是多少？",
    "options": [
      "允许最高1.75米",
      "允许最高1米",
      "允许最低1米",
      "允许最低1.75米"
    ],
    "correct_answer": 2,
    "explanation": "司机应该将他们的车辆开到足够靠左侧的位置，以便其他车辆可以安全地超车或超越右侧，但不要开得太靠左，以至于你开在自行车道上或阻塞或危及骑车者或行人。如果司机需要超车自行车骑手，且具备安全条件，他们应尽可能给予根据所在速度限制区域建议的间隔，以确保安全。",
    "image_name": ""
  },
  {
    "index": 675,
    "id": "RSA0212",
    "section": "安全与负责驾驶",
    "question": "在超过50km/h的速度区域安全超车自行车时，建议的最小通过距离是多少？",
    "options": [
      "保持至少1米的距离",
      "允许最大1.5米的距离",
      "允许最大1.75米的距离",
      "保持至少1.5米的距离"
    ],
    "correct_answer": 3,
    "explanation": "司机应将车辆开到足够靠左的位置，以便交通可以安全地从右侧超车，但不要开得太靠左，以至于驶入自行车道或堵塞、危害骑自行车的人或行人。如果司机希望超越骑自行车的人，并且情况允许，他们应尽可能地给予建议的安全间距，这取决于他们所处的速限区域。",
    "image_name": ""
  },
  {
    "index": 676,
    "id": "RSA0213",
    "section": "安全与负责驾驶",
    "question": "一名行人在行走沿着光线不足的道路时，如何降低发生事故的风险？",
    "options": [
      "穿深色衣服",
      "与团体一起行走",
      "走在路的左侧",
      "穿戴高可见度衣物"
    ],
    "correct_answer": 3,
    "explanation": "即使有最好的车前灯，驾驶员在晚上看到的比白天少。行人和未点灯的自行车在黑暗中极其难以看到，特别是当他们不得不应对迎面而来的灯光的强烈刺眼时。行人在白天应始终穿着明亮和高可见度的衣服，在晚上在建筑稠密区域外行走时应穿反光服装。",
    "image_name": ""
  },
  {
    "index": 677,
    "id": "RSA0214",
    "section": "安全与负责驾驶",
    "question": "什么是礼让行人过街？",
    "options": [
      "一处无人行横道",
      "一处位于行人道上的人行横道",
      "一处人行横道上有“向右看”标识的",
      "一处带闪烁琥珀色灯光的人行横道"
    ],
    "correct_answer": 0,
    "explanation": "行人只能通过无控制的过境地点（礼让行人过马路处），确保所有交通工具注意到他们通过马路。进入无控制的过境地点（礼让行人过马路处）的驾驶员应该以极慢的速度行驶，并注意行人在该区域行走可能存在的危险。",
    "image_name": ""
  },
  {
    "index": 678,
    "id": "RSA228068",
    "section": "安全与负责驾驶",
    "question": "在拥挤缓慢的城市交通中，驾驶员应该偶尔检查盲点，特别是哪些道路使用者？",
    "options": [
      "汽车",
      "电动滑板车",
      "货车"
    ],
    "correct_answer": 1,
    "explanation": "司机在启动和改变方向之前应注意并检查盲区，在适当的情况下。电动滑板车很容易隐藏在盲区内，在缓慢行驶的交通中，它们的移动速度可能比您更快。\n\n在适当的情况下，司机应该意识到并检查盲点，然后再启动和改变方向。电动滑板车很容易隐藏在盲点中，在行驶缓慢的交通中，它们的速度可能比你更快。",
    "image_name": ""
  },
  {
    "index": 679,
    "id": "RSA228072",
    "section": "安全与负责驾驶",
    "question": "当在道路上行驶时，路面有坑洼并且前方有电动滑板车时，司机应该怎么做？",
    "options": [
      "为了避免电动滑板车避开坑洼而突然改变方向，请留有额外的空间",
      "保持直线行驶并按喇叭，提醒电动滑板车他们的接近",
      "预计电动滑板车会靠左行驶并保持速度"
    ],
    "correct_answer": 0,
    "explanation": "在驾驶电动滑板车时，您应始终意识到它们的脆弱性。在行驶在有坑洼或路面不良的道路上时，在超越电动滑板车时，请给予充足的通行间距。请注意，他们可能会突然躲避坑洞。",
    "image_name": ""
  },
  {
    "index": 680,
    "id": "RSA228074",
    "section": "安全与负责驾驶",
    "question": "当打算超越前方同向行驶的电动滑板车时，司机应遵循哪些程序？",
    "options": [
      "检查后视镜，打转向灯，如果安全的话，就开出去",
      "打转向灯，检查后视镜，如果安全的话，就开出去超车",
      "打转向灯，开出去并检查后视镜以确保后方车辆"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员在超车时应遵循观察后视镜 示意 操控的程序。只有在安全的情况下才应超车。超车电动滑板车时，应提供额外的空间，因为它们可能需要躲避坑洼或在风大的日子里被风吹入您的行驶道路。",
    "image_name": ""
  },
  {
    "index": 681,
    "id": "RSA228076",
    "section": "安全与负责驾驶",
    "question": "在暗夜驾驶行驶在未照明的乡间道路上时，司机应该注意什么？",
    "options": [
      "电动滑板车用户都会佩戴反光腰带，在他们的电动滑板车上配备正确的灯光，并确保自己明显可见",
      "在暗夜道路上，电动滑板车用户更加容易受到伤害",
      "电动滑板车用户应在路边留有空间，以便驾驶员可以无需超车拐弯行驶"
    ],
    "correct_answer": 1,
    "explanation": "在黑暗的冬季早晨和傍晚驾驶时，驾驶员应格外小心 一些容易被忽视的道路使用者，如骑车者、电动滑板车和行人（尤其是学童），在光线较暗的条件下可能不那么容易被看见。",
    "image_name": ""
  },
  {
    "index": 682,
    "id": "RSA228078",
    "section": "安全与负责驾驶",
    "question": "在有自行车手和电动滑板车用户的十字路口打算左转时，司机应该怎么做？",
    "options": [
      "向左打灯，检查右侧镜子然后完成转弯",
      "请按喇叭以警示其他道路使用者您的转弯意图",
      "转弯前请使用后视镜检查左侧自行车手和电动滑板车用户"
    ],
    "correct_answer": 2,
    "explanation": "车辆并没有比其他道路用户拥有更大的通行权。作为司机，您应特别注意易受伤害的道路使用者，如电动滑板车用户、骑自行车者和摩托车骑手，并意识到他们有权安全使用道路。",
    "image_name": ""
  },
  {
    "index": 683,
    "id": "RSA228084",
    "section": "安全与负责驾驶",
    "question": "夜间在无路灯的道路上行驶时，司机应该怎么做？",
    "options": [
      "沿着道路中间行驶",
      "注意无灯骑行电动滑板车",
      "靠近左侧行驶并打开前雾灯"
    ],
    "correct_answer": 1,
    "explanation": "在夜间驾驶时，即使配备最好的车头灯，也很难看清可能会遇到的所有危险，例如路上的未点亮灯光的电动滑板车。在夜间驾驶时，您应该以能够在您可清楚看到前方路况清晰距离内安全停车的速度行驶。",
    "image_name": ""
  },
  {
    "index": 684,
    "id": "RSA228090",
    "section": "安全与负责驾驶",
    "question": "在交叉口，哪一类道路使用者特别容易受伤害？",
    "options": [
      "電動滑板車使用者",
      "貨車司机",
      "汽車司机"
    ],
    "correct_answer": 0,
    "explanation": "骑自行车、骑摩托车和使用电动滑板车的人在交叉口通常很难被看到，而且他们可能比你想象的更快接近。",
    "image_name": ""
  },
  {
    "index": 685,
    "id": "RSA228092",
    "section": "安全与负责驾驶",
    "question": "司机在左转进入侧路时应注意什么？",
    "options": [
      "来车必须留有足够空间超车",
      "电动滑板车可能会靠左（近侧）超车",
      "电动滑板车可能会靠右（远侧）超车"
    ],
    "correct_answer": 1,
    "explanation": "转向左时，司机应注意到可能会有自行车骑手、行人和电动滑板车靠近左侧（靠近车边）。在左转之前始终要向您的左侧（靠近车边）确认。",
    "image_name": ""
  },
  {
    "index": 686,
    "id": "RSA228097",
    "section": "安全与负责驾驶",
    "question": "在红绿灯停车时，司机应特别注意哪些从左侧靠近的道路使用者？",
    "options": [
      "拖拉机",
      "汽车",
      "电动滑板车"
    ],
    "correct_answer": 2,
    "explanation": "在交通灯变绿之前，特别是在左转时，您应注意后方电动滑板车靠近的情况。",
    "image_name": ""
  },
  {
    "index": 687,
    "id": "ABMW0654U19",
    "section": "安全与负责驾驶",
    "question": "反鎖死制動系統（ABS）的作用是什麼？",
    "options": [
      "ABS显示汽车收音机播放的电台名称",
      "ABS在碰撞时展开气囊",
      "ABS锁定制动器以防止在急刹车时打滑",
      "ABS在急停车情况下防止车轮锁死"
    ],
    "correct_answer": 3,
    "explanation": "防抱死制动系统（ABS）是一种在大多数现代车辆中找到的制动系统。当驾驶员急刹车时，它会自动启动。在潮湿路面上，它可以帮助防止车轮打滑，使驾驶员在刹车时仍可继续转向。请注意，ABS并不能缩短刹车距离。",
    "image_name": ""
  },
  {
    "index": 688,
    "id": "RSA225299",
    "section": "安全与负责驾驶",
    "question": "在车道两侧设置隆起凸起带的目的是什么？",
    "options": [
      "防止牲畜进入行车道",
      "警示驾驶员车辆偏离车道",
      "改善暴雨中的路面排水"
    ],
    "correct_answer": 1,
    "explanation": "隆起带和凹槽是道路路肩上的凸起或凹凸不平的图案，既提供听觉警示（隆隆声音），又提供物理震动，以提醒驾驶员他们正要离开行车道。除了警示不专注的驾驶员外，在能见度差的恶劣天气中，隆起带还有助于引导驾驶员保持在道路上行驶。",
    "image_name": ""
  },
  {
    "index": 689,
    "id": "BW0002RU19",
    "section": "安全与负责驾驶",
    "question": "在繁忙道路上停车并下车前，司机应确保做什么？",
    "options": [
      "在打开车门之前，驾驶员应该检查是安全的",
      "确保车轮处于正前方",
      "确保乘客先打开他们的车门",
      "确保换挡杆在空挡"
    ],
    "correct_answer": 0,
    "explanation": "停在繁忙道路上的车辆时，司机在打开车门之前应先确认安全，因为可能会有骑车人或其他车辆紧挨而过。",
    "image_name": ""
  },
  {
    "index": 690,
    "id": "BW0113RU19",
    "section": "安全与负责驾驶",
    "question": "在离开车辆之前，司机应该做什么？",
    "options": [
      "在打开车门之前检查内后视镜",
      "将车门打开一部分，然后向后看",
      "立即打开车门并离开车辆",
      "在打开车门之前检查他们的侧后视镜并向后看"
    ],
    "correct_answer": 3,
    "explanation": "在打開任何門之前，查看是否有其他道路使用者通過，特別是注意行人、騎自行車的人和騎摩托車的人。只有在確保安全的情況下才能離開車輛，盡快關閉門。在可能的情況下，乘客應盡可能在靠近路邊的一側離開車輛。",
    "image_name": ""
  },
  {
    "index": 691,
    "id": "BWO0114R",
    "section": "安全与负责驾驶",
    "question": "在离开车辆之前，驾驶员应该如何确保车辆的安全？",
    "options": [
      "拉手刹，熄火并挂低档",
      "车轮向路边倾斜，停车并熄火",
      "挂低档并熄火",
      "车轮远离路边倾斜，停车并熄火"
    ],
    "correct_answer": 0,
    "explanation": "在离开您的车辆之前，请拉起手刹，关闭发动机并挂入低档。如果车辆配备自动变速箱，请选择P档。",
    "image_name": ""
  },
  {
    "index": 692,
    "id": "BW0115U19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在下车时应采取哪些安全预防措施？",
    "options": [
      "尽快打开车门试图出去，确保换档杆处于空档状态",
      "在打开车门之前，四周查看是否有靠近的交通和行人",
      "确保所有贵重物品都已经安全并且不易被看见"
    ],
    "correct_answer": 2,
    "explanation": "打开任何门之前，请检查是否有其他道路使用者经过，特别是注意行人、骑车者和摩托车骑手。只有在确保安全的情况下才能下车，并尽快关闭车门。乘客应尽可能从靠近路缘的一侧下车。",
    "image_name": ""
  },
  {
    "index": 693,
    "id": "BW0116RU19",
    "section": "安全与负责驾驶",
    "question": "在繁忙的道路上，司机应该如何让乘客下车？",
    "options": [
      "停车并鼓励乘客尽快下车",
      "停车并让乘客在靠近路边的一侧下车",
      "在允许乘客下车之前，向后面车辆发出信号超车",
      "停车并让乘客从他们坐的车辆任何一侧下车"
    ],
    "correct_answer": 1,
    "explanation": "在打开任何门之前，请检查是否有其他道路使用者通过，特别注意行人、骑车者和摩托车骑手。乘客应该在靠近路缘的一侧下车，不要妨碍行人。",
    "image_name": ""
  },
  {
    "index": 694,
    "id": "CD0150RU19",
    "section": "安全与负责驾驶",
    "question": "在离开车辆之前，司机应该做什么来确保车辆的安全？",
    "options": [
      "在停车时保持发动机运转，并拉起驻车制动器",
      "在停车时保持发动机运转，并拉起排气制动器",
      "拉起驻车制动器并关闭发动机",
      "拉起排气制动器并关闭发动机"
    ],
    "correct_answer": 2,
    "explanation": "在离开车辆之前，请拉紧手刹并关闭点火开关。检查确保能够安全打开车门而不危及他人，并在安全的情况下离开车辆。",
    "image_name": ""
  },
  {
    "index": 695,
    "id": "RSA01047",
    "section": "安全与负责驾驶",
    "question": "在打开车门之前，司机应该给乘客什么建议？",
    "options": [
      "确保穿着适当的衣物保护",
      "解开安全带，立即离开车辆",
      "四周查看，并谨慎打开车门",
      "留下窗户微微开着以便空气流通"
    ],
    "correct_answer": 2,
    "explanation": "在打开任何车门之前，请检查附近是否有其他道路使用者，特别是摩托车手和行人。\n",
    "image_name": ""
  },
  {
    "index": 696,
    "id": "RSA01048",
    "section": "安全与负责驾驶",
    "question": "你如何确保你的车辆安全停放？",
    "options": [
      "不要停放在可能危及其他道路使用者安全的地方",
      "尽快驶入停车位",
      "在狭窄道路上，将您的车停放在另一辆车的对面",
      "避免将车辆倒车入位"
    ],
    "correct_answer": 0,
    "explanation": "停车时，请确保不妨碍正常交通流动，确保您的车辆不会干扰、阻塞或危及其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 697,
    "id": "RSA01049",
    "section": "安全与负责驾驶",
    "question": "倒车出停车位时应考虑什么？",
    "options": [
      "永远不要快速倒车以脱离空间",
      "仅使用内后视镜检查后方",
      "避免开启后雨刷",
      "四周检查行人和车辆"
    ],
    "correct_answer": 3,
    "explanation": "有些停车场设计为您向前停车，以使装载购物更容易。在这些情况下，当您倒车离开停车位时要格外小心，因为行人和车辆可能从您身后经过。",
    "image_name": ""
  },
  {
    "index": 698,
    "id": "BW0016RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机打算将车倒入看不见的区域，应该怎么做？",
    "options": [
      "打开驾驶员的车门并向后看",
      "倒车时看左侧镜子",
      "打开驾驶员车窗并向后看",
      "倒车时请人协助指挥"
    ],
    "correct_answer": 3,
    "explanation": "不要试图倒车进入你无法清晰看到的区域。你应该寻求可以安全引导你进入该区域的人的帮助。",
    "image_name": ""
  },
  {
    "index": 699,
    "id": "BW0029RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机被后视镜反射的前灯强光眩晕，应该怎么办？",
    "options": [
      "打开后雾灯，向后车辆发出信号让其关闭大灯",
      "调整后视镜，将光线反射向后方驾驶员",
      "开关灯光以提醒后方驾驶员降低灯光",
      "使用后视镜的夜间驾驶模式"
    ],
    "correct_answer": 3,
    "explanation": "如果司机被后方车辆的灯光闪瞎了眼，他们应该调整后视镜为夜间驾驶模式。这样可以让他们集中精力看前方道路，不被后方车辆的灯光干扰。",
    "image_name": ""
  },
  {
    "index": 700,
    "id": "BW0064RU19",
    "section": "安全与负责驾驶",
    "question": "拖拉机最容易翻车的时候是什么时候？",
    "options": [
      "在平路行驶时",
      "缓慢倒车时",
      "急转弯时",
      "上坡行驶时"
    ],
    "correct_answer": 2,
    "explanation": "當您駕駛拖拉機時，應該意識到拖拉機比其他車輛更不穩定，在操控時要格外小心。",
    "image_name": ""
  },
  {
    "index": 701,
    "id": "BW0047RU23",
    "section": "安全与负责驾驶",
    "question": "为什么允许孩子站在汽车前排座位之间的空间是危险的？",
    "options": [
      "他们可能会分散其他司机的注意力，从而让他们的注意力离开道路",
      "如果突然刹车，他们可能会向前甩出去",
      "如果突然刹车，他们可能会向后甩出去"
    ],
    "correct_answer": 1,
    "explanation": "乘坐小孩或物品时，司机有责任确保它们被适当地约束。",
    "image_name": ""
  },
  {
    "index": 702,
    "id": "BWO048R",
    "section": "安全与负责驾驶",
    "question": "儿童何时可以站在打开的天窗处将头伸出？",
    "options": [
      "永远不允许儿童这样做",
      "当他们年满12岁以上时",
      "当他们戴着眼部保护装备时",
      "当以低于30km/h的速度行驶时"
    ],
    "correct_answer": 0,
    "explanation": "在汽车或货车上载有儿童时，司机有责任确保他们被适当地约束。",
    "image_name": ""
  },
  {
    "index": 703,
    "id": "BW0049",
    "section": "安全与负责驾驶",
    "question": "持有W類學習許可證的人在什麼時候可以在拖拉機或工作車輛上載客？",
    "options": [
      "当乘客有个人保险保障时",
      "乘客持有完整的M类别驾照并有个人保险保障时",
      "当需要他们的帮助时",
      "当有适当的乘客座位并且乘客持有完整的W类别驾照时"
    ],
    "correct_answer": 3,
    "explanation": "持有W類駕照的持有人僅在以下情況下可以在車輛中攜帶乘客：1. 該車輛設計可載客，且2. 乘客持有W類駕照並已超過兩年。",
    "image_name": ""
  },
  {
    "index": 704,
    "id": "BW0050RU23",
    "section": "安全与负责驾驶",
    "question": "在车内能否让儿童独自待着？",
    "options": [
      "只有在有足夠通風的情況下才能駕駛",
      "只有當車輛停放在有監督的停車場時",
      "絕對不能讓孩子在車輛內獨自待著"
    ],
    "correct_answer": 2,
    "explanation": "在车内不能将儿童单独留在车内，即使是很短的时间。儿童可能会干扰车辆的控制，而且他们可能无法处理紧急情况，如火灾或电气故障，这可能导致严重的伤害或死亡。",
    "image_name": ""
  },
  {
    "index": 705,
    "id": "BWOO56R",
    "section": "安全与负责驾驶",
    "question": "司机在什么情况下可以搭载比汽车座位安全带数量更多的乘客？",
    "options": [
      "永远不允许",
      "始终允许",
      "当驾驶员拥有适当的保险覆盖时",
      "当驾驶员的视线不受干扰时"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员必须确保车辆内的每位乘客都系好安全带。不系安全带是一种违法行为。驾驶员有责任确保17岁以下的乘客系好安全带。年长乘客自己负责系好安全带。",
    "image_name": ""
  },
  {
    "index": 706,
    "id": "BWO0130R",
    "section": "安全与负责驾驶",
    "question": "一个车辆负载更容易移位的时候是在哪个时候？\n在什么时候车辆载重更有可能移动？",
    "options": [
      "轻踩刹车时",
      "转弯时",
      "超车时",
      "倒车时"
    ],
    "correct_answer": 1,
    "explanation": "驾驶员有责任确保货物被妥善固定和均匀分布，以便在转向和刹车时能够正确控制车辆。",
    "image_name": ""
  },
  {
    "index": 707,
    "id": "BW0131RU23",
    "section": "安全与负责驾驶",
    "question": "司机在駕駛載貨載重的車輛時應該如何應對彎道？",
    "options": [
      "比空载时速度慢",
      "与空载时相同速度",
      "在转弯时比空载时更急转弯"
    ],
    "correct_answer": 0,
    "explanation": "过快驶近弯道并在行驶过程中，驾驶已装载车辆可能导致失控。这 可以通过以安全和谨慎的方式驾驶，提前阅读道路情况来避免。",
    "image_name": ""
  },
  {
    "index": 708,
    "id": "BW0030RU19",
    "section": "安全与负责驾驶",
    "question": "夜晚如果司机因后视镜反光而感到眩光，该怎么做？",
    "options": [
      "打开后雾灯",
      "调整镜子以将光线反射回后车驾驶员",
      "暂时调整镜子的角度",
      "打开危险警示灯"
    ],
    "correct_answer": 2,
    "explanation": "如果你的内后视镜反射的后方车辆的灯光让你眼花缭乱，请启动夜间驾驶/防眩目模式。 如果车辆没有配备此功能，驾驶员应暂时调整内后视镜的角度以减轻眩光，让他们能够不受干扰地驾驶。",
    "image_name": ""
  },
  {
    "index": 709,
    "id": "BW0031RU19",
    "section": "安全与负责驾驶",
    "question": "在晚上，单边头灯开车会对迎面而来的司机有什么影响？\n夜间开车只开一个前灯会对迎面而来的司机造成什么影响？",
    "options": [
      "这不会对迎面而来的驾驶员产生影响",
      "它可能使他们眼花",
      "他们可能会误将车辆认作摩托车",
      "它可能使他们更清楚地看到车辆"
    ],
    "correct_answer": 2,
    "explanation": "法律要求机动车（摩托车除外）必须配备两个前灯。只有一个前灯的车辆可能被误认为是摩托车，其他道路使用者可能会认为它在道路上的位置与实际情况不符。应定期检查车辆灯光，并立即修理故障灯光。",
    "image_name": ""
  },
  {
    "index": 710,
    "id": "BW0033U19",
    "section": "安全与负责驾驶",
    "question": "停在未点灯的公共道路上的汽车、拖拉机或工作车辆夜晚应该展示哪些灯光？",
    "options": [
      "只有尾灯",
      "油灯",
      "靠近路缘侧的前后至少一侧车灯",
      "靠近道路中心侧的前后至少一侧车灯"
    ],
    "correct_answer": 3,
    "explanation": "停放车辆在黑暗的公共道路上会对其他道路使用者造成潜在的危险。因此，驾驶员应该把侧边/停车灯打开，以便其他道路使用者能看到车辆。驾驶员停车时不应该开启前照灯，因为这可能会让其他道路使用者感到迷惑。",
    "image_name": ""
  },
  {
    "index": 711,
    "id": "BW0069RU19",
    "section": "安全与负责驾驶",
    "question": "司机何时应该使用车辆的侧灯？",
    "options": [
      "在雾天驾驶时",
      "在夜晚驾驶无照明的区域时",
      "在无照明道路停车时",
      "始终停车时"
    ],
    "correct_answer": 2,
    "explanation": "在夜晚在未照明的公共道路上停放车辆会为其他道路使用者造成潜在危险。因此，驾驶员应该留下侧/停车灯，以便其他道路使用者能看到车辆。驾驶员停车时不应该开启前灯，因为这可能会导致其他道路使用者迷惑。",
    "image_name": ""
  },
  {
    "index": 712,
    "id": "BW0004RU19",
    "section": "安全与负责驾驶",
    "question": "在这种情况下，双车道的右侧车道司机应该注意什么？",
    "options": [
      "對向來車",
      "增加了可見度",
      "騎摩托車的人可能會進行迴轉",
      "橫風可能會將騎士吹到他們的行進路線中"
    ],
    "correct_answer": 3,
    "explanation": "在潮湿多风的条件下驾驶时，驾驶员应意识到这些条件可能影响摩托车手或骑车者等易受影响的道路使用者的稳定性。在开阔且暴露的区域，这些道路使用者可能会被风吹入驾驶员的行驶路径中。",
    "image_name": "BW0004RU19.png"
  },
  {
    "index": 713,
    "id": "BW0008RU19",
    "section": "安全与负责驾驶",
    "question": "如果车辆的车窗被冰覆盖，驾驶员应该怎么做？",
    "options": [
      "确保挡风玻璃前方视线清晰",
      "使用沸水除冰",
      "彻底清除所有车窗的冰",
      "在暖风和除雾器清除冰前缓慢行驶"
    ],
    "correct_answer": 2,
    "explanation": "确保所有车窗完全清除冰雪，以便驾驶员可以安全地观察四周的路况和交通状况。在行驶在湿滑路况时，这点尤为重要。在车辆中携带一罐除冰剂是一个良好的做法，如果可能的话，可以将洗涤液箱加满除冰剂。",
    "image_name": ""
  },
  {
    "index": 714,
    "id": "BW0009RU19",
    "section": "安全与负责驾驶",
    "question": "如果车辆的窗户和镜子被覆盖冰，司机应该怎么办？",
    "options": [
      "使用加了盐的开水来清除冰",
      "打开雨刷",
      "打开暖风系统，使用刮刀清除冰后再开车",
      "在暖风系统清除冰之前以较低的速度行驶"
    ],
    "correct_answer": 2,
    "explanation": "确保所有车窗和镜子完全没有冰，以便驾驶员可以安全地观察周围道路和交通状况。在行驶在湿滑路面时尤为重要。最佳实践是在车辆中携带一罐除冰剂，如果可能的话，用除冰剂填满洗涤器储水桶。",
    "image_name": ""
  },
  {
    "index": 715,
    "id": "BW0026RU19",
    "section": "安全与负责驾驶",
    "question": "何时应该使用后雾灯？",
    "options": [
      "在浓雾或大雪中",
      "只有在轻微雾气中",
      "在夜间在无照明的区域行驶时",
      "当后方车辆跟得太近时"
    ],
    "correct_answer": 0,
    "explanation": "司机只能在浓雾或下雪天气中使用后雾灯。在普通道路和天气条件下使用雾灯可能会使后方的驾驶员眩目或失明。此外，雾灯可能会使刹车灯更难被看到。",
    "image_name": ""
  },
  {
    "index": 716,
    "id": "BW0027RU19",
    "section": "安全与负责驾驶",
    "question": "什么时候应该使用后雾灯？",
    "options": [
      "在浓雾或大雪天气驾驶时",
      "后雾灯应仅在黎明和黄昏时使用",
      "后雾灯应始终使用",
      "当后尾灯均损坏时"
    ],
    "correct_answer": 0,
    "explanation": "司机只应在浓雾或雪花纷飞时使用后雾灯。在普通道路和天气条件下使用雾灯会使后方驾驶员眩目或失明。此外，雾灯可能使刹车灯更难被看到。",
    "image_name": ""
  },
  {
    "index": 717,
    "id": "CD0083RU19",
    "section": "安全与负责驾驶",
    "question": "潮湿天气对车辆外部镜子有哪些影响？",
    "options": [
      "这可能会使电加热后的镜子短路",
      "这可能会扭曲驾驶员的后视",
      "它没有任何影响",
      "它可以保持清洁"
    ],
    "correct_answer": 1,
    "explanation": "在雨中驾驶时，水滴会附着在外部镜子上，遮挡了司机对车辆侧面和后方的视野。如果车辆配有加热镜子，请打开加热功能以清除水滴。或者，定期停车手动清除水滴。",
    "image_name": ""
  },
  {
    "index": 718,
    "id": "CD0099AAU23",
    "section": "安全与负责驾驶",
    "question": "在恶劣天气条件下开始行程前，驾驶员应该做什么？",
    "options": [
      "用冷却剂补充挡风玻璃洗涤器水箱",
      "检查计划路线的天气预报",
      "增加轮胎气压以确保在道路上有更好的抓地力",
      "减小轮胎气压以确保在道路上有更好的抓地力"
    ],
    "correct_answer": 1,
    "explanation": "在恶劣天气条件下驾驶更加危险且更加累人。驾驶员应查看天气预报、天气警报和其他信息来源，了解预期路线上的条件，并留出额外时间完成行程。",
    "image_name": ""
  },
  {
    "index": 719,
    "id": "CD0100RU19",
    "section": "安全与负责驾驶",
    "question": "在恶劣天气出发前，司机应该做什么？",
    "options": [
      "加满变速箱冷却液",
      "加满挡风玻璃清洗液箱",
      "降低轮胎压力以确保路面抓地力更好",
      "增加轮胎压力以确保路面抓地力更好"
    ],
    "correct_answer": 1,
    "explanation": "在恶劣天气中开始长途旅行前，司机应确保挡风玻璃清洁液充足，以确保在这些条件下保持挡风玻璃清晰。",
    "image_name": ""
  },
  {
    "index": 720,
    "id": "CD0103U23",
    "section": "安全与负责驾驶",
    "question": "司机在雪地或结冰天气中如何应对陡坡下坡路段？",
    "options": [
      "保持踩离合器并轻踩刹车",
      "始终靠近左侧，使用短促的刹车操作来控制速度",
      "选择比平时更高的档位以避免轮胎打滑",
      "提前换成较低的档位并轻踩刹车以控制速度"
    ],
    "correct_answer": 3,
    "explanation": "在雪地或冰面上，车辆需要更长的距离才能停下来。在陡坡下降之前，驾驶大型车辆的司机应该减速并选择更低的挡位，轻踩刹车，只在需要时使用。如果车辆配备了手动选择的减速器，在开始下坡之前应将其启用。",
    "image_name": ""
  },
  {
    "index": 721,
    "id": "CPC1138AU19",
    "section": "安全与负责驾驶",
    "question": "在方向盘的轻重感中，最有可能表示什么？",
    "options": [
      "冰面",
      "光滑表面",
      "碎石表面",
      "潮湿表面"
    ],
    "correct_answer": 0,
    "explanation": "方向盘过于轻盈表明失去了牵引力。这种情况通常发生在路面结冰时。与雨水或积雪相比，冰面提供了更坚硬、更光滑的表面，所以很难避免打滑，驾驶员应该留出多达正常制动距离的10倍来安全停车。",
    "image_name": ""
  },
  {
    "index": 722,
    "id": "CD0154RAU23",
    "section": "安全与负责驾驶",
    "question": "在开车通过隧道之前，司机应该做什么？",
    "options": [
      "停用全球定位系统（GPS）",
      "注册在第一个隧道站",
      "只打开侧灯",
      "确保有足够的燃料"
    ],
    "correct_answer": 3,
    "explanation": "如果您的路线穿过隧道，您必须确保您的车辆有足够的燃料安全通过。",
    "image_name": ""
  },
  {
    "index": 723,
    "id": "CD0156RU19",
    "section": "安全与负责驾驶",
    "question": "進入隧道前，為了提高視野，駕駛應該做什麼？",
    "options": [
      "請取下太陽眼鏡",
      "在前方駕駛時保持距離",
      "戴上太陽眼鏡以防止光線耀眼",
      "拉下遮陽板以消除頭頂光線的反射"
    ],
    "correct_answer": 0,
    "explanation": "在隧道内，即使开启了隧道灯光，可用光线仍然较少。为了提高视野，请在进入隧道前摘下太阳眼镜。",
    "image_name": ""
  },
  {
    "index": 724,
    "id": "CD0158RU19",
    "section": "安全与负责驾驶",
    "question": "当车辆因拥堵而停在隧道内时，司机应该怎么做？",
    "options": [
      "打开危险警示灯",
      "保持靠近前方车辆",
      "关闭发动机并离开车辆",
      "走向最近的紧急出口"
    ],
    "correct_answer": 0,
    "explanation": "在通过隧道时遇到交通拥堵时，与前方车辆保持安全距离，并在静止时打开危险警示灯。",
    "image_name": ""
  },
  {
    "index": 725,
    "id": "CD0159RU19",
    "section": "安全与负责驾驶",
    "question": "当车辆因拥堵而停在隧道中时，司机应该怎么做？",
    "options": [
      "保持发动机在低档位空转",
      "只使用手势信号",
      "打开雾灯",
      "关闭发动机"
    ],
    "correct_answer": 3,
    "explanation": "在通过隧道时，如果您的车辆被困在静止交通中一段时间，为了减少隧道内的尾气并节省燃料，您应该熄灭引擎。",
    "image_name": ""
  },
  {
    "index": 726,
    "id": "CD0160RU23",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆因故障或事故被迫在隧道内停车，司机应该做什么？",
    "options": [
      "留在车内等待帮助到达",
      "从紧急站点呼救",
      "示意其他车辆超车"
    ],
    "correct_answer": 1,
    "explanation": "如果在隧道内发生故障或事故，请停车，熄火，打开危险警示灯，查看收音机以获取指示，并使用紧急电话向紧急站台求助，查看隧道内所有电子标志以获取信息。",
    "image_name": ""
  },
  {
    "index": 727,
    "id": "CD0161RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆在隧道内抛锚了，司机应该怎么做?",
    "options": [
      "搭便车到最近的服务区寻求帮助",
      "走到隧道尽头打电话给警察",
      "拦下经过的司机请求帮助",
      "使用紧急电话寻求帮助"
    ],
    "correct_answer": 3,
    "explanation": "如果司机的车因故障在隧道内停下，请熄灭引擎，打开警示灯，检查收音机以获得指示，使用紧急站的紧急电话寻求帮助，检查隧道内所有电子标志以获取信息。",
    "image_name": ""
  },
  {
    "index": 728,
    "id": "CD0162RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆在隧道里抛锚了，司机应该怎么做？",
    "options": [
      "倒车到出口",
      "示意其他车辆超车",
      "打开危险警示灯",
      "留在车内等待帮助到来"
    ],
    "correct_answer": 2,
    "explanation": "如果司机的车因故障而在隧道内停车，应将发动机熄火，打开危险警示灯，检查收音机以获取指示，并使用应急站的紧急电话寻求帮助，检查隧道内所有电子标识获取信息。",
    "image_name": ""
  },
  {
    "index": 729,
    "id": "CD0163RU19",
    "section": "安全与负责驾驶",
    "question": "如果一辆车在隧道中起火，驾驶员该怎么办？",
    "options": [
      "等候隧道交通广播宣布火灾演习",
      "尽快驾驶到最近的紧急出口",
      "留在车内致电紧急站报告火灾",
      "立即离开车辆，使用最近的紧急站紧急电话"
    ],
    "correct_answer": 3,
    "explanation": "如果车辆内有烟雾或火灾，请关闭发动机，立即离开车辆，前往应急站，并使用应急电话通知隧道操作员，通过最近的可用出口离开隧道。",
    "image_name": ""
  },
  {
    "index": 730,
    "id": "BW0083RU19",
    "section": "安全与负责驾驶",
    "question": "过度加油可能导致哪种可能的影响？",
    "options": [
      "这可能降低油压",
      "这可能损坏油泵",
      "这可能爆裂油过滤器",
      "这可能损坏催化转化器"
    ],
    "correct_answer": 3,
    "explanation": "车辆的发动机不要加满机油是至关重要的，因为这可能会永久损坏催化转换器，催化转换器是大多数车辆排气系统的一部分，可去除车辆排气中高达75%的一氧化碳、氮氧化物和碳氢化合物。损坏这一部分会增加排放。",
    "image_name": ""
  },
  {
    "index": 731,
    "id": "BW0107RU19",
    "section": "安全与负责驾驶",
    "question": "为了避免车辆过多的废气排放，司机应该采取什么措施？",
    "options": [
      "为了减少在路上花费的时间，以较高的速度驾驶",
      "驾驶柴油动力车辆",
      "使用燃油添加剂提高燃油辛烷值",
      "定期更换车辆的空气过滤器"
    ],
    "correct_answer": 3,
    "explanation": "司机应该根据制造商的指导规定定期维护他们的车辆。 使用脏空气过滤器的车辆会消耗更多燃料并产生更多尾气污染。 空气过滤器应在正常维护过程中更换。 如果车辆在多尘的环境中使用，则空气过滤器可能需要更经常更换。 有关更多信息，请参阅车辆所有者手册。",
    "image_name": ""
  },
  {
    "index": 732,
    "id": "BW0108RU19",
    "section": "安全与负责驾驶",
    "question": "一般来说，车辆应该多久进行一次保养？",
    "options": [
      "每30个月一次",
      "每年一次",
      "根据制造商的建议",
      "每30,000公里一次"
    ],
    "correct_answer": 2,
    "explanation": "驾驶员应定期按照制造商的指南对车辆进行保养。这有助于车辆正常运行，从而节省燃料并减少排放。此外，驾驶员还应定期进行液体和轮胎的日常和每周检查。",
    "image_name": ""
  },
  {
    "index": 733,
    "id": "BW0109RU19",
    "section": "安全与负责驾驶",
    "question": "催化轉換器的目的是什麼？",
    "options": [
      "允许排气系统进行整修",
      "仅在汽油车辆上控制排气噪音水平",
      "仅在柴油车辆上控制排气噪音水平",
      "减少有害排放物"
    ],
    "correct_answer": 3,
    "explanation": "催化轉換器是車輛排氣系統的一部分。它們幫助保護環境，能從車輛排放氣體中去除高達75%的一氧化碳、氮氧化物和碳氫化合物。",
    "image_name": ""
  },
  {
    "index": 734,
    "id": "BW0018RU19",
    "section": "安全与负责驾驶",
    "question": "在长途旅行中，司机应该做些什么以保持警觉？",
    "options": [
      "保持收音机开启并关闭窗户",
      "调高暖气以保持驾驶员舒适",
      "增加速度以缩短行程",
      "增加空气循环并必要时停车"
    ],
    "correct_answer": 3,
    "explanation": "在长途旅行中，驾驶员应该定期休息。适当散步和饮用含咖啡因的饮料（茶或咖啡）有助于让他们恢复活力。车辆应保持凉爽通风良好，有持续的新鲜空气流动。",
    "image_name": ""
  },
  {
    "index": 735,
    "id": "CD0032U19",
    "section": "安全与负责驾驶",
    "question": "在长途旅行中，司机可以做些什么来保持警觉？\n司机可以通过以下方式保持注意力在长途旅行中：\n定期休息和拉伸，避免疲劳驾驶。\n保持充足的水分摄入，避免脱水导致的疲劳。\n避免过度饮酒或食用会使人昏昏欲睡的食物。\n避免使用手机或其他会分散注意力的设备。\n开车时聆听轻柔的音乐或讨论交通状况的广播，以保持警觉。\n保持车内气温舒适，避免过热或过冷造成不适。",
    "options": [
      "停下，停在一个安全的地方，喝杯咖啡",
      "专心倾听收音机",
      "摇下车窗，让新鲜空气进来",
      "调高车内温度"
    ],
    "correct_answer": 0,
    "explanation": "假如驾驶员继续开车时与疲劳斗争，可能会导致类似于酗酒驾驶的后果。在一个安全的地方停车，喝咖啡并休息15分钟可以让驾驶员恢复精神，使其能够继续短暂开车。",
    "image_name": ""
  },
  {
    "index": 736,
    "id": "RSA01045U19",
    "section": "安全与负责驾驶",
    "question": "在哪些时间段可以在路边检查站对驾驶员进行药物测试？",
    "options": [
      "只有在发生事故后",
      "只在白天",
      "只在夜晚",
      "白天或夜晚任何时候"
    ],
    "correct_answer": 3,
    "explanation": "法律允许随时对驾驶员进行测试。",
    "image_name": ""
  },
  {
    "index": 737,
    "id": "RSA225189",
    "section": "安全与负责驾驶",
    "question": "司机在靠近目的地的短距离内感到疲倦时应该怎么做？",
    "options": [
      "加速以便尽快到达目的地",
      "在安全的地方停下来休息一下",
      "在接近目的地时继续他们的旅程"
    ],
    "correct_answer": 1,
    "explanation": "在靠近目的地时，不要被困倦诱惑继续驾驶。驾驶员应当在一个安全的地方停车休息。许多由驾驶员疲劳引起的碰撞事故发生在靠近目的地的短距离内，因为身体开始放松。",
    "image_name": ""
  },
  {
    "index": 738,
    "id": "BWOO65R",
    "section": "安全与负责驾驶",
    "question": "驾驶拖拉机和挂车进入环形交叉路口时，司机应该怎么做以避免可能的侧翻？",
    "options": [
      "减慢速度",
      "以高档行驶",
      "拉起驻车制动器",
      "增加速度"
    ],
    "correct_answer": 0,
    "explanation": "司机应始终以安全速度驾驶。特别是在改变方向时，比如驶入环形交叉路口。如果驾驶拖拉机带着挂车，应特别小心，因为它们容易不稳定。",
    "image_name": ""
  },
  {
    "index": 739,
    "id": "BW0066RU19",
    "section": "安全与负责驾驶",
    "question": "“什么是“折叠”一词的含义？”",
    "options": [
      "当拖车太重无法被拖拉机牵引时",
      "当车辆因道路上的冰雪或积水而打滑时",
      "当拖车行驶速度快于牵引车辆时",
      "当千斤顶不够强大无法举起一个轴时"
    ],
    "correct_answer": 2,
    "explanation": "牵引拖车或房车会大幅降低牵引车辆的稳定性。如果驾驶员急刹车或迅速减速，拖车可能会围绕牵引头联结点转动，导致两辆车偏离方向，并有可能翻车。",
    "image_name": ""
  },
  {
    "index": 740,
    "id": "BWO067",
    "section": "安全与负责驾驶",
    "question": "何时最容易发生卡车折叠情况？",
    "options": [
      "在横穿坡度时行驶时",
      "在试图急剧减速下坡行驶时",
      "当拖车弹簧过度润滑时",
      "在上坡行驶时"
    ],
    "correct_answer": 1,
    "explanation": "拖曳拖车或房车会严重降低牵引车辆的稳定性。如果驾驶员急刹车或快速减速，拖车可能会围绕牵引销架转动，导致两车偏离轨道，并可能发生翻车事故。",
    "image_name": ""
  },
  {
    "index": 741,
    "id": "CD0173RU19",
    "section": "安全与负责驾驶",
    "question": "加入高速公路时，司机应该怎么做？",
    "options": [
      "调整速度以匹配高速公路交通流，并合并到合适的空档中",
      "利用车辆的大小来确定其在高速公路上的位置",
      "在匝道上等待，直到交通流中出现合适的空隙",
      "在硬路肩上行驶一段距离，直到交通流中出现合适的空隙"
    ],
    "correct_answer": 0,
    "explanation": "当从匝道驶入高速公路时，驾驶员应根据加速车道上高速公路的车流速度调整自己的速度，并并入第一车道的适当间隙。不要强迫其他车辆改变道或减速以避让您的车辆。",
    "image_name": ""
  },
  {
    "index": 742,
    "id": "ABMW0686RU19",
    "section": "安全与负责驾驶",
    "question": "当驾驶员正在向左转弯时，他们特别应集中注意哪些镜子？",
    "options": [
      "车内和左外后视镜",
      "车内后视镜",
      "车内和右外后视镜",
      "右外后视镜"
    ],
    "correct_answer": 0,
    "explanation": "在左转时，驾驶员应特别注意自行车手和其他车辆可能会从他们的近侧（左侧）靠近。因此，在检查镜子时，特别重要的是在转弯前同时检查左侧外部镜和内部镜。驾驶员在转弯时必须始终使用镜子-信号-镜子-操纵的惯例。如果穿越...，他们应该格外小心。",
    "image_name": ""
  },
  {
    "index": 743,
    "id": "BW0006RU19",
    "section": "安全与负责驾驶",
    "question": "牵引高大和宽体拖车时，驾驶员应该做什么？",
    "options": [
      "在拖车后部左侧挂上红旗驾驶",
      "使用扩展镜检查后方车辆",
      "始终开启危险警示灯驾驶",
      "在拖车前部右侧挂上红旗驾驶"
    ],
    "correct_answer": 1,
    "explanation": "在牵引高大宽体拖车时，驾驶员应该在牵引车的两侧使用延长后视镜。这将使驾驶员能够更好地观察车辆后方和两侧的交通状况。",
    "image_name": ""
  },
  {
    "index": 744,
    "id": "BW0012RU19",
    "section": "安全与负责驾驶",
    "question": "司机在倒车前应该做出哪些具体观察？",
    "options": [
      "向两侧和后方看",
      "仅查看车门镜",
      "仅查看内后视镜",
      "向右侧后方看"
    ],
    "correct_answer": 0,
    "explanation": "倒车前，应该向两侧和后方环顾，检查车辆周围是否有儿童或其他道路使用者，确保安全可倒车。",
    "image_name": ""
  },
  {
    "index": 745,
    "id": "BW0013U19",
    "section": "安全与负责驾驶",
    "question": "在倒车之前，驾驶员应该做出哪些具体观察，尤其是装有外部听觉警告装置的车辆？",
    "options": [
      "观察只应在盲点处进行",
      "应打开驾驶员的车门并向后查看进行观察",
      "应观察车辆的前方、侧面和后方，包括盲点",
      "不需要特定的观察，因为旁观者会注意到车辆"
    ],
    "correct_answer": 2,
    "explanation": "司机不应仅依赖外部听得见的警示装置来警告他人车辆正在倒车。在倒车之前，司机必须通过观察车辆前方、侧面和后方，包括盲区，确保安全倒车。永远不要假设倒车是安全的，仅因为车辆装有外部听得见的警示装置。",
    "image_name": ""
  },
  {
    "index": 746,
    "id": "BW0014RU19",
    "section": "安全与负责驾驶",
    "question": "当司机打算倒车进入侧路时应该怎么做？",
    "options": [
      "在倒车时，完全关注左侧车门镜",
      "在倒车前将车门镜角度调低",
      "在倒车前和过程中仔细检查四周",
      "完全打开左侧车门以查看后方"
    ],
    "correct_answer": 2,
    "explanation": "倒车进入边路之前和期间，请四处检查确保情况安全且清晰，特别注意行人在车辆后方穿越以及其他道路使用者。",
    "image_name": ""
  },
  {
    "index": 747,
    "id": "BW0129RU23",
    "section": "安全与负责驾驶",
    "question": "司机何时必须使用红旗作为标记，以标记超过一米的后悬挂载荷？",
    "options": [
      "随时",
      "只在白天",
      "只在夜晚",
      "从来不"
    ],
    "correct_answer": 1,
    "explanation": "在白天，您必须使用一面红旗标记任何超过一米的突出物。晚上则必须使用红灯。",
    "image_name": ""
  },
  {
    "index": 748,
    "id": "BW0132R",
    "section": "安全与负责驾驶",
    "question": "如果司机驾驶的车辆爆胎了，司机应该做什么？",
    "options": [
      "尽快踩下刹车",
      "继续以正常速度行驶并停在下一个车库",
      "拉紧手刹将车辆停下",
      "紧握方向盘并靠边停车"
    ],
    "correct_answer": 3,
    "explanation": "如果你的车辆爆胎了，请牢牢握住方向盘，逐渐减速并停在安全的地方。打开危险警示灯。",
    "image_name": ""
  },
  {
    "index": 749,
    "id": "BW0135RU19",
    "section": "安全与负责驾驶",
    "question": "如果车辆配备了防抱死制动系统（ABS），驾驶员在紧急情况下应该如何踩刹车？",
    "options": [
      "紧踩刹车踏板并保持",
      "慢速踩下刹车并释放",
      "轻踩刹车踏板",
      "快速踩下刹车并释放"
    ],
    "correct_answer": 0,
    "explanation": "如果您的车辆配备了ABS制动系统，请紧急刹车。ABS不会使车辆更快地停下，它只会防止车轮锁死。这有助于您保持对车辆的控制。",
    "image_name": ""
  },
  {
    "index": 750,
    "id": "BW0136RU19",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆发生四驱侧滑，司机应该怎么做？",
    "options": [
      "向相同方向转动方向盘并使用手刹",
      "向相同方向转动方向盘并松开油门",
      "向相反方向转动方向盘以提高轮胎抓地力",
      "向相反方向转动方向盘并使用手刹"
    ],
    "correct_answer": 1,
    "explanation": "如果您的车辆陷入四轮打滑状态，请向打滑方向转动方向盘并松开油门。这样可以帮助车轮重新归位，让您恢复控制。",
    "image_name": ""
  },
  {
    "index": 751,
    "id": "BWO0137R",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆发生前轮侧滑，司机应该怎么做？",
    "options": [
      "踩下脚刹车",
      "拉紧手刹",
      "松开油门",
      "继续加速"
    ],
    "correct_answer": 2,
    "explanation": "如果您的车辆发生前驱车轮侧滑，请松开油门并在轮胎重新获得路面抓地力之前不要尝试转向。",
    "image_name": ""
  },
  {
    "index": 752,
    "id": "BWO138R",
    "section": "安全与负责驾驶",
    "question": "如果司机的车辆发生后轮侧滑，司机应该怎么做？",
    "options": [
      "向与前轮方向相同的方向转动方向盘",
      "踩脚刹停止车辆",
      "向与后轮方向相同的方向转动方向盘",
      "拉紧手刹停止车辆"
    ],
    "correct_answer": 2,
    "explanation": "如果你的车辆发生后轮侧滑，应该向后轮行驶的方向转动方向盘。这个操作应该非常逐渐进行，因为过度转动方向盘会导致车辆向相反方向侧滑。",
    "image_name": ""
  },
  {
    "index": 753,
    "id": "BW0139RU19",
    "section": "安全与负责驾驶",
    "question": "在没有防抱死制动系统（ABS）的车辆中，司机应如何处理前轮直线打滑？",
    "options": [
      "踩下离合器，松开加速器",
      "快速间歇地踩下并释放脚刹车",
      "轻轻将方向盘从一侧转向另一侧",
      "拉紧手刹并踩住脚刹车"
    ],
    "correct_answer": 1,
    "explanation": "如果您的车辆没有ABS并且因为刹车而发生直线前轮打滑，请快速反复踩下刹车踏板。这样可以帮助恢复轮胎抓地力，让您重新掌控车辆。",
    "image_name": ""
  },
  {
    "index": 754,
    "id": "BW0140R",
    "section": "安全与负责驾驶",
    "question": "如果司机在路上遇到爆胎，应该怎么办？",
    "options": [
      "继续驾驶直到到达车库",
      "立即拉紧手刹停车",
      "轻轻踩脚刹停车",
      "关闭发动机点火开关停车"
    ],
    "correct_answer": 2,
    "explanation": "当你驾驶的车辆爆胎时，逐渐减速，并找到一个安全合适的地方停车。打开危险警示灯，更换轮胎或寻求帮助。",
    "image_name": ""
  },
  {
    "index": 755,
    "id": "BW0141RU19",
    "section": "安全与负责驾驶",
    "question": "前轮爆胎会对车辆产生什么影响？",
    "options": [
      "方向盘会向一侧拉动",
      "方向盘会保持在直行位置",
      "防抱死制动系统将自动解除",
      "车轮将锁死并停止转动"
    ],
    "correct_answer": 0,
    "explanation": "如果您驾驶的车辆前轮爆胎，您将通过方向盘感受到其影响。车轮通常会朝爆胎的一侧拉动。",
    "image_name": ""
  },
  {
    "index": 756,
    "id": "BW0142RU19",
    "section": "安全与负责驾驶",
    "question": "一辆车的后轮爆胎可能会产生什么影响？",
    "options": [
      "转向盘会往右拉",
      "这可能会导致车辆左右摇摆",
      "手刹会自动启动",
      "这可能会导致车轮锁定并停止旋转"
    ],
    "correct_answer": 1,
    "explanation": "如果你驾驶的车辆的后轮爆胎，车辆可能会左右摇摆，这会影响车辆的稳定性。减速，尽可能安全地停车，并打开危险警示灯。更换车轮或寻求帮助。",
    "image_name": ""
  },
  {
    "index": 757,
    "id": "BW0143R",
    "section": "安全与负责驾驶",
    "question": "当驾驶员在行驶时发现车辆发动机突然熄火时，应该采取什么行动？",
    "options": [
      "踩下油门，然后松开",
      "换到更低的挡位",
      "检查手刹已完全解除",
      "打灯信号并将车辆转向路边"
    ],
    "correct_answer": 3,
    "explanation": "如果驾驶时车辆发动机熄火，重要的是要打开转向灯并驶到路边，打开危险警告灯以警示其他驾驶员，并联系相关的故障拖车服务以获得帮助。",
    "image_name": ""
  },
  {
    "index": 758,
    "id": "BWO0144R",
    "section": "安全与负责驾驶",
    "question": "如果在缓行交通中发动机熄火，液压助力转向会受到什么影响？",
    "options": [
      "转向液储液箱会失去所有液体",
      "转向盘会自动锁定",
      "转向会变得沉重且难以操作",
      "转向会变得更轻更容易操作"
    ],
    "correct_answer": 2,
    "explanation": "液压助力转向由发动机驱动的泵操作。如果发动机熄火，泵就停止工作，转向就会变得沉重，需要更多力气才能转动。",
    "image_name": ""
  },
  {
    "index": 759,
    "id": "BW0148RU19",
    "section": "安全与负责驾驶",
    "question": "驾驶员在行驶时觉得对向来车可能会撞上他们的车辆。他们应该怎么办？",
    "options": [
      "立即拉紧手刹以帮助使车辆停下来",
      "按喇叭以吸引其他驾驶员的注意并采取规避动作",
      "切断发动机点火以帮助使车辆停下来",
      "轻踩脚刹并使车辆停下来"
    ],
    "correct_answer": 1,
    "explanation": "如果有对向车辆挡住你的去路，请采取规避动作并按喇叭警示对方驾驶员。立即将你的车辆停下来。\n\n将来车挡住你的去路，采取规避动作并按喇叭警示对方驾驶员，立即停车。",
    "image_name": ""
  },
  {
    "index": 760,
    "id": "BW0149RU19",
    "section": "安全与负责驾驶",
    "question": "在路上突然遇到危险时，司机应该怎么做？",
    "options": [
      "同时拉起手刹和踩下脚刹",
      "缓慢刹车并关闭点火",
      "踩下离合器并关闭点火",
      "减速并牢固踩下脚刹"
    ],
    "correct_answer": 3,
    "explanation": "在紧急情况下停车时，要紧紧踩住脚刹，并保持压力直到车辆停下。在停车前轻踩离合器踏板。",
    "image_name": ""
  },
  {
    "index": 761,
    "id": "BW0150RU19",
    "section": "安全与负责驾驶",
    "question": "在行驶中突然被要求停车时，司机应该怎么做？",
    "options": [
      "急转方向盘到一侧并拉手刹",
      "同时拉手刹和脚刹",
      "牢牢踩住脚刹",
      "踩下离合器后再拉手刹"
    ],
    "correct_answer": 2,
    "explanation": "在紧急情况下停车时，需要牢记踩紧脚刹，并保持踩压直到车辆停止。在停车前刹车时要踩下离合器踏板。",
    "image_name": ""
  },
  {
    "index": 762,
    "id": "BW0151RU19",
    "section": "安全与负责驾驶",
    "question": "紧急情况下需要停车时，司机应该怎么做？",
    "options": [
      "踩离合器和拉手刹",
      "踩脚刹并挂入更高的挡位",
      "牢固地踩脚刹",
      "轻轻地踩脚刹"
    ],
    "correct_answer": 2,
    "explanation": "在紧急情况下停车时，需牢牢踩住刹车踏板并保持力度，直到车辆停下来。在停车前踩下离合踏板。",
    "image_name": ""
  },
  {
    "index": 763,
    "id": "BW0152RU19",
    "section": "安全与负责驾驶",
    "question": "在紧急情况下需要停车时，驾驶员应该怎么做？",
    "options": [
      "踩下刹车并挂入更高挡位",
      "踩下离合器踏板并挂入更低挡位",
      "关闭ABS系统",
      "牢牢踩下刹车踏板"
    ],
    "correct_answer": 3,
    "explanation": "在紧急情况下停止车辆时，牢固踩住脚刹，并保持直到车辆停止。在停车前踩下离合器踏板。",
    "image_name": ""
  },
  {
    "index": 764,
    "id": "BW0153",
    "section": "安全与负责驾驶",
    "question": "司机应该如何避免不得不进行紧急制动？",
    "options": [
      "使用左脚覆盖刹车踏板时",
      "使用左脚覆盖离合器踏板时",
      "与前方车辆保持安全距离",
      "保持左手可用于拉紧手刹"
    ],
    "correct_answer": 2,
    "explanation": "在车流中驾驶时，请提前阅读前方路况，并与前方车辆保持安全距离。使用两秒规则来确定与前车的安全距离。",
    "image_name": ""
  },
  {
    "index": 765,
    "id": "BW5",
    "section": "安全与负责驾驶",
    "question": "一个司机要避免不得不进行紧急停车应该怎么做？",
    "options": [
      "使用左脚遮住离合器踏板",
      "使用左脚遮住刹车踏板",
      "保持左手可用于拉手刹",
      "提前扫视道路"
    ],
    "correct_answer": 3,
    "explanation": "在交通中开车时，要提前阅读道路并与前方车辆保持安全距离。使用“两秒规则”来确定与前方车辆的安全距离。",
    "image_name": ""
  },
  {
    "index": 766,
    "id": "RSA0220U23",
    "section": "安全与负责驾驶",
    "question": "未经陪同的学习驾驶员被定罪后会被处以多少处罚点？",
    "options": [
      "4分罚分",
      "3分罚分",
      "2分罚分"
    ],
    "correct_answer": 0,
    "explanation": "考照学员需知道独自驾驶会使处罚点数增至4分。",
    "image_name": ""
  },
  {
    "index": 767,
    "id": "RSA0222U23",
    "section": "安全与负责驾驶",
    "question": "一名驾驶学员因独自驾驶被警察拦下，最少会面对多少罚款？",
    "options": [
      "转换成简体中文为：160欧元",
      "140欧元",
      "120欧元"
    ],
    "correct_answer": 0,
    "explanation": "学习驾驶员需要意识到，如果被警方停下来单独驾驶，将会导致经济处罚。",
    "image_name": ""
  },
  {
    "index": 768,
    "id": "RSA0223",
    "section": "安全与负责驾驶",
    "question": "如果车主允许学习驾驶者驾驶他们的车辆，车主可能面临的最高罚款是多少？",
    "options": [
      "€2,000",
      "€1,500",
      "€1,000",
      "€500"
    ],
    "correct_answer": 2,
    "explanation": "一名初学驾驶者需要意识到，在未经陪同情况下驾驶非自己所有的车辆可能会导致车主面临高达€1,000的罚款并且车辆被扣押。",
    "image_name": ""
  },
  {
    "index": 769,
    "id": "RSA0224",
    "section": "安全与负责驾驶",
    "question": "学习驾驶员是否可以在车主同意的情况下单独驾驶？",
    "options": [
      "是的，前提是车主有开放式驾驶保险",
      "是的，前提是车主已经同意",
      "是的，前提是车主是家庭成员并且已经同意",
      "不可以，学习驾驶者即使得到车主同意也不被允许独自驾驶"
    ],
    "correct_answer": 3,
    "explanation": "一个学习驾驶员需要知道，即使得到车辆所有者的同意，他们也不被允许独自驾驶。",
    "image_name": ""
  },
  {
    "index": 770,
    "id": "RSA0225",
    "section": "安全与负责驾驶",
    "question": "新手驾驶员的陪同驾驶员需要持有B类全照驾驶证多久？",
    "options": [
      "6个月",
      "1年",
      "2年",
      "3年"
    ],
    "correct_answer": 2,
    "explanation": "一个学车司机需要意识到并不是任何人都可以成为陪同驾驶员。陪同驾驶员必须至少持有两年的完整驾照并积累丰富的驾驶经验。",
    "image_name": ""
  },
  {
    "index": 771,
    "id": "RSA0226U23",
    "section": "安全与负责驾驶",
    "question": "学习驾驶员独自驾驶的罚款是多少？",
    "options": [
      "120欧元",
      "140欧元",
      "160欧元"
    ],
    "correct_answer": 2,
    "explanation": "一名学员驾驶员需要知道独自驾驶会受到罚款。",
    "image_name": ""
  },
  {
    "index": 772,
    "id": "RSA0228",
    "section": "安全与负责驾驶",
    "question": "当学习驾驶员通过驾驶考试后，持有能力证书时，可以独立驾驶吗？",
    "options": [
      "不可以，学习驾驶员在获得该类别的完整驾驶执照之前不被允许独自驾驶",
      "是的，一旦通知了保险公司，学习驾驶员可以持有竞争力证书独自驾驶",
      "不可以，学习驾驶员持竞争力证书时，除非继续展示“L”牌，否则不被允许独自驾驶",
      "是的，一旦展示N牌，学习驾驶员可以持有竞争力证书独自驾驶"
    ],
    "correct_answer": 0,
    "explanation": "一名顺利通过驾驶考试的学车者需要意识到，适用于学习许可持有人的规则仍然适用于他们，直到他们持有该类别的完整驾驶执照。竞争证书不等同于完整驾驶执照。",
    "image_name": ""
  },
  {
    "index": 773,
    "id": "RSA0229",
    "section": "安全与负责驾驶",
    "question": "如果学习驾驶员持有第三张或更多的学习许可证，他们能够独自驾驶吗？",
    "options": [
      "不，持有任何学员驾驶执照的驾驶者不能独自行驶",
      "是的，但不能在高速公路上行驶",
      "是的，只要在车辆的前后展示N牌",
      "不，除非在车辆的前后展示L牌"
    ],
    "correct_answer": 0,
    "explanation": "一名学习驾驶员需明确知道，无论持有多少学习驾驶许可，都不得在任何情况下独自驾驶。",
    "image_name": ""
  },
  {
    "index": 774,
    "id": "RSA0230",
    "section": "安全与负责驾驶",
    "question": "在过去两年内通过汽车驾驶考试的人能充当陪同驾驶员吗？",
    "options": [
      "不可以，除非他们是合格的认可驾驶教练（ADI）",
      "可以，只要他们携带完整的驾照",
      "不行，他们必须持有完整的驾驶执照至少2年",
      "可以，只要他们完成了基本驾驶培训（EDT）"
    ],
    "correct_answer": 2,
    "explanation": "要成为学员驾驶员的陪同驾驶员，您必须至少持有完整的驾驶执照2年。",
    "image_name": ""
  },
  {
    "index": 775,
    "id": "RSA0231",
    "section": "安全与负责驾驶",
    "question": "学习驾驶员可以独自驾驶的情况吗？",
    "options": [
      "是的，在驾驶测试前开车前往考试中心",
      "否，学习驾驶者必须始终由合格驾驶员陪同",
      "是的，在遇到认可驾驶教练（ADI）时",
      "是的，在完成驾驶测试后"
    ],
    "correct_answer": 1,
    "explanation": "学习驾驶员必须意识到他们必须始终由合格驾驶员陪同。",
    "image_name": ""
  },
  {
    "index": 776,
    "id": "CD0178RU23",
    "section": "安全与负责驾驶",
    "question": "司机接近一个显示闪烁琥珀灯的斑马线。路上仍有行人。司机应该怎么做？",
    "options": [
      "等待并让行人以自己的步伐过马路",
      "向行人示意尽快通过",
      "鸣笛作为警告并谨慎通过"
    ],
    "correct_answer": 0,
    "explanation": "当行人穿越道的黄灯闪烁时，你必须让行。",
    "image_name": ""
  },
  {
    "index": 777,
    "id": "RSA228086",
    "section": "安全与负责驾驶",
    "question": "当驾驶员打算在繁忙的城市路口左转，并且有行人、骑自行车者和电动滑板车用户时，驾驶员应该怎么做？",
    "options": [
      "保持靠右行驶，为自行车手和电动滑板车用户让路",
      "注意可能会在驾驶员车辆前尝试穿越马路的行人、自行车手和电动滑板车用户",
      "向左打灯，观察右侧镜子，当确保安全时转弯"
    ],
    "correct_answer": 1,
    "explanation": "在繁忙的城市街道上左转时，驾驶员应特别注意脆弱的道路使用者，如行人、骑自行车的人、摩托车手和电动滑板车用户，他们可能会突然出现，尤其是从左侧出现，可能并不清楚车辆的意图。",
    "image_name": ""
  },
  {
    "index": 778,
    "id": "BW0080RU19",
    "section": "安全与负责驾驶",
    "question": "一般来说，拖车的总重量超过多少必须安装制动器？",
    "options": [
      "750 公斤",
      "850 公斤",
      "900 公斤",
      "500 公斤"
    ],
    "correct_answer": 0,
    "explanation": "如果拖车的总重量超过750千克或者拖车的重量达到牵引车的一半，就必须给拖车安装制动装置。",
    "image_name": ""
  },
  {
    "index": 779,
    "id": "ABMW27U19",
    "section": "技术问题",
    "question": "驾驶时胎压不足可能影响什么？",
    "options": [
      "制动能力",
      "引擎温度",
      "气候控制系统",
      "排气系统"
    ],
    "correct_answer": 0,
    "explanation": "轮胎未充气可能会对车辆的许多系统产生不利影响，包括制动性能、悬挂、转向和燃油消耗。特别是，轮胎未充气可能会影响车辆的制动性能，并导致轮胎过早磨损。轮胎应始终按照车辆制造商的指导方针充气，有关信息可在车辆手册中找到。",
    "image_name": ""
  },
  {
    "index": 780,
    "id": "ABMW0653RU19",
    "section": "技术问题",
    "question": "当驾驶员操作指示灯开关时听到比正常更快的点击声音，这可能意味着什么？",
    "options": [
      "電壓調節器工作不正常",
      "指示燈泡可能已經燒壞",
      "危險警示燈亮著",
      "危險警示燈開關故障"
    ],
    "correct_answer": 1,
    "explanation": "开启指示器时听到快速点击声通常是指示灯泡之一损坏的迹象。驾驶员有责任确保他们的车辆适合上路。这应包括定期检查所有灯光、反光器和指示器是否正常工作。",
    "image_name": ""
  },
  {
    "index": 781,
    "id": "ABMW0660RU19",
    "section": "技术问题",
    "question": "驾驶自动变速箱车辆时，驾驶员需要特别注意什么？",
    "options": [
      "轮胎打滑更常见",
      "在高速公路上行驶是不允许的",
      "变速箱在低档行驶时可能会过热",
      "发动机制动力减弱"
    ],
    "correct_answer": 3,
    "explanation": "驾驶自动挡车辆时，当驾驶员松开油门时，车辆的减速率可能不同于手动挡车辆。驾驶员应意识到这一点，因为他们可能需要提前踩刹车以便在需要时停车。",
    "image_name": ""
  },
  {
    "index": 782,
    "id": "ABMW0661U19",
    "section": "技术问题",
    "question": "自动变速器对发动机制动力有什么影响？",
    "options": [
      "将制动能力转移到驻车制动器",
      "它增加了它",
      "它减少了它",
      "它将制动能力传输到所有车轮"
    ],
    "correct_answer": 2,
    "explanation": "驾驶自动变速车时，当驾驶员松开油门时，车辆可能不会像手动挡车辆那样以相同速率减速。驾驶员应意识到这一点，因为他们可能需要提前踩刹车以便在需要停车时停下车辆。",
    "image_name": ""
  },
  {
    "index": 783,
    "id": "ABMW0665RU19",
    "section": "技术问题",
    "question": "如果油压表显示少量或没有压力，或者警告灯点亮，可能是什么问题？",
    "options": [
      "机油油位太低",
      "机油太冷",
      "机油太稠",
      "机油油位太高"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员应定期检查车辆的机油液位，如果机油液位偏低，应将其添加至正常水平。如果需要经常添加机油，应请有经验的人员检查车辆，以查看是否存在问题。",
    "image_name": ""
  },
  {
    "index": 784,
    "id": "ABMW0666RU19",
    "section": "技术问题",
    "question": "如果车辆发动机油未按要求更换，可能会发生什么情况？",
    "options": [
      "车辆的燃油消耗可能会增加",
      "车辆的燃油消耗可能会减少",
      "发动机可能会过热",
      "发动机的部件可能会增加磨损"
    ],
    "correct_answer": 3,
    "explanation": "随着时间的推移，发动机油会变得不再有效，失去其黏度和润滑特性，因此必须根据制造商的建议随时更换。若不按要求更换可能会导致昂贵且严重的发动机损坏。通常在进行车辆维护时进行机油更换。",
    "image_name": ""
  },
  {
    "index": 785,
    "id": "ABMW0667RU19",
    "section": "技术问题",
    "question": "如果一辆车在低油压的情况下行驶，会对发动机产生什么影响？",
    "options": [
      "这会加速发动机的磨损",
      "这会提高燃油效率",
      "这会增加排放废气",
      "这会增加燃油消耗"
    ],
    "correct_answer": 0,
    "explanation": "低油压通常与低油位或故障油泵有关。发动机机油低位应按照制造商的建议进行加注。未这样做可能导致昂贵且严重的发动机损坏。",
    "image_name": ""
  },
  {
    "index": 786,
    "id": "ABMW0668RU23",
    "section": "技术问题",
    "question": "如果车辆的油压表显示低或红色油压警告灯亮起，驾驶员应该怎么做？",
    "options": [
      "在添加机油之前，以低档行驶",
      "将车开到一个安全的地方停下车辆，然后检查机油液面",
      "在添加机油之前，请以较低速度行驶"
    ],
    "correct_answer": 1,
    "explanation": "车辆的引擎安全运行必须保证机油循环良好。如果警示灯或表盘指示机油或机油压力过低，驾驶员应尽快停车在安全地方检查机油液位，必要时加注机油。继续驾驶可能会损坏引擎。若问题不仅仅是与机油液位有关，应请有经验的人员检查车辆。",
    "image_name": ""
  },
  {
    "index": 787,
    "id": "ABMW0669RU19",
    "section": "技术问题",
    "question": "在检查车辆发动机油液位之前，驾驶员应该做什么？",
    "options": [
      "确保发动机已关闭且冷却",
      "确保发动机已启动且温热",
      "确保发动机正在运转",
      "确保车辆处于低档位"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员需要了解应对车辆进行的定期检查。检查发动机机油液位至关重要 在水平地面停放车辆，熄火且冷却的状态下进行以获取更准确的读数。有关更多信息和指导，请参考车辆手册。",
    "image_name": ""
  },
  {
    "index": 788,
    "id": "ABMW0670RU19",
    "section": "技术问题",
    "question": "引擎油的作用是什么？",
    "options": [
      "它给排气系统润滑",
      "它给轮毂轴承润滑",
      "它给制动系统润滑",
      "它给发动机润滑"
    ],
    "correct_answer": 3,
    "explanation": "引擎油的作用是 lubricate and cool the moving parts of the engine。请参考车辆手册了解更多信息和指导。",
    "image_name": ""
  },
  {
    "index": 789,
    "id": "ABMW0673RU19",
    "section": "技术问题",
    "question": "何时建议使用冷却剂？",
    "options": [
      "全年通用",
      "仅限夏季",
      "仅限汽油发动机",
      "仅限冬季"
    ],
    "correct_answer": 0,
    "explanation": "冷却液的作用是在发动机运转过程中保持发动机冷却。冷却液通常是水和防冻液的混合物 这确保发动机保持冷却，同时在非常寒冷的天气中防止冷却液冻结。",
    "image_name": ""
  },
  {
    "index": 790,
    "id": "ABMW0674RU23",
    "section": "技术问题",
    "question": "燃油表上的警告灯和/或红色区域代表什么意思？\nTranslated: 燃油表上的警告灯和/或红色区域代表什么意思？",
    "options": [
      "油箱里加入了错误类型的燃料",
      "油箱中的燃油量较低",
      "燃油系统存在泄漏"
    ],
    "correct_answer": 1,
    "explanation": "许多车辆配备了各种警示灯和仪表。燃油表上的红色区域或警示灯表示车辆燃油严重不足，应尽快加油。",
    "image_name": ""
  },
  {
    "index": 791,
    "id": "ABMW0675RU19",
    "section": "技术问题",
    "question": "如果车辆电池没电会发生什么？",
    "options": [
      "电池会漏酸进引擎",
      "电池需要更换",
      "前灯泡需要更换",
      "引擎无法启动"
    ],
    "correct_answer": 3,
    "explanation": "所有机动车都有电池供电，主要是用来启动发动机。如果电池没电，司机将无法正常启动发动机。当发动机运转时，会产生自己的电力来充电电池并运行各种电气部件，包括灯光、加热、收音机等等。如果电池完全耗尽，就必须更换新电池。",
    "image_name": ""
  },
  {
    "index": 792,
    "id": "ABMW0676RU19",
    "section": "技术问题",
    "question": "汽油或柴油动力机动车配备电池的主要目的是什么？",
    "options": [
      "降低燃油消耗",
      "提供制动",
      "为发动机提供热量",
      "启动发动机"
    ],
    "correct_answer": 3,
    "explanation": "电池的主要目的是启动发动机。当发动机运转时，它会产生自己的电力来充电电池并运行各种电气部件，包括灯光、加热、收音机等。",
    "image_name": ""
  },
  {
    "index": 793,
    "id": "ABMW0681RU19",
    "section": "技术问题",
    "question": "弱电池对车辆的行驶性能会产生什么影响？",
    "options": [
      "燃油效率会降低",
      "前灯将不起作用",
      "上坡加速会减少",
      "不会产生影响"
    ],
    "correct_answer": 3,
    "explanation": "某些可能会发现用弱电池启动汽车有些困难，但一旦引擎启动，那就没关系了。如果电池无法充电或无法保持充电，请寻求权威人士的建议。",
    "image_name": ""
  },
  {
    "index": 794,
    "id": "ABMW0682RU19",
    "section": "技术问题",
    "question": "一辆车的减震器磨损会对车辆有什么影响？",
    "options": [
      "这可能导致车辆以不稳定的方式“跳动”",
      "这可能导致电路短路",
      "这可能增加燃油消耗",
      "这可能触发安全气囊的释放"
    ],
    "correct_answer": 0,
    "explanation": "磨损的减震器会严重影响车辆的操控，尤其是在不平整的路面或转弯时，还会导致轮胎不必要的磨损。在急刹车时可能会增加刹车距离，因为不能保持轮胎与路面的充分接触。",
    "image_name": ""
  },
  {
    "index": 795,
    "id": "ABMW0692RU23",
    "section": "技术问题",
    "question": "轮胎的速度等级表示什么？",
    "options": [
      "车辆可行驶的最高速度",
      "轮胎设计的最高速度",
      "轮胎设计的最低速度"
    ],
    "correct_answer": 1,
    "explanation": "轮胎的速度等级是轮胎设计的最高速度。这与轮胎的速度性能有关。这并不涉及轮胎应该或可以合法驾驶的速度。",
    "image_name": ""
  },
  {
    "index": 796,
    "id": "ABMW0693RU19",
    "section": "技术问题",
    "question": "在安装无内胎轮胎时，为什么应该更换阀门？",
    "options": [
      "为了保证车轮保持平衡",
      "为了确保车轮螺母保持紧固",
      "为了确保车轮保持对齐",
      "为了确保轮胎保持充气"
    ],
    "correct_answer": 3,
    "explanation": "更换无内胎轮胎时，建议更换阀门。这是因为旧阀门自上次更换轮胎后一直固定在轮毂上。旧阀门可能会磨损、泄漏或导致气体泄漏。",
    "image_name": ""
  },
  {
    "index": 797,
    "id": "ABMW0701RU19",
    "section": "技术问题",
    "question": "低胎压对车辆有什么影响？",
    "options": [
      "引擎噪音增加",
      "制动和转弯受影响",
      "车辆加速更快",
      "制动器可能过热"
    ],
    "correct_answer": 1,
    "explanation": "轮胎压力不正确会对车辆的多个系统产生不利影响，包括悬挂、转向和燃油消耗等。特别是轮胎过度放气会影响车辆的制动能力和转弯时的效果。轮胎应根据车辆制造商的指南气压充气，有关信息可在车辆手册中找到。",
    "image_name": ""
  },
  {
    "index": 798,
    "id": "ABMW0708RU19",
    "section": "技术问题",
    "question": "车辆轮胎气压过低的影响是什么？",
    "options": [
      "制动和转向受损",
      "车辆发动机磨损加剧",
      "制动和转向改善",
      "燃油经济性和制动性能提高"
    ],
    "correct_answer": 0,
    "explanation": "驾驶员应定期至少一周检查一次车辆的轮胎气压（包括备胎）。气压不足会对车辆的许多系统产生不利影响，包括制动能力、悬挂、转向、燃油消耗和轮胎过早磨损。轮胎应始终根据车辆制造商的指南进行充气，有关信息可在车辆的中找到。",
    "image_name": ""
  },
  {
    "index": 799,
    "id": "ABMW0713RU19",
    "section": "技术问题",
    "question": "在高速行驶时，方向盘持续震动表示什么？",
    "options": [
      "避震器磨损",
      "轮胎平衡不均匀",
      "转向不正",
      "重量分配不均匀"
    ],
    "correct_answer": 1,
    "explanation": "如果驾驶员在行驶过程中感到方向盘持续震动，尤其是在较高速度时，通常表明车辆轮胎的平衡不均匀。这可能导致车辆的操控不稳定。如果情况如此，应请有经验的人员进行调查。",
    "image_name": ""
  },
  {
    "index": 800,
    "id": "ABMW26U19",
    "section": "技术问题",
    "question": "更换车辆上的车轮之后，应该在行驶短距离后检查以下哪项？",
    "options": [
      "轮毂螺帽的紧固度",
      "轮胎气嘴",
      "制动器垫片间隙",
      "轮胎胎纹深度"
    ],
    "correct_answer": 0,
    "explanation": "更换车辆上的车轮后，驾驶短距离后检查更换车轮上的轮毂螺母或螺栓的紧固程度，确保它们安装牢固。如有疑问，请寻求胜任的人员帮助。",
    "image_name": ""
  },
  {
    "index": 801,
    "id": "RSA225227",
    "section": "技术问题",
    "question": "刹车时，车辆减速和停止的速度取决于什么？",
    "options": [
      "制动踏板所施加的向下压力",
      "制动踏板所施加的向上压力",
      "油门踏板所施加的向下压力"
    ],
    "correct_answer": 0,
    "explanation": "制动踏板上的向下压力决定车辆减速和停止的速度。在正常驾驶过程中，驾驶员应提前阅读前方路况，学会及时而逐渐地踩刹车。",
    "image_name": ""
  },
  {
    "index": 802,
    "id": "ABMWO711RU19",
    "section": "技术问题",
    "question": "驾驶时，司机应将左脚放在哪里休息？",
    "options": [
      "在刹车踏板下方",
      "在离合器踏板下方",
      "在地板或脚踏板上",
      "在离合器踏板上"
    ],
    "correct_answer": 2,
    "explanation": "当驾驶员驾驶时，应该把左脚放在地板或脚踏板上，而不是踩在踏板下面。这样做可能导致在紧急情况下反应时间延迟。把脚放在踏板上可能导致滑行，可能会无意中增加车辆的速度，或导致离合器机构损坏。"
  },
  {
    "index": 803,
    "id": "BW0071R",
    "section": "技术问题",
    "question": "在高速公路上，司机什么时候应该使用危险警示灯？",
    "options": [
      "牵引另一辆车时",
      "在硬路肩上行驶时",
      "当另一辆车跟车距离太近时",
      "因前方有危险需要迅速减速时"
    ],
    "correct_answer": 3,
    "explanation": "使用危险警示灯来警告其他道路使用者前方有危险。例如，如果您因为前方交通拥堵而不得不急剧减速，您可以使用危险警示灯来警告后方车辆需要减速。"
  },
  {
    "index": 804,
    "id": "BW0084R",
    "section": "技术问题",
    "question": "如果燃油系统被空气锁住，司机应该怎么做？",
    "options": [
      "紧固喷油器管道",
      "放松燃油泵",
      "排放燃油系统中的空气",
      "排放燃油滤清器中的燃油"
    ],
    "correct_answer": 2,
    "explanation": "燃油系统可能会出现气锁问题，如果您让燃油过低或系统中有泄漏，应在驾驶前解决此问题。解决方法可能只需简单地放掉燃油系统中的气体。"
  },
  {
    "index": 805,
    "id": "BWO0092R",
    "section": "技术问题",
    "question": "何种情况下，车辆可以安装交叉帘式和子午线轮胎？",
    "options": [
      "当每种类型安装在不同的车轴上",
      "在运输重物时",
      "在雪地拖车时",
      "在湿滑的路况下驾驶"
    ],
    "correct_answer": 0,
    "explanation": "通常情况下，您应该在整个车辆上配备相同类型的轮胎。但是，如果您需要混合安装斜交胎和子午线轮胎，任何轴上的轮胎都应该是相同类型的。"
  }
]
